var _defs, _symbol, _path, _path2, _g, _path3, _polygon, _g2, _path4, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon3, _g3, _path13, _polygon4, _g4, _g5, _g6, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _path14, _g7, _path15, _polygon5, _path16, _path17, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _path18, _polygon6, _g8, _path19, _rect, _polygon7, _path20, _g9, _g10, _g11, _g12, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _g13, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _path21, _polygon8, _g14, _g15, _path22, _polygon9, _g16, _g17, _path23, _g18, _path24, _g19, _path25, _path26, _g20, _rect2, _path27, _polygon10, _polygon11, _g21, _polygon12, _polyline, _g22, _path28, _polygon13, _g23, _path29, _polygon14, _path30, _polygon15, _g24, _path31, _g25, _path32, _path33, _path34, _path35, _polygon16, _path36, _path37, _path38, _polygon17, _path39, _g26, _path40, _path41, _path42, _g27, _path43, _polygon18, _polygon19, _g28, _polygon20, _polygon21, _g29, _path44, _polygon22, _g30, _path45, _path46, _g31, _path47, _path48, _g32, _g33, _path49, _path50, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _path51, _path52, _polygon23, _path53, _g34, _polygon24, _path54, _g35, _g36, _symbol98, _path55, _path56, _polygon25, _path57, _g37, _polygon26, _path58, _g38, _g39, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _polygon27, _polyline2, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _path59, _path60, _g40, _symbol117, _symbol118, _symbol119, _symbol120, _path61, _path62, _g41, _g42, _symbol121, _symbol122, _symbol123, _path63, _path64, _g43, _g44, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _path65, _path66, _g45, _g46, _g47, _path67, _path68, _g48, _g49, _g50, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153, _symbol154, _symbol155, _symbol156, _symbol157, _symbol158, _symbol159, _symbol160, _symbol161, _symbol162, _symbol163, _polygon28, _polygon29, _g51, _symbol164, _polygon30, _polygon31, _g52, _polygon32, _polygon33, _g53, _symbol165, _symbol166, _symbol167, _symbol168, _symbol169, _symbol170, _symbol171, _symbol172, _image, _path69, _symbol173, _symbol174, _path70, _symbol175, _symbol176, _rect3, _polygon34, _polygon35, _polygon36, _path71, _symbol177, _symbol178;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCiena(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M100,49.2c0,27.8-22.2,50-50,50c-6.8,0-13.2-1.2-19.3-3.8l-9-22.2h44.8V34.5l21.5-9l11.8,22.2 C99.8,48.2,100,48.8,100,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M100,49.2c0,27.8-22.2,50-50,50c-6.8,0-13.2-1.2-19.3-3.8l-9-22.2h44.8V34.5l20-9l13.2,22.2 C99.8,48.2,100,48.8,100,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M150,73.8c0,41.5-33.5,75-75,75c-10.2,0-20-2-28.8-5.5L32.8,110L55,70l45-18.2l32.2-13.5l17.5,33.5 C149.8,72.5,150,73.2,150,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M150,73.8c0,41.5-33.5,75-75,75c-10.2,0-20-2-28.8-5.5L32.8,110L55,70l45-18.2l32.2-13.5l17.5,33.5 C149.8,72.5,150,73.2,150,73.8z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 3
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_2_",
    x: 19.1,
    y: 14.2,
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 47.7024 55.2879)",
    width: 19.9,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_2_",
    x: 31,
    y: 28.6,
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 64.1461 85.4025)",
    width: 18,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_2_",
    x: 31,
    y: 28.3,
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 64.2631 84.7809)",
    width: 18,
    height: 16.3
  }))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "add-note",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h16v12.207a2 2 0 0 1-.544 1.37l-1.687 1.794a2 2 0 0 1-1.457.629H2a2 2 0 0 1-2-2V0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EEF",
    d: "M.5.5V14A1.5 1.5 0 0 0 2 15.5h10.312a1.5 1.5 0 0 0 1.093-.472l1.687-1.793a1.5 1.5 0 0 0 .408-1.028V.5H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4l4-4z",
    fillRule: "nonzero",
    fill: "#009EEF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#009EEF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.506 10.81-.247.247-.342 1.026 1.026-.342.247-.247-.684-.684zm6.564-6.564L4.917 10.4l.683.684 6.154-6.154-.684-.684zm1.209-.525a.483.483 0 0 0-.684 0l-.115.115.684.684.115-.115a.484.484 0 0 0 0-.684zm-8.527 7.023 7.433-7.433a1.065 1.065 0 0 1 1.504 0c.415.415.415 1.09 0 1.504l-7.433 7.433L3 13l.752-2.256z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "app-icon-bpmn",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.7917,
    y1: 48.7917,
    x2: 1.2083,
    y2: 1.2083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M45.8,50H4.2C1.8,50,0,48.2,0,45.8V4.2C0,1.8,1.8,0,4.2,0h41.7C48.2,0,50,1.8,50,4.2v41.7 C50,48.2,48.2,50,45.8,50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M21.2,26.4L8.3,38l11.9,12H45c2.8,0,5-2.2,5-5V25L39.5,12.9 l-5.8,2.6L28.8,20L21.2,26.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 10.1,
    transform: "matrix(0.6913 0.7226 -0.7226 0.6913 21.777 -17.1368)",
    opacity: 0.5,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 2,
    height: 13.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A1E7FF",
    d: "M40,12.4l-3.1,3.1c-0.4,0.4-1,0.4-1.4,0l-3.1-3.1c-0.4-0.4-0.4-1,0-1.4l3.1-3.1c0.4-0.4,1-0.4,1.4,0 l3.1,3.1C40.4,11.3,40.4,12,40,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    d: "M36.2,7.6c0.3,0,0.5,0.1,0.7,0.3l3.1,3.1c0.4,0.4,0.4,1,0,1.4l-3.1,3.1c-0.2,0.2-0.5,0.3-0.7,0.3 s-0.5-0.1-0.7-0.3l-3.1-3.1c-0.4-0.4-0.4-1,0-1.4l3.1-3.1C35.7,7.7,36,7.6,36.2,7.6 M36.2,6.6c-0.5,0-1,0.2-1.4,0.6l-3.1,3.1 c-0.8,0.8-0.8,2,0,2.8l3.1,3.1c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l3.1-3.1c0.8-0.8,0.8-2,0-2.8l-3.1-3.1 C37.3,6.8,36.8,6.6,36.2,6.6L36.2,6.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    enableBackground: "new    ",
    d: "M23.4,22.6c-0.3,0-0.6-0.1-0.7-0.3l-9.3-10.5c-0.4-0.4-0.3-1,0.1-1.4 c0.4-0.4,1-0.3,1.4,0.1L24.1,21c0.4,0.4,0.3,1-0.1,1.4C23.9,22.5,23.6,22.6,23.4,22.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 22.9,
    transform: "matrix(0.6718 0.7407 -0.7407 0.6718 27.9231 -1.9914)",
    opacity: 0.5,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 2,
    height: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 14.1,
    cy: 11.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1E7FF",
    cx: 10.6,
    cy: 35.6,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.4,28.7h-16c-1.1,0-2-0.9-2-2l0-6c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v6C33.4,27.8,32.5,28.7,31.4,28.7z "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#009EEF",
    cx: 28.8,
    cy: 24.9,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    enableBackground: "new    ",
    d: "M41.9,39.8c-0.3,0-0.5-0.1-0.7-0.3L28,25.7c-0.4-0.4-0.4-1,0-1.4 c0.4-0.4,1-0.4,1.4,0l13.2,13.8c0.4,0.4,0.4,1,0,1.4C42.4,39.8,42.2,39.8,41.9,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#FFFFFF",
    d: "M38.5,32.6l-2.6,2.6c-0.4,0.4-1,0.4-1.4,0L32,32.6c-0.4-0.4-0.4-1,0-1.4l2.6-2.6 c0.4-0.4,1-0.4,1.4,0l2.6,2.6C38.9,31.6,38.9,32.2,38.5,32.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.95,
    fill: "#A1E7FF",
    enableBackground: "new    ",
    cx: 41.9,
    cy: 38.8,
    r: 4.5
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "app-icon-setting",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.3911,
    y1: 48.3911,
    x2: 1.5885,
    y2: 1.5885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M44.5,50h-39C2.4,50,0,47.5,0,44.5V5.5C0,2.4,2.5,0,5.5,0h39C47.6,0,50,2.5,50,5.5v39 C50,47.5,47.6,50,44.5,50z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "44.9,19.2 50,25.2 50,45.2 49.8,46.2 49.6,46.6  49.2,47.4 48.8,48.2 47.8,49.1 46.6,49.7 44.8,50.2 18.7,50.2 6.5,34.7 14.6,32.9 21.2,39.7 35.8,35 39.7,21.8  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1B7",
    d: "M41.6,25.2c0-2.5,1.3-4.7,3.3-5.9c-0.4-1.6-1-3.1-1.7-4.5c-0.5,0.2-1.1,0.2-1.6,0.2c-3.7,0-6.7-3-6.7-6.8 c0-0.6,0.1-1.3,0.2-1.8c-1.3-0.7-2.7-1.3-4.2-1.8c-1.2,2.1-3.3,3.6-5.9,3.6S20.1,6.7,19,4.5l0,0c-1.5,0.4-2.9,1-4.2,1.8 c0.2,0.6,0.2,1.3,0.2,1.9c0,3.8-3,6.8-6.8,6.8c-0.7,0-1.3-0.1-1.8-0.2c-0.8,1.6-1.5,3.2-1.9,4.9c1.8,1.2,3,3.3,3,5.6 s-1.1,4.3-2.7,5.4c0.3,1.4,0.8,2.7,1.6,4c0.6-0.2,1.3-0.2,1.9-0.2c3.7,0,6.8,3,6.8,6.8c0,0.7-0.1,1.2-0.2,1.9 c1.3,0.7,2.6,1.2,4,1.7c1.2-2.2,3.3-3.7,5.9-3.7s4.8,1.5,6,3.7c1.6-0.5,3-1.1,4.3-1.9c-0.2-0.5-0.2-1.2-0.2-1.8 c0-3.8,3-6.8,6.7-6.8c0.5,0,1.1,0.1,1.6,0.2c0.6-1.2,1.2-2.4,1.6-3.7C42.8,29.7,41.6,27.7,41.6,25.2z M24.8,37.8 c-7.2,0-13.1-5.8-13.1-13.1s5.8-13.1,13.1-13.1c7.2,0,13.1,5.8,13.1,13.1S32.1,37.8,24.8,37.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34,30.4l-2.4-2.2c0,0,0.3-5.3-1.5-7.3c-1.6-1.6-5.4-1.5-6.6-1.4c-0.2,0-0.2,0.2-0.1,0.2l3.4,3.3 c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.2,0.2,0.2,0.2,0.4c0.2,0.6-0.2,1.4-0.8,2.3l-0.5,0.5c-0.8,0.7-1.6,0.8-2.3,0.7 c-0.2,0-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.2-0.2l-3.3-3.4c-0.1-0.1-0.2,0-0.2,0.1c-0.1,1.1-0.1,5,1.4,6.6 c1.8,1.8,7.3,1.5,7.3,1.5l2.2,2.4l1.3,1.4l8.3,9.6l0,0c1.3,1.3,3.8,1.4,5.2,0c1.3-1.3,1.3-3.8,0-5.2l0,0l-9.3-8.3L34,30.4z  M43.9,43.8c-0.8,0.8-2.2,0.8-2.9,0.1c-0.8-0.7-0.8-2.1,0-2.9c0.8-0.7,2.2-0.7,2.9,0.1C44.7,41.8,44.7,43.1,43.9,43.8z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "app-icon-template",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.7099,
    y1: -676.0821,
    x2: 3.6663,
    y2: -679.1257,
    gradientTransform: "matrix(24.576 0 0 24.576 -87.4 16692.8867)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M71.2,80.1H9c-5,0-9-4-9-9V8.9c0.3-5,4.3-9,9-9h62.2c4.8,0,8.8,4,8.8,9v62.4 C80.2,76.1,76.2,80.1,71.2,80.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "63.2,66.1 63,22 80,40.4 80,72.2 79.7,73.7 79.5,74.3  78.7,75.8 78.1,77 76.5,78.3 74.4,79.3 71.7,80.1 29,80.1 16.9,67 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M57.3,33.2H34.9c-1.1,0-1.9-0.6-1.9-1.6s0.7-1.6,1.9-1.6h22.4 c1.1,0,1.9,0.6,1.9,1.6S58.4,33.2,57.3,33.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M26.5,28.1h-3c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2h3 c1.1,0,2-0.9,2-2v-3C28.5,29,27.6,28.1,26.5,28.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M57.3,57.7H34.9c-1.1,0-1.9-0.6-1.9-1.6c0-1,0.7-1.6,1.9-1.6 h22.4c1.1,0,1.9,0.6,1.9,1.6C59.2,57.1,58.4,57.7,57.3,57.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M26.5,52.6h-3c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2h3 c1.1,0,2-0.9,2-2v-3C28.5,53.5,27.6,52.6,26.5,52.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M52.2,45.1H34.6c-0.9,0-1.5-0.6-1.5-1.5s0.6-1.5,1.5-1.5h17.6 c0.9,0,1.5,0.6,1.5,1.5S53,45.1,52.2,45.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M26.5,40.1h-3c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2h3 c1.1,0,2-0.9,2-2v-3C28.5,41,27.6,40.1,26.5,40.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M44.3,23.4H22.6c-1.1,0-1.8-0.6-1.8-1.6c0-1,0.7-1.6,1.8-1.6 h21.7c1.1,0,1.8,0.6,1.8,1.6C46.1,22.7,45.4,23.4,44.3,23.4z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "63,22 54,22 54,14 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E8E8E8",
    strokeMiterlimit: 10,
    d: "M15.8,15.8c0-1.1,0.9-2,2-2h34.4c1.1,0,2.7,0.6,3.5,1.3l6,5.4 c0.8,0.7,1.5,2.2,1.5,3.3v40.3c0,1.1-0.9,2-2,2H17.8c-1.1,0-2-0.9-2-2V15.8z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "app-icon-user-group",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.3688,
    y1: 48.3688,
    x2: 1.675,
    y2: 1.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M44.4,50H5.6C2.5,50,0,47.5,0,44.4V5.6C0.1,2.5,2.6,0,5.6,0h38.8C47.5,0,50,2.5,50,5.6v38.9 C50,47.5,47.5,50,44.4,50z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "37.4,13.1 50,23.1 50,45.1 49.8,46 49.6,46.4  49.2,47.2 48.7,48.1 47.8,48.9 46.6,49.5 44.8,50 18.9,50 3.1,34.9 25.3,38.3 26.2,33.3 29,28.7 32.4,13.1  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M35.3,12.6L35.3,12.6c-2.8,0-5.1,2.3-5.1,5.1c0,0.4,0.1,0.8,0.1,1.3 c-0.1,0.1-0.3,0.1-0.4,0.3c-0.3,0.3-0.4,0.6-0.4,0.9l0.1,1.1c0,0.7,0.4,1.3,1.1,1.3H31c0.3,1.4,0.6,3,1.8,3.6 c0,0-0.4,1.6-0.4,1.7c-0.7,0.1-0.3,0-0.3,0c-3.9,0.1-6.9,2.9-6.9,2.9c-1.3,1.1-1.8,2.8-1.9,4.3c-1.3,0,25.4,0,24.2,0 c-0.2-1.4-0.7-3.1-1.9-4.3c0,0-2.9-2.8-6.9-2.9c-0.1,0,0.4,0-0.3,0c0-0.1-0.4-1.7-0.4-1.7c1.3-0.6,1.6-2.1,1.8-3.6h0.1 c0.7,0,1.1-0.6,1.1-1.3l0.1-1.1c0-0.3-0.1-0.6-0.4-0.9c-0.1-0.1-0.3-0.2-0.4-0.3c0.1-0.4,0.1-0.8,0.1-1.3 C40.3,14.9,38.1,12.7,35.3,12.6L35.3,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M47.8,35.2H23.1v-0.3l-0.3-0.1c0.3-1.9,0.9-3.4,2.1-4.4c0.1-0.1,3.1-2.8,7.1-2.9h0.1 c0.1-0.2,0.1-0.6,0.3-1.3c-1.2-0.8-1.5-2.3-1.7-3.5c-0.8-0.1-1.3-0.8-1.3-1.6l-0.1-1c0-0.4,0.2-0.8,0.4-1.1 c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.4-0.1-0.7-0.1-1.1c0-3,2.4-5.4,5.4-5.4h0.1c2.9,0.1,5.3,2.5,5.3,5.4c0,0.4,0,0.8-0.1,1.1 c0.1,0.1,0.1,0.1,0.3,0.2c0.3,0.3,0.4,0.7,0.4,1.1l-0.1,1.1c0,0.8-0.5,1.4-1.3,1.5c-0.2,1.2-0.5,2.8-1.7,3.5 c0.2,0.6,0.3,1,0.3,1.3h0.1c4,0.2,6.9,2.8,7,2.9c1.1,1,1.8,2.5,2,4.4L47.8,35.2z M23.6,34.6h23.5c-0.3-1.6-0.9-2.9-1.8-3.7 c-0.1,0-2.9-2.7-6.7-2.8l0,0l0,0H38v-0.3c0-0.1-0.3-0.9-0.4-1.6l-0.1-0.3l0.3-0.1c1.1-0.6,1.4-1.9,1.6-3.4l0.1-0.3h0.3 c0.6,0,0.9-0.5,0.9-0.9l0.1-1.1c0-0.2-0.1-0.4-0.3-0.6c-0.1-0.1-0.2-0.1-0.3-0.2l-0.3-0.1l0.1-0.3c0.1-0.3,0.1-0.8,0.1-1.1 c0-2.6-2.1-4.8-4.7-4.8h-0.1c-2.6,0-4.8,2.2-4.8,4.8c0,0.4,0.1,0.7,0.1,1.1l0.1,0.4l-0.2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.2,0.2-0.3,0.4-0.3,0.6l0.1,1c0,0.5,0.3,1,0.8,1H31l0.1,0.3c0.3,1.6,0.6,2.9,1.6,3.4L33,26v0.1c-0.2,0.7-0.4,1.5-0.4,1.6V28 h-0.3c-0.3,0-0.4,0-0.4,0h-0.3c-3.6,0.3-6.3,2.8-6.3,2.8C24.4,31.7,23.8,33,23.6,34.6z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M15.3,12.6L15.3,12.6c-2.8,0-5.1,2.3-5.1,5.1c0,0.4,0.1,0.8,0.1,1.3 c-0.1,0.1-0.3,0.1-0.4,0.3c-0.3,0.3-0.4,0.6-0.4,0.9l0.1,1.1c0,0.7,0.4,1.3,1.1,1.3h0.1c0.3,1.4,0.6,3,1.8,3.6 c0,0-0.4,1.6-0.4,1.7c-0.7,0.1-0.3,0-0.3,0C8,27.9,5,30.6,5,30.6c-1.3,1.1-1.8,2.8-1.9,4.3c-1.3,0,25.4,0,24.2,0 c-0.2-1.4-0.7-3.1-1.9-4.3c0,0-2.9-2.8-6.9-2.9c-0.1,0,0.4,0-0.3,0c0-0.1-0.4-1.7-0.4-1.7c1.3-0.6,1.6-2.1,1.8-3.6h0.1 c0.7,0,1.1-0.6,1.1-1.3l0.1-1.1c0-0.3-0.1-0.6-0.4-0.9c-0.1-0.1-0.3-0.2-0.4-0.3c0.1-0.4,0.1-0.8,0.1-1.3 C20.3,14.9,18,12.7,15.3,12.6L15.3,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M27.7,35.2H3v-0.3l-0.3-0.1c0.3-1.9,0.9-3.4,2.1-4.4c0.1-0.1,3.1-2.8,7.1-2.9H12c0.1-0.2,0.1-0.6,0.3-1.3 c-1.2-0.8-1.5-2.3-1.7-3.5c-0.8-0.1-1.3-0.8-1.3-1.6l-0.1-1c0-0.4,0.2-0.8,0.4-1.1c0.1-0.1,0.2-0.1,0.3-0.2 c-0.1-0.4-0.1-0.7-0.1-1.1c0-3,2.4-5.4,5.4-5.4h0.1c2.9,0.1,5.3,2.5,5.3,5.4c0,0.4,0,0.8-0.1,1.1c0.1,0.1,0.1,0.1,0.3,0.2 c0.3,0.3,0.4,0.7,0.4,1.1l-0.1,1.1c0,0.8-0.5,1.4-1.3,1.5c-0.2,1.2-0.5,2.8-1.7,3.5c0.2,0.6,0.3,1,0.3,1.3h0.1 c4,0.2,6.9,2.8,7,2.9c1.1,1,1.8,2.5,2,4.4L27.7,35.2z M3.5,34.6H27c-0.3-1.6-0.9-2.9-1.8-3.7c-0.1,0-2.9-2.7-6.7-2.8l0,0l0,0 h-0.6v-0.3c0-0.1-0.3-0.9-0.4-1.6l-0.1-0.3l0.3-0.1c1.1-0.6,1.4-1.9,1.6-3.4l0.1-0.3h0.3c0.6,0,0.9-0.5,0.9-0.9l0.1-1.1 c0-0.2-0.1-0.4-0.3-0.6c-0.1-0.1-0.2-0.1-0.3-0.2l-0.3-0.1l0.1-0.3c0.1-0.3,0.1-0.8,0.1-1.1c0-2.6-2.1-4.8-4.7-4.8h-0.1 c-2.6,0-4.8,2.2-4.8,4.8c0,0.4,0.1,0.7,0.1,1.1l0.1,0.4l-0.2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.2-0.3,0.4-0.3,0.6l0.1,1 c0,0.5,0.3,1,0.8,1H11l0.1,0.3c0.3,1.6,0.6,2.9,1.6,3.4L13,26l-0.1,0.3c-0.2,0.7-0.4,1.5-0.4,1.6v0.3h-0.3c-0.3,0-0.4,0-0.4,0 h-0.3C7.9,28.5,5.2,31,5.2,31C4.4,31.7,3.7,33,3.5,34.6z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#355B74",
    d: "M25,10.2L25,10.2c-3.8,0-6.8,3.1-6.8,6.8c0,0.6,0.1,1.1,0.2,1.7c-0.2,0.1-0.3,0.2-0.5,0.3 c-0.3,0.3-0.5,0.7-0.5,1.2l0.2,1.4c0,0.9,0.6,1.7,1.5,1.7h0.1c0.3,1.9,0.7,4,2.4,4.8c0,0-0.6,2.1-0.6,2.2c-0.9,0.1-0.3,0-0.4,0 c-5.2,0.2-9.2,3.8-9.2,3.8c-1.7,1.5-2.3,3.8-2.6,5.7c-1.8,0,33.8,0,32.3,0c-0.2-1.9-0.9-4.2-2.6-5.7c0,0-3.9-3.7-9.2-3.8 c-0.1,0,0.5,0-0.4,0c0-0.1-0.6-2.2-0.6-2.2c1.7-0.8,2.1-2.8,2.4-4.8h0.1c0.9,0,1.5-0.7,1.5-1.7l0.2-1.4c0-0.4-0.2-0.8-0.5-1.2 c-0.2-0.2-0.3-0.3-0.5-0.3c0.2-0.5,0.2-1.1,0.2-1.7C31.7,13.2,28.7,10.3,25,10.2L25,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M41.6,40.3H8.8v-0.4l-0.3-0.1c0.3-2.6,1.2-4.6,2.7-5.9c0.2-0.2,4.1-3.7,9.4-3.9h0.1 c0.1-0.3,0.2-0.7,0.4-1.7c-1.6-1-2-3-2.3-4.7c-1-0.2-1.7-1-1.7-2.1L17,20.2c0-0.6,0.2-1.1,0.6-1.5c0.1-0.1,0.2-0.2,0.3-0.3 c-0.1-0.5-0.2-0.9-0.2-1.4c0-4,3.2-7.2,7.2-7.2H25c3.9,0.1,7.1,3.3,7.1,7.2c0,0.5,0,1-0.1,1.5c0.1,0.1,0.2,0.2,0.3,0.3 c0.4,0.4,0.6,0.9,0.6,1.5l-0.2,1.5c0,1.1-0.7,1.9-1.7,2c-0.2,1.6-0.7,3.7-2.3,4.7c0.2,0.8,0.3,1.3,0.4,1.7h0.2 c5.3,0.3,9.2,3.7,9.3,3.9c1.4,1.3,2.3,3.3,2.7,5.9L41.6,40.3z M9.3,39.4h31.3c-0.3-2.2-1.2-3.8-2.4-4.9c-0.1,0-3.8-3.6-8.9-3.8 l0,0l0,0h-0.8v-0.4c0-0.1-0.3-1.2-0.6-2.2l-0.1-0.3l0.3-0.2c1.4-0.7,1.8-2.5,2.2-4.5l0.1-0.3h0.3c0.8,0,1.2-0.7,1.2-1.2l0.2-1.5 c0-0.3-0.2-0.6-0.4-0.8c-0.1-0.1-0.2-0.2-0.4-0.3L31,18.8l0.1-0.3c0.2-0.4,0.2-1,0.2-1.5c0-3.5-2.8-6.3-6.2-6.4H25 c-3.5,0-6.3,2.9-6.3,6.4c0,0.5,0.1,0.9,0.2,1.4l0.1,0.5l-0.2,0.2c-0.2,0.1-0.2,0.2-0.4,0.3C18.2,19.7,18,20,18,20.2l0.2,1.3 c0,0.7,0.3,1.3,1.1,1.3h0.3l0.2,0.3c0.3,2.1,0.7,3.8,2.2,4.5l0.3,0.2l-0.1,0.3c-0.2,0.9-0.6,2-0.6,2.2v0.4h-0.4 c-0.3,0-0.5,0-0.5,0h-0.4c-4.8,0.3-8.3,3.7-8.4,3.7C10.5,35.6,9.7,37.2,9.3,39.4z"
  })))))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-about",
    viewBox: "-7.5 -7.5 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#617780",
    d: "M47.5,52.5h-50c-2.8,0-5-2.2-5-5v-50c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C52.5,50.3,50.3,52.5,47.5,52.5z "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "40,4.9 52,20.1 52,53 11.2,52.5 5,40 40,40 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    opacity: 0.5,
    fill: "#F1F1F1",
    width: 35,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 16,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.2,
    width: 11,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMVJREFUeNqU0csOwUAYhmE9Olsi 7CysuAO3L7bE3oaokEiEhFKtd5KvMm1sTPKk08n8mf/gVIrLKX3NyuyvfcFFgCp8nb3xQqx9mgeY y3V0MUQHHh44YYcLEt8KaGOMGUZ67Ywl5rjnAXk6NfQxwVSpRbhirRcdt1S0OQzRUloN1fO956v6 FE+lsMcATe0PuKnozLdaZg43WGhvArZY4ahuFdrqKZWeBOpMpJdju632LEIx/4lSTZR2YaK/pp2V pv3/+ggwABoTMW1QKiaXAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 29.7062 7.0513)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 35,
    cy: 10.3,
    rx: 2.2,
    ry: 2.2
  })))))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-add-ne",
    viewBox: "-32 -18 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M23,42h-50c-2.8,0-5-2.2-5-5v-50c0-2.8,2.2-5,4.5-5h50c3.3,0,5.5,2.2,5.5,5v50C28,39.8,25.8,42,23,42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "15.5,-5.6 28,9.8 28,42 -13.3,42 -19.5,29.5 15.5,29.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -5.5,
    opacity: 0.35,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 35,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.5,
    y: 5.5,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: 5.5,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.5,
    y: 5.5,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5.5,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 5.5,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 10.5,
    cy: -0.2,
    rx: 2.2,
    ry: 2.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ADD_NE"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: -7.1,
    fill: "#009EEF",
    width: 11.4,
    height: 12.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.4-9.5H6.6c-1.1,0-2.1,1-2.1,2.1V5.4c0,1.2,1,2.1,2.1,2.1h12.8c1.2,0,2.1-1,2.1-2.1V-7.4 C21.5-8.5,20.5-9.5,19.4-9.5z M18.5,0.5h-4v4h-3v-4h-4v-3h4v-4h3v4h4V0.5z"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-alarm-1",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M150,75c0,41.4-33.6,75-75,75c-10.2,0-19.8-2.1-28.8-5.7C19.2,132.9,0,106.2,0,75C0,33.6,33.6,0,75,0 c40.8,0,74.1,32.7,75,73.2C150,73.8,150,74.4,150,75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M150,75c0,41.4-33.6,75-75,75"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M148.2,91.5c-7.5,32.7-36,57.3-70.5,58.5h-5.4l-40.8-42H102 V50.4L148.2,91.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 51.3,
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 69,
    height: 56.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    d: "M48.6,45.3v68.1h13.5V45.3H48.6z M60,56.4h-9v-9h9V56.4z  M60.3,68.7h-9v-9.3h9V68.7z M60.3,80.4h-9v-9.3h9V80.4z M60,110.4h-9v-9.3h9V110.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 56.7,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 10.2,
    height: 45.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.1,
    y: 56.7,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 10.2,
    height: 45.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 56.7,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 10.2,
    height: 45.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.7,
    y: 56.7,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 10.2,
    height: 45.3
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M133.2,34.8v22.8c0,2.7-2.1,4.8-4.8,4.8h-12.9l-12.6,9.9v-9.9 H89.1c-2.7,0-4.8-2.1-4.8-4.8V34.8c0-2.7,2.1-4.8,4.8-4.8h39.3C131.1,30,133.2,32.4,133.2,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M131.7,32.7v22.8c0,2.7-2.1,4.8-4.8,4.8h-12.6l-11.7,9.9v-9.9H88.8c-2.7,0-4.8-2.1-4.8-4.8V32.7 c0-2.7,2.1-4.8,4.8-4.8h38.4C129.6,27.9,131.7,30.3,131.7,32.7z"
  }))))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-alarm-api",
    viewBox: "575 575 50 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M625,600c0,13.9-11.1,25-25,25c-3.4,0-6.6-0.6-9.7-1.9c-8.9-3.7-15.3-12.7-15.3-23.1c0-13.9,11.1-25,25-25 c13.6,0,24.6,10.9,25,24.4C625,599.6,625,599.9,625,600z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M624.3,606.1c-2.5,10.9-12.3,18.5-23.8,18.9h-1.8l-13.4-15.2 l23.3,1.2l8.6-20.5L624.3,606.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#414141",
    enableBackground: "new    ",
    d: "M617.8,593v16c0,1.8-1.5,3.7-3.2,3.7h-8.2l-8.1,6.7v-6.7h-9.9 c-1.8,0-3.2-2-3.2-3.9V593c0-1.8,1.5-3.5,3.2-3.5h26.4C616.3,589.4,617.8,591,617.8,593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M617.8,591.2v16c0,1.8-1.5,3.7-3.2,3.7h-8.2l-8.3,6.7v-6.7h-9.9c-1.8,0-3.2-2-3.2-3.9v-15.6 c0-1.8,1.5-3.5,3.2-3.5h26.4C616.3,588.1,617.8,589.4,617.8,591.2z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 587.125 605.75)",
    fill: "#009999",
    fontFamily: "'Roboto-Regular'",
    fontSize: 18
  }, "API"))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-alarm",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M100,50c0,27.8-22.2,50-50,50c-6.8,0-13.2-1.2-19.3-3.8C12.8,88.8,0,70.8,0,50C0,22.2,22.2,0,50,0 c27.2,0,49.2,21.8,50,48.8C100,49.2,100,49.8,100,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    clipPath: "url(#SVGID_2_)",
    fill: "#272425",
    enableBackground: "new    ",
    points: "86.8,23.2 100,51.8  94.8,91.8 45,102.2 25,73.2 40.8,42.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "none",
    d: "M100,49.2c0,27.8-22.2,50-50,50"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 41.8,
    height: 38.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M35,33.2V75h8.2V33.2H35z M41.8,40h-5v-5h5V40z M41.8,46.8h-5v-5h5V46.8z M41.8,53.2h-5v-5h5V53.2z  M41.8,71.8h-5v-5h5V71.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 43.2,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 5,
    height: 26.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43.2,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 5,
    height: 26.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.8,
    y: 43.2,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 5,
    height: 26.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.2,
    y: 43.2,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 5,
    height: 26.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    cx: 61.8,
    cy: 39.2,
    r: 2.2
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#414141",
    enableBackground: "new    ",
    d: "M87.5,23.8V40c0,1.8-1.5,3.8-3.2,3.8H76l-8.2,6.8v-6.8h-10 c-1.8,0-3.2-2-3.2-4v-16c0-1.8,1.5-3.5,3.2-3.5h26.8C86,20.2,87.5,21.8,87.5,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.5,22v16.2c0,1.8-1.5,3.8-3.2,3.8H76l-8.4,6.8V42h-10c-1.8,0-3.2-2-3.2-4V22.2c0-1.8,1.5-3.5,3.2-3.5 h26.8C86,18.8,87.5,20.2,87.5,22z"
  }))))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-bacon",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M44.5,50H5.6C2.5,50,0,47.5,0,44.4V5.6C0.1,2.5,2.6,0,5.6,0h38.8C47.6,0,50,2.5,50,5.6v38.9 C50,47.5,47.6,50,44.5,50z"
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "5.5,21.1 11.6,10.4 50,26 50,45.1 49.9,46 49.7,46.4  49.3,47.3 48.8,48.1 47.9,48.9 46.6,49.5 44.9,50 32.4,50  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#FFFFFF",
    stroke: "#414141",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    d: "M39.9,39.8 c-1.9-2-10.6-4.8-12.4-6.3c-1.9-1.5-4.2-4.8-8.1-7c-2.5-1.2-5.3-1.7-7.9-2.7c-3.2-1.2-6-2.7-6-2.7l6.1-10.7c0,0,4.6,2.3,7.7,3.6 c3.1,1.4,5.9,1.5,7.9,2.7c3.5,1.5,7.1,6.6,8.1,7c2.2,0.8,9.7,4.5,11.6,6.5l-7.3,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "none",
    stroke: "#33424F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    d: " M9.7,13.2c0,0,2.8,1.5,6,2.7c2.6,1,6.3,1.5,9.1,3.3c3.1,1.7,6.6,6,8.8,6.8c2.2,0.8,9.6,4.4,11.5,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "none",
    stroke: "#33424F",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    d: " M7.6,17.1c0,0,3,1.2,6,2.7c2.5,1.3,5.2,2,7.7,3.2c3.5,1.5,7.6,5.8,8.9,6.9c1.6,1.4,10.2,4.1,12.1,6.2"
  }))))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-BPMN",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M45.8,50H4.2C1.8,50,0,48.2,0,45.8V4.2C0,1.8,1.8,0,4.2,0h41.7C48.2,0,50,1.8,50,4.2v41.7 C50,48.2,48.2,50,45.8,50z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M21.2,26.4L8.3,38l11.9,12H45c2.8,0,5-2.2,5-5V25L39.5,12.9 l-5.8,2.6L28.8,20L21.2,26.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 10.1,
    transform: "matrix(0.6913 0.7226 -0.7226 0.6913 21.777 -17.1368)",
    opacity: 0.5,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 2,
    height: 13.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A1E7FF",
    d: "M40,12.4l-3.1,3.1c-0.4,0.4-1,0.4-1.4,0l-3.1-3.1c-0.4-0.4-0.4-1,0-1.4l3.1-3.1c0.4-0.4,1-0.4,1.4,0 l3.1,3.1C40.4,11.3,40.4,12,40,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M36.2,7.6c0.3,0,0.5,0.1,0.7,0.3l3.1,3.1c0.4,0.4,0.4,1,0,1.4l-3.1,3.1c-0.2,0.2-0.5,0.3-0.7,0.3 s-0.5-0.1-0.7-0.3l-3.1-3.1c-0.4-0.4-0.4-1,0-1.4l3.1-3.1C35.7,7.7,36,7.6,36.2,7.6 M36.2,6.6c-0.5,0-1,0.2-1.4,0.6l-3.1,3.1 c-0.8,0.8-0.8,2,0,2.8l3.1,3.1c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l3.1-3.1c0.8-0.8,0.8-2,0-2.8l-3.1-3.1 C37.3,6.8,36.8,6.6,36.2,6.6L36.2,6.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    enableBackground: "new    ",
    d: "M23.4,22.6c-0.3,0-0.6-0.1-0.7-0.3l-9.3-10.5c-0.4-0.4-0.3-1,0.1-1.4 c0.4-0.4,1-0.3,1.4,0.1L24.1,21c0.4,0.4,0.3,1-0.1,1.4C23.9,22.5,23.6,22.6,23.4,22.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 22.9,
    transform: "matrix(0.6718 0.7407 -0.7407 0.6718 27.9231 -1.9914)",
    opacity: 0.5,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 2,
    height: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 14.1,
    cy: 11.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1E7FF",
    cx: 10.6,
    cy: 35.6,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.4,28.7h-16c-1.1,0-2-0.9-2-2l0-6c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v6C33.4,27.8,32.5,28.7,31.4,28.7z "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#009EEF",
    cx: 28.8,
    cy: 24.9,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    enableBackground: "new    ",
    d: "M41.9,39.8c-0.3,0-0.5-0.1-0.7-0.3L28,25.7c-0.4-0.4-0.4-1,0-1.4 c0.4-0.4,1-0.4,1.4,0l13.2,13.8c0.4,0.4,0.4,1,0,1.4C42.4,39.8,42.2,39.8,41.9,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#FFFFFF",
    d: "M38.5,32.6l-2.6,2.6c-0.4,0.4-1,0.4-1.4,0L32,32.6c-0.4-0.4-0.4-1,0-1.4l2.6-2.6 c0.4-0.4,1-0.4,1.4,0l2.6,2.6C38.9,31.6,38.9,32.2,38.5,32.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.95,
    fill: "#A1E7FF",
    enableBackground: "new    ",
    cx: 41.9,
    cy: 38.8,
    r: 4.5
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-community",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M44.4,50H5.6C2.5,50,0,47.5,0,44.4V5.6C0.1,2.5,2.6,0,5.6,0h38.8C47.5,0,50,2.5,50,5.6v38.9 C50,47.5,47.5,50,44.4,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "36.5,12.5 50,23.7 50,45.1 49.8,46 49.6,46.4  49.2,47.2 48.7,48.1 47.8,48.9 46.6,49.5 44.8,50 18.9,50 3.1,34.9 25.3,38.3 26.2,33.3 29,28.7 27.8,26.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M35.3,12.6L35.3,12.6c-2.8,0-5.1,2.3-5.1,5.1c0,0.4,0.1,0.8,0.1,1.3c-0.1,0.1-0.3,0.1-0.4,0.3 c-0.3,0.3-0.4,0.6-0.4,0.9l0.1,1.1c0,0.7,0.4,1.3,1.1,1.3H31c0.3,1.4,0.6,3,1.8,3.6c0,0-0.4,1.6-0.4,1.7c-0.7,0.1-0.3,0-0.3,0 c-3.9,0.1-6.9,2.9-6.9,2.9c-1.3,1.1-1.8,2.8-1.9,4.3c-1.3,0,25.4,0,24.2,0c-0.2-1.4-0.7-3.1-1.9-4.3c0,0-2.9-2.8-6.9-2.9 c-0.1,0,0.4,0-0.3,0c0-0.1-0.4-1.7-0.4-1.7c1.3-0.6,1.6-2.1,1.8-3.6h0.1c0.7,0,1.1-0.6,1.1-1.3l0.1-1.1c0-0.3-0.1-0.6-0.4-0.9 c-0.1-0.1-0.3-0.2-0.4-0.3c0.1-0.4,0.1-0.8,0.1-1.3C40.3,14.9,38.1,12.7,35.3,12.6L35.3,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M47.8,35.2H23.1v-0.3l-0.3-0.1c0.3-1.9,0.9-3.4,2.1-4.4c0.1-0.1,3.1-2.8,7.1-2.9h0.1 c0.1-0.2,0.1-0.6,0.3-1.3c-1.2-0.8-1.5-2.3-1.7-3.5c-0.8-0.1-1.3-0.8-1.3-1.6l-0.1-1c0-0.4,0.2-0.8,0.4-1.1 c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.4-0.1-0.7-0.1-1.1c0-3,2.4-5.4,5.4-5.4h0.1c2.9,0.1,5.3,2.5,5.3,5.4c0,0.4,0,0.8-0.1,1.1 c0.1,0.1,0.1,0.1,0.3,0.2c0.3,0.3,0.4,0.7,0.4,1.1l-0.1,1.1c0,0.8-0.5,1.4-1.3,1.5c-0.2,1.2-0.5,2.8-1.7,3.5 c0.2,0.6,0.3,1,0.3,1.3h0.1c4,0.2,6.9,2.8,7,2.9c1.1,1,1.8,2.5,2,4.4L47.8,35.2z M23.6,34.6h23.5c-0.3-1.6-0.9-2.9-1.8-3.7 c-0.1,0-2.9-2.7-6.7-2.8l0,0l0,0H38v-0.3c0-0.1-0.3-0.9-0.4-1.6l-0.1-0.3l0.3-0.1c1.1-0.6,1.4-1.9,1.6-3.4l0.1-0.3h0.3 c0.6,0,0.9-0.5,0.9-0.9l0.1-1.1c0-0.2-0.1-0.4-0.3-0.6c-0.1-0.1-0.2-0.1-0.3-0.2l-0.3-0.1l0.1-0.3c0.1-0.3,0.1-0.8,0.1-1.1 c0-2.6-2.1-4.8-4.7-4.8h-0.1c-2.6,0-4.8,2.2-4.8,4.8c0,0.4,0.1,0.7,0.1,1.1l0.1,0.4l-0.2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.2,0.2-0.3,0.4-0.3,0.6l0.1,1c0,0.5,0.3,1,0.8,1H31l0.1,0.3c0.3,1.6,0.6,2.9,1.6,3.4l0.3,0.1L33,26.1 c-0.2,0.7-0.4,1.5-0.4,1.6v0.3h-0.3c-0.3,0-0.4,0-0.4,0h-0.3c-3.6,0.3-6.3,2.8-6.3,2.8C24.4,31.7,23.8,33,23.6,34.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M15.3,12.6L15.3,12.6c-2.8,0-5.1,2.3-5.1,5.1c0,0.4,0.1,0.8,0.1,1.3c-0.1,0.1-0.3,0.1-0.4,0.3 c-0.3,0.3-0.4,0.6-0.4,0.9l0.1,1.1c0,0.7,0.4,1.3,1.1,1.3h0.1c0.3,1.4,0.6,3,1.8,3.6c0,0-0.4,1.6-0.4,1.7c-0.7,0.1-0.3,0-0.3,0 C8,27.9,5,30.6,5,30.6c-1.3,1.1-1.8,2.8-1.9,4.3c-1.3,0,25.4,0,24.2,0c-0.2-1.4-0.7-3.1-1.9-4.3c0,0-2.9-2.8-6.9-2.9 c-0.1,0,0.4,0-0.3,0c0-0.1-0.4-1.7-0.4-1.7c1.3-0.6,1.6-2.1,1.8-3.6h0.1c0.7,0,1.1-0.6,1.1-1.3l0.1-1.1c0-0.3-0.1-0.6-0.4-0.9 c-0.1-0.1-0.3-0.2-0.4-0.3c0.1-0.4,0.1-0.8,0.1-1.3C20.3,14.9,18,12.7,15.3,12.6L15.3,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M27.7,35.2H3v-0.3l-0.3-0.1c0.3-1.9,0.9-3.4,2.1-4.4c0.1-0.1,3.1-2.8,7.1-2.9H12c0.1-0.2,0.1-0.6,0.3-1.3 c-1.2-0.8-1.5-2.3-1.7-3.5c-0.8-0.1-1.3-0.8-1.3-1.6l-0.1-1c0-0.4,0.2-0.8,0.4-1.1c0.1-0.1,0.2-0.1,0.3-0.2 c-0.1-0.4-0.1-0.7-0.1-1.1c0-3,2.4-5.4,5.4-5.4h0.1c2.9,0.1,5.3,2.5,5.3,5.4c0,0.4,0,0.8-0.1,1.1c0.1,0.1,0.1,0.1,0.3,0.2 c0.3,0.3,0.4,0.7,0.4,1.1l-0.1,1.1c0,0.8-0.5,1.4-1.3,1.5c-0.2,1.2-0.5,2.8-1.7,3.5c0.2,0.6,0.3,1,0.3,1.3h0.1 c4,0.2,6.9,2.8,7,2.9c1.1,1,1.8,2.5,2,4.4L27.7,35.2z M3.5,34.6H27c-0.3-1.6-0.9-2.9-1.8-3.7c-0.1,0-2.9-2.7-6.7-2.8l0,0l0,0 h-0.6v-0.3c0-0.1-0.3-0.9-0.4-1.6l-0.1-0.3l0.3-0.1c1.1-0.6,1.4-1.9,1.6-3.4l0.1-0.3h0.3c0.6,0,0.9-0.5,0.9-0.9l0.1-1.1 c0-0.2-0.1-0.4-0.3-0.6c-0.1-0.1-0.2-0.1-0.3-0.2l-0.3-0.1l0.1-0.3c0.1-0.3,0.1-0.8,0.1-1.1c0-2.6-2.1-4.8-4.7-4.8h-0.1 c-2.6,0-4.8,2.2-4.8,4.8c0,0.4,0.1,0.7,0.1,1.1l0.1,0.4l-0.2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.2-0.3,0.4-0.3,0.6l0.1,1 c0,0.5,0.3,1,0.8,1h0.3l0.1,0.3c0.3,1.6,0.6,2.9,1.6,3.4l0.3,0.1l-0.1,0.3c-0.2,0.7-0.4,1.5-0.4,1.6v0.3h-0.3c-0.3,0-0.4,0-0.4,0 h-0.3c-3.6,0.3-6.3,2.8-6.3,2.8C4.4,31.7,3.7,33,3.5,34.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M25,10.2L25,10.2c-3.8,0-6.8,3.1-6.8,6.8c0,0.6,0.1,1.1,0.2,1.7c-0.2,0.1-0.3,0.2-0.5,0.3 c-0.3,0.3-0.5,0.7-0.5,1.2l0.2,1.4c0,0.9,0.6,1.7,1.5,1.7h0.1c0.3,1.9,0.7,4,2.4,4.8c0,0-0.6,2.1-0.6,2.2c-0.9,0.1-0.3,0-0.4,0 c-5.2,0.2-9.2,3.8-9.2,3.8c-1.7,1.5-2.3,3.8-2.6,5.7c-1.8,0,33.8,0,32.3,0c-0.2-1.9-0.9-4.2-2.6-5.7c0,0-3.9-3.7-9.2-3.8 c-0.1,0,0.5,0-0.4,0c0-0.1-0.6-2.2-0.6-2.2c1.7-0.8,2.1-2.8,2.4-4.8h0.1c0.9,0,1.5-0.7,1.5-1.7l0.2-1.4c0-0.4-0.2-0.8-0.5-1.2 c-0.2-0.2-0.3-0.3-0.5-0.3c0.2-0.5,0.2-1.1,0.2-1.7C31.7,13.2,28.7,10.3,25,10.2L25,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M41.6,40.3H8.8v-0.4l-0.3-0.1c0.3-2.6,1.2-4.6,2.7-5.9c0.2-0.2,4.1-3.7,9.4-3.9h0.1 c0.1-0.3,0.2-0.7,0.4-1.7c-1.6-1-2-3-2.3-4.7c-1-0.2-1.7-1-1.7-2.1L17,20.2c0-0.6,0.2-1.1,0.6-1.5c0.1-0.1,0.2-0.2,0.3-0.3 c-0.1-0.5-0.2-0.9-0.2-1.4c0-4,3.2-7.2,7.2-7.2H25c3.9,0.1,7.1,3.3,7.1,7.2c0,0.5,0,1-0.1,1.5c0.1,0.1,0.2,0.2,0.3,0.3 c0.4,0.4,0.6,0.9,0.6,1.5l-0.2,1.5c0,1.1-0.7,1.9-1.7,2c-0.2,1.6-0.7,3.7-2.3,4.7c0.2,0.8,0.3,1.3,0.4,1.7h0.2 c5.3,0.3,9.2,3.7,9.3,3.9c1.4,1.3,2.3,3.3,2.7,5.9L41.6,40.3z M9.3,39.4h31.3c-0.3-2.2-1.2-3.8-2.4-4.9c-0.1,0-3.8-3.6-8.9-3.8 l0,0l0,0h-0.8v-0.4c0-0.1-0.3-1.2-0.6-2.2l-0.1-0.3l0.3-0.2c1.4-0.7,1.8-2.5,2.2-4.5l0.1-0.3h0.3c0.8,0,1.2-0.7,1.2-1.2l0.2-1.5 c0-0.3-0.2-0.6-0.4-0.8c-0.1-0.1-0.2-0.2-0.4-0.3l-0.3-0.2l0.1-0.3c0.2-0.4,0.2-1,0.2-1.5c0-3.5-2.8-6.3-6.2-6.4h-0.1 c-3.5,0-6.3,2.9-6.3,6.4c0,0.5,0.1,0.9,0.2,1.4l0.1,0.5l-0.2,0.2c-0.2,0.1-0.2,0.2-0.4,0.3c-0.2,0.3-0.4,0.6-0.4,0.8l0.2,1.3 c0,0.7,0.3,1.3,1.1,1.3h0.3l0.2,0.3c0.3,2.1,0.7,3.8,2.2,4.5l0.3,0.2l-0.1,0.3c-0.2,0.9-0.6,2-0.6,2.2v0.4h-0.4 c-0.3,0-0.5,0-0.5,0h-0.4c-4.8,0.3-8.3,3.7-8.4,3.7C10.5,35.6,9.7,37.2,9.3,39.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-domain",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "49.5,22.9 60,39 60,60 27.8,60 14.4,41 31.5,33.1 "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    cx: 30.5,
    cy: 28.5,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 37.5,
    cy: 31.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 23.5,
    cy: 22.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 20.5,
    cy: 35.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "19.2,37 21.8,23 12,23 12,21 24.2,21 21.8,34.4 36.9,30.8 49,22 49.8,23.4 37.7,32.7 37.6,32.7 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 38.8,
    y1: 11.8,
    x2: 37.6,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "3.1341,3.1341",
    x1: 35,
    y1: 14.5,
    x2: 26,
    y2: 20.7
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "24.7,21.6 23.5,22.5 24.8,23.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2.8419,2.8419",
    points: " 27.2,24.8 37.1,30.8 42.9,38.7  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 43.7,
    y1: 39.8,
    x2: 44.6,
    y2: 41
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: 3,
    x1: 36.3,
    y1: 33.1,
    x2: 23.5,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 34.5,
    transform: "matrix(0.7866 0.6175 -0.6175 0.7866 27.6634 -2.8879)",
    fill: "#FFFFFF",
    width: 2,
    height: 8.1
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-equipment-broswer",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M41.2,45H3.8C1.7,45,0,43.3,0,41.2V3.8C0,1.7,1.7,0,3.8,0h37.5C43.3,0,45,1.7,45,3.8v37.5 C45,43.3,43.3,45,41.2,45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "35,12 45,23.2 45,45 14,45 9,36 35,36 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    points: "9,12 35,12 35,36 9,36.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M15,10v27h6V10H15z M20,15h-4v-4h4V15z M20,20h-4v-4h4V20z M20,25h-4v-4h4V25z M20,36h-4v-4h4V36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 17,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 17,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 17
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    cx: 31.5,
    cy: 14.5,
    r: 1.5
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-event",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M150,75c0,41.4-33.6,75-75,75c-10.2,0-19.8-2.1-28.8-5.7C19.2,132.9,0,106.2,0,75C0,33.6,33.6,0,75,0 c40.8,0,74.1,32.7,75,73.2C150,73.8,150,74.4,150,75z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M148.2,91.5c-7.5,32.7-36,57.3-70.5,58.5h-5.4l-40.8-42l36-59 l41.1-1.3L148.2,91.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65A8A6",
    cx: 59.5,
    cy: 93.5,
    r: 30.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B4D8D7",
    cx: 54.8,
    cy: 49,
    r: 18.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9AD6D4",
    cx: 83,
    cy: 75,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B2E0E0",
    cx: 109,
    cy: 47.7,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 107.8,
    cy: 99.5,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 122,
    cy: 78.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 83,
    cy: 47.7,
    r: 23.5
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-export",
    viewBox: "2.5 2.5 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M55.8,62.5H9.1c-3.7,0-6.6-3-6.6-6.6V9.1c0-3.7,3-6.6,6.6-6.6h46.7c3.7,0,6.6,3,6.6,6.6v46.7 C62.4,59.5,59.5,62.5,55.8,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M49.1,50.5h-32v-40h23.4L49,20.7L49.1,50.5L49.1,50.5z M18.5,49.2h29.4V21.1H40l-0.1-9.2H18.5V49.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#637582",
    points: "48.9,43.1 47.6,44.5 47.6,32.9 48.9,34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "49.1,21.1 62.4,35.1 62.4,56.6 62.2,57.7 61.9,58.2  61.5,59.2 60.9,60.2 59.8,61.2 58.3,61.9 56.2,62.5 25,62.5 17.5,50.5 49.1,50.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 28.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -11.1095 43.3201)",
    fill: "#FFFFFF",
    width: 2.4,
    height: 12.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 35.9,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 43.4253 -20.7572)",
    fill: "#FFFFFF",
    width: 2.4,
    height: 12.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 37.4,
    fill: "#FFFFFF",
    width: 16.2,
    height: 2.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-fiber-map",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "10,18 10,38 23,46 23,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "38,18 38,39 50,46 50,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "37,18 37,39 24,46 24,24  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 38,
    cy: 17.6,
    r: 10.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M30.4,20.5c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S31.5,20.5,30.4,20.5z M30.4,17.5 c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S30.9,17.5,30.4,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M37.4,27.8l-1-0.1c0,0,0.5-4.8-1.6-7.1c-0.7-0.8-1.9-1.2-2.9-1.2v-1c1,0,2.7,0.5,3.6,1.5 C37.9,22.5,37.4,27.6,37.4,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M45.8,20.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S46.9,20.5,45.8,20.5z M45.8,17.5c-0.6,0-1,0.4-1,1 s0.4,1,1,1s1-0.4,1-1S46.3,17.5,45.8,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M38.7,27.8c0-0.2-0.6-5.3,1.7-7.9c0.9-1,2.5-1.5,3.5-1.5v1c-1,0-2.1,0.4-2.8,1.2c-2,2.3-1.5,7-1.5,7.1 L38.7,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M42.6,16.1c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S43.7,16.1,42.6,16.1z M42.6,13.1c-0.6,0-1,0.4-1,1 s0.4,1,1,1s1-0.4,1-1S43.2,13.1,42.6,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M37.9,27.8c0-1.2-0.3-12.1,3.6-13.1l0.2,1c-2.3,0.6-3,7.8-2.8,12.1L37.9,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M33.5,16.1c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S34.6,16.1,33.5,16.1z M33.5,13.1c-0.6,0-1,0.4-1,1 s0.4,1,1,1s1-0.4,1-1S34.1,13.1,33.5,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M38.2,27.8l-1,0c0.2-4.4-0.5-11.5-2.8-12.1l0.2-1C38.5,15.6,38.3,26.5,38.2,27.8z"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "50,24 60,36 60,60 24.1,60 10,38 24,46 38,38 50,46 "
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-launcher-capacity-map",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M135,150H15c-8.4,0-15-6.6-15-15V15C0,6.6,6.6,0,15,0h120c8.4,0,15,6.6,15,15v120 C150,143.4,143.4,150,135,150z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M150,92v43.2c0,8.4-6.6,15-15,15H53.1L21.3,97.4L54,114.2l3,3 l36-21h3l36,21V61.7L150,92z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    points: "21.3,44 21.3,97.4 54,114.2 54,60.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    points: "96,45.2 96,96.2 132,117.2 132,61.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    points: "93,45.2 93,96.2 57,117.2 57,60.2  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M129,56.6c-4.2,7.2-12,12-21,12c-13.5,0-24.6-11.1-24.6-24.6c0-13.2,10.5-24.3,24-24.6v22.8L129,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M132.6,44c0,3.6-0.6,6.9-2.1,9.9l-4.4-3.7c0.9-2.1,0.5-3.5,0.5-6.2c0-10.2-8.4-18.6-18.6-18.6 c-0.3,0-0.3,0-0.6,0v-6c0.3,0,0.3,0,0.6,0C121.5,19.4,132.6,30.5,132.6,44z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-launcher-log",
    viewBox: "-25 743 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M5439.4,6190.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M19.4,793h-38.8c-3.1,0-5.6-2.5-5.6-5.6v-38.8c0.2-3.1,2.7-5.6,5.6-5.6h38.8c3.1,0,5.6,2.5,5.6,5.6v38.9 C25,790.5,22.5,793,19.4,793z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "13.4,780.8 13.5,753.8 25,768 25,788.1 24.8,789  24.7,789.4 24.2,790.3 23.8,791.1 22.8,791.9 21.5,792.5 19.8,793 0.9,793 -13.4,780.8  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M12.3,753.2h-24.7c-1.1,0-2,0.9-2,2v6.5h1v-6.5c0-0.5,0.4-1,1-1h24.7c0.5,0,1,0.5,1,1v24.4c0,0.6-0.5,1-1,1 h-24.7c-0.6,0-1-0.4-1-1v-13.1h-1v13.1c0,1.1,0.9,2,2,2h24.7c1.1,0,2-0.9,2-2v-24.4C14.3,754.1,13.4,753.2,12.3,753.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-4.6,768.6 -7.7,766.6 -9.2,767.6 -14.3,767.6 -14.3,765.6 -9.8,765.6 -7.7,764.2 -5.9,765.4  -3.5,755.7 0.4,764.2 3.2,762.6 5.4,765.3 10.3,765.3 10.3,767.3 4.4,767.3 2.8,765.2 -0.4,767.1 -2.9,761.7 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M-7.4,776.1h3.1v1.2h-4.6v-7.1h1.5V776.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M2.1,773.9c0,0.5-0.1,1-0.2,1.5c-0.1,0.4-0.4,0.8-0.6,1.1s-0.6,0.5-1,0.7c-0.4,0.2-0.8,0.2-1.2,0.2 s-0.9-0.1-1.2-0.2c-0.4-0.2-0.7-0.4-1-0.7s-0.5-0.7-0.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5v-0.3c0-0.5,0.1-1,0.2-1.5s0.4-0.8,0.6-1.1 s0.6-0.5,1-0.7c0.4-0.2,0.8-0.2,1.2-0.2s0.9,0.1,1.2,0.2c0.4,0.2,0.7,0.4,1,0.7s0.5,0.7,0.6,1.1s0.2,0.9,0.2,1.5V773.9z M0.6,773.5 c0-0.7-0.1-1.3-0.4-1.7s-0.6-0.6-1.1-0.6s-0.9,0.2-1.1,0.6s-0.4,1-0.4,1.7v0.3c0,0.4,0,0.7,0.1,1c0.1,0.3,0.2,0.5,0.3,0.7 c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.1,0.7,0.1c0.5,0,0.9-0.2,1.1-0.6s0.4-1,0.4-1.7V773.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M8.8,776.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.8,0.2 c-0.3,0.1-0.6,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.2-0.7-0.4-1-0.7s-0.5-0.7-0.6-1.1S3,774.5,3,773.9v-0.4 c0-0.5,0.1-1,0.2-1.5c0.1-0.4,0.3-0.8,0.6-1.1s0.6-0.5,0.9-0.7s0.8-0.2,1.2-0.2c0.5,0,0.9,0.1,1.2,0.2c0.3,0.1,0.6,0.3,0.8,0.5 s0.4,0.5,0.5,0.7s0.2,0.6,0.2,1H7.3c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.1-0.1-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.4-0.2s-0.3-0.1-0.6-0.1 c-0.5,0-0.9,0.2-1.1,0.6c-0.3,0.4-0.4,0.9-0.4,1.7v0.4c0,0.7,0.1,1.3,0.4,1.7s0.7,0.6,1.2,0.6c0.2,0,0.3,0,0.5,0s0.2-0.1,0.3-0.1 c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1v-1.2H6v-1.1h2.8V776.4z"
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-library",
    viewBox: "0 84 260 260"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M238.3,344H21.7C9.5,344,0,334.5,0,322.3V105.7C0,93.5,9.5,84,21.7,84h216.7c12.1,0,21.7,9.5,21.7,21.7 v216.7C260,334.5,250.5,344,238.3,344z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "217.5,170.2 260,240 260,344 104.4,344 42.5,279.2  112.5,279.2 112.5,289.2 147.5,289.2 147.5,279.2 217.5,279.2 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-75.9,123.1C-75.8,123.1-75.8,123.1-75.9,123.1L-75.9,123.1L-75.9,123.1z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M214.5,170c1.6,0,3,1.4,3,3v103c0,1.7-1.4,3-3,3h-64c-1.6,0-3,1.4-3,3v4c0,1.6-1.4,3-3,3h-29 c-1.7,0-3-1.4-3-3v-4c0-1.6-1.3-3-3-3h-64c-1.7,0-3-1.3-3-3V173c0-1.6,1.3-3,3-3H214.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M211,167.9c0,0-17-13.1-38-12.9c-15.8,0.2-35.9,4-42,16.7V275c0,0,25.7-28.2,80-10.4 C211,230.2,211,167.9,211,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49,167.9c0,0,17-13.1,38-12.9c15.8,0.2,35.9,4,42,16.7V275c0,0-25.7-28.2-80-10.4 C49,230.2,49,167.9,49,167.9z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-link-browser",
    viewBox: "0 0 70 60"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AA3E",
    points: "17.7,59.9 0.4,29.9 17.7,0 52.3,0 69.6,29.9 52.3,59.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    points: "53.2,17.2 21.8,16.5 13.9,40.2 29.5,59.9 51.6,60 64.8,38.2 "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    d: "M30.6,45.4l-6.5-1.8l-12.2-2.2l5.8-15h10.1l12.4,0.4L30.6,45.4z M16,39.1l8.8,1.6l4.2,1.2 l6.3-12.2l-7.6-0.3l-8,0L16,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    d: "M30.2,45.1l0-3L42.5,42l-6.8-13.5l21-0.3L51.5,45h-6.6L30.2,45.1z M45.8,42h3.5l3.3-10.7 l-12.1,0.1L45.8,42z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    d: "M25.5,42.6l-2.9-0.7l2.9-12.6h-8.9l4.1-14.5L44.6,18l-16,10.8L25.5,42.6z M20.5,26.4h6.3 l9.5-6.4l-13.5-1.8L20.5,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M56.6,31.5l-21.3-0.3l7.3-16.5l12,1.2L56.6,31.5z M39.9,28.2l13.3,0.2l-1.3-9.9l-7.4-0.7 L39.9,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57,29.9l-22.7-0.3L42.1,12l12.7,1.2L57,29.9z M40.4,25.7l12,0.2l-1.2-8.9l-6.7-0.6L40.4,25.7z"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-log",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M44.4,50H5.6C2.5,50,0,47.5,0,44.4V5.6C0.2,2.5,2.7,0,5.6,0h38.8C47.5,0,50,2.5,50,5.6v38.9 C50,47.5,47.5,50,44.4,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "38.4,37.8 38.5,10.8 50,25 50,45.1 49.8,46 49.7,46.4  49.2,47.3 48.8,48.1 47.8,48.9 46.5,49.5 44.8,50 25.9,50 11.6,37.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M796.4,748.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M36.8,10.2H13.2c-1.4,0-2.5,1.1-2.5,2.5v8.1h0.8v-8.1c0-0.9,0.7-1.7,1.7-1.7h23.7c0.9,0,1.7,0.7,1.7,1.7 v23.4c0,0.9-0.8,1.7-1.7,1.7H13.2c-0.9,0-1.7-0.7-1.7-1.7V22.8h-0.8v13.2c0,1.3,1.1,2.5,2.5,2.5h23.7c1.4,0,2.5-1.2,2.5-2.5V12.7 C39.3,11.3,38.3,10.2,36.8,10.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M17.7,34.1h3.1v1.2h-4.6v-7.1h1.5V34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M27.2,31.8c0,0.6-0.1,1-0.2,1.5c-0.2,0.4-0.3,0.8-0.6,1.1c-0.2,0.2-0.6,0.5-0.9,0.7 c-0.3,0.2-0.7,0.2-1.2,0.2c-0.5,0-0.8-0.1-1.2-0.2c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.2-0.5-0.7-0.7-1.1c-0.2-0.4-0.2-0.9-0.2-1.5v-0.3 c0-0.5,0.1-1,0.2-1.5c0.2-0.5,0.3-0.8,0.6-1.1c0.3-0.2,0.6-0.5,0.9-0.7c0.3-0.2,0.7-0.2,1.2-0.2s0.8,0.1,1.3,0.2 c0.3,0.2,0.7,0.4,0.9,0.7c0.2,0.2,0.5,0.7,0.6,1.1c0.1,0.4,0.2,0.9,0.2,1.5v0.3H27.2z M25.7,31.5c0-0.7-0.2-1.3-0.4-1.7 c-0.2-0.4-0.7-0.6-1.2-0.6s-0.9,0.2-1.2,0.6c-0.2,0.4-0.4,0.9-0.4,1.7v0.3c0,0.3,0,0.7,0.1,1c0.1,0.3,0.2,0.5,0.3,0.7 c0.2,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2c0.5,0,0.8-0.2,1.2-0.6c0.2-0.4,0.4-1,0.4-1.7V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M33.8,34.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.1-0.3,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.8,0.2 c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.2-0.2c-0.3-0.2-0.7-0.3-1-0.7c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2-0.4-0.2-0.9-0.2-1.5v-0.4 c0-0.6,0.1-1,0.2-1.5c0.2-0.5,0.3-0.7,0.6-1.1c0.2-0.3,0.6-0.5,0.9-0.7c0.3-0.2,0.8-0.2,1.2-0.2s0.8,0.1,1.2,0.2 c0.3,0.1,0.6,0.2,0.8,0.5c0.2,0.3,0.4,0.4,0.5,0.7s0.2,0.6,0.2,0.9h-1.4c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.2-0.2-0.3 c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2-0.1-0.3-0.1-0.6-0.1c-0.5,0-0.9,0.2-1.2,0.6c-0.3,0.4-0.4,0.9-0.4,1.7v0.4c0,0.7,0.2,1.3,0.4,1.7 C30,33.8,30.4,34,31,34c0.2,0,0.3,0,0.5,0s0.2-0.1,0.3-0.1s0.2-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1v-1.2h-1.3v-1.1h2.8L33.8,34.3 L33.8,34.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "20,24.6 17.3,22.6 15.6,23.8 11.2,23.8 11.2,22.9 15.3,22.9 17.3,21.6 19.5,23.2 22.1,14.6  25.2,21.8 28.1,20.1 30,22.7 35.3,22.7 35.3,23.6 29.6,23.6 27.8,21.2 24.8,23.1 22.2,17 "
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-maintenance",
    viewBox: "482 370 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M535.4,430.1h-46.8c-3.7,0-6.6-3-6.6-6.6v-46.9c0-3.7,3-6.6,6.6-6.6h46.8c3.7,0,6.6,3,6.6,6.6v46.8 C542,427,539.1,430.1,535.4,430.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "535.9,392.9 542,397.7 542,424.1 541.8,425.2  541.5,425.7 541.1,426.7 540.5,427.7 539.4,428.7 537.9,429.4 535.8,430.1 504.5,430.1 489.8,411.4 499.5,409.3 507.4,417.5  524.9,411.8 529.6,396  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1B7",
    d: "M531.9,400c0-3,1.6-5.6,4-7.1c-0.5-1.9-1.2-3.7-2.1-5.4c-0.6,0.2-1.3,0.2-1.9,0.2c-4.4,0-8.1-3.6-8.1-8.1 c0-0.7,0.1-1.5,0.3-2.1c-1.6-0.9-3.3-1.6-5.1-2.2c-1.4,2.5-4,4.3-7.1,4.3s-5.8-1.8-7.1-4.4l0,0c-1.8,0.5-3.5,1.2-5,2.1 c0.2,0.7,0.3,1.5,0.3,2.3c0,4.5-3.6,8.1-8.1,8.1c-0.8,0-1.5-0.1-2.2-0.3c-1,1.9-1.8,3.8-2.3,5.9c2.1,1.5,3.6,4,3.6,6.7 c0,2.7-1.3,5.1-3.3,6.5c0.4,1.7,1,3.3,1.9,4.8c0.7-0.2,1.5-0.3,2.3-0.3c4.4,0,8.1,3.6,8.1,8.1c0,0.8-0.1,1.5-0.3,2.3 c1.5,0.8,3.1,1.5,4.8,2c1.4-2.6,4-4.4,7.1-4.4c3.1,0,5.8,1.8,7.2,4.4c1.9-0.6,3.6-1.3,5.2-2.3c-0.2-0.6-0.3-1.4-0.3-2.1 c0-4.5,3.6-8.1,8.1-8.1c0.6,0,1.3,0.1,1.9,0.2c0.7-1.5,1.4-2.9,1.9-4.4C533.4,405.5,531.9,403,531.9,400z M511.8,415.2 c-8.6,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7c8.6,0,15.7,7,15.7,15.7S520.5,415.2,511.8,415.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M522.8,406.3l-2.9-2.6c0,0,0.4-6.4-1.8-8.7c-1.9-1.9-6.5-1.8-7.9-1.7c-0.2,0-0.2,0.2-0.1,0.3l4.1,4 c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.2,0.3,0.2,0.5c0.2,0.7-0.2,1.7-1,2.7l-0.6,0.6c-0.9,0.8-1.9,1-2.7,0.9c-0.2,0-0.3-0.1-0.5-0.2 c-0.1-0.1-0.2-0.1-0.3-0.2l-4-4.1c-0.1-0.1-0.3,0-0.3,0.1c-0.1,1.3-0.1,6,1.7,7.9c2.2,2.1,8.7,1.8,8.7,1.8l2.6,2.9l1.5,1.7l10,11.5 l0,0c1.6,1.6,4.5,1.7,6.2,0c1.6-1.6,1.6-4.6,0-6.2l0,0l-11.2-10L522.8,406.3z M534.7,422.4c-0.9,1-2.6,1-3.5,0.1 c-0.9-0.9-0.9-2.5,0-3.5c0.9-0.9,2.6-0.9,3.5,0.1C535.6,420,535.6,421.5,534.7,422.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-manage",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M54.9,59.9H5c-2.8,0-5-2.2-5-5V5.1c0-2.8,2.2-5,5-5h49.9c2.8,0,5,2.2,5,5v49.9 C59.9,57.7,57.6,59.9,54.9,59.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "51,26.1 60,36.1 60,59.7 30.7,59.9 11.6,40.2 24.3,47.3 38.1,39.9 51,47.3 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "11.6,19.7 11.6,40.2 24.3,47.3 24.3,26.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "38.8,19.7 38.8,39.9 51.5,47.3 51.5,26.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "38.4,19.7 38.4,39.9 24.7,47.3 24.7,26.1  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M46.2,30.3H30.9c-1.1,0-2-0.9-2-2V13c0-1.1,0.9-2,2-2h15.2c1.1,0,2,0.9,2,2v15.3 C48.2,29.4,47.3,30.3,46.2,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M38.3,26.6c0.9,0,1.7,0.5,2.1,1.2c0.6-0.1,1.1-0.3,1.6-0.6c0-0.2-0.1-0.4-0.1-0.6c0-1.3,1.1-2.4,2.4-2.4 c0.2,0,0.4,0,0.6,0.1c0.3-0.5,0.5-1,0.7-1.5c-0.7-0.4-1.2-1.2-1.2-2.1c0-0.9,0.5-1.7,1.3-2.1l0,0c-0.1-0.5-0.3-1-0.6-1.5 c-0.2,0.1-0.4,0.1-0.7,0.1c-1.3,0-2.4-1.1-2.4-2.4c0-0.2,0-0.4,0.1-0.7c-0.5-0.3-1.1-0.5-1.7-0.7c-0.4,0.6-1.2,1-2,1 c-0.8,0-1.5-0.4-1.9-1c-0.5,0.1-1,0.3-1.5,0.6c0.1,0.2,0.1,0.4,0.1,0.7c0,1.3-1.1,2.4-2.4,2.4c-0.2,0-0.5,0-0.7-0.1 c-0.3,0.4-0.5,0.9-0.6,1.4c0.8,0.4,1.3,1.2,1.3,2.1c0,0.9-0.5,1.7-1.3,2.1c0.2,0.5,0.4,1.1,0.6,1.5c0.2-0.1,0.4-0.1,0.6-0.1 c1.3,0,2.4,1.1,2.4,2.4c0,0.2,0,0.4-0.1,0.6c0.4,0.2,0.9,0.4,1.3,0.6C36.7,27,37.5,26.6,38.3,26.6z M34.3,20.6 c0-2.3,1.9-4.2,4.3-4.2c2.4,0,4.2,1.9,4.2,4.3s-1.9,4.2-4.3,4.2C36.1,24.9,34.3,23,34.3,20.6z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-metric",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M44.4,48.9H5.6c-3.1,0-5.6-2.5-5.6-5.6V4.5c0.2-3.1,2.7-5.6,5.6-5.6h38.8c3.1,0,5.6,2.5,5.6,5.6v38.9 C50,46.4,47.5,48.9,44.4,48.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "36.2,34.3 39.3,25.4 38.5,14.4 50,26.1 50,44  49.8,44.9 49.7,45.3 49.2,46.2 48.8,47 47.8,47.8 46.5,48.4 44.8,48.9 27.9,48.9 13.3,35.5 25.8,39  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M47.3,51.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    y: 22.1,
    fill: "#637582",
    width: 4.1,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 11.7,
    transform: "matrix(-0.9912 -0.1322 0.1322 -0.9912 41.3346 30.1642)",
    fill: "#637582",
    width: 2.5,
    height: 4.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M25,9.8c7.8,0,14.2,6.3,14.2,14.2S32.8,38.1,25,38.1s-14.2-6.3-14.2-14.2S17.2,9.8,25,9.8 M25,7.3 c-9.2,0-16.7,7.5-16.7,16.7S15.8,40.6,25,40.6s16.7-7.5,16.7-16.7S34.2,7.3,25,7.3L25,7.3z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M25,9.8c7.8,0,14.2,6.3,14.2,14.2S32.8,38.1,25,38.1s-14.2-6.3-14.2-14.2S17.2,9.8,25,9.8 M25,7.3 c-9.2,0-16.7,7.5-16.7,16.7S15.8,40.6,25,40.6s16.7-7.5,16.7-16.7S34.2,7.3,25,7.3L25,7.3z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 27.8,
    y1: 21.8,
    x2: 32.7,
    y2: 16.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M25.8,22.4c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5 C24.3,23.1,25,22.4,25.8,22.4 M25.8,20.8c-1.8,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2 C29,22.2,27.6,20.8,25.8,20.8L25.8,20.8z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#E8E8E8",
    enableBackground: "new    ",
    d: "M30.2,33.5H19.8c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2 h10.5c0.7,0,1.2,0.6,1.2,1.2C31.5,32.9,30.9,33.5,30.2,33.5z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-metric2",
    viewBox: "-10 -10 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M43.3,50H-3.3C-7,50-10,47-10,43.3V-3.3C-9.8-7-6.8-10-3.3-10h46.6C47-10,50-7,50-3.3v46.7 C50,47,47,50,43.3,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "33.5,32.5 37.2,21.8 36.2,8.6 50,22.6 50,44.1  49.8,45.2 49.6,45.7 49.1,46.8 48.5,47.7 47.4,48.7 45.8,49.4 43.8,50 23.5,50 5.9,33.9 21,38.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M46.8,52.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M20,3c9.4,0,17,7.6,17,17s-7.6,17-17,17S3,29.4,3,20S10.6,3,20,3 M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20 S31,0,20,0L20,0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M20,3c9.4,0,17,7.6,17,17s-7.6,17-17,17S3,29.4,3,20S10.6,3,20,3 M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20 S31,0,20,0L20,0z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.2,
    y1: 17.8,
    x2: 29.2,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 20,
    y1: 9.7,
    x2: 20,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 30.7,
    y1: 20,
    x2: 33.8,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 6.3,
    y1: 20,
    x2: 9.5,
    y2: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M20,18.2c1,0,1.8,0.8,1.8,1.8S21,21.8,20,21.8S18.2,21,18.2,20S19,18.2,20,18.2 M20,16.2 c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S22.1,16.2,20,16.2L20,16.2z"
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-monitor",
    viewBox: "-10 -10 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M43.3,50H-3.3C-7,50-10,47-10,43.3V-3.3C-9.8-7-6.8-10-3.3-10h46.6C47-10,50-7,50-3.3v46.7 C50,47,47,50,43.3,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "36.2,28.8 36.2,8.6 50,22.6 50,44.1 49.8,45.2  49.6,45.7 49.1,46.8 48.5,47.7 47.4,48.7 45.8,49.4 43.8,50 23.5,50 3.9,28.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M34.2,9.3c0.8,0,1.5,0.7,1.5,1.5v18c0,0.8-0.7,1.5-1.5,1.5H5.8c-0.8,0-1.5-0.7-1.5-1.5v-18 C4.3,10,5,9.3,5.8,9.3H34.2 M34.2,7.8H5.8c-1.7,0-3,1.3-3,3v18c0,1.7,1.3,3,3,3h28.4c1.7,0,3-1.3,3-3v-18 C37.2,9.1,35.9,7.8,34.2,7.8L34.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M31.2,35.8c0,0.8-0.7,1.5-1.5,1.5H10.3c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h4.5v-1.6h10.5v1.6h4.5 C30.6,34.3,31.2,35,31.2,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M46.8,52.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 17.8,
    fill: "#637582",
    width: 4.9,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 5.3,
    transform: "matrix(0.9912 0.1322 -0.1322 0.9912 1.1677 -2.0451)",
    fill: "#637582",
    width: 3,
    height: 4.9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "14.9,24.8 12.4,21.4 11.2,20.1 9.4,21.9 2.8,21.9 2.8,19.9 8.6,19.9 11.2,17.3 13.7,19.9 17.1,1.2  21.5,17.5 24.7,14.5 27.6,19.9 33.1,19.9 33.1,21.9 26.4,21.9 24.2,17.8 20.4,21.3 17.5,10.3 "
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-ne-browser",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    opacity: 0.5,
    fill: "#F1F1F1",
    width: 35,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 42,
    cy: 18.8,
    rx: 2.2,
    ry: 2.2
  })), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "47,12.6 60,28.1 60,60 18.6,60 11.5,48 47,48 "
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-orchestrate-config",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#009999",
    points: "12.5,47.2 0,25 12.5,2.8 37.5,2.8 50,25 37.5,47.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    enableBackground: "new    ",
    points: "39.5,16.4 9.4,25.7 21,47.2 37.5,47.2 47.6,29.2  "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.5,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    points: "32.6,34.7 19.3,24.1 35.1,15 37.1,18.4 26.4,24.6  35.1,31.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.7,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    points: "20.3,22.6 19.9,14.1 23.9,13.7 24.3,22.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.5,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    points: "22.7,26.3 11.8,25.6 12.1,21.6 23,22.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.5,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    points: "20.5,35.4 16.8,34 21,23.7 24.7,25.1  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 21.5,
    cy: 12.1,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 11.3,
    cy: 23.6,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 36.1,
    cy: 16.3,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 22.5,
    cy: 23.6,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 35.6,
    cy: 34.3,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 18.6,
    cy: 35.3,
    r: 3.5
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#009999",
    cx: 32.2,
    cy: 30.7,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.8,33.9c0.5-1,1.3-1.6,2.3-1.7c0.1-0.7,0.2-1.4,0.1-2.1C41,30,40.7,30,40.5,29.9C39,29.2,38.4,27.5,39,26 c0.1-0.2,0.2-0.5,0.4-0.6c-0.4-0.5-0.9-1-1.3-1.5c-0.8,0.6-1.9,0.8-3,0.4c-1-0.5-1.6-1.4-1.7-2.5l0,0c-0.6-0.1-1.3-0.1-1.9,0 c0,0.2-0.1,0.5-0.2,0.8c-0.6,1.5-2.3,2.2-3.8,1.5c-0.2-0.1-0.5-0.2-0.7-0.4c-0.6,0.5-1.2,1-1.6,1.6c0.5,0.8,0.6,1.8,0.2,2.7 c-0.4,0.9-1.2,1.5-2,1.6c0.1,0.6,0,1.2,0.1,1.9c0.2,0,0.5,0.1,0.8,0.2c1.5,0.6,2.1,2.3,1.5,3.8c-0.1,0.2-0.2,0.5-0.5,0.7 c0.4,0.5,0.8,0.9,1.2,1.4c0.8-0.6,1.9-0.9,3-0.4s1.6,1.4,1.7,2.5c0.7,0.1,1.4,0.1,2,0c0-0.2,0.1-0.5,0.2-0.8 c0.6-1.5,2.3-2.2,3.8-1.5c0.2,0.1,0.4,0.2,0.6,0.4c0.5-0.4,0.9-0.8,1.2-1.2C38.5,35.9,38.3,34.9,38.8,33.9z M30,36 c-2.8-1.2-4.1-4.6-2.9-7.5s4.6-4.1,7.4-2.9c2.8,1.2,4.1,4.6,2.9,7.5C36.1,35.9,32.8,37.2,30,36z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-orchestrate",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AA3E",
    points: "25,94.3 0,50 25,5.6 75,5.6 100,50 75,94.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    points: "78.9,32.7 18.8,51.5 42,94.3 75,94.3 95.2,58.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    points: "66.1,36.8 45.7,48.7  67.8,66.2  "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 84,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABklJREFUeNrsWu1OGzkU9ccMmZlA gaawKyTU//AMlfYl4HVKn4eXaNVnoOq/VkWbZWEp0JBM5sP2nmMmbLuluz8nKvdIbjz29a1zcr/s QSmBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgWD7oZd5TCOFhAf3NtoMQ+qO9gMCjV6/0 yclJ3Nf+/v6D+8N86ObD0cuXQd0RvBTE2iX5UfXR0ZHeurgw22zb25YoisLe3NxYPg8GA3t+fm6z LDOYMs+fP48sYo0+3N9Xr1+/XgoD6ZvQOyK3tkiise/fJ03TJG3bJm5jIy2USiGTOufSqqrYT4gS RPvbW12WpSk+ftQgXkGHPjw8XBD7KF0+kkn33tzcNDs7O/xxk0Wboq00jW3T1ILluE/0A/quTlM3 xKP6qo3HY3d1deVjGDg6Cn2FgD4tNFomyRwOh4nf3Ez9dDrw3mcNvB0bK5Rzq2ClCFqz5YixmfZ+ AJ9PwKL1da1hzbpeW1O2rhVCQfj06ZN69+5deGwWGq0Tn4bWOMvztCjLAfpZBQIT53Jvbe7aNjPG pN6Y+MMb7x0Ib2ySzI1zZWstF80wNYeOCjqazmJ9X1ZqeqET2fxkb09fXl5GN7fX1ysdmavBufUm hJFv221rzC9gZMd0jX2OcY4ylOUaru10JNRJ3Sr0Y6S2F+tEIclszgSErL1CN4e1kcwnRusNtKfw 3xHERiDmafB+E59P8DzUxmQKVguCDetRzAVnjEcocHB5D51+dzLxv71500uCSvr4FZmIkDxi+cM9 gNABUnnutF5FHNjwSj3DBElcB2kF6syVLj7VGJth7AYyJJWstta5uvG+xiPCr6Xbm65WDY+CUAKu qdVoZDVLIVpp0+SaVgoSwfQmxp95knrn0itd5U7Sbg3JNEbBohuQO8cPUuosK1kZVKurtrq8bPv6 Xr3EUJ6ARqORRrwxLI086kwknkEwJoc1DkHcE7QNkEVin8Iq6foj9jnGOcpEWazhWuqgLuqk7h+d sn46Qhfnc5yAdDafx0zPU1GwNu0sMdMh5JAbdta5CmuMbfHMOcpQlmu4ljqoizqp+7/uAn6+LA/s 7u4qtb7OYl0jc2tmGCQWq+9KpARPKRiJJIeuRcIxFucoA1mu4VrqoC7qjLp7Qm8x9PT0VOF8jprJ hhrxECYW4LpBIWvTuEgv/gmaoXNhangOnEOdGTjGhjUGn3XbMrsFN5+r06oCr+uPI4Yurt7whcM8 y0gUanjruoKcSaeGTMViPbYQSgjNQ9dfjHcyddfaToenTup+4Jrv561DeZHBkikUhUUnCW0bkxK+ /gDuO9Ask+7c3XTBkGRXGOep6AvGbtD/DMauwNw1mPyCYv/WpSmPSnWJLP/hwwffxxG0N5dHJg63 w6EbTqdwVlW3xpQ4mKPyUROUS3mMk3RxePOiDo1lk9YTEHyFUomZZ4I21UlSgv0aX6YN0InMFc7O zh5V2RTG43HA0cbTXacgDcmlBHm3tDjExUsQd4F4+ics9g/VtdjHWJyDDGW5hmupg7qok7r5fzye y5EQ9MHxsfn17dsElppOUP5kSTKE66/xfA7r3ABh68b7NdaZOF6mcbPGNCQP4WECYm9A5jVCxg0s dDKHda8htuLA0Jy9eNEeHxx4WvjjKJuQLPYR36qq8qgZXVKWTZjN5sjUUxIEoj5jY+dg4wxtDHJ/ Z2OfY3EOMpTlGq6lDuqiTupWuh9b6fWC+eDgwMA17RixvECNWdT1QBdFhgSTw1JzbI7vO1JYqO0s 1OFE1DDjg8zSIHaSzNnKSoVsVe/A5XGGd8fHx76vC2bTI6ExlpIAEkFCnEMVCYtj1k7gzsraSzDz F6yTMfMi9jHGOcpEWaz5msy+YucyWOj9RXN3+xRfyKGGvH8VwssOnD/NrPvhYcUeY/7r1x90c6xx CzL7fP2xDIR+Qypfh+D0BE9OjN3ZgU1e8FRp8jyP+yxLFgIIAFtb3o3HiAytZ8xchndJy0To/T4i sXt7GkklXprwio83R/+69gusYXkqgmxgAuqIVGoJ3s0v21+OfPfHDkhcfOkW+3sgEAnnPv4u2x85 LCOhD+7rn7uR77YblEAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAI/hd/CzAAA++GpmuG WmgAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 1 -14)"
  })), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 44.6,
    y1: 44.9,
    x2: 43.8,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 45.7,
    y1: 48.7,
    x2: 28.6,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 45.7,
    y1: 48.7,
    x2: 40,
    y2: 63.6
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    fill: "#FFFFFF",
    cx: 43,
    cy: 27.8,
    r: 5.8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 84,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABqdJREFUeNrsWstuE0kUrap+uR0H m3gCM0aIBbvkG5DmB1gmv0P4Hn8E4SPMGgVhAh4nTmynn1V3zi3baCIW7KZb8j1Sqbq7qtvVx+e+ ylZKIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCNoH3fp1ESnaXdS/LJeE0N+shUDg+/fv 9WQy0ersTJ3h2qdPn/zYyckJjcdjP/n09JQu3r0jtSG5NcQGbSHz4uJCHx8fG5BnptOpef36tQms DdZXV7xGw202mwWAefXqlWfxeDbT56en6vLysjXi0G0hkwkDkTpJEjMcDn+SmHU6Os1zv84sy4iO jpwzxtnp1NV17YqicLe3t84r9uKCmlarbguZ8/k8KEDkIE0D41yoiUK9WoXwm6aKIr/OqKqojCJ7 oFSttu3u7s72+30LF2HbQKpuC5lQZtjr9SKcx9xyNAzGIcye55Sbe5wJgiqo66oMw8IqVYZZVt2m aTUCuW0gNWwLmeFwGJfLZcekaacqy24cRZ26qjoUBJFzLoiMIQsoa8ta6xwsZ1EYZhjPu3jedBOo FJPapEKbCko+AMEHGvv8eTiM49hlWQriDrCgQx0EfafUwBANjNYD0rqvnOvB/LtoCQJTSBvlqhJZ QaeuKSlLenh4AL8BvX37lraB6n+HaeJDOTWCmnwAYp/JJs7KjKLoAI5xAPKG2tpnypi/rHMvFDdj XkB2I8j6T5D9DMQegdR+HIYHutvt1GkawZey2s3k5ERz/rovCtUMTo2eQ502CNhPplTXhw7KBGFH ZMxQO3es0WP+EGQOEKQOWaGgKUEf+KfwdwNZ0zZAwQHbqqrcy+XS/f3xo2pCpY34UE7aWaFsIRzN YfoJhWGKCz2kRJ5UmP0fUPJTkNXDeeQrJq0LkLvEccR0gvgaiihqa/OYqFBhWAajUaXWa4PPaCQw NROUUAHNr6/18ObGE2rDMILv6WCki5TpkH0myDxSTKwxPRCYgEjC3ALXY2JtOlfhngyMrXG25mcU eB/cz4GusezFNOBA1SlKSZDpFYpIHjhrI4TmGL6xg4agrXogsAeynmB+H+dPNB/v+o35H2zn8hcR 8zNiPEvjS0JhoM/OzvaD0J0NIiHXOSogEGSQeKL2cQH8ZgRF+lwUSmRfmdCGsA73fA7fmWhWLOep m7kh16P8LlwApGnq1cn1PzUQmExTpvHy5Uul+n2V4hiBCdzA+rk5p2mzrYSsibZbH8RRmwnyPehn f7qZi3sQl3Tckk2Jxgj98uULy1QhKrOMHDcwY8GahX+ssbASLHOBVEKVBXG/OyaqMK/iyA5p1vgy OJl3XJqi9qfdzpTeB0J3e5rIGSnfvLwLrEcFYhBXVI7+AQpcg9gVbliCwCXuuueer+F4heesQXgG dRZ8bx0EFuMuzXOaHx3RePNh+5GHokrSvA1H3W6AgxAmHBlrOXrHxLW8MSH7VhDCdl7jOquTCeSU 6Q79LZL6W1y7QWm0gBO9B5trlaY5ctqqm2V2dnlJ8KO0NyaPSEzJauV3jijPS6iSUyBW3p0nSql/ QOoPR/QdxH7D8bXaHH/nMRB5g3n3IHxdVlXe4SpUa07wHYoG4k2SvfGh25dFpmPZd7IPLGCyGSsQ AwuY9RwK/IF2DcKmOP8KIr/CpKc4v8acH/C3c5C9gLKXURw/sH9FUVAjB7Wj0Yje8W5+A4l9I5sj lx8++N327ufPKMO7GpWSTsLQ149Ga/BEFkqtTBDkYOQBLmAFAu/RL3B9oZl0KDkgukdQWytrM7iQ YoYH2cXCXl1d0fn5+f4olIMFknuC2XN0ru1gwD4yR3K5gmTvQdQNSJqhpPwO1X7DIqdgZ4oxr042 eSjzluL4Hupeu8PDfLVaVclWnU2Ze5Pbd37jgoMTRKWCslTu6VNy6zVx6gTUKknKEKWm2/jWh8C5 tQ88UKup63UYhmskqjkrM7+7q4qiqLdfkNvHDeafvnQymXg/OsrAW8KFkWJSYMe+LufqyUSogGDT zJDTUYR8IIaT0DX7zAUielIUtg1keuNruLDwO/e73SfevYfyDKdURa/H9aTp8A90qKi4COhs89Zd 4wDEP9KxmbeBzEbTpl1pzySMx2NP0PWbNzUS/qrX61VqPi8G8KsgLH+WJL5nP4uknZP/EqlRxark XzzbQmYbFPp4LUTqYvcnh41L+GV9E5SUajz27oJTo//8m4Ta8RLtg36820ePBx6Xk6QEAoFAIBAI BAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQPBb/CvAANJ30vlu1QdAAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -19 5)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    fill: "#FFFFFF",
    cx: 22.8,
    cy: 47.4,
    r: 5.8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 87,
    height: 87,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAYAAABxyNlsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAB4NJREFUeNrsWstuGzcUJTlvvSzV CZpHgxborvmGAinQbZbO78T5jX5CvM2yC39Bd/a6MAo3bRpb1mPeJHvOSGqdoJtuOm50D0DMaMgZ UWcOz70kpZRAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCD516P9N/7xX/vZF/UHXvZD7 L/rkQearV6/02dmZVkdH6un5+Qd9PfvmG69OTtTTp0/9y5cvvf6b7DtDdHDXiD0+Ptb379835+fn 5vLhQ/N1lpnA2mBQFMHNzU1QVVWQpimvmS/HY402+qc3b3iPfvHihTo9PRXlftwPKhXkGCiRfTI/ o3yFkud5AFWaKst0WpZdf8s09UlR4BbvBoOBRVuHtg5VDkr3r1+/dlsl+30nt1Mrh/9sNjOPHj0K VqtVAITGmDBJkiBXKiThURh2/W3alqS5gVItlGydc621th2NRvby8tJeX1872gWe6/skOLgrxMI8 g3vOhes0jTPvExCbomSl98MkigaubYfO2gFKBpmncRTFRdPEodadsgFdj8cqqGu1ePJEvYOC+7aJ 3smlv5LYL+CnMWCiKNVhONBBMLRKjcHcGHKdsBitRyhDFIhWpSA5tlqHOoqM8YhpRaFAshrmuYfy /cXFhYJ376VyO9W2bdsplsTaLEsw/gextSPn/UEYBAcgdQbaZki9psq5Ke6bKBCPY2aUSmgfaGNc EGgQrJok8RN48ng89ni2ev78ue9LvWFfzJJY+ig8FWKN6K9x2DSZj6IRiJqgbuqoWO8nIHWIgZ+A 1FBZ6Bn+ivMS9Wvj3AJ1Ma4FLawBavHL5dKBXIdne6RsrsvrtN4bcrtfiuCjGcBulIrwMUEZQo0T 79wMpB5iPH8GUg5wfYxrKbw1QvEgtUV9AdKWIDnDZ16ncl0AuUK2Le5pwzC0sx9/NMewhuMecuDe lMsg9uDBgy7VysIwcnGcgtiB3fjrZyYI7kGx98DZzG8UnOG2yMNdQWKD8xxqH4DgSNFvoWcovkHa UCP41SoMa1hGg5e3CZg9ZA1hj5agMSlglA/bOI7QkRSZwJABDCxMSTDa3INiDzHsSXjmqfDNNLgm uThPQLbG0SKSVWhT4KXkYdvm/G1IzYL379+3nOFxNvdfw/RpCVCWadI0iNuWthAHmyE+YtDCcboN ZDOQN+ssAsdd8TwaM9UMciCf92mkangZicNI2OXGh4eHmlNn2u4+kNtZAocrlKXHmz4w4sckhrkt rGAA0kZ6Q/QI5G2Otwrr0H6EF8DMge0zpGj07RgjIIqahpmQuZlMepsoGdUj4Ld6vemDMYj2zpgI xMQgLGGBahMwk8J7U7X9vCus1zyHNfDF4AnR1uZCnJhuylxV+mCx6MjlItDekAsv1IPBoJOdxbS2 JSHsD6xi2y8D4jr1cWagd/W3r2/rducIhoYezJz39nfRgvZKufBCD+X6NWcyyJ4gOee5+GJttwDT Fa1td3Suq/MfX9/W7c7BuIM9eIyCDwwWFuT3zhagXD/cEgO1WUwIGkT7GtGnYoFCK7BSQp2l2n7e FdZ7nmtdddkD7mVuy9LwRSDn5SQCntsRyzXfvUjFuGKFoeon+OF+NHJIYLnMVWOEc4mr0EyzjFmB xGE3uXDObNW562+N9rlmG+fW8N8cdlDAr0l2jReEcBZYeK+D5/a2ttAHufyxzBY88lyXlKWt07RB R2prbYFItEKDhWFe632MQl+1UGoJEqMdud0LcO4GpM5xXODFrKD+HPdVum2bQRhSxQ7e7t9+++3t nYpPe+GGCyncOWBAwxRVhwhQjiu4xgRc5WLA2sxmvYI66bUkqoYqS5QVaFqizHF+jeMV6q5A/pXT eu6tXWCGsY5hJavVqp5Op/bd6anvY3WsN8+lNSBV6nYSijhuMOa5EJPjbTN3ugJJf4Dc31Heguxf wcwlAz8C1qXbfH6LWPYbCH4HZb/H5zkmEUu8qNyEYUXvxUhwtB9+1z6tiv1lDRi2NssyWGRQYWiv fRQZqJUG6zWHv7U5xvSiWxVDfzFx4BSv7YKcRpq8sYQb6/0N7llhdlbY5bJW43ELuOvvv3c/HB15 tdmV2I/1XFrDs2fP1Hw+5zS4S1e5FgvifAjFQZ0WNsEMoEJlgeMaadoKxwVy4TmOc/jGHKTPwRq9 dxlYu8ZbKsdJQuU2eLb7uizd6Xff9bf01+eC+dHR0Qc7EVwwxxvnChkXcrggniL6J1BsdMvGHEht mB3QTlBfmKYpYBMlSk2s1+uWe2knJydO9bSPZnomt/NedXZmfzk4sCSlIllVtdZ1vQydm7cIVJD2 Owz7328XXmMd27AtSM3tdFryGXzWbpOyz9/W+/8WaA/cSOSGIve9Ph+PfVkytinOwtosjuuS67fI gaM4Lg09VakCBJdD2AV8tQKxFY41PrdXV1e2vLi4E7u/8r+FT9kWdtkDt2+2/kiCLMhqLx8+bEBe lT9+XE7BKVK3rvCc11jHNmzLe3gvn8FnqTvwtyb5r9iekfvP/fsf/stRIBAIBAKBQCAQCAQCgUAg EAgEAoFAIBAIBAKBQCAQCASfPv4UYACAEHWoj9RAJgAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 28 -10)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    fill: "#FFFFFF",
    cx: 71.9,
    cy: 33.5,
    r: 7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 89,
    height: 89,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABZCAYAAABVC4ivAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACFtJREFUeNrsWslu3EYQ7YXrrFos GRICG4lv0TcEcIBcfVR+x/Jv5Bf0EzoHSAAfLORmwEDGjpWRNNIsHLKXvGpy5DESBMiJ40w9oMSe 7h4O9br4uqpIIRgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwfiyIb+U6/Peh+OrV69C 38uXL0OHlJ/9C55J/i/XBVLPQOibN2+kOD0VJ5eX/3itb7791ovzc3FycuLPiPia9I0iW2/gosuz szN5cHWlzOvX+tmzZ0r/9pvudDp6MpnoLMsium60Fdo0pp4+fSpHo5H8pijEjycn4uLiYqMcaJM8 OZBLnru7u6vSNFXR11+r5d2dhieofVhRFBLEhmtG26Ptx0I4C0sHA2vevnXL5dLd3Ny44NlnZ34T vFpuEsE4KjLy2OFwqEFkDM2NyEyS6A7GqqoK1xzHsZ+D3KgsLfTakIH0Ct+1+C54F45sE4iWm0Tw eDzW+/v7epFlMZhOVLebWGNSDCYwkomoWQjRkGh8baWOoqWbzUo3HJZ5UVQ4l8W57CYQrTeJ4CdP nkT39/dpLkRWCNEFmz1hbV96P9DODcHSABtiH9aDdZW1OTw4QTum/8VHkcyNkbgDxNHRkf/w4YOA lovnz5+vdHoLSfY+bHCHV1e0sQWClVJZpXUPxBK5QyXljtB6FyuxC9J3vFJDRBADBaK9lB2vdYr+ WDinQbiSMfi21s/ncz8YDMjbPXTeX15ebqUnyzOILUUQzrloZ2cnQV8gOIb3Kq13vHP7Uut9SUfv 90HqHpENI6+mhYBMi1QoFSvyZK2lM0YgBHGJ1g6y4+bjMbq1f/HihW/Lm6P2nJjC23MJmVDYxKKJ Ay/G5CqKehbeC2L3QF4gFZ5L3ttDO1tdM60P/hTom+LjBB5Ouk1Ei6osndHaqmYTNMY4xNMu/KiU W+PJkvAaXvz48ePIWptkUuZLSISGHJDXgpBHmHWI4yFoOYAXP1p5MayPc3QxTqTTHRDB65VUyilH EZ0waFsE0qaaz53/6iurf/7Zv/j111a8uTVPpngYsayEdpIex4aiCNJY5/rw4KG3dk/UxD4C0bsN sZn/dM0GfQt8zjEvhpaHPnh0ibugcNYWYLvAOUuKtY+Pj23IHluIMlRbUkEE0++XyOQQ+8Y2ilJo Zy5JaxFFgJwdVZO759cM/btkRLwnSUEftRsbYgPsg+guSUsI/RBjH9bRS0jP20AbJEsq8lAaTL+/ U19D1MTCdPvTZtYDOeS5A7JAOkUb6McC9WnTg/f2Pc1p5lGbxiATXUhGjgVL4c0xJTH0O4iZJdU/ VoWm/70nrzCdTiXSYG3jGNuUjeGZaSDa+7whOxgIzCEhtACfGc0FaTmNS5pDVvelkJ+QwMRVFUie DAatJV6qLT2GRsp5ryerNJXY/rXTVKLABoZwTNReTRta4qlNycbKSJPXjiA3pnEs0MM8hH0RNFpj EsJsqbCQcnh3J9dLpVvjyYfEYlnKKIqCdOBWf6hfNJ/V+udQPEYCA08Nx/AZUYWoyfz0XWsVFkti 4T4jtJGo7ZKLj7AySTxubQ/9BG3gz7lwpJqDb4o8kIpw9LWgOkl9NLf5/DdDIoIIwyPt/kyAcff4 rSGZypCjoyPfmU59vFz6FMQgw1vFtxVxT0Uf0Ri4rOC5FZyVxkww+kzjCNlW49QG+RXCvzCnqhfG pWnqocmB4NUTle3w5F9+Eb1eL3iiiZCPgFyQQ+QWkIAF+udk0IFZaCs1B5ELEP1gggx96+OQCoqN l4rOR0THcajEQZNbq120kYzQP0sbn59MJp7SXrBp0qoqDSUPIAzefI85dyCtQ1U2EKbgkiQFFT6T gPvGowsQHeai/x4Lcu+wKHQOZJHLOElKt1hYkSQOcbL/8N13Xm5LWk2p7cHBgUSmFzaryPsQxoma wAieHKIHigyaDc1jzFK9gry0qVnMwPQ92hO0b9A/RnsMpb7GIt3As+9wnCEVXEy73XIHd8vVxUUr 1bjW5IJ0mR4VgWi7SJIKad/SN14Mr7wFSWMc/0TfRzKQ+AeIfjDqE9RH40p9pLnOuRt8f4KxqTJm AbclTTcWGyEiC0+/uU1VuAfJoCcYeZ5Xy05nmRkzr6yN4L4a0YF0tQcTUaS/q4LQeu2iALkzzJkI 8l4hrnHiWyIZafpCzmalSJGXvH3rbn74wf10eupF/ZRkO+rJJBn0xOL29lZSHhIjGjNpKhIHaqOI tNNJkgjoMG63JYgsfL0ZToNeg0yM3yiSCZCL47UG0dKYO0jE1JXlHJ69nM/nZgFdflYU7uL779sp OYp2IU9PTxVuY914aIJQItOUSlvbjbSmQk8vpNbO5SEDRCYXvliXNEvIQ4guyHuNtTOs2AwD8y5t inUIaJBh2vPzcydaes6nWiY5aPNF81CUSEFsW6iynOVaT+CVNxj4E0T+ATl4D4ZG2BR/Jwtt9NFY mIO59B36brVGMO4Y15YWb4onh2tYfx1gBI8+hmFTpLpEghAkKYsiQeodI5rWZeMYCcXXSGCQLVZJ lpV+PqekpETiUeEc5rhetI14LWAj3iBa6TM98MyRYvf7fV8Mhw7xbcgC9XJZIUIokbBQ7FsobGpl XbBfxMYUPk0Ll2VLg1AtqSpzPxqZd+/eucPDQ8/vXfyDR6+emKwXhujpSaim5bnMiqJ+gyjLfLpY UPkihIHrtQtaLH6D6D+QPTo6ksfv38vx3p7cv76WyBLDNSNT9Ojz6At1EMzxm0buJpP8cF1UZHv1 L292rr/RSYWftZTZb9w/s+H4dI0g3a93fgHvJjMYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAw GAwGg/F/wF8CDABCl9UOwiKNIgAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 0 3)"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 45,
    cy: 47.2,
    r: 7.7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 87,
    height: 87,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAYAAABxyNlsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAB7RJREFUeNrsWrlyG0cUnGtPHAR4 qCxYLqukzAycKVagVKH0O5R+Qh9hpv4ApU6cgaldqhIlW0USIAHsNYf7LUCZctmBo4WN11VTuzuz Sw4aPT09sxCCwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBj/d8j/TP9CEOFupfyi64HJ /Rd9CiDz9evXcjqdSvHihTg+O/uir9Pvvgvi9FQcHx+Hk5OTIP8ke2uI1ttG7KtXr+TR0ZE6OztT 5/fvq8dZprRzOi8KPZ/PdVVVOk1TqlPfDgYS98iff/yRnpEvX74Ub9++ZeX+tR+kVJCjoETqk/oV 5SHKarXSUKWqskymZdn2t0zTMBLCi03BvX6Jcry5xhcUtkHBclvUSsN/PB6ryWSiF4uFBoxSyiRJ oldCGCI8Mqbtb2NtMFHk4qZxuLRU8IyDqi2Kv7q68qenp75rgvW2EAvz1Ifem2WaxlkICYhNUbIy hF4SRbm3tuedy1EyyDw1TRPXSkUNPkMN4vtxTMTL/f39YK0Vjx49ErCWnfbc1l+J2Afw0xhQUZRK Y3KpdQ+yHMATBjgO0dGhkrKP0jNaZw4Ea6ViAz/W3utSKZlHkYCNhFuCnz9/Hrr0YN21akFCq1gi 1mVZgvGfx871fQh7IHEPchzDc8eIXiMolq4HgUgWIoOKE3wRJkDiJNvQNAGTXSCCAZ/nuXj69Gln k5zpilkilnwUngqxRuSvMYZ6FqKo77Ueom0E0xyC0CFuzHGegkQjnBPS+wZmWkK5i+B9JvEsyFae lAuOQaonTMlzp9POJjfV5UR6fn4uDw4OdJPnkQPLIKeHhiEIG0vnDoNzX0Gl9xF6vwahD9D2ACp+ gDo6TpxS91F3D/cf4DjCh+nH1mZIDnG/39c9fD5KH5REdskWWq8djUb0/6ME/ingsbggfx2DzEOl 9RHajkDiEag5xPk+zvfQNoDKcxxTEGqgWknsQdUO19YrRemhiXCOuOaQgz1ycCfeazq0BIlFgaK4 ZeM4QkdSeGiPJjCQOcIN+7jnsFWlUkPUZWHTX9TVIHqJe6JWlSAUxwrWUUC9K9TH9NkoI08+fLBt GunAGlSXloAsq5o01RjKEJqIcZ2BoD7OhziOwnoiIyW3kxqsYZ+u6RxkjulLwPUeyB7CRvooOZ5N Df4eZWNafCA5tMvnnZnQSEmblVg7qVkiAuSCJMq3GcikYQ/LFP2wJrvf1q37S1qtN3sJDUgGjyKH raQgP8HfiGAUJifhYFV3eXkpj1F+wFNSyv+9cj8Dw1Yu131QsAQNv4yIHBCWgMAUbCQgJCE1ivVQ jzdDPgbFye017mmfk2vyDZKvLvA3yySR8+Gws1VoZ+ReXFxIRCZJ8nTrZS1lVSXulPY6BN1eQ9Jf 1Ms1PtdhYvPruNsiQ9lD+aZD8XSWcxHB1mEfQT+xNjgpPdTqJRUpEWalo6xKR+IficBtxjXdZykZ QOHu87n3lBbo2mvnQqG1KOdzUVWV2Nvb2y1yCVAuzeDtjhZmMyewOMBEVsMzK1ok0AYYCCvD2gpo ujdqTW5NbSC7QHsBdZdQboVc3KDOwhYwGIyLsFqjFVs7i0q5G+TSBjfSQhgOhyH0+z6jfArCMKwr RWR5v5S0+pLyhnLw5s1DA/Vq1AUcK9QsUK5B7E177twKBBawjwpr6gYfzF3QFuTFRfj48WPYFeXS B5WTySQg5/qkLF2dpk1CpHi/8rekkW2GQJMVPWBp0dD2NwTaSqxRtwDJM7Rf4XwO8m/whSw9qT1J apBtk17PIWoQubuzQqPVEr05oAkNw5d2sxRUq0EcDXsVaBJDRpXrL4K8loZ7hfqCFI37rqHQK7Rf ou4SbRdqTfJMWXsTrF0hMFRFltnLX37xjx8/9l2s0DpLC2QNtLENgh0iU4PhXjbWLkHQNYi+gjV8 Amm/gTwa0+dUoNL3IPa9oKP3H6gdH+D3QCSDWFKzNabAPEiebC2IvXr2zL86Oelk86arCe2zNSCS OSSHBtdVZMyycI4yF4xVOthEjfMlyMqh2CSsY5nHeQN5F57alCIVz1XTXEOti7quC8SMGpZDbyb8 8dlZOJVyd2zh1hpor3U2m8nBYNDWVXEcUvJUimBaWxxaO6BEEGgvIYQFiLwG6TMQPEP8msEO5g5W 4JtmURmzymAHURRhVZ26d+/e+Tdv3nS25djpmwgimF7H2O+/F/79e9GLojaalUrRpGWxbmhAcIVS aprspCS/XaDT10GpGyiUygLGvUB7UYHYdB3TLP62f/Lkyc6+iWgDFr0Of/fTT0KDiMFi0S4smijy cV3b0nurjamV1iVWDIWCMkXTrNodMcQ1WMOKCqIXbDupLs/PG4wC2nL0Dx8+7PwtcOe/WyBl3RJM 773o9cw4z/1Ma581jU2NaTyMFCRWWBxUwZgSsa3El1BlWVaiqcZzdRzH9ubmxpIV3Lt3L2zD6/Wt +d3CnX1eRduR9PoHMU3pyUSpT58UxbaiKNr7VlkWDu78buG2TKfTQCmEf7fwD/3ZEHx3W1LdbvT8 dW+CVnmUOLaN1G0l9++ULDZvEv42K2/r78S2mdx/078gGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwG g8FgMBgMBoPB6Ah/CDAAukI2NJ9A3rcAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 24 24)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "#FFFFFF",
    cx: 67.8,
    cy: 66.2,
    r: 7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 87,
    height: 87,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAYAAABxyNlsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAB8FJREFUeNrsWk1v20YU3A+SIinJ siRbgA0ULWKkh/iYP5BDrjnafyfO7/E1d+eaQwr4ICO3JG1iN3EkR7YskSJ3t/NWUuqkvfREpXoD LEgulxQ1HM57b0khGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPxf4f8Ya7POeHudspv Lt0xuf/hmhzIfPbsmez3+1IcHIj9s7NvrrX/4IETx8dif3/fPX361Mm/yV4ZovWqEXt0dCS3t7fV 2dmZOt/ZUXtJorQxOp1O9Wg00nme6ziOqU/93GxKjJG/PX9Ox8jDw0Px4sULVu7310FKBTkKSqRr Um/RfkGbTCYaqlR5ksg4y/z1ZnHsNoWwYtEw1t6i7S+2cYPcKihYropa6fFvt9tqd3dXj8djDQRK qaBWq+mJEAERHgaBv96iLF0QhiYqCoPNkhqOMVB1iWavrq7s8fGxrZpgvSrEwjz1lrWBbbfDoChq IDZGSzLn6rUwTG1Z1q0xKVoCmccYE82UCgv8hxmIb0QRES87nY4ry1Lcu3dPwFrW2nO9v5JiidgI gKkSsYmLojpk2YQnNLHcwIVuKCkbaPVA68SAYK1UFMCPtbU6U0qmYShgI25J8JMnT1yVHqyrVi1I 0GQFCFJRHoZx6Fxqw7ChiFClNiHHNjy3jdRrE4ptYbvpiGQhEqi4JoMgcLgbJFtXFA7ncUQwYNM0 FY8ePaosyAVVMUsBDL4oB4OBouu4ESLCxZAVNJQxGwZkYkwLRDYxgCwhdovrldYWWM9A/thZm0go GGOUJeXi1CDVEvrkuf1+ZcGtKuVKwunpqY7v39dxnkeqKBKhdUMo1TJKdcD+ltJ6C+RuQ7FbOKYr Sb1Sbri5PcSWSHVO4ybQ6RzUa4KyNFOlDDzYgGj7a6/nTk5OHHLm9SGXvHZvb0+B2DCPohpCewr1 NYW1RGBXWbsNuRGx2yCNyO1g2cKyCXWnID/GdgDVSsrjYA0G2yUIp+yhCLGOdM0gD7bIgyvxXlWV LRyg6qLfn6I4ADlBDFtwlAkI0cCj3oKC24JIhXJBck8ulujrYX+P+ol00NoFsW2yEAS+BvqI9Iis hnLk3YuLeTZSAVRVfos0SaLiosdZEblIpyKsx9hXx6PeJLKgSQpgPqhhu7MIbD7AYbtt0UD4JtqG nBOb4vQxrCEkcuncyBx8+bw25NKcwfn5uWy1Wp7cEBkDAhYRQoqL4aAUpFKQ1hCk5Dlx9e+2Gzi2 jjtVR1/qA5u1NSxDxLKwKAqdoKobDoeS5iXohq6NLRBQVUlUYL7cpVyVPBTEhiAtAhs1sWjor0Gx NTlfn+9DMHO0jSX1wRqQxTmvWBFFKgxDmeHco42NyqrQKsj1f/bhw4d+A+Uq5brSzlNVtUhZ1bKB bO2XyApo7919kvqtVQiCCqql0CbpeG2MhHIlgqX8qULxVEGufz5fvXrlN6Bc5+sAa6mf0lMn7kzK QKXGL6U0INL3gXBDI6FmQ/2LsWZ5PGo2V4ahg3LdHxWSG1RpC41Gw0G5DgRb5LYGd7oEmVQgzKDS nITtm3MZmgKZlqKhnO/PQHaO9RzM5zhuBu0WoLeEck2EohiPhYN63TopV9DkNkpeh2zBl6lFEBgU DIUg0lB5gagpiJuAuDFZs1ss0X8Dgn3D/rGkdVRp6L/1x+BYnG+GVs7C0Ct50Ok4mliXUq4HufRH H+API1vw5OKfl0gTiJQM+26hxBssRyDrCwZfYf1KLBrG+AZzHfptGiPEyBMtxIQIpps0m09H2u5w 6N9YrFX5S63X60lEdVUGgS6N8fO3eOyp6tIIUNrN35RZqrywRs83zZbfol0TqVgOMX6I8QNBhEv5 Bes3wpjJTOschUmBCs3sJYldqwqN3n0h13VIlUwNOtNFQeRNiBwizmn9GeufoOKPIPYC5F2AzHOk XL4p6sM+jLmEzw78MbAOVZZTsgbUwOVb3BhUaP4dWxWTN5VNOZ6cnIgsy8Tb01OZpqmcaO1dMTDG 511gwsFHS6wVUPFX4km1IPPLwhKGbq5eUizZyE2k1ARpWL4RBMVkZ6f8/eVLd3h4WElQq0y55Lso gSlboDSqbMInYZIZUqlxqfWIHnVSJS7wTwz+AAI/gKH31OS8nYPkj7CASw1rwEmuVVHcUkC8juNi MBgYUi09Ies4We4nsel1DL01oLQ1nJeoFsqF42oKSDOszdA71Vr77AGNgt01sq1r5JEjkH9TaD0G uZNYax/MLnGzdtPUB7QqX1ZWWv4uvZdeKL5vtcwMMJubpN6JnM1uUGaN4L0DKPNzAYWCwE/U5Fyt n0HqFUgfIXCNU5A7rtdzpF5FdH5eObGVK3epXvre4LLfB4/adZLEwYuXFVcZwzszKg5QVCDoZSgO plBthixjavI8g+pzuimTbrco3r0zXVRszWZzJV6vr/x3C8t5BCSzanMxeErvybLMdaFOyjbKN28s effjx48t+fiqfLcQrAi5ywrKErl9qBhLS1/T0GQ3HnWJYuCrEBJkGZMBsq9u192+fu2uQOo+SD04 OFieZyU+afphvhWj6e6zxfdiVN0dL6ou8uwjymNXiNRVJvffr+/uV47/nCdwgsFgMBgMBoPBYDAY DAaDwWAwGAwGg8FgMBgMBoPBYDAYjArwlwADAJDQdTzjUfgAAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -5 25)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "#FFFFFF",
    cx: 38.9,
    cy: 67.3,
    r: 7
  }))))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-pm-browser",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M150,75c0,41.5-33.5,75-75,75c-10.2,0-20-2-28.8-5.8C19,133,0,106.2,0,75C0,33.5,33.5,0,75,0 c40.8,0,74,32.8,75,73.2C150,73.8,150,74.5,150,75z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M148.2,91.1c-7.5,32.7-36,57.3-70.5,58.5h-5.4L34.1,110 l18.8-58.8l55.8-3.9L148.2,91.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "none",
    d: "M150,73.8c0,41.5-33.5,75-75,75"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F2",
    cx: 53.5,
    cy: 59.8,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F2",
    cx: 43,
    cy: 104.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F2",
    cx: 101.2,
    cy: 88,
    r: 10.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F1F1F2",
    points: "35.2,110 49,58.8 56.2,60.8 46,99.2 100.2,84.2 102.2,91.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2,
    y: 57.5,
    transform: "matrix(-0.8418 -0.5398 0.5398 -0.8418 67.6393 142.4169)",
    fill: "#F1F1F2",
    width: 5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F2",
    d: "M83.5,84.2l-7.2-4.8l4-6.2l7.2,4.8L83.5,84.2z M69.2,75L62,70.2l4-6.2l7.2,4.8L69.2,75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 83.3,
    transform: "matrix(-0.8417 -0.54 0.54 -0.8417 127.9744 211.5808)",
    fill: "#F1F1F2",
    width: 5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.2,39.2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.5,70h-30c-5.5,0-10-4.5-10-10V42.5c0-5.5,4.5-10,10-10h30c5.5,0,10,4.5,10,10V60 C132.5,65.5,128,70,122.5,70z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#009999",
    points: "107,66.5 100.8,55.8 99.2,60.5 83.2,60.5 83.2,55.5 95.5,55.5 99.5,43.5 106.8,56 110.2,49  113.8,54.5 125.5,54.2 125.5,59.2 111,59.5 110.8,59 "
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-quote",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.4188,
    y1: 48.3688,
    x2: 1.7625,
    y2: 1.7125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M44.5,50H5.7c-3.1,0-5.6-2.5-5.6-5.6V5.6C0.3,2.5,2.8,0,5.7,0h38.8C47.5,0,50,2.5,50,5.6v38.9 C50.1,47.5,47.6,50,44.5,50z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28,24.1c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.6-0.4-0.9-0.5S25.5,22,25,21.8 c-0.7-0.2-1.3-0.4-1.8-0.6c-0.5-0.2-1-0.5-1.4-0.8c-0.4-0.3-0.7-0.6-0.9-1c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.5,0.1-0.9,0.3-1.3 c0.2-0.4,0.4-0.7,0.8-1c0.3-0.3,0.7-0.5,1.2-0.7c0.5-0.2,1-0.3,1.6-0.3V13H26v1.9c1.2,0.1,2.1,0.5,2.8,1.2c0.7,0.7,1,1.6,1,2.7h-2 c0-0.4-0.1-0.7-0.2-1c-0.1-0.3-0.3-0.6-0.5-0.8c-0.2-0.2-0.5-0.4-0.8-0.5c-0.3-0.1-0.7-0.2-1.1-0.2c-0.5,0-0.8,0-1.2,0.1 c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.4,0.4-0.5,0.6c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.3,0,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.5,0.6 c0.2,0.2,0.6,0.3,0.9,0.5c0.4,0.2,0.9,0.3,1.5,0.5c0.7,0.2,1.3,0.4,1.8,0.6c0.5,0.2,1,0.5,1.4,0.8c0.4,0.3,0.7,0.6,0.8,1 c0.2,0.4,0.3,0.8,0.3,1.3c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.5,0.7-0.8,1c-0.4,0.3-0.8,0.5-1.3,0.7c-0.5,0.2-1.1,0.3-1.7,0.3V29 h-1.6v-1.6c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-1-0.4-1.4-0.7c-0.4-0.3-0.7-0.7-1-1.1c-0.2-0.5-0.4-1-0.4-1.6h2c0,0.5,0.1,0.9,0.3,1.2 c0.2,0.3,0.4,0.6,0.7,0.7c0.3,0.2,0.6,0.3,1,0.4c0.4,0.1,0.7,0.1,1.1,0.1c0.5,0,0.9,0,1.3-0.1c0.4-0.1,0.7-0.2,0.9-0.4 c0.3-0.2,0.5-0.4,0.6-0.6C27.9,24.7,28,24.4,28,24.1z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fill: "#FFFFFF",
    d: "M36,34H14c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S36.6,34,36,34z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "39,41.4 39.8,9.5 50,25.6 50,45.1 49.8,46 49.7,46.4  49.2,47.3 48.8,48.1 47.8,48.9 46.5,49.5 44.8,50 22.2,50 11.3,41.9 "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M38,9c0.6,0,1,0.4,1,1v30c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1V10c0-0.6,0.4-1,1-1H38 M38,8H12 c-1.1,0-2,0.9-2,2v30c0,1.1,0.9,2,2,2h26c1.1,0,2-0.9,2-2V10C40,8.9,39.1,8,38,8L38,8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fill: "#FFFFFF",
    d: "M26,38H14c-0.6,0-1-0.4-1-1s0.4-1,1-1h12c0.6,0,1,0.4,1,1S26.6,38,26,38z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-resource-b",
    viewBox: "665 475 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M709.4,525h-38.8c-3.1,0-5.6-2.5-5.6-5.6v-38.8c0.1-3.1,2.6-5.6,5.6-5.6h38.8c3.1,0,5.6,2.5,5.6,5.6v38.9 C715,522.5,712.5,525,709.4,525z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "708.1,485.8 715,502.2 715,520.1 714.8,521  714.6,521.4 714.2,522.2 713.7,523.1 712.8,523.9 711.6,524.5 709.8,525 682.7,525 671.7,508.1 677.7,505 672.8,494.8 685.3,485.9  693.1,495.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#009EEF",
    points: "677,514.5 672.9,507.5 677,500.5 685,500.5 689.1,507.5 685,514.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M684.8,501l3.8,6.5l-3.8,6.5h-7.5l-3.8-6.5l3.8-6.5H684.8 M685.3,500h-8.7l-4.3,7.5l4.3,7.5h8.7l4.3-7.5 L685.3,500L685.3,500z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 693.6,
    y: 500.8,
    fill: "#009EEF",
    width: 13.2,
    height: 13.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M706.2,501.3v12.2h-12.2v-12.2H706.2 M707.2,500.3h-14.2v14.2h14.2V500.3L707.2,500.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 673.2,
    y: 486.3,
    fill: "#009EEF",
    width: 33.4,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M706.2,486.8v7h-32.4v-7H706.2 M707.2,485.8h-34.4v9h34.4V485.8L707.2,485.8z"
  })))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-resource",
    viewBox: "375 125 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M428.3,185h-46.6c-3.7,0-6.7-3-6.7-6.7v-46.6c0.1-3.7,3.1-6.7,6.7-6.7h46.6c3.7,0,6.7,3,6.7,6.7v46.7 C435,182,432,185,428.3,185z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "426.7,138 435,157.6 435,179.1 434.7,180.2  434.5,180.7 434,181.7 433.4,182.7 432.4,183.7 430.9,184.4 428.8,185 396.2,185 383,164.7 390.2,161 384.3,148.8 399.4,138.1  408.7,150.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#637582",
    stroke: "#BABCBE",
    strokeMiterlimit: 10,
    points: "389,173 383.8,164 389,155 399.4,155 404.6,164 399.4,173  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.7,
    y: 155.4,
    fill: "#637582",
    stroke: "#BABCBE",
    strokeMiterlimit: 10,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.3,
    y: 138,
    fill: "#637582",
    stroke: "#BABCBE",
    strokeMiterlimit: 10,
    width: 41.3,
    height: 10.8
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-service-browser",
    viewBox: "45 50 60 50"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AA3E",
    points: "60.5,100 46,75 60.5,50 89.5,50 104,75 89.5,100 "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    enableBackground: "new    ",
    points: "88.5,61 85.7,62.3 81.5,66.5 73.2,75.8 61,75.8 57,79.8  68.9,100 89.5,100 100.5,81 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 85.1,
    y1: 65,
    x2: 85.1,
    y2: 67
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "3,3",
    x1: 85.1,
    y1: 69,
    x2: 85.1,
    y2: 84
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 85.1,
    y1: 86,
    x2: 85.1,
    y2: 87
  }))), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    fill: "#272425",
    cx: 57.5,
    cy: 75,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 57,
    cy: 74.4,
    r: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 57.1,
    y1: 75,
    x2: 68.1,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 85,
    y1: 61.5,
    x2: 73,
    y2: 74.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 57.5,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.3,
    y: 71.3,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    fill: "#272425",
    cx: 85.4,
    cy: 88,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 84.8,
    cy: 87.4,
    r: 4.5
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-setting-security",
    viewBox: "-25 -5 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M19.5,45h-38.9c-3.1,0-5.6-2.5-5.6-5.6V0.6c0-3.1,2.5-5.6,5.6-5.6h38.9C22.5-5,25-2.5,25,0.6v38.9 C25,42.5,22.5,45,19.5,45z"
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "2.8,21.6 11.3,8.3 25,22.2 25,40.1 24.8,41  24.6,41.4 24.2,42.3 23.7,43.1 22.9,43.9 21.6,44.5 19.8,45 2.8,45 -11.7,27.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M-0.8,5.2l12.1,3.1v16.6c0,0-1,6-12.1,11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M-0.8,5.2l-12.1,3.1v16.6c0,0,1,6,12.1,11"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 19.2,
    fill: "#5A6974",
    width: 12.4,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A6974",
    d: "M-0.4,24.3h-1.1c-2.3,0-4.2-1.9-4.2-4.2v-3.7c0-2.3,1.9-4.2,4.2-4.2h1.1c2.3,0,4.2,1.9,4.2,4.2v3.7 C3.8,22.5,1.9,24.3-0.4,24.3z M-1.4,14.3c-1.2,0-2.1,0.9-2.1,2.1v3.7c0,1.2,0.9,2.1,2.1,2.1h1.1c1.2,0,2.1-0.9,2.1-2.1v-3.7 c0-1.2-0.9-2.1-2.1-2.1H-1.4z"
  })))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-topology",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "10,18 10,38 23,46 23,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "38,18 38,39 50,46 50,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "37,18 37,39 24,46 24,24  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 35.1,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 26,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30.4,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30.1,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 35,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 37,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: 27.6,
    transform: "matrix(0.5978 0.8016 -0.8016 0.5978 29.6551 -2.8385)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 31.6,
    transform: "matrix(0.948 0.3183 -0.3183 0.948 12.1999 -4.2819)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 33.8,
    transform: "matrix(0.26 0.9656 -0.9656 0.26 52.4599 6.7993)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 30.8,
    transform: "matrix(0.6808 0.7325 -0.7325 0.6808 34.006 -9.4806)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 33.8,
    transform: "matrix(0.7258 0.6879 -0.6879 0.7258 32.6047 -13.2272)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 6.8,
    height: 1
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 35.4,
    y1: 36.6,
    x2: 40.5,
    y2: 31.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 34.8,
    transform: "matrix(0.6343 0.7731 -0.7731 0.6343 43.0651 -20.5179)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 8.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 27.7,
    transform: "matrix(0.2201 0.9755 -0.9755 0.2201 58.4711 -16.6737)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 7.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 23.6,
    transform: "matrix(0.5529 0.8333 -0.8333 0.5529 37.972 -19.4299)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 25.8,
    transform: "matrix(0.7206 0.6933 -0.6933 0.7206 29.5731 -14.5623)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 27.8,
    transform: "matrix(0.8991 0.4377 -0.4377 0.8991 14.6553 -7.0654)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 17.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 25,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 31,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 9,
    height: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "50,24 60,36 60,60 24.1,60 10,38 24,46 38,38 50,46 "
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-user-account",
    viewBox: "-25 -5 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M19.4,45h-38.8c-3.1,0-5.6-2.5-5.6-5.6V0.6c0-3.1,2.5-5.6,5.6-5.6h38.8C22.5-5,25-2.5,25,0.6v38.9 C24.9,42.5,22.4,45,19.4,45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "3.6,4.9 24.9,22.2 24.9,40 24.7,40.9 24.5,41.3  24.1,42.2 23.6,43 22.8,43.8 21.5,44.4 19.7,45 -6.1,45 -17.7,33.5 0.2,33.2 1,28.4 3.9,23.7 2.7,21.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M-0.8,3.9L-0.8,3.9c-3.8,0-6.8,3.1-6.8,6.8c0,0.6,0.1,1.1,0.2,1.6c-0.2,0.1-0.3,0.2-0.5,0.4 c-0.3,0.3-0.5,0.7-0.5,1.2l0.2,1.4c0,0.9,0.6,1.7,1.5,1.7h0.1c0.3,1.9,0.8,4,2.4,4.8c0,0-0.6,2.1-0.6,2.2c-0.9,0.1-0.3,0-0.4,0 c-5.2,0.2-9.2,3.8-9.2,3.8c-1.6,1.5-2.3,3.7-2.5,5.7c-1.7,0,33.8,0,32.2,0c-0.2-1.9-0.9-4.2-2.5-5.7c0,0-4-3.7-9.2-3.8 c-0.1,0,0.5,0-0.4,0c0-0.1-0.6-2.2-0.6-2.2C4.2,21,4.7,18.9,5,17h0.1c0.9,0,1.5-0.7,1.5-1.7l0.2-1.4c0-0.5-0.2-0.9-0.5-1.2 c-0.1-0.1-0.3-0.3-0.5-0.3c0-0.6,0.1-1.1,0.1-1.7C5.9,7,2.9,3.9-0.8,3.9L-0.8,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M15.3,34H-17v-0.5l-0.4-0.1c0.3-2.6,1.2-4.6,2.7-6c0.2-0.2,4.1-3.8,9.5-4l0,0c0.1-0.2,0.2-0.7,0.4-1.4 c-1.4-1-1.9-2.8-2.2-4.6c-1-0.2-1.6-1-1.6-2.1l-0.2-1.4c0-0.6,0.2-1.2,0.6-1.6c0.1,0,0.2-0.1,0.3-0.2C-8,11.6-8,11.2-8,10.7 c0-4,3.2-7.2,7.2-7.3l0,0h0.1c4,0,7.2,3.3,7.2,7.3c0,0.5,0,0.9-0.1,1.4c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.4,0.6,0.9,0.6,1.5L7,15.3 c0,1.1-0.7,1.9-1.6,2c-0.3,1.9-0.9,3.6-2.3,4.6c0.2,0.8,0.4,1.2,0.4,1.5l0,0c5.4,0.2,9.4,3.8,9.5,4c1.5,1.3,2.4,3.4,2.7,6 l-0.4,0.1V34z M-16.4,33h31.1c-0.3-2.1-1.1-3.8-2.3-4.9c0,0-3.7-3.4-8.6-3.7H3.6H3.5l-1-0.1l0.1-0.4c-0.1-0.2-0.3-1.2-0.6-2.1 l-0.1-0.3l0.4-0.2c1.5-0.8,1.9-2.7,2.2-4.5l0.1-0.4h0.3c0.8,0,1.1-0.6,1.1-1.2l0.2-1.5c0-0.2-0.1-0.5-0.4-0.8 c-0.1-0.1-0.2-0.2-0.4-0.2L5,12.5l0.1-0.4c0.1-0.5,0.2-1,0.2-1.5c0-3.5-2.8-6.3-6.2-6.3h-0.1l0,0h0c-3.4,0-6.2,2.9-6.2,6.3 c0,0.5,0.1,1,0.2,1.5l0.1,0.4l-0.4,0.3c-0.1,0-0.2,0.1-0.3,0.2c-0.3,0.2-0.4,0.5-0.4,0.9l0.2,1.4c0,0.7,0.3,1.2,1,1.2h0.4 l0.1,0.4c0.3,1.8,0.7,3.7,2.2,4.5l0.4,0.2L-3.7,22c-0.3,0.7-0.6,1.7-0.6,2l0.1,0.4l-1,0.1h-0.1h-0.3c-4.8,0.3-8.5,3.7-8.5,3.7 C-15.3,29.3-16,30.9-16.4,33z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-user-role",
    viewBox: "2.5 2.5 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M55.8,62.5H9.1c-3.7,0-6.6-3-6.6-6.6V9.1c0-3.7,3-6.6,6.6-6.6h46.7c3.7,0,6.6,3,6.6,6.6v46.7 C62.4,59.5,59.5,62.5,55.8,62.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "36.8,14.2 62.4,35.1 62.4,56.6 62.2,57.7 61.9,58.2  61.5,59.2 60.9,60.2 59.8,61.2 58.3,61.9 56.2,62.5 25,62.5 11.2,48.8 32.8,48.5 33.7,42.6 37.2,36.9 35.8,34.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    stroke: "#BABCBE",
    strokeWidth: 0.9563,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M31.4,13.2 L31.4,13.2c-4.5,0-8.1,3.7-8.1,8.1c0,0.6,0.1,1.3,0.3,1.9c-0.2,0.1-0.5,0.3-0.6,0.4c-0.4,0.4-0.6,0.8-0.6,1.4l0.2,1.7 c0,1.1,0.6,2,1.8,2h0.1c0.4,2.3,0.9,4.8,3,5.7c0,0-0.7,2.5-0.7,2.7c-1.1,0.1-0.4,0-0.5,0c-6.3,0.2-11.1,4.6-11.1,4.6 c-1.9,1.8-2.8,4.5-3,6.8c-2.1,0,40.6,0,38.8,0c-0.3-2.3-1.1-5-3-6.8c0,0-4.7-4.4-11.1-4.6c-0.1,0,0.6,0-0.5,0 c0-0.1-0.7-2.7-0.7-2.7c1.9-1,2.6-3.4,3-5.7h0c1.1,0,1.8-0.9,1.8-2l0.2-1.7c0-0.6-0.2-1-0.6-1.4c-0.2-0.2-0.4-0.3-0.6-0.4 c0.2-0.6,0.3-1.3,0.3-1.9c0-4.4-3.6-8.1-8-8.1H31.4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    stroke: "#637582",
    strokeWidth: 1.1267,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M53.5,53.2H40.3 c-1.5,0-2.7-1.2-2.7-2.7V37.3c0-1.5,1.2-2.7,2.7-2.7h13.2c1.5,0,2.7,1.2,2.7,2.7v13.2C56.1,52,54.9,53.2,53.5,53.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 42.6,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 106.2621 47.4313)",
    fill: "#637582",
    width: 2.1,
    height: 6.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#637582",
    points: "44.9,48.7 43.4,47.3 51.8,39.1 53.3,40.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-user-session",
    viewBox: "2.5 2.5 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M55.8,62.5H9.1c-3.7,0-6.6-3-6.6-6.6V9.1c0-3.7,3-6.6,6.6-6.6h46.7c3.7,0,6.6,3,6.6,6.6v46.7 C62.4,59.5,59.5,62.5,55.8,62.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "36.8,14.2 62.4,35.1 62.4,56.6 62.2,57.7 61.9,58.2  61.5,59.2 60.9,60.2 59.8,61.2 58.3,61.9 56.2,62.5 25,62.5 11.2,48.8 32.8,48.5 33.7,42.6 37.2,36.9 35.8,34.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    stroke: "#BABCBE",
    strokeWidth: 0.9563,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M31.4,13.2 L31.4,13.2c-4.5,0-8.1,3.7-8.1,8.1c0,0.6,0.1,1.3,0.3,1.9c-0.2,0.1-0.5,0.3-0.6,0.4c-0.4,0.4-0.6,0.8-0.6,1.4l0.2,1.7 c0,1.1,0.6,2,1.8,2h0.1c0.4,2.3,0.9,4.8,3,5.7c0,0-0.7,2.5-0.7,2.7c-1.1,0.1-0.4,0-0.5,0c-6.3,0.2-11.1,4.6-11.1,4.6 c-1.9,1.8-2.8,4.5-3,6.8c-2.1,0,40.6,0,38.8,0c-0.3-2.3-1.1-5-3-6.8c0,0-4.7-4.4-11.1-4.6c-0.1,0,0.6,0-0.5,0 c0-0.1-0.7-2.7-0.7-2.7c1.9-1,2.6-3.4,3-5.7h0c1.1,0,1.8-0.9,1.8-2l0.2-1.7c0-0.6-0.2-1-0.6-1.4c-0.2-0.2-0.4-0.3-0.6-0.4 c0.2-0.6,0.3-1.3,0.3-1.9c0-4.4-3.6-8.1-8-8.1H31.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 43.9,
    cy: 45.4,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#637582",
    cx: 43.9,
    cy: 45.6,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M43.9,45.6L43.9,45.6c-0.4,0-0.6-0.3-0.6-0.6v-6.3c0-0.4,0.3-0.6,0.6-0.6l0,0c0.4,0,0.6,0.3,0.6,0.6V45 C44.6,45.3,44.3,45.6,43.9,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M43.6,46L43.6,46c-0.2-0.3-0.2-0.6,0-0.8l3.3-3.3c0.3-0.2,0.6-0.2,0.8,0l0,0c0.2,0.3,0.2,0.6,0,0.8 L44.4,46C44.2,46.2,43.9,46.2,43.6,46z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "app-menu-icon-user-tenant",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M36,40H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v32C40,38.2,38.2,40,36,40z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    d: "M18.4,18.2c-0.2-0.8-0.6-1.5-1.1-2c-0.1-0.1-1.8-1.6-4.1-1.8c0-0.1,0-0.2-0.1-0.3 c0.5-0.4,0.8-1.1,0.9-1.9c0.4-0.2,0.7-0.6,0.7-1.1l0.1-0.5c0-0.4-0.1-0.7-0.4-0.9c0,0,0,0,0,0c0-0.2,0-0.3,0-0.5 c0-1.9-1.4-3.4-3.3-3.5l-0.1,0c-1.9,0-3.5,1.6-3.5,3.5c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0c-0.2,0.2-0.4,0.5-0.4,0.9l0.1,0.7 c0,0.5,0.3,0.9,0.7,1.1c0.1,0.7,0.4,1.4,0.9,1.9c0,0.1-0.1,0.2-0.1,0.3c-2.3,0.2-4,1.7-4.1,1.8c-0.5,0.5-0.9,1.2-1.1,2 c-0.1-0.1-0.1-0.3-0.1-0.4V4.3c0-0.5,0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8v13.4C18.5,17.9,18.5,18,18.4,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.7,4C17.8,4,18,4.2,18,4.3v11.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.1-0.1-1.6-1.5-3.7-1.8 c0.3-0.4,0.5-1,0.6-1.4c0.5-0.3,0.8-0.8,0.8-1.4l0.1-0.6l0-0.1v-0.1c0-0.4-0.1-0.7-0.4-1c0-0.1,0-0.2,0-0.3c0-2.2-1.7-3.9-3.8-4 l-0.1,0l-0.1,0l0,0c-2.1,0-3.9,1.8-3.9,4c0,0.1,0,0.2,0,0.3c-0.2,0.3-0.4,0.7-0.4,1v0.1l0,0.1l0.1,0.6c0,0.6,0.3,1.1,0.8,1.4 C7.7,13,7.9,13.5,8.2,14c-2.2,0.4-3.7,1.8-3.7,1.8c-0.1,0.1-0.3,0.3-0.4,0.4V4.3C4,4.2,4.2,4,4.3,4H11H17.7 M17.7,3H11H4.3 C3.6,3,3,3.6,3,4.3v13.4c0,0.6,0.4,1.1,1,1.3c0.1-0.8,0.4-1.8,1.1-2.5c0,0,1.7-1.6,4-1.7c0,0,0,0,0,0c0,0,0.1,0,0.2,0 c0,0,0.3-1,0.3-1c-0.7-0.4-0.9-1.2-1.1-2.1h0c-0.4,0-0.6-0.3-0.6-0.7l-0.1-0.6c0-0.2,0.1-0.4,0.2-0.5C8,9.9,8.1,9.8,8.1,9.8 C8.1,9.6,8.1,9.3,8.1,9.1c0-1.6,1.3-2.9,2.9-3h0h0l0.1,0c1.6,0,2.8,1.3,2.8,3c0,0.2,0,0.5-0.1,0.7c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.2,0.3,0.2,0.5l-0.1,0.6c0,0.4-0.2,0.7-0.6,0.7h0c-0.1,0.8-0.3,1.7-1.1,2.1c0,0,0.3,0.9,0.3,1c0.1,0,0.1,0,0.2,0 c0,0,0,0,0,0c2.3,0.1,4,1.7,4,1.7c0.7,0.7,1,1.6,1.1,2.5c0.6-0.2,1-0.7,1-1.3V4.3C19,3.6,18.4,3,17.7,3L17.7,3z M12.9,14.9 C12.9,14.9,13,14.9,12.9,14.9C13,14.9,13,14.9,12.9,14.9L12.9,14.9z M9.1,14.9C9,14.9,9,14.9,9.1,14.9C9,14.9,9.1,14.9,9.1,14.9 L9.1,14.9z"
  })), /*#__PURE__*/React.createElement("line", {
    opacity: 0.8,
    fill: "#33424F",
    x1: 5.5,
    y1: 4.6,
    x2: 12.1,
    y2: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    d: "M36.4,18.2c-0.2-0.8-0.6-1.5-1.1-2c-0.1-0.1-1.8-1.6-4.1-1.8c0-0.1,0-0.2-0.1-0.3 c0.5-0.4,0.8-1.1,0.9-1.9c0.4-0.2,0.7-0.6,0.7-1.1l0.1-0.5c0-0.4-0.1-0.7-0.4-0.9c0,0,0,0,0,0c0-0.2,0-0.3,0-0.5 c0-1.9-1.4-3.4-3.3-3.5l-0.1,0c-1.9,0-3.5,1.6-3.5,3.5c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0c-0.2,0.2-0.4,0.5-0.4,0.9l0.1,0.7 c0,0.5,0.3,0.9,0.7,1.1c0.1,0.7,0.4,1.4,0.9,1.9c0,0.1-0.1,0.2-0.1,0.3c-2.3,0.2-4,1.7-4.1,1.8c-0.5,0.5-0.9,1.2-1.1,2 c-0.1-0.1-0.1-0.3-0.1-0.4V4.3c0-0.5,0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8v13.4C36.5,17.9,36.5,18,36.4,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.7,4C35.8,4,36,4.2,36,4.3v11.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.1-0.1-1.6-1.5-3.7-1.8 c0.3-0.4,0.5-1,0.6-1.4c0.5-0.3,0.8-0.8,0.8-1.4l0.1-0.6l0-0.1v-0.1c0-0.4-0.1-0.7-0.4-1c0-0.1,0-0.2,0-0.3c0-2.2-1.7-3.9-3.8-4 l-0.1,0l-0.1,0l0,0c-2.1,0-3.9,1.8-3.9,4c0,0.1,0,0.2,0,0.3c-0.2,0.3-0.4,0.7-0.4,1v0.1l0,0.1l0.1,0.6c0,0.6,0.3,1.1,0.8,1.4 c0.1,0.4,0.3,0.9,0.6,1.4c-2.2,0.4-3.7,1.8-3.7,1.8c-0.1,0.1-0.3,0.3-0.4,0.4V4.3C22,4.2,22.2,4,22.3,4H29H35.7 M35.7,3H29h-6.7 C21.6,3,21,3.6,21,4.3v13.4c0,0.6,0.4,1.1,1,1.3c0.1-0.8,0.4-1.8,1.1-2.5c0,0,1.7-1.6,4-1.7c0,0,0,0,0,0c0,0,0.1,0,0.2,0 c0,0,0.3-1,0.3-1c-0.7-0.4-0.9-1.2-1.1-2.1h0c-0.4,0-0.6-0.3-0.6-0.7l-0.1-0.6c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.1-0.1,0.2-0.1 c-0.1-0.2-0.1-0.5-0.1-0.7c0-1.6,1.3-2.9,2.9-3h0h0l0.1,0c1.6,0,2.8,1.3,2.8,3c0,0.2,0,0.5-0.1,0.7c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.2,0.3,0.2,0.5l-0.1,0.6c0,0.4-0.2,0.7-0.6,0.7h0c-0.1,0.8-0.3,1.7-1.1,2.1c0,0,0.3,0.9,0.3,1c0.1,0,0.1,0,0.2,0 c0,0,0,0,0,0c2.3,0.1,4,1.7,4,1.7c0.7,0.7,1,1.6,1.1,2.5c0.6-0.2,1-0.7,1-1.3V4.3C37,3.6,36.4,3,35.7,3L35.7,3z M30.9,14.9 C30.9,14.9,31,14.9,30.9,14.9C31,14.9,31,14.9,30.9,14.9L30.9,14.9z M27.1,14.9C27,14.9,27,14.9,27.1,14.9 C27,14.9,27.1,14.9,27.1,14.9L27.1,14.9z"
  })), /*#__PURE__*/React.createElement("line", {
    opacity: 0.8,
    fill: "#33424F",
    x1: 23.5,
    y1: 4.6,
    x2: 30.1,
    y2: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    d: "M36.4,36.2c-0.2-0.8-0.6-1.5-1.1-2c-0.1-0.1-1.8-1.6-4.1-1.8c0-0.1,0-0.2-0.1-0.3 c0.5-0.4,0.8-1.1,0.9-1.9c0.4-0.2,0.7-0.6,0.7-1.1l0.1-0.5c0-0.4-0.1-0.7-0.4-0.9c0,0,0,0,0,0c0-0.2,0-0.3,0-0.5 c0-1.9-1.4-3.4-3.3-3.5l-0.1,0c-1.9,0-3.5,1.6-3.5,3.5c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0c-0.2,0.2-0.4,0.5-0.4,0.9l0.1,0.7 c0,0.5,0.3,0.9,0.7,1.1c0.1,0.7,0.4,1.4,0.9,1.9c0,0.1-0.1,0.2-0.1,0.3c-2.3,0.2-4,1.7-4.1,1.8c-0.5,0.5-0.9,1.2-1.1,2 c-0.1-0.1-0.1-0.3-0.1-0.4V22.3c0-0.5,0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8v13.4C36.5,35.9,36.5,36,36.4,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.7,22c0.2,0,0.3,0.2,0.3,0.3v11.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.1-0.1-1.6-1.5-3.7-1.8 c0.3-0.4,0.5-1,0.6-1.4c0.5-0.3,0.8-0.8,0.8-1.4l0.1-0.6l0-0.1v-0.1c0-0.4-0.1-0.7-0.4-1c0-0.1,0-0.2,0-0.3c0-2.2-1.7-3.9-3.8-4 l-0.1,0l-0.1,0l0,0c-2.1,0-3.9,1.8-3.9,4c0,0.1,0,0.2,0,0.3c-0.2,0.3-0.4,0.7-0.4,1v0.1l0,0.1l0.1,0.6c0,0.6,0.3,1.1,0.8,1.4 c0.1,0.4,0.3,0.9,0.6,1.4c-2.2,0.4-3.7,1.8-3.7,1.8c-0.1,0.1-0.3,0.3-0.4,0.4V22.3c0-0.2,0.2-0.3,0.3-0.3H29H35.7 M35.7,21H29 h-6.7c-0.7,0-1.3,0.6-1.3,1.3v13.4c0,0.6,0.4,1.1,1,1.3c0.1-0.8,0.4-1.8,1.1-2.5c0,0,1.7-1.6,4-1.7c0,0,0,0,0,0c0,0,0.1,0,0.2,0 c0,0,0.3-1,0.3-1c-0.7-0.4-0.9-1.2-1.1-2.1h0c-0.4,0-0.6-0.3-0.6-0.7l-0.1-0.6c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.1-0.1,0.2-0.1 c-0.1-0.2-0.1-0.5-0.1-0.7c0-1.6,1.3-2.9,2.9-3h0h0l0.1,0c1.6,0,2.8,1.3,2.8,3c0,0.2,0,0.5-0.1,0.7c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.2,0.3,0.2,0.5l-0.1,0.6c0,0.4-0.2,0.7-0.6,0.7h0c-0.1,0.8-0.3,1.7-1.1,2.1c0,0,0.3,0.9,0.3,1c0.1,0,0.1,0,0.2,0 c0,0,0,0,0,0c2.3,0.1,4,1.7,4,1.7c0.7,0.7,1,1.6,1.1,2.5c0.6-0.2,1-0.7,1-1.3V22.3C37,21.6,36.4,21,35.7,21L35.7,21z M30.9,32.9 C30.9,32.9,31,32.9,30.9,32.9C31,32.9,31,32.9,30.9,32.9L30.9,32.9z M27.1,32.9C27,32.9,27,32.9,27.1,32.9 C27,32.9,27.1,32.9,27.1,32.9L27.1,32.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    d: "M18.4,36.2c-0.2-0.8-0.6-1.5-1.1-2c-0.1-0.1-1.8-1.6-4.1-1.8c0-0.1,0-0.2-0.1-0.3 c0.5-0.4,0.8-1.1,0.9-1.9c0.4-0.2,0.7-0.6,0.7-1.1l0.1-0.5c0-0.4-0.1-0.7-0.4-0.9c0,0,0,0,0,0c0-0.2,0-0.3,0-0.5 c0-1.9-1.4-3.4-3.3-3.5l-0.1,0c-1.9,0-3.5,1.6-3.5,3.5c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0c-0.2,0.2-0.4,0.5-0.4,0.9l0.1,0.7 c0,0.5,0.3,0.9,0.7,1.1c0.1,0.7,0.4,1.4,0.9,1.9c0,0.1-0.1,0.2-0.1,0.3c-2.3,0.2-4,1.7-4.1,1.8c-0.5,0.5-0.9,1.2-1.1,2 c-0.1-0.1-0.1-0.3-0.1-0.4V22.3c0-0.5,0.4-0.8,0.8-0.8h13.3c0.5,0,0.8,0.4,0.8,0.8v13.4C18.5,35.9,18.5,36,18.4,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.7,22c0.2,0,0.3,0.2,0.3,0.3v11.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.1-0.1-1.6-1.5-3.7-1.8 c0.3-0.4,0.5-1,0.6-1.4c0.5-0.3,0.8-0.8,0.8-1.4l0.1-0.6l0-0.1v-0.1c0-0.4-0.1-0.7-0.4-1c0-0.1,0-0.2,0-0.3c0-2.2-1.7-3.9-3.8-4 l-0.1,0l-0.1,0l0,0c-2.1,0-3.9,1.8-3.9,4c0,0.1,0,0.2,0,0.3c-0.2,0.3-0.4,0.7-0.4,1v0.1l0,0.1l0.1,0.6c0,0.6,0.3,1.1,0.8,1.4 C7.7,31,7.9,31.5,8.2,32c-2.2,0.4-3.7,1.8-3.7,1.8c-0.1,0.1-0.3,0.3-0.4,0.4V22.3C4,22.2,4.2,22,4.3,22H11H17.7 M17.7,21H11H4.3 C3.6,21,3,21.6,3,22.3v13.4c0,0.6,0.4,1.1,1,1.3c0.1-0.8,0.4-1.8,1.1-2.5c0,0,1.7-1.6,4-1.7c0,0,0,0,0,0c0,0,0.1,0,0.2,0 c0,0,0.3-1,0.3-1c-0.7-0.4-0.9-1.2-1.1-2.1h0c-0.4,0-0.6-0.3-0.6-0.7l-0.1-0.6c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.1-0.1,0.2-0.1 c-0.1-0.2-0.1-0.5-0.1-0.7c0-1.6,1.3-2.9,2.9-3h0h0l0.1,0c1.6,0,2.8,1.3,2.8,3c0,0.2,0,0.5-0.1,0.7c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.2,0.3,0.2,0.5l-0.1,0.6c0,0.4-0.2,0.7-0.6,0.7h0c-0.1,0.8-0.3,1.7-1.1,2.1c0,0,0.3,0.9,0.3,1c0.1,0,0.1,0,0.2,0 c0,0,0,0,0,0c2.3,0.1,4,1.7,4,1.7c0.7,0.7,1,1.6,1.1,2.5c0.6-0.2,1-0.7,1-1.3V22.3C19,21.6,18.4,21,17.7,21L17.7,21z M12.9,32.9 C12.9,32.9,13,32.9,12.9,32.9C13,32.9,13,32.9,12.9,32.9L12.9,32.9z M9.1,32.9C9,32.9,9,32.9,9.1,32.9C9,32.9,9.1,32.9,9.1,32.9 L9.1,32.9z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "app-user-role",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_8_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.3648,
    y1: 48.3648,
    x2: 1.6302,
    y2: 1.6302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M44.5,50H5.5C2.5,50,0,47.5,0,44.5v-39C0,2.4,2.5,0,5.5,0h38.9C47.5,0,50,2.5,50,5.5v38.9 C50,47.5,47.5,50,44.5,50z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "28.6,9.8 50,27.2 50,45.1 49.8,46 49.5,46.4  49.2,47.2 48.7,48.1 47.8,48.9 46.5,49.5 44.8,50 18.8,50 7.3,38.6 25.3,38.3 26,33.4 29,28.7 27.8,26.6  "
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    stroke: "#BABCBE",
    strokeWidth: 0.9563,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M24.1,8.9 L24.1,8.9c-3.8,0-6.8,3.1-6.8,6.8c0,0.5,0.1,1.1,0.2,1.6c-0.2,0.1-0.4,0.2-0.5,0.3c-0.3,0.3-0.5,0.7-0.5,1.2l0.2,1.4 c0,0.9,0.5,1.7,1.5,1.7h0.1c0.3,1.9,0.7,4,2.5,4.7c0,0-0.6,2.1-0.6,2.3c-0.9,0.1-0.3,0-0.4,0c-5.2,0.2-9.2,3.8-9.2,3.8 c-1.6,1.5-2.3,3.8-2.5,5.7c-1.8,0,33.8,0,32.3,0c-0.2-1.9-0.9-4.2-2.5-5.7c0,0-3.9-3.7-9.3-3.8c-0.1,0,0.5,0-0.4,0 c0-0.1-0.6-2.3-0.6-2.3c1.6-0.8,2.2-2.8,2.5-4.8l0,0c0.9,0,1.5-0.8,1.5-1.7l0.2-1.4c0-0.5-0.2-0.8-0.5-1.2 c-0.2-0.2-0.3-0.2-0.5-0.3c0.2-0.5,0.2-1.1,0.2-1.6c0-3.7-3-6.8-6.7-6.8L24.1,8.9"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    stroke: "#637582",
    strokeWidth: 1.1267,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M42.5,42.2h-11 c-1.2,0-2.2-1-2.2-2.2V29c0-1.2,1-2.2,2.2-2.2h11c1.2,0,2.2,1,2.2,2.2v11C44.7,41.2,43.7,42.2,42.5,42.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 33.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.4564 34.6242)",
    fill: "#637582",
    width: 1.7,
    height: 5.2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#637582",
    points: "35.4,38.5 34.1,37.3 41.1,30.5 42.4,31.7  "
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "app-user-tentant",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5312,
    y1: 48.5312,
    x2: 1.4688,
    y2: 1.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M45,50H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C50,47.8,47.8,50,45,50z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M23,22.8c-0.3-1-0.8-1.9-1.4-2.5c-0.1-0.1-2.3-2-5.1-2.2 c0-0.1,0-0.2-0.1-0.4c0.6-0.5,1-1.4,1.1-2.4c0.5-0.2,0.9-0.8,0.9-1.4l0.1-0.6c0-0.5-0.1-0.9-0.5-1.1l0,0c0-0.2,0-0.4,0-0.6 c0-2.4-1.8-4.2-4.1-4.4h-0.1c-2.4,0-4.4,2-4.4,4.4c0,0.2,0,0.4,0,0.6l0,0c-0.2,0.2-0.5,0.6-0.5,1.1L9,14.1c0,0.6,0.4,1.1,0.9,1.4 c0.1,0.9,0.5,1.7,1.1,2.4c0,0.1-0.1,0.2-0.1,0.4c-2.9,0.2-5,2.1-5.1,2.2C5.1,21.1,4.6,22,4.4,23c-0.1-0.1-0.1-0.4-0.1-0.5V5.4 c0-0.6,0.5-1,1-1h16.6c0.6,0,1,0.5,1,1v16.8C23.1,22.4,23.1,22.5,23,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.1,5c0.1,0,0.4,0.2,0.4,0.4v14.9c-0.1-0.2-0.4-0.4-0.5-0.5c-0.1-0.1-2-1.9-4.6-2.2 c0.4-0.5,0.6-1.2,0.8-1.8c0.6-0.4,1-1,1-1.8l0.1-0.8v-0.1V13c0-0.5-0.1-0.9-0.5-1.2c0-0.1,0-0.2,0-0.4c0-2.7-2.1-4.9-4.8-5h-0.1 h-0.1l0,0c-2.6,0-4.9,2.3-4.9,5c0,0.1,0,0.2,0,0.4c-0.2,0.4-0.5,0.9-0.5,1.2v0.1v0.1L8.5,14c0,0.8,0.4,1.4,1,1.8 c0.1,0.5,0.4,1.1,0.7,1.7c-2.8,0.5-4.6,2.2-4.6,2.2c-0.1,0.1-0.4,0.4-0.5,0.5V5.4C5,5.2,5.2,5,5.4,5h8.4H22.1 M22.1,3.8h-8.4H5.4 c-0.9,0-1.6,0.8-1.6,1.6v16.8c0,0.8,0.5,1.4,1.2,1.6c0.1-1,0.5-2.2,1.4-3.1c0,0,2.1-2,5-2.1l0,0c0,0,0.1,0,0.2,0l0.4-1.2 c-0.9-0.5-1.1-1.5-1.4-2.6l0,0c-0.5,0-0.8-0.4-0.8-0.9L9.8,13c0-0.2,0.1-0.5,0.2-0.6l0.1-0.1c0-0.2,0-0.6,0-0.9 c0-2,1.6-3.6,3.6-3.7l0,0l0,0h0.1c2,0,3.5,1.6,3.5,3.7c0,0.2,0,0.6-0.1,0.9c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.4,0.2,0.6 l-0.1,0.8c0,0.5-0.2,0.9-0.8,0.9l0,0c-0.1,1-0.4,2.1-1.4,2.6c0,0,0.4,1.1,0.4,1.2c0.1,0,0.1,0,0.2,0l0,0c2.9,0.1,5,2.1,5,2.1 c0.9,0.9,1.2,2,1.4,3.1c0.8-0.2,1.2-0.9,1.2-1.6V5.4C23.8,4.5,23,3.8,22.1,3.8L22.1,3.8z M16.1,18.6 C16.1,18.6,16.2,18.6,16.1,18.6C16.2,18.6,16.2,18.6,16.1,18.6L16.1,18.6z M11.4,18.6C11.2,18.6,11.2,18.6,11.4,18.6 C11.2,18.6,11.4,18.6,11.4,18.6L11.4,18.6z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M45.5,22.8c-0.3-1-0.8-1.9-1.4-2.5c-0.1-0.1-2.2-2-5.1-2.2 c0-0.1,0-0.2-0.1-0.4c0.6-0.5,1-1.4,1.1-2.4c0.5-0.2,0.9-0.8,0.9-1.4l0.1-0.6c0-0.5-0.1-0.9-0.5-1.1l0,0c0-0.2,0-0.4,0-0.6 c0-2.4-1.8-4.2-4.1-4.4h-0.1c-2.4,0-4.4,2-4.4,4.4c0,0.2,0,0.4,0,0.6l0,0c-0.2,0.2-0.5,0.6-0.5,1.1l0.1,0.9c0,0.6,0.4,1.1,0.9,1.4 c0.1,0.9,0.5,1.7,1.1,2.4c0,0.1-0.1,0.2-0.1,0.4c-2.9,0.2-5,2.1-5.1,2.2c-0.6,0.6-1.1,1.5-1.4,2.5c-0.1-0.1-0.1-0.4-0.1-0.5V5.4 c0-0.6,0.5-1,1-1h16.6c0.6,0,1,0.5,1,1v16.8C45.6,22.4,45.6,22.5,45.5,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.6,5C44.8,5,45,5.2,45,5.4v14.9c-0.1-0.2-0.4-0.4-0.5-0.5c-0.1-0.1-2-1.9-4.6-2.2 c0.4-0.5,0.6-1.2,0.8-1.8c0.6-0.4,1-1,1-1.8l0.1-0.8v-0.1V13c0-0.5-0.1-0.9-0.5-1.2c0-0.1,0-0.2,0-0.4c0-2.7-2.1-4.9-4.8-5h-0.1 h-0.1l0,0c-2.6,0-4.9,2.3-4.9,5c0,0.1,0,0.2,0,0.4c-0.2,0.4-0.5,0.9-0.5,1.2v0.1v0.1L31,14c0,0.8,0.4,1.4,1,1.8 c0.1,0.5,0.4,1.1,0.8,1.8c-2.8,0.5-4.6,2.2-4.6,2.2c-0.1,0.1-0.4,0.4-0.5,0.5V5.4C27.5,5.2,27.8,5,27.9,5h8.4H44.6 M44.6,3.8h-8.4 h-8.4c-0.9,0-1.6,0.8-1.6,1.6v16.8c0,0.8,0.5,1.4,1.2,1.6c0.1-1,0.5-2.2,1.4-3.1c0,0,2.1-2,5-2.1l0,0c0,0,0.1,0,0.2,0l0.4-1.2 c-0.9-0.5-1.1-1.5-1.4-2.6l0,0c-0.5,0-0.8-0.4-0.8-0.9L32.2,13c0-0.2,0.1-0.5,0.2-0.6c0.1-0.1,0.1-0.1,0.2-0.1 c-0.1-0.2-0.1-0.6-0.1-0.9c0-2,1.6-3.6,3.6-3.7l0,0l0,0h0.1c2,0,3.5,1.6,3.5,3.7c0,0.2,0,0.6-0.1,0.9c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.2,0.4,0.2,0.6l-0.1,0.8c0,0.5-0.2,0.9-0.8,0.9l0,0c-0.1,1-0.4,2.1-1.4,2.6c0,0,0.4,1.1,0.4,1.2c0.1,0,0.1,0,0.3,0l0,0 c2.9,0.1,5,2.1,5,2.1c0.9,0.9,1.2,2,1.4,3.1c0.7-0.2,1.2-0.9,1.2-1.6V5.4C46.2,4.5,45.5,3.8,44.6,3.8L44.6,3.8z M38.6,18.6 C38.6,18.6,38.8,18.6,38.6,18.6C38.8,18.6,38.8,18.6,38.6,18.6L38.6,18.6z M33.9,18.6C33.8,18.6,33.8,18.6,33.9,18.6 C33.8,18.6,33.9,18.6,33.9,18.6L33.9,18.6z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M45.5,45.2c-0.3-1-0.8-1.9-1.4-2.5c-0.1-0.1-2.2-2-5.1-2.2 c0-0.1,0-0.2-0.1-0.4c0.6-0.5,1-1.4,1.1-2.4c0.5-0.2,0.9-0.8,0.9-1.4l0.1-0.6c0-0.5-0.1-0.9-0.5-1.1l0,0c0-0.2,0-0.4,0-0.6 c0-2.4-1.8-4.2-4.1-4.4h-0.1c-2.4,0-4.4,2-4.4,4.4c0,0.2,0,0.4,0,0.6l0,0c-0.2,0.2-0.5,0.6-0.5,1.1l0.1,0.9c0,0.6,0.4,1.1,0.9,1.4 c0.1,0.9,0.5,1.8,1.1,2.4c0,0.1-0.1,0.2-0.1,0.4c-2.9,0.2-5,2.1-5.1,2.2c-0.6,0.6-1.1,1.5-1.4,2.5c-0.1-0.1-0.1-0.4-0.1-0.5V27.9 c0-0.6,0.5-1,1-1h16.6c0.6,0,1,0.5,1,1v16.7C45.6,44.9,45.6,45,45.5,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.6,27.5c0.3,0,0.4,0.2,0.4,0.4v14.9c-0.1-0.2-0.4-0.4-0.5-0.5c-0.1-0.1-2-1.9-4.6-2.2 c0.4-0.5,0.6-1.2,0.8-1.8c0.6-0.4,1-1,1-1.8l0.1-0.8v-0.1v-0.1c0-0.5-0.1-0.9-0.5-1.2c0-0.1,0-0.3,0-0.4c0-2.8-2.1-4.9-4.8-5h-0.1 h-0.1l0,0c-2.6,0-4.9,2.2-4.9,5c0,0.1,0,0.2,0,0.4c-0.2,0.4-0.5,0.9-0.5,1.2v0.1v0.1l0.1,0.8c0,0.8,0.4,1.4,1,1.8 c0.1,0.5,0.4,1.1,0.8,1.8c-2.8,0.5-4.6,2.2-4.6,2.2c-0.1,0.1-0.4,0.4-0.5,0.5V27.9c0-0.3,0.3-0.4,0.4-0.4h8.3H44.6 M44.6,26.2 h-8.4h-8.4c-0.9,0-1.6,0.8-1.6,1.6v16.7c0,0.7,0.5,1.4,1.2,1.6c0.1-1,0.5-2.2,1.4-3.1c0,0,2.1-2,5-2.1l0,0c0,0,0.1,0,0.2,0 l0.4-1.2c-0.9-0.5-1.1-1.5-1.4-2.6l0,0c-0.5,0-0.8-0.4-0.8-0.9l-0.1-0.8c0-0.2,0.1-0.5,0.2-0.6s0.1-0.1,0.2-0.1 c-0.1-0.2-0.1-0.6-0.1-0.9c0-2,1.6-3.6,3.6-3.8l0,0l0,0h0.1c2,0,3.5,1.6,3.5,3.8c0,0.2,0,0.6-0.1,0.9c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.2,0.4,0.2,0.6l-0.1,0.8c0,0.5-0.2,0.9-0.8,0.9l0,0c-0.1,1-0.4,2.1-1.4,2.6c0,0,0.4,1.1,0.4,1.2c0.1,0,0.1,0,0.3,0l0,0 c2.9,0.1,5,2.1,5,2.1c0.9,0.9,1.2,2,1.4,3.1c0.7-0.3,1.2-0.9,1.2-1.6V27.9C46.2,27,45.5,26.2,44.6,26.2L44.6,26.2z M38.6,41.1 C38.6,41.1,38.8,41.1,38.6,41.1C38.8,41.1,38.8,41.1,38.6,41.1L38.6,41.1z M33.9,41.1C33.8,41.1,33.8,41.1,33.9,41.1 C33.8,41.1,33.9,41.1,33.9,41.1L33.9,41.1z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M23,45.2c-0.3-1-0.8-1.9-1.4-2.5c-0.1-0.1-2.3-2-5.1-2.2 c0-0.1,0-0.2-0.1-0.4c0.6-0.5,1-1.4,1.1-2.4c0.5-0.2,0.9-0.8,0.9-1.4l0.1-0.6c0-0.5-0.1-0.9-0.5-1.1l0,0c0-0.2,0-0.4,0-0.6 c0-2.4-1.8-4.2-4.1-4.4h-0.1c-2.4,0-4.4,2-4.4,4.4c0,0.2,0,0.4,0,0.6l0,0c-0.2,0.2-0.5,0.6-0.5,1.1L9,36.6c0,0.6,0.4,1.1,0.9,1.4 c0.1,0.9,0.5,1.8,1.1,2.4c0,0.1-0.1,0.2-0.1,0.4C8,41,5.9,42.9,5.7,43c-0.6,0.6-1.1,1.5-1.4,2.5c-0.1-0.1-0.1-0.4-0.1-0.5V27.9 c0-0.6,0.5-1,1-1h16.6c0.6,0,1,0.5,1,1v16.7C23.1,44.9,23.1,45,23,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.1,27.5c0.3,0,0.4,0.2,0.4,0.4v14.9c-0.1-0.2-0.4-0.4-0.5-0.5c-0.1-0.1-2-1.9-4.6-2.2 c0.4-0.5,0.6-1.2,0.8-1.8c0.6-0.4,1-1,1-1.8l0.1-0.8v-0.1v-0.1c0-0.5-0.1-0.9-0.5-1.2c0-0.1,0-0.3,0-0.4c0-2.8-2.1-4.9-4.8-5h-0.1 h-0.1l0,0c-2.6,0-4.9,2.2-4.9,5c0,0.1,0,0.2,0,0.4c-0.2,0.4-0.5,0.9-0.5,1.2v0.1v0.1l0.1,0.8c0,0.8,0.4,1.4,1,1.8 c0.1,0.5,0.4,1.1,0.7,1.8c-2.8,0.5-4.6,2.2-4.6,2.2c-0.1,0.1-0.4,0.4-0.5,0.5V27.9c-0.1-0.1,0.1-0.4,0.3-0.4h8.4H22.1 M22.1,26.2 h-8.4H5.4c-0.9,0-1.6,0.8-1.6,1.6v16.7c0,0.7,0.5,1.4,1.2,1.6c0.1-1,0.5-2.2,1.4-3.1c0,0,2.1-2,5-2.1l0,0c0,0,0.1,0,0.2,0l0.4-1.2 c-0.9-0.5-1.1-1.5-1.4-2.6l0,0c-0.5,0-0.8-0.4-0.8-0.9l-0.1-0.8c0-0.2,0.1-0.5,0.2-0.6c0.1-0.1,0.1-0.1,0.2-0.1 c-0.1-0.2-0.1-0.6-0.1-0.9c0-2,1.6-3.6,3.6-3.8l0,0l0,0h0.1c2,0,3.5,1.6,3.5,3.8c0,0.2,0,0.6-0.1,0.9c0.1,0,0.2,0.1,0.2,0.1 c0.1,0.1,0.2,0.4,0.2,0.6l-0.1,0.8c0,0.5-0.2,0.9-0.8,0.9l0,0c-0.1,1-0.4,2.1-1.4,2.6c0,0,0.4,1.1,0.4,1.2c0.1,0,0.1,0,0.2,0l0,0 c2.9,0.1,5,2.1,5,2.1c0.9,0.9,1.2,2,1.4,3.1c0.8-0.3,1.2-0.9,1.2-1.6V27.9C23.8,27,23,26.2,22.1,26.2L22.1,26.2z M16.1,41.1 C16.1,41.1,16.2,41.1,16.1,41.1C16.2,41.1,16.2,41.1,16.1,41.1L16.1,41.1z M11.4,41.1C11.2,41.1,11.2,41.1,11.4,41.1 C11.2,41.1,11.4,41.1,11.4,41.1L11.4,41.1z"
  }))))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "appbar-bp-logo",
    viewBox: "0 0 125 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M10.6,8.3c-0.5-0.6-1.2-1.1-1.9-1.5C7.9,6.5,7.1,6.3,6.1,6.3C5.3,6.3,4.6,6.4,4,6.7C3.5,6.8,3,7,2.7,7.2V0 L0.3,0.4l0,0v19.4l0,0c0.6,0.2,1.3,0.3,2.1,0.5c0.9,0.2,1.9,0.2,3,0.2c1,0,2-0.2,2.8-0.5c0.8-0.3,1.5-0.8,2.1-1.4 c0.6-0.6,1-1.4,1.4-2.2c0.3-0.9,0.5-1.9,0.5-3c0-1-0.1-2-0.4-2.9C11.5,9.7,11.1,8.9,10.6,8.3z M9.6,13.4c0,1.6-0.4,2.8-1.2,3.6 c-0.8,0.8-1.8,1.3-3.1,1.3c-0.7,0-1.2,0-1.6-0.1c-0.4-0.1-0.8-0.1-1-0.2V9.5C3,9.3,3.4,9.1,4,8.9c0.5-0.2,1.2-0.3,1.8-0.3 c0.7,0,1.3,0.1,1.8,0.4c0.5,0.2,0.9,0.6,1.2,1c0.3,0.4,0.5,1,0.7,1.6C9.6,12.1,9.6,12.7,9.6,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M18.5,18.2c-0.3-0.1-0.5-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-1V0L15,0.4l0,0v16.2 c0,1.3,0.3,2.2,0.9,2.8c0.6,0.6,1.7,0.9,3.2,1l0,0l0.3-2.1l0,0C19.1,18.3,18.8,18.3,18.5,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M29.9,18.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0.1-0.7,0.1c-0.2,0-0.5,0-0.8,0.1c-0.3,0-0.5,0-0.8,0 c-1.2,0-2.1-0.4-2.6-1.1c-0.5-0.7-0.8-1.9-0.8-3.5V6.6h-2.5v7.6c0,0.9,0.1,1.8,0.3,2.5c0.2,0.8,0.5,1.4,0.9,2c0.4,0.6,1,1,1.7,1.3 c0.7,0.3,1.6,0.5,2.6,0.5c1.2,0,2.3-0.1,3.2-0.2c0.9-0.2,1.6-0.3,2.2-0.4l0,0V6.6h-2.5V18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M45.6,8c-1-1.1-2.4-1.7-4.2-1.7c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.3-1.4,0.7-2,1.3c-0.6,0.6-1,1.3-1.4,2.2 c-0.3,0.9-0.5,1.9-0.5,3.1c0,1,0.1,2,0.4,2.8c0.3,0.9,0.7,1.6,1.2,2.2c0.6,0.6,1.3,1.1,2.1,1.5c0.9,0.4,1.9,0.5,3.1,0.5 c0.9,0,1.8-0.1,2.5-0.3c0.7-0.2,1.3-0.3,1.6-0.5l0,0l-0.3-2l0,0l0,0c-0.3,0.1-0.7,0.3-1.3,0.4c-0.6,0.1-1.3,0.2-2.1,0.2 c-1.5,0-2.6-0.4-3.3-1.1c-0.7-0.7-1.1-1.8-1.2-3.1H47l0,0c0-0.1,0-0.3,0-0.5v-0.4C47.1,10.9,46.6,9.2,45.6,8z M41.4,8.4 c1,0,1.7,0.4,2.3,1c0.6,0.7,0.8,1.6,0.8,2.6h-6.6c0.1-0.5,0.2-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.7-1.2c0.3-0.3,0.6-0.6,1.1-0.8 C40.3,8.5,40.8,8.4,41.4,8.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.4,7.7c0,0.2,0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.4,0.3 C123.5,9,123.3,9,123.2,9c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.1-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.4C122,8.1,122,7.9,122,7.7 c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.5,0.1 c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.2,0.2,0.3,0.4C124.4,7.3,124.4,7.5,124.4,7.7z M124.2,7.7c0-0.2,0-0.3-0.1-0.4 c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.1s-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.3-0.1,0.4c0,0.2,0,0.3,0.1,0.4c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2 c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3C124.1,8,124.2,7.9,124.2,7.7z  M123.5,8.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.2h-0.2v0.5h-0.3V7c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0 c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.1 c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2H123.5z M122.9,7.7h0.1c0.1,0,0.2,0,0.3,0s0.1-0.1,0.1-0.2 c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2-0.1-0.2-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0V7.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M60.1,8.3c-0.6-0.6-1.3-1.1-2.1-1.4c-0.8-0.3-1.8-0.5-2.8-0.5c-1.1,0-2.1,0.1-3,0.2 c-0.9,0.2-1.6,0.3-2.1,0.5l0,0V25h2.5v-5.4c0.3,0.2,0.7,0.4,1.3,0.6c0.6,0.2,1.3,0.3,2.1,0.3c1,0,1.8-0.2,2.6-0.5 c0.8-0.3,1.4-0.8,1.9-1.5c0.5-0.6,0.9-1.4,1.2-2.2c0.3-0.9,0.4-1.8,0.4-2.8c0-1.1-0.2-2.1-0.5-3C61.1,9.6,60.6,8.9,60.1,8.3z  M52.4,8.8c0.2-0.1,0.6-0.1,1-0.2c0.4-0.1,1-0.1,1.7-0.1c1.3,0,2.3,0.4,3.1,1.3c0.8,0.8,1.2,2.1,1.2,3.6c0,0.7-0.1,1.3-0.2,1.9 c-0.1,0.6-0.4,1.1-0.7,1.5c-0.3,0.4-0.7,0.8-1.2,1c-0.5,0.2-1.1,0.4-1.8,0.4c-0.7,0-1.3-0.1-1.8-0.3c-0.5-0.2-1-0.5-1.3-0.7V8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M68.2,18.2c-0.3-0.1-0.5-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-1V0l-2.4,0.4l0,0 v16.2c0,1.3,0.3,2.2,0.9,2.8c0.6,0.6,1.7,0.9,3.2,1l0,0l0.3-2l0,0l0,0C68.8,18.3,68.5,18.3,68.2,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.8,7.8c-0.4-0.5-1-0.8-1.6-1.1c-0.7-0.3-1.5-0.4-2.5-0.4c-0.8,0-1.6,0.1-2.4,0.2 c-0.7,0.1-1.3,0.3-1.6,0.4l0,0l0.3,2l0,0l0,0c0.3-0.1,0.7-0.2,1.3-0.3c0.6-0.1,1.3-0.2,2.1-0.2c0.6,0,1.1,0.1,1.5,0.3 c0.4,0.2,0.7,0.4,0.9,0.7c0.2,0.3,0.4,0.6,0.5,1c0.1,0.4,0.1,0.8,0.1,1.2v0.6c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4-0.1-0.6-0.1 c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.8,0c-0.8,0-1.5,0.1-2.2,0.2c-0.7,0.2-1.3,0.4-1.8,0.7c-0.5,0.3-0.9,0.8-1.2,1.3 c-0.3,0.5-0.5,1.2-0.5,1.9c0,0.8,0.1,1.5,0.4,2c0.3,0.6,0.6,1,1.1,1.3c0.5,0.3,1,0.6,1.7,0.7c0.6,0.2,1.3,0.2,2.1,0.2 c0.5,0,1.1,0,1.6-0.1c0.5,0,1.1-0.1,1.5-0.1c0.5-0.1,0.9-0.1,1.3-0.2c0.4-0.1,0.7-0.1,0.9-0.1l0,0v-8.5c0-0.8-0.1-1.5-0.3-2.1 C80.5,8.8,80.2,8.2,79.8,7.8z M78.5,14.2v4c-0.3,0.1-0.7,0.1-1.1,0.1c-0.4,0-0.9,0-1.5,0c-0.9,0-1.7-0.2-2.2-0.5 c-0.5-0.3-0.8-0.9-0.8-1.8c0-0.5,0.1-0.8,0.3-1.1c0.2-0.3,0.5-0.5,0.8-0.7c0.3-0.2,0.7-0.3,1.1-0.3c0.4-0.1,0.8-0.1,1.2-0.1 c0.5,0,1,0,1.4,0.1C78,14.1,78.3,14.2,78.5,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M94.1,8.1c-0.4-0.5-1-1-1.7-1.3c-0.7-0.3-1.6-0.5-2.7-0.5c-1.2,0-2.3,0.1-3.2,0.2 c-0.9,0.2-1.7,0.3-2.2,0.4l0,0v13.2h2.5V8.8c0.1,0,0.2,0,0.4-0.1c0.2,0,0.4-0.1,0.7-0.1c0.2,0,0.5,0,0.8-0.1c0.3,0,0.6,0,0.8,0 c0.6,0,1.2,0.1,1.6,0.2c0.4,0.2,0.8,0.4,1,0.8c0.3,0.4,0.4,0.8,0.6,1.4c0.1,0.6,0.2,1.3,0.2,2.1v7.1h2.5v-7.6 c0-0.9-0.1-1.8-0.3-2.5C94.9,9.3,94.6,8.6,94.1,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.1,6.3c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.3-1.4,0.7-2,1.3c-0.6,0.6-1,1.3-1.4,2.2 c-0.3,0.9-0.5,1.9-0.5,3.1c0,1,0.1,2,0.4,2.8c0.3,0.9,0.7,1.6,1.2,2.2c0.6,0.6,1.3,1.1,2.1,1.5c0.9,0.4,1.9,0.5,3.1,0.5 c0.9,0,1.8-0.1,2.5-0.3c0.7-0.2,1.3-0.3,1.6-0.5l0,0l-0.3-2l0,0l0,0c-0.3,0.1-0.7,0.3-1.3,0.4c-0.6,0.1-1.3,0.2-2.1,0.2 c-1.5,0-2.6-0.4-3.3-1.1c-0.7-0.7-1.1-1.8-1.2-3.1h9.2l0,0c0-0.1,0-0.3,0-0.5v-0.4c0-2.3-0.5-4.1-1.5-5.2 C107.4,6.9,106,6.3,104.1,6.3z M104.1,8.4c1,0,1.7,0.4,2.3,1c0.6,0.7,0.8,1.6,0.8,2.6h-6.6c0.1-0.5,0.2-0.9,0.3-1.3 c0.2-0.4,0.4-0.8,0.7-1.2c0.3-0.3,0.6-0.6,1.1-0.8C103.1,8.5,103.6,8.4,104.1,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M120.2,17.7L120.2,17.7L120.2,17.7c-0.2,0.1-0.5,0.2-1,0.3c-0.4,0.2-1,0.2-1.7,0.2c-0.4,0-0.8-0.1-1.1-0.2 c-0.3-0.1-0.6-0.3-0.8-0.5c-0.2-0.2-0.4-0.6-0.5-1c-0.1-0.4-0.2-1-0.2-1.7V8.7h5.1V6.6H115V2.5l-2.4,0.4l0,0V15 c0,0.9,0.1,1.7,0.2,2.4c0.1,0.7,0.4,1.3,0.8,1.7c0.4,0.5,0.9,0.8,1.5,1.1c0.6,0.2,1.4,0.4,2.3,0.4c0.8,0,1.5-0.1,2.1-0.3 c0.6-0.2,1-0.3,1.3-0.5l0,0L120.2,17.7z"
  }))))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "appbar-network-hover",
    viewBox: "-5 5 35 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M10.6,39.9c0.6,0.1,1.3,0.1,1.9,0.1c0.4,0,0.7,0,1.1,0c-3.5-2.8-5.7-7.2-5.7-12c0-8.5,7-15.5,15.5-15.5 c1.3,0,2.6,0.2,3.8,0.5c-0.5-0.9-1.2-1.6-1.9-2.4c-0.6-0.1-1.2-0.1-1.9-0.1c-9.7,0-17.5,7.8-17.5,17.5C5.9,32.6,7.7,36.8,10.6,39.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    d: "M12.5,38c-0.6,0-1.2,0-1.7-0.1C2.9,37.1-3,30.4-3,22.5c0-7.6,5.5-14.1,13-15.3C10.6,7.1,11.2,7,11.9,7 c0.2,0,0.3,0,0.5,0h0.1c4.3,0,8.3,1.7,11.3,4.9c0.6,0.7,1.2,1.4,1.7,2.1c1.6,2.5,2.5,5.5,2.5,8.5c0,3.6-1.3,7.2-3.6,10 c-0.3,0.3-0.5,0.6-0.9,0.9c-2.7,2.7-6.2,4.3-10.1,4.6C13.2,38,12.9,38,12.5,38 M12.5,40c0.4,0,0.7,0,1.1,0 c4.4-0.3,8.4-2.2,11.3-5.2c0.4-0.3,0.7-0.7,1-1.1c2.6-3,4.1-7,4.1-11.2c0-3.5-1.1-6.8-2.9-9.6c-0.5-0.9-1.2-1.6-1.9-2.4 C22,7.1,17.5,5,12.4,5c-0.2,0-0.4,0-0.7,0c-0.8,0-1.5,0.1-2.2,0.2C1.3,6.6-5,13.8-5,22.5c0,9,6.8,16.5,15.6,17.4 C11.2,40,11.9,40,12.5,40L12.5,40z"
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#009EEF",
    cx: 6.8,
    cy: 29.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#009EEF",
    cx: 18.5,
    cy: 12,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.8,32.5l1-1.7c-0.8-0.5-1.6-1-2.3-1.7l-1.2,1.6C18.1,31.3,18.9,31.9,19.8,32.5z M15,28.6l1.4-1.4 c-0.7-0.7-1.3-1.4-1.8-2.2L13,26.2C13.6,27,14.2,27.8,15,28.6z M11.3,23.5l1.8-1c-0.5-0.8-0.9-1.7-1.2-2.6L10,20.6 C10.3,21.7,10.8,22.6,11.3,23.5z M9.1,17.7l2-0.4c-0.2-0.9-0.4-1.9-0.5-2.8l-2,0.2C8.7,15.6,8.8,16.7,9.1,17.7z M10.5,12 c0,0,0.1-1.8,0.2-2.7l-2-0.2c-0.1,1-0.2,1.9-0.2,2.9C8.5,12,10.5,12,10.5,12z M11.2,6.8c0.2-0.6,0.4-1.2,0.6-1.8 C11,5,10.3,5.1,9.6,5.2C9.5,5.6,9.4,5.9,9.3,6.3L11.2,6.8z M24.9,34.8c-0.8-0.2-1.6-0.5-2.3-0.9l0.8-1.8c0.9,0.4,1.8,0.7,2.7,1 l-0.2,0.6L24.9,34.8z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "appbar-network",
    viewBox: "-5 5 35 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M10.6,39.9c0.6,0.1,1.3,0.1,1.9,0.1c0.4,0,0.7,0,1.1,0c-3.5-2.8-5.7-7.2-5.7-12c0-8.5,7-15.5,15.5-15.5 c1.3,0,2.6,0.2,3.8,0.5c-0.5-0.9-1.2-1.6-1.9-2.4c-0.6-0.1-1.2-0.1-1.9-0.1c-9.7,0-17.5,7.8-17.5,17.5C5.9,32.6,7.7,36.8,10.6,39.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M12.5,38c-0.6,0-1.2,0-1.7-0.1C2.9,37.1-3,30.4-3,22.5c0-7.6,5.5-14.1,13-15.3C10.6,7.1,11.2,7,11.9,7 c0.2,0,0.3,0,0.5,0h0.1c4.3,0,8.3,1.7,11.3,4.9c0.6,0.7,1.2,1.4,1.7,2.1c1.6,2.5,2.5,5.5,2.5,8.5c0,3.6-1.3,7.2-3.6,10 c-0.3,0.3-0.5,0.6-0.9,0.9c-2.7,2.7-6.2,4.3-10.1,4.6C13.2,38,12.9,38,12.5,38 M12.5,40c0.4,0,0.7,0,1.1,0 c4.4-0.3,8.4-2.2,11.3-5.2c0.4-0.3,0.7-0.7,1-1.1c2.6-3,4.1-7,4.1-11.2c0-3.5-1.1-6.8-2.9-9.6c-0.5-0.9-1.2-1.6-1.9-2.4 C22,7.1,17.5,5,12.4,5c-0.2,0-0.4,0-0.7,0c-0.8,0-1.5,0.1-2.2,0.2C1.3,6.6-5,13.8-5,22.5c0,9,6.8,16.5,15.6,17.4 C11.2,40,11.9,40,12.5,40L12.5,40z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 6.8,
    cy: 29.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 18.5,
    cy: 12,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M19.8,32.5l1-1.7c-0.8-0.5-1.6-1-2.3-1.7l-1.2,1.6C18.1,31.3,18.9,31.9,19.8,32.5z M15,28.6l1.4-1.4 c-0.7-0.7-1.3-1.4-1.8-2.2L13,26.2C13.6,27,14.2,27.8,15,28.6z M11.3,23.5l1.8-1c-0.5-0.8-0.9-1.7-1.2-2.6L10,20.6 C10.3,21.7,10.8,22.6,11.3,23.5z M9.1,17.7l2-0.4c-0.2-0.9-0.4-1.9-0.5-2.8l-2,0.2C8.7,15.6,8.8,16.7,9.1,17.7z M10.5,12 c0,0,0.1-1.8,0.2-2.7l-2-0.2c-0.1,1-0.2,1.9-0.2,2.9C8.5,12,10.5,12,10.5,12z M11.2,6.8c0.2-0.6,0.4-1.2,0.6-1.8 C11,5,10.3,5.1,9.6,5.2C9.5,5.6,9.4,5.9,9.3,6.3L11.2,6.8z M24.9,34.8c-0.8-0.2-1.6-0.5-2.3-0.9l0.8-1.8c0.9,0.4,1.8,0.7,2.7,1 l-0.2,0.6L24.9,34.8z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "appbar-system-hover",
    viewBox: "-494 367 35 35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#F9FAFA",
    d: "M-466.7,394.2H-494V367h27.3V394.2z M-493,393.2h25.3v-25.3H-493V393.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -491.4,
    y: 375.4,
    opacity: 0.2,
    fill: "#F9FAFA",
    width: 22.1,
    height: 16.1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    d: "M-462.1,394.2c0.6-1.3,1.7-2.1,3-2.2c0.1-0.9,0.2-1.8,0.1-2.6c-0.3-0.1-0.6-0.1-0.9-0.3 c-1.9-0.8-2.7-3-1.9-4.9c0.1-0.3,0.3-0.6,0.5-0.8c-0.5-0.7-1.1-1.3-1.7-1.8c-1,0.8-2.5,1-3.7,0.5c-1.3-0.6-2.1-1.8-2.2-3.1l0,0 c-0.8-0.1-1.7-0.1-2.5,0c0,0.3-0.1,0.7-0.3,1c-0.8,1.9-3,2.7-4.8,1.9c-0.3-0.1-0.6-0.3-0.9-0.5c-0.8,0.6-1.4,1.3-2,2 c0.6,1,0.7,2.3,0.2,3.4c-0.5,1.1-1.5,1.9-2.6,2.1c-0.1,0.8-0.1,1.6-0.1,2.4c0.3,0,0.7,0.1,1,0.3c1.9,0.8,2.7,3,1.9,4.9 c-0.1,0.3-0.3,0.6-0.6,0.9c0.5,0.6,1,1.2,1.6,1.7c1-0.8,2.5-1.1,3.8-0.5c1.3,0.6,2.1,1.8,2.2,3.1c0.9,0.1,1.7,0.1,2.6,0 c0-0.3,0.1-0.6,0.3-0.9c0.8-1.9,3-2.7,4.8-1.9c0.3,0.1,0.5,0.3,0.8,0.5c0.6-0.5,1.1-1,1.6-1.5 C-462.5,396.8-462.7,395.4-462.1,394.2z M-473.3,396.9c-3.6-1.6-5.2-5.8-3.6-9.4c1.6-3.6,5.8-5.3,9.4-3.7c3.6,1.6,5.2,5.8,3.6,9.4 C-465.5,396.8-469.7,398.4-473.3,396.9z"
  })))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "appbar-system",
    viewBox: "-494 367 35 35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#F1F1F1",
    d: "M-466.7,394.2H-494V367h27.3V394.2z M-493,393.2h25.3v-25.3H-493V393.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -491.4,
    y: 375.4,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 22.1,
    height: 16.1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M-462.1,394.2c0.6-1.3,1.7-2.1,3-2.2c0.1-0.9,0.2-1.8,0.1-2.6c-0.3-0.1-0.6-0.1-0.9-0.3 c-1.9-0.8-2.7-3-1.9-4.9c0.1-0.3,0.3-0.6,0.5-0.8c-0.5-0.7-1.1-1.3-1.7-1.8c-1,0.8-2.5,1-3.7,0.5c-1.3-0.6-2.1-1.8-2.2-3.1l0,0 c-0.8-0.1-1.7-0.1-2.5,0c0,0.3-0.1,0.7-0.3,1c-0.8,1.9-3,2.7-4.8,1.9c-0.3-0.1-0.6-0.3-0.9-0.5c-0.8,0.6-1.4,1.3-2,2 c0.6,1,0.7,2.3,0.2,3.4c-0.5,1.1-1.5,1.9-2.6,2.1c-0.1,0.8-0.1,1.6-0.1,2.4c0.3,0,0.7,0.1,1,0.3c1.9,0.8,2.7,3,1.9,4.9 c-0.1,0.3-0.3,0.6-0.6,0.9c0.5,0.6,1,1.2,1.6,1.7c1-0.8,2.5-1.1,3.8-0.5c1.3,0.6,2.1,1.8,2.2,3.1c0.9,0.1,1.7,0.1,2.6,0 c0-0.3,0.1-0.6,0.3-0.9c0.8-1.9,3-2.7,4.8-1.9c0.3,0.1,0.5,0.3,0.8,0.5c0.6-0.5,1.1-1,1.6-1.5 C-462.5,396.8-462.7,395.4-462.1,394.2z M-473.3,396.9c-3.6-1.6-5.2-5.8-3.6-9.4c1.6-3.6,5.8-5.3,9.4-3.7c3.6,1.6,5.2,5.8,3.6,9.4 C-465.5,396.8-469.7,398.4-473.3,396.9z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "appbar-user",
    viewBox: "0 0 34.985 34.971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "USER_ICON"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M17.462,6.65H17.4l-0.005,0c-3.689,0.038-6.658,3.058-6.658,6.767c0,0.562,0.067,1.107,0.196,1.628 l0.472-0.116l-0.206-0.441c-0.218,0.102-0.422,0.24-0.598,0.415l0,0c-0.362,0.361-0.596,0.865-0.596,1.424l0.004,0.065 l0.176,1.307l0.482-0.065h-0.487c0,0.519,0.158,1.015,0.479,1.397c0.318,0.382,0.815,0.628,1.374,0.624h0.068v-0.487l-0.481,0.076 c0.145,0.908,0.33,1.859,0.693,2.715c0.361,0.852,0.922,1.629,1.808,2.084l0.222-0.433l-0.467-0.135 c0,0.001-0.139,0.48-0.278,0.977c-0.07,0.249-0.139,0.502-0.193,0.704c-0.027,0.101-0.049,0.19-0.066,0.262l-0.022,0.1 l-0.015,0.136l0.004,0.061l0.483-0.058l-0.029-0.486c-0.192,0.011-0.313,0.019-0.386,0.024l-0.079,0.005l-0.021,0.002 l-0.013,0.001l-0.018,0.002l-0.034,0.006l-0.063,0.017l-0.101,0.049l-0.114,0.101c-0.046,0.055-0.111,0.164-0.111,0.31 c0,0.192,0.112,0.324,0.172,0.371c0.122,0.093,0.161,0.086,0.193,0.1c0.065,0.014,0.081,0.014,0.091,0.014 c0.004,0,0.007,0,0.012,0.001l0.02,0l0.048-0.002l0.066-0.004l0.034-0.003l0.026-0.003l0.039-0.007l0.068-0.02l0.107-0.055 l0.113-0.107c0.045-0.057,0.1-0.162,0.1-0.295c0.001-0.101-0.035-0.198-0.075-0.26c-0.083-0.122-0.152-0.151-0.192-0.174 l-0.125-0.043l-0.08-0.009l-0.021,0l-0.015,0c-5.073,0.168-8.776,3.657-8.817,3.684l0.002-0.002 c-1.649,1.524-2.276,3.701-2.507,5.55l0.483,0.06l0.129-0.469c-0.995-0.273-1.736-1.189-1.735-2.27V3.328 c0-0.648,0.263-1.234,0.691-1.663c0.428-0.428,1.013-0.692,1.658-0.692h14.178h14.178c0.645,0,1.23,0.264,1.658,0.692 c0.427,0.429,0.691,1.016,0.691,1.663v28.417c0.002,1.081-0.739,1.997-1.735,2.27l0.129,0.469l0.483-0.06 c-0.231-1.849-0.858-4.026-2.507-5.55l0.002,0.002c-0.041-0.027-3.744-3.516-8.817-3.684l-0.015,0l-0.03,0.001l-0.051,0.005 l-0.092,0.023l-0.133,0.073l-0.114,0.127c-0.04,0.062-0.074,0.158-0.073,0.257c0.002,0.181,0.093,0.296,0.143,0.345 c0.108,0.098,0.146,0.096,0.175,0.112l0.079,0.022l0.052,0.007l0.076,0.005l0.034,0.002l0.042,0.001l0.029-0.001l0.059-0.007 l0.105-0.032l0.139-0.091c0.061-0.052,0.156-0.185,0.155-0.356c0-0.146-0.065-0.255-0.111-0.31 c-0.098-0.109-0.146-0.116-0.177-0.135l-0.091-0.03l-0.054-0.009l-0.049-0.004c-0.054-0.004-0.183-0.012-0.458-0.028l-0.029,0.486 l0.483,0.056l0.003-0.059l-0.015-0.136c-0.022-0.112-0.064-0.273-0.119-0.482c-0.165-0.616-0.439-1.561-0.439-1.563l-0.467,0.135 l0.222,0.433c0.886-0.455,1.447-1.231,1.808-2.084c0.363-0.856,0.549-1.806,0.693-2.715l-0.481-0.076v0.487h0.068 c0.559,0.004,1.056-0.242,1.374-0.624c0.321-0.381,0.479-0.878,0.479-1.397h-0.487l0.482,0.065l0.176-1.307l0.004-0.065 c0-0.558-0.234-1.062-0.596-1.424l0,0c-0.175-0.176-0.38-0.313-0.598-0.415l-0.206,0.441l0.472,0.116 c0.129-0.521,0.196-1.067,0.196-1.628c0-3.709-2.968-6.729-6.658-6.767l-0.005,0h-0.062v0.973h0.062l-0.005,0 c3.15,0.031,5.694,2.614,5.694,5.794c0,0.484-0.058,0.951-0.167,1.395c-0.056,0.225,0.056,0.459,0.266,0.557 c0.123,0.057,0.236,0.135,0.321,0.221l0,0c0.194,0.196,0.311,0.453,0.312,0.736h0.487l-0.482-0.065l-0.176,1.307l-0.004,0.065 c0,0.322-0.1,0.593-0.249,0.769c-0.153,0.175-0.339,0.275-0.631,0.279h-0.068c-0.239,0-0.443,0.174-0.481,0.41 c-0.139,0.882-0.318,1.763-0.627,2.486c-0.311,0.726-0.73,1.276-1.358,1.599c-0.206,0.106-0.309,0.345-0.245,0.568 c0,0.001,0.138,0.477,0.276,0.969c0.069,0.246,0.138,0.496,0.188,0.689c0.025,0.096,0.046,0.179,0.06,0.236l0.013,0.062 l0.001,0.003l0.357-0.05l-0.36,0l0.003,0.05l0.357-0.05l-0.36,0h0.457l-0.454-0.053l-0.003,0.053h0.457l-0.454-0.053 c-0.015,0.133,0.025,0.266,0.111,0.369c0.086,0.102,0.21,0.165,0.344,0.173c0.191,0.011,0.311,0.019,0.383,0.023l0.073,0.005 l0.012,0.001l0.022-0.276l-0.027,0.275l0.005,0l0.022-0.276l-0.027,0.275l0.044-0.459l-0.061,0.457l0.016,0.002l0.044-0.459 l-0.061,0.457l0.064-0.479l-0.097,0.473l0.033,0.006l0.064-0.479l-0.097,0.473l0.097-0.476l-0.16,0.459l0.062,0.017l0.097-0.476 l-0.16,0.459l0.16-0.459l-0.261,0.41l0.101,0.049l0.16-0.459l-0.261,0.41l0.261-0.411l-0.375,0.31l0.114,0.101l0.261-0.411 l-0.375,0.31l0.375-0.31l-0.487,0c0,0.146,0.065,0.255,0.111,0.31l0.375-0.31l-0.487,0h0.487l-0.332-0.356 c-0.061,0.052-0.156,0.185-0.155,0.356h0.487l-0.332-0.356l0.332,0.356l-0.132-0.468c-0.034,0.015-0.08,0.011-0.2,0.113 l0.332,0.356l-0.132-0.468l0.131,0.468l-0.02-0.486c-0.005,0.001-0.008,0.001-0.012,0.001c-0.011,0-0.028,0-0.099,0.017 l0.131,0.468l-0.02-0.486l0.02,0.48v-0.48l-0.02,0l0.02,0.48v-0.48v0.424l0.017-0.424l-0.017,0v0.424l0.017-0.424l-0.05-0.003 L21.6,25.197l-0.012,0.139l0.016-0.139l-0.004,0l-0.012,0.139l0.016-0.139l-0.05,0.434l0.076-0.431l-0.027-0.004l-0.05,0.434 l0.076-0.431l-0.084,0.472l0.139-0.459l-0.055-0.013l-0.084,0.472l0.139-0.459l-0.141,0.465l0.236-0.424l-0.095-0.04l-0.141,0.465 l0.236-0.424l-0.236,0.425l0.354-0.334l-0.117-0.091l-0.236,0.425l0.354-0.334l-0.354,0.334h0.486 c-0.001-0.169-0.083-0.283-0.133-0.334l-0.354,0.334h0.486h-0.486l0.413,0.257c0.04-0.062,0.074-0.158,0.073-0.257h-0.486 l0.413,0.257l-0.413-0.257l0.222,0.433c0.04-0.024,0.11-0.054,0.191-0.176l-0.413-0.257l0.222,0.433l-0.222-0.432l0.096,0.476 l0.126-0.044l-0.222-0.432l0.096,0.476l-0.093-0.464l0.016,0.473l0.077-0.009l-0.093-0.464l0.016,0.473l-0.012-0.352v0.353 l0.012,0l-0.012-0.352v0.353V25.68l-0.015,0.486c2.313,0.069,4.368,0.923,5.841,1.768c0.737,0.422,1.327,0.84,1.731,1.15 c0.202,0.155,0.357,0.284,0.46,0.372l0.116,0.101l0.035,0.031l0.002,0.002c1.391,1.273,1.988,3.221,2.2,4.953 c0.017,0.14,0.095,0.266,0.212,0.345c0.117,0.078,0.264,0.102,0.399,0.065c1.409-0.386,2.449-1.675,2.451-3.209V3.328 C34.983,1.495,33.494,0.002,31.663,0H17.485H3.307c-1.831,0.002-3.32,1.495-3.322,3.328v28.417 c0.002,1.533,1.041,2.822,2.451,3.209c0.136,0.037,0.282,0.013,0.399-0.065c0.117-0.078,0.195-0.205,0.212-0.345 c0.212-1.732,0.809-3.68,2.2-4.953l0.002-0.002l0.035-0.031c0.378-0.347,3.813-3.271,8.148-3.392l-0.015-0.486v0.487v-0.382 l-0.02,0.382l0.02,0.001v-0.382l-0.02,0.382l0.024-0.473l-0.072,0.468l0.048,0.005l0.024-0.473l-0.072,0.468l0.074-0.479 l-0.163,0.457l0.09,0.023l0.074-0.479l-0.163,0.457l0.164-0.458l-0.296,0.386l0.132,0.072l0.164-0.458l-0.296,0.386l0.296-0.386 l-0.411,0.26l0.115,0.126l0.296-0.386l-0.411,0.26l0.411-0.26h-0.486c-0.001,0.101,0.035,0.198,0.075,0.26l0.411-0.26h-0.486 h0.486l-0.343-0.345c-0.05,0.049-0.141,0.164-0.143,0.345h0.486l-0.343-0.345l0.343,0.344l-0.168-0.456 c-0.029,0.016-0.067,0.014-0.175,0.112l0.343,0.344l-0.168-0.456l0.167,0.452l-0.089-0.474l-0.077,0.021l0.167,0.452l-0.089-0.474 l0.075,0.397l-0.038-0.403l-0.037,0.005l0.075,0.397l-0.038-0.403L13.326,25.2L13.3,25.202l-0.007,0l0.017,0.374v-0.374l-0.017,0 l0.017,0.374v-0.374v0.481l0.027-0.481l-0.027-0.001v0.481l0.027-0.481l-0.028,0.485l0.081-0.479l-0.054-0.006l-0.028,0.485 l0.081-0.479l-0.081,0.48l0.179-0.452l-0.097-0.027l-0.081,0.48l0.179-0.452l-0.179,0.452l0.314-0.371l-0.135-0.081l-0.179,0.452 l0.314-0.371l-0.314,0.371h0.487c0-0.192-0.112-0.324-0.172-0.371l-0.314,0.371h0.487H13.31l0.375,0.31 c0.046-0.055,0.111-0.164,0.111-0.31H13.31l0.375,0.31l-0.375-0.31l0.198,0.445c0.032-0.019,0.079-0.025,0.177-0.135l-0.375-0.31 l0.198,0.445l-0.198-0.444l0.107,0.474l0.09-0.03l-0.198-0.444l0.107,0.474l-0.106-0.47l0.053,0.479l0.053-0.009l-0.106-0.47 l0.053,0.479l-0.043-0.386l0.032,0.387l0.011-0.001l-0.043-0.386l0.032,0.387c0.005-0.001,0.128-0.009,0.468-0.029 c0.133-0.008,0.259-0.071,0.344-0.174c0.086-0.103,0.126-0.237,0.11-0.37l-0.454,0.054h0.458L14.275,25.6l-0.454,0.054h0.458 h-0.36l0.357,0.05l0.003-0.05h-0.36l0.357,0.05l0.001-0.003c0.008-0.046,0.05-0.215,0.103-0.411 c0.16-0.599,0.434-1.544,0.435-1.546c0.065-0.223-0.038-0.462-0.245-0.568c-0.628-0.324-1.047-0.873-1.358-1.599 c-0.309-0.723-0.488-1.604-0.627-2.486c-0.037-0.236-0.241-0.41-0.481-0.41h-0.068c-0.292-0.004-0.478-0.105-0.631-0.279 c-0.15-0.176-0.25-0.446-0.249-0.769l-0.004-0.065l-0.176-1.307l-0.482,0.065h0.487c0-0.283,0.117-0.541,0.312-0.736l0,0 c0.085-0.086,0.198-0.164,0.321-0.221c0.21-0.098,0.322-0.332,0.266-0.557c-0.11-0.445-0.167-0.911-0.167-1.395 c0-3.18,2.544-5.763,5.694-5.794l-0.005,0h0.062V6.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E8E8E8"
    },
    points: "31.663,0.487 17.485,0.487 31.663,0.487  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "backplate-normal",
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M24,26H2c-1.105,0-2-0.895-2-2V2c0-1.105,0.895-2,2-2h22c1.105,0,2,0.895,2,2v22C26,25.105,25.105,26,24,26z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 13.65,
    fill: "#C3C5C6",
    width: 11.05,
    height: 8.45
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.95,
    y: 19.5,
    fill: "#C3C5C6",
    width: 8.45,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.95,
    y: 13.65,
    fill: "#C3C5C6",
    width: 8.45,
    height: 4.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C3C5C6",
    points: "22.75,3.25 18.85,7.54 20.8,7.54 18.85,11.05 22.75,6.76 20.8,6.76 22.75,3.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C3C5C6",
    points: "7.15,3.25 3.25,7.54 5.2,7.54 3.25,11.05 7.15,6.76 5.2,6.76 7.15,3.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C3C5C6",
    d: "M12.231,3.878c-0.301,0-0.652,0.132-1.051,0.412c-0.455,0.325-0.715,0.715-0.65,1.105 c0.1,0.748,1.113,1.34,1.67,1.606c-0.017,0.071-0.045,0.138-0.045,0.214c0,0.449,0.313,0.815,0.737,0.941 c0.031,0.526-0.033,1.511-0.477,1.789c-0.098,0.065-0.211,0.098-0.349,0.098c-0.138,0-0.301-0.033-0.496-0.098 c-0.325-0.13-0.715-0.39-0.715-0.65c0.065-0.39,0.91-0.845,1.3-0.975l-0.13-0.455c-0.52,0.13-1.56,0.65-1.625,1.365 c0,0.39,0.325,0.78,1.04,1.04c0.26,0.065,0.52,0.13,0.715,0.13s0.455-0.065,0.585-0.13c0.666-0.41,0.685-1.537,0.664-2.096 c0.471-0.096,0.831-0.478,0.831-0.959c0-0.099-0.031-0.188-0.058-0.279c0.405-0.204,1.05-0.442,1.548-0.442 c0.149,0,0.284,0.021,0.396,0.071c0.195,0.13,0.325,0.325,0.325,0.715c0,0.325-0.065,0.78-0.325,0.91 c-0.055,0.016-0.114,0.023-0.176,0.023c-0.459,0-1.098-0.387-1.384-0.673l-0.39,0.325c0.325,0.26,1.105,0.78,1.755,0.78 c0.13,0,0.26,0,0.455-0.065c0.39-0.13,0.585-0.585,0.585-1.3c-0.065-0.52-0.26-0.91-0.65-1.105 c-0.191-0.095-0.41-0.134-0.638-0.134c-0.63,0-1.335,0.293-1.73,0.491c-0.19-0.193-0.454-0.317-0.753-0.317 c-0.302,0-0.569,0.128-0.759,0.326c-0.517-0.266-1.333-0.737-1.386-1.211c0-0.195,0.13-0.455,0.455-0.65 c0.252-0.151,0.543-0.302,0.782-0.302c0.07,0,0.135,0.013,0.193,0.042c0.325,0.195,0.325,1.105,0.26,1.495l0.52,0.065 c0.065-0.26,0.195-1.56-0.52-1.95C12.59,3.93,12.42,3.878,12.231,3.878L12.231,3.878z"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C5C6",
    d: "M24,1c0.551,0,1,0.449,1,1v22c0,0.551-0.449,1-1,1H2c-0.551,0-1-0.449-1-1V2c0-0.551,0.449-1,1-1H24 M24,0H2 C0.895,0,0,0.895,0,2v22c0,1.105,0.895,2,2,2h22c1.105,0,2-0.895,2-2V2C26,0.895,25.105,0,24,0L24,0z"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "blueplanet-logo",
    viewBox: "0 0 125 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M10.7,8.3c-0.5-0.6-1.2-1.1-1.9-1.5C8.1,6.5,7.2,6.3,6.2,6.3c-0.8,0-1.5,0.1-2.1,0.3C3.6,6.8,3.1,7,2.8,7.2 V0L0.4,0.4l0,0v19.4l0,0c0.6,0.2,1.3,0.3,2.1,0.5c0.9,0.2,1.9,0.2,3,0.2c1,0,2-0.2,2.8-0.5c0.8-0.3,1.5-0.8,2.1-1.4 c0.6-0.6,1-1.4,1.4-2.2c0.3-0.9,0.5-1.9,0.5-3c0-1-0.1-2-0.4-2.9C11.6,9.7,11.2,8.9,10.7,8.3z M9.7,13.4c0,1.6-0.4,2.8-1.2,3.6 c-0.8,0.8-1.8,1.3-3.1,1.3c-0.7,0-1.2,0-1.6-0.1c-0.4-0.1-0.8-0.1-1-0.2V9.5c0.3-0.2,0.7-0.5,1.3-0.7c0.5-0.2,1.2-0.3,1.8-0.3 c0.7,0,1.3,0.1,1.8,0.4c0.5,0.2,0.9,0.6,1.2,1c0.3,0.4,0.5,1,0.7,1.6C9.7,12.1,9.7,12.7,9.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M18.6,18.2c-0.3-0.1-0.5-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-1V0l-2.4,0.4l0,0v16.2 c0,1.3,0.3,2.2,0.9,2.8c0.6,0.6,1.7,0.9,3.2,1l0,0l0.3-2.1l0,0C19.2,18.3,18.9,18.3,18.6,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M30,18.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0.1-0.7,0.1c-0.2,0-0.5,0-0.8,0.1c-0.3,0-0.5,0-0.8,0 c-1.2,0-2.1-0.4-2.6-1.1c-0.5-0.7-0.8-1.9-0.8-3.5V6.6h-2.5v7.6c0,0.9,0.1,1.8,0.3,2.5c0.2,0.8,0.5,1.4,0.9,2c0.4,0.6,1,1,1.7,1.3 c0.7,0.3,1.6,0.5,2.6,0.5c1.2,0,2.3-0.1,3.2-0.2c0.9-0.2,1.6-0.3,2.2-0.4l0,0V6.6H30V18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M45.7,8c-1-1.1-2.4-1.7-4.2-1.7c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.3-1.4,0.7-2,1.3c-0.6,0.6-1,1.3-1.4,2.2 c-0.3,0.9-0.5,1.9-0.5,3.1c0,1,0.1,2,0.4,2.8c0.3,0.9,0.7,1.6,1.2,2.2c0.6,0.6,1.3,1.1,2.1,1.5c0.9,0.4,1.9,0.5,3.1,0.5 c0.9,0,1.8-0.1,2.5-0.3c0.7-0.2,1.3-0.3,1.6-0.5l0,0l-0.3-2l0,0l0,0c-0.3,0.1-0.7,0.3-1.3,0.4c-0.6,0.1-1.3,0.2-2.1,0.2 c-1.5,0-2.6-0.4-3.3-1.1c-0.7-0.7-1.1-1.8-1.2-3.1h9.2l0,0c0-0.1,0-0.3,0-0.5v-0.4C47.2,10.9,46.7,9.2,45.7,8z M41.5,8.4 c1,0,1.7,0.4,2.3,1c0.6,0.7,0.8,1.6,0.8,2.6H38c0.1-0.5,0.2-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.7-1.2c0.3-0.3,0.7-0.6,1.1-0.8 C40.4,8.5,40.9,8.4,41.5,8.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M60.2,8.3c-0.6-0.6-1.3-1.1-2.1-1.4c-0.8-0.3-1.8-0.5-2.8-0.5c-1.1,0-2.1,0.1-3,0.2 c-0.9,0.2-1.6,0.3-2.1,0.5l0,0V25h2.5v-5.4c0.3,0.2,0.7,0.4,1.3,0.6c0.6,0.2,1.3,0.3,2.1,0.3c1,0,1.8-0.2,2.6-0.5 c0.8-0.3,1.4-0.8,1.9-1.5c0.5-0.6,0.9-1.4,1.2-2.2c0.3-0.9,0.4-1.8,0.4-2.8c0-1.1-0.2-2.1-0.5-3C61.2,9.6,60.8,8.9,60.2,8.3z  M52.5,8.8c0.2-0.1,0.6-0.1,1-0.2c0.4-0.1,1-0.1,1.7-0.1c1.3,0,2.3,0.4,3.1,1.3c0.8,0.8,1.2,2.1,1.2,3.6c0,0.7-0.1,1.3-0.2,1.9 c-0.1,0.6-0.4,1.1-0.7,1.5c-0.3,0.4-0.7,0.8-1.2,1c-0.5,0.2-1.1,0.4-1.8,0.4c-0.7,0-1.3-0.1-1.8-0.3c-0.5-0.2-1-0.5-1.3-0.7V8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M68.3,18.2c-0.3-0.1-0.5-0.2-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-1V0l-2.4,0.4l0,0 v16.2c0,1.3,0.3,2.2,0.9,2.8c0.6,0.6,1.7,0.9,3.2,1l0,0l0.3-2l0,0l0,0C68.9,18.3,68.6,18.3,68.3,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.9,7.8c-0.4-0.5-1-0.8-1.6-1.1c-0.7-0.3-1.5-0.4-2.5-0.4c-0.8,0-1.6,0.1-2.4,0.2 c-0.7,0.1-1.3,0.3-1.6,0.4l0,0l0.3,2l0,0l0,0c0.3-0.1,0.7-0.2,1.3-0.3c0.6-0.1,1.3-0.2,2.1-0.2c0.6,0,1.1,0.1,1.5,0.3 c0.4,0.2,0.7,0.4,0.9,0.7c0.2,0.3,0.4,0.6,0.5,1c0.1,0.4,0.1,0.8,0.1,1.2v0.6c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4-0.1-0.6-0.1 c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.8,0c-0.8,0-1.5,0.1-2.2,0.2c-0.7,0.2-1.3,0.4-1.8,0.7c-0.5,0.3-0.9,0.8-1.2,1.3 c-0.3,0.5-0.5,1.2-0.5,1.9c0,0.8,0.1,1.5,0.4,2c0.3,0.6,0.6,1,1.1,1.3c0.5,0.3,1,0.6,1.7,0.7c0.6,0.2,1.3,0.2,2.1,0.2 c0.5,0,1.1,0,1.6-0.1c0.5,0,1.1-0.1,1.5-0.1c0.5-0.1,0.9-0.1,1.3-0.2C80.5,20,80.8,20,81,20l0,0v-8.5c0-0.8-0.1-1.5-0.3-2.1 C80.6,8.8,80.3,8.2,79.9,7.8z M78.6,14.2v4c-0.3,0.1-0.7,0.1-1.1,0.1c-0.4,0-0.9,0-1.5,0c-0.9,0-1.7-0.2-2.2-0.5 c-0.5-0.3-0.8-0.9-0.8-1.8c0-0.5,0.1-0.8,0.3-1.1c0.2-0.3,0.5-0.5,0.8-0.7c0.3-0.2,0.7-0.3,1.1-0.3c0.4-0.1,0.8-0.1,1.2-0.1 c0.5,0,1,0,1.4,0.1C78.2,14.1,78.4,14.2,78.6,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M94.2,8.1c-0.4-0.5-1-1-1.7-1.3c-0.7-0.3-1.6-0.5-2.7-0.5c-1.2,0-2.3,0.1-3.2,0.2C85.8,6.8,85,6.9,84.5,7 l0,0v13.2h2.5V8.8c0.1,0,0.2,0,0.4-0.1c0.2,0,0.4-0.1,0.7-0.1c0.2,0,0.5,0,0.8-0.1c0.3,0,0.6,0,0.8,0c0.6,0,1.2,0.1,1.6,0.2 c0.4,0.2,0.8,0.4,1,0.8c0.3,0.4,0.4,0.8,0.6,1.4c0.1,0.6,0.2,1.3,0.2,2.1v7.1h2.5v-7.6c0-0.9-0.1-1.8-0.3-2.5 C95,9.3,94.7,8.6,94.2,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.2,6.3c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.3-1.4,0.7-2,1.3c-0.6,0.6-1,1.3-1.4,2.2 c-0.3,0.9-0.5,1.9-0.5,3.1c0,1,0.1,2,0.4,2.8c0.3,0.9,0.7,1.6,1.2,2.2c0.6,0.6,1.3,1.1,2.1,1.5c0.9,0.4,1.9,0.5,3.1,0.5 c0.9,0,1.8-0.1,2.5-0.3c0.7-0.2,1.3-0.3,1.6-0.5l0,0l-0.3-2l0,0l0,0c-0.3,0.1-0.7,0.3-1.3,0.4c-0.6,0.1-1.3,0.2-2.1,0.2 c-1.5,0-2.6-0.4-3.3-1.1c-0.7-0.7-1.1-1.8-1.2-3.1h9.2l0,0c0-0.1,0-0.3,0-0.5v-0.4c0-2.3-0.5-4.1-1.5-5.2 C107.5,6.9,106.1,6.3,104.2,6.3z M104.2,8.4c1,0,1.7,0.4,2.3,1c0.6,0.7,0.8,1.6,0.8,2.6h-6.6c0.1-0.5,0.2-0.9,0.3-1.3 c0.2-0.4,0.4-0.8,0.7-1.2c0.3-0.3,0.6-0.6,1.1-0.8C103.2,8.5,103.7,8.4,104.2,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M120.3,17.7L120.3,17.7L120.3,17.7c-0.2,0.1-0.5,0.2-1,0.3c-0.4,0.2-1,0.2-1.7,0.2c-0.4,0-0.8-0.1-1.1-0.2 c-0.3-0.1-0.6-0.3-0.8-0.5c-0.2-0.2-0.4-0.6-0.5-1c-0.1-0.4-0.2-1-0.2-1.7V8.7h5.1V6.6h-5.1V2.5l-2.4,0.4l0,0V15 c0,0.9,0.1,1.7,0.2,2.4c0.1,0.7,0.4,1.3,0.8,1.7c0.4,0.5,0.9,0.8,1.5,1.1c0.6,0.2,1.4,0.4,2.3,0.4c0.8,0,1.5-0.1,2.1-0.3 c0.6-0.2,1-0.3,1.3-0.5l0,0L120.3,17.7z"
  }))))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "blueplanet-strip",
    viewBox: "0 0 5 370"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4CA3D6",
    points: "0,0 0,8 5,7.4 5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4CA3D6",
    points: "0,0 0,8 5,7.4 5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#429ED4",
    points: "0,8 0,14.6 5,14 5,7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2A8FCD",
    points: "0,14.6 0,16.4 5,20.9 5,13.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1977C2",
    points: "0,25.5 0,35.5 5,42.8 5,38.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1E89CA",
    points: "0,35.3 0,90.5 5,96.9 5,42.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1767B6",
    points: "0,90.5 0,127 5,129.5 5,96.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1353A5",
    points: "0,127 0,157 5,156.7 5,129.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#135BAC",
    points: "0,156.9 0,191 5,187.2 5,156.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A73BF",
    points: "0,191 0,195.8 5,200.1 5,187.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#247BC3",
    points: "5,203.9 5,199.1 0,194.8 0,207.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3B93CE",
    points: "5,218.4 5,203.9 0,207.7 0,224.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#67B0DB",
    points: "5,238.3 5,218.4 0,224 0,234.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3B93CE",
    points: "5,256.2 5,238.3 0,234.6 0,259.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1354A9",
    points: "5,264.3 5,260.6 0,259.2 0,263.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0F49A2",
    points: "5,273.4 5,263.2 0,262.4 0,274.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0F4DA5",
    points: "5,278.9 5,272.3 0,274.6 0,281.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#135EB2",
    points: "5,283.7 5,278.9 0,281.2 0,287.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1B77C1",
    points: "5,306.4 5,283.7 0,287.3 0,307.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A75C0",
    points: "5,322 5,314.2 0,313.4 0,334.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2484C7",
    points: "5,370 5,322 0,334.4 0,370  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#227AC3",
    points: "5,314.4 5,305.3 0,307.9 0,313.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#278BCA",
    points: "5,260.6 5,256.2 0,259.2 0,259.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C7CC3",
    points: "0,16.4 0,25.6 5,38.6 5,20.9  "
  })))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "blueplanet",
    viewBox: "0 0 730 200"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M60.1,49c-2.9-3.4-6.4-6.2-10.6-8.1c-4.2-1.9-9-2.9-14.4-2.9c-4.3,0-8.2,0.6-11.5,1.7 c-3.2,1.1-5.6,2.2-7.2,3.2v-40L2.9,5.3l-0.1,0v107.3l0.1,0c3.1,0.9,7,1.7,11.8,2.6c4.8,0.9,10.3,1.3,16.6,1.3 c5.7,0,11-0.9,15.6-2.7c4.6-1.8,8.6-4.4,11.8-7.8c3.3-3.4,5.8-7.5,7.6-12.3c1.8-4.8,2.7-10.3,2.7-16.4c0-5.7-0.8-11.1-2.2-15.9 C65.2,56.6,63,52.5,60.1,49z M54.7,77.3c0,8.6-2.2,15.4-6.4,20.1c-4.3,4.7-10,7.1-17.1,7.1c-3.6,0-6.7-0.2-9.1-0.5 c-2.4-0.3-4.2-0.7-5.6-1V55.8c1.6-1.3,3.9-2.6,7-3.8c3-1.2,6.4-1.9,10-1.9c3.8,0,7.1,0.7,9.8,2.1c2.7,1.4,4.9,3.3,6.6,5.7 c1.7,2.4,3,5.3,3.7,8.6C54.3,69.9,54.7,73.5,54.7,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M103.8,103.7c-1.4-0.4-2.5-1.1-3.4-1.9c-0.8-0.8-1.5-2-1.8-3.4C98.2,97,98,95.1,98,93v-90L84.4,5.3l-0.1,0 v89.8c0,7.1,1.8,12.4,5.2,15.8c3.5,3.4,9.4,5.2,17.6,5.4l0.1,0l1.9-11.5l-0.1,0C107,104.5,105.2,104.1,103.8,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M167.1,102.9c-0.5,0.2-1.2,0.3-2.2,0.5c-1.1,0.1-2.3,0.3-3.7,0.4c-1.4,0.1-2.8,0.3-4.3,0.4 c-1.5,0.1-3,0.1-4.4,0.1c-6.7,0-11.6-2-14.4-5.8c-2.8-3.9-4.3-10.4-4.3-19.5V39.8h-13.7v42.1c0,5.1,0.5,9.8,1.6,13.9 c1.1,4.2,2.8,7.8,5.2,10.9c2.4,3.1,5.6,5.5,9.5,7.2c3.9,1.7,8.8,2.5,14.6,2.5c6.6,0,12.5-0.4,17.5-1.3c5-0.9,9.1-1.7,12.2-2.4 l0.1,0V39.8h-13.7V102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009ADE",
    d: "M253.9,47.4c-5.4-6.3-13.2-9.5-23.3-9.5c-4.3,0-8.6,0.8-12.7,2.5c-4.1,1.6-7.8,4.1-11,7.4 c-3.2,3.3-5.7,7.4-7.6,12.3c-1.9,4.9-2.9,10.8-2.9,17.4c0,5.6,0.8,10.9,2.2,15.6c1.5,4.7,3.8,8.9,6.9,12.3c3.1,3.5,7,6.2,11.8,8.2 c4.7,2,10.4,3,16.9,3c5.2,0,9.8-0.5,13.9-1.4c4.1-1,7-1.9,8.6-2.7l0.1,0l-1.9-11.3l0-0.2l-0.2,0.1c-1.6,0.8-4,1.6-7.2,2.4 c-3.2,0.8-7.2,1.2-11.8,1.2c-8.3,0-14.4-2-18.3-6c-3.9-4-6.1-9.8-6.7-17.4h51.1l0-0.1c0.1-0.8,0.1-1.6,0.1-2.5v-2.2 C262,63.3,259.3,53.7,253.9,47.4z M230.5,49.6c5.4,0,9.7,1.9,12.8,5.8c3.1,3.8,4.6,8.7,4.5,14.6H211c0.3-2.5,0.9-5,1.8-7.4 c0.9-2.5,2.2-4.7,3.8-6.6c1.6-1.9,3.6-3.5,5.9-4.6C224.8,50.2,227.5,49.6,230.5,49.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M690.4,45.7c0,1.1-0.2,2.1-0.6,3c-0.4,0.9-0.9,1.7-1.5,2.3c-0.6,0.6-1.3,1.1-2.2,1.4 c-0.8,0.3-1.7,0.5-2.6,0.5c-0.9,0-1.8-0.2-2.6-0.5c-0.8-0.3-1.5-0.8-2.2-1.4c-0.6-0.6-1.1-1.4-1.5-2.3c-0.4-0.9-0.6-1.9-0.6-3 s0.2-2.1,0.6-3c0.4-0.9,0.9-1.6,1.5-2.3c0.6-0.6,1.3-1.1,2.2-1.4c0.8-0.3,1.7-0.5,2.6-0.5c0.9,0,1.8,0.2,2.6,0.5 c0.8,0.3,1.5,0.8,2.2,1.4c0.6,0.6,1.1,1.4,1.5,2.3C690.2,43.5,690.4,44.5,690.4,45.7z M688.9,45.7c0-0.9-0.1-1.7-0.4-2.4 c-0.3-0.7-0.6-1.3-1.1-1.9c-0.5-0.5-1-0.9-1.7-1.2c-0.7-0.3-1.4-0.4-2.2-0.4c-0.8,0-1.5,0.1-2.2,0.4c-0.7,0.3-1.2,0.7-1.7,1.2 c-0.5,0.5-0.8,1.1-1.1,1.9c-0.3,0.7-0.4,1.5-0.4,2.4c0,0.9,0.1,1.7,0.4,2.4c0.3,0.7,0.6,1.3,1.1,1.9c0.5,0.5,1,0.9,1.7,1.2 c0.7,0.3,1.4,0.4,2.2,0.4c0.8,0,1.5-0.1,2.2-0.4c0.7-0.3,1.2-0.7,1.7-1.2c0.5-0.5,0.8-1.1,1.1-1.9 C688.8,47.3,688.9,46.5,688.9,45.7z M685.6,49.6c-0.3-0.6-0.6-1.2-1-1.7c-0.4-0.5-0.7-1-1-1.3h-1.3v3h-1.4v-7.7 c0.4-0.1,0.7-0.1,1.1-0.2c0.4,0,0.8-0.1,1.1-0.1c1.1,0,2,0.2,2.6,0.6c0.6,0.4,0.9,1.1,0.9,1.9c0,0.5-0.1,0.9-0.4,1.3 c-0.3,0.4-0.6,0.6-1.1,0.8c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.4,0.5,0.5,0.8c0.2,0.3,0.4,0.6,0.6,0.9c0.2,0.3,0.4,0.6,0.5,1H685.6 z M682.2,45.5h0.8c0.6,0,1.1-0.1,1.5-0.2s0.6-0.5,0.6-1c0-0.5-0.2-0.8-0.6-1c-0.4-0.2-0.8-0.3-1.4-0.3c-0.1,0-0.3,0-0.5,0 c-0.2,0-0.3,0-0.5,0V45.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M334,48.7c-3.3-3.4-7.2-6-11.8-7.8c-4.6-1.8-9.8-2.7-15.6-2.7c-6.2,0-11.8,0.5-16.5,1.4 c-4.7,0.9-8.7,1.8-11.9,2.5l-0.1,0v99.3h13.7v-29.8c1.6,1,4,2.1,7.2,3.2c3.3,1.1,7.2,1.7,11.5,1.7c5.4,0,10.2-1,14.4-2.9 c4.2-1.9,7.7-4.6,10.6-8.1c2.9-3.4,5.1-7.6,6.6-12.4c1.5-4.8,2.2-10.1,2.2-15.7c0-6-0.9-11.5-2.7-16.4 C339.8,56.2,337.2,52.1,334,48.7z M291.7,51.8c1.3-0.4,3.1-0.7,5.3-1c2.2-0.3,5.4-0.4,9.4-0.4c7.1,0,12.9,2.4,17.1,7 c4.3,4.6,6.4,11.4,6.4,20c0,3.8-0.4,7.4-1.1,10.7c-0.8,3.3-2,6.2-3.7,8.6c-1.7,2.4-3.9,4.3-6.6,5.7c-2.7,1.4-6,2.1-9.8,2.1 c-3.6,0-7-0.6-10-1.9c-3-1.2-5.3-2.5-7-3.8V51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M379,103.7c-1.4-0.4-2.5-1.1-3.4-1.9c-0.8-0.8-1.5-2-1.8-3.4c-0.4-1.4-0.6-3.2-0.6-5.4v-90l-13.5,2.3 l-0.1,0v89.8c0,7.1,1.8,12.4,5.2,15.8c3.5,3.4,9.4,5.2,17.6,5.4l0.1,0l1.9-11.3l0-0.1l-0.1,0C382.2,104.5,380.5,104.1,379,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M443.2,45.9c-2.3-2.5-5.3-4.5-9-5.9c-3.7-1.4-8.3-2.1-13.6-2.1c-4.7,0-9.1,0.4-13.1,1.1 c-4,0.7-6.9,1.5-8.7,2.2l-0.1,0l1.6,11.2l0,0.2l0.2-0.1c1.6-0.7,4.1-1.3,7.4-1.9c3.3-0.6,7.2-0.9,11.5-0.9c3.4,0,6.2,0.5,8.3,1.5 c2.1,1,3.8,2.3,5,4c1.2,1.7,2.1,3.6,2.6,5.7c0.5,2.1,0.7,4.3,0.7,6.5v3.6c-0.4-0.1-1-0.2-1.8-0.4c-1-0.2-2.2-0.4-3.4-0.6 c-1.3-0.2-2.7-0.4-4.1-0.6c-1.4-0.1-2.8-0.2-4.2-0.2c-4.2,0-8.3,0.4-12.1,1.3c-3.8,0.9-7.2,2.2-10.1,4c-2.9,1.8-5.2,4.3-6.9,7.2 c-1.7,3-2.5,6.6-2.5,10.7c0,4.3,0.7,8.1,2.2,11.1c1.4,3.1,3.5,5.6,6.1,7.5c2.6,1.9,5.7,3.3,9.3,4.1c3.5,0.9,7.5,1.3,11.7,1.3 c2.9,0,6-0.1,9-0.4c3-0.2,5.9-0.5,8.4-0.8c2.6-0.3,4.9-0.6,7-0.9c2.1-0.3,3.7-0.6,4.8-0.8l0.1,0V66.7c0-4.2-0.5-8.1-1.4-11.6 C447,51.5,445.4,48.5,443.2,45.9z M436.1,81.8v22.1c-1.6,0.4-3.6,0.6-6,0.8c-2.4,0.1-5.3,0.2-8.4,0.2c-5.2,0-9.4-0.9-12.4-2.8 c-3-1.8-4.5-5.2-4.5-9.9c0-2.5,0.6-4.6,1.8-6.2c1.2-1.6,2.8-2.8,4.6-3.7c1.8-0.9,3.9-1.5,6.1-1.8c2.2-0.3,4.4-0.4,6.4-0.4 c3,0,5.7,0.2,7.8,0.5C433.6,81,435.1,81.4,436.1,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M522.7,47.8c-2.4-3-5.5-5.4-9.5-7.1c-3.9-1.7-8.9-2.5-14.9-2.5c-6.6,0-12.5,0.4-17.6,1.3 c-5.1,0.9-9.2,1.7-12.2,2.4l-0.1,0v72.9h13.7V51.7c0.5-0.1,1.2-0.2,2.3-0.4c1.1-0.2,2.4-0.4,3.7-0.5c1.4-0.1,2.9-0.3,4.4-0.4 c1.6-0.1,3-0.1,4.4-0.1c3.5,0,6.5,0.5,8.9,1.4c2.4,0.9,4.3,2.4,5.7,4.3c1.4,2,2.4,4.6,3.1,7.9c0.6,3.2,0.9,7.2,0.9,11.8v39.2h13.7 V72.7c0-5.1-0.5-9.8-1.4-14C526.7,54.5,525,50.8,522.7,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M578.1,37.9c-4.3,0-8.6,0.8-12.7,2.5c-4.1,1.6-7.8,4.1-11,7.4c-3.2,3.3-5.7,7.4-7.7,12.3 c-1.9,4.9-2.9,10.8-2.9,17.4c0,5.6,0.8,10.9,2.2,15.6c1.5,4.7,3.8,8.9,6.9,12.3c3.1,3.5,7,6.2,11.8,8.2c4.7,2,10.4,3,16.9,3 c5.2,0,9.8-0.5,13.9-1.4c4.1-1,7-1.9,8.6-2.7l0.1,0l-1.9-11.3l0-0.2l-0.2,0.1c-1.6,0.8-4,1.6-7.2,2.4c-3.2,0.8-7.2,1.2-11.8,1.2 c-8.3,0-14.4-2-18.3-6c-3.9-4-6.1-9.8-6.7-17.4h51.1l0-0.1c0.1-0.8,0.1-1.6,0.1-2.5v-2.2c0-12.8-2.7-22.5-8.1-28.8 C596,41.1,588.2,37.9,578.1,37.9z M578,49.6c5.4,0,9.7,1.9,12.8,5.8c3.1,3.8,4.6,8.7,4.5,14.6h-36.8c0.3-2.5,0.9-5,1.8-7.4 c0.9-2.5,2.2-4.7,3.8-6.6c1.6-1.9,3.6-3.5,5.9-4.6C572.2,50.2,574.9,49.6,578,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M666.9,101.1l0-0.2l-0.2,0.1c-1,0.4-2.7,1-5.1,1.9c-2.4,0.9-5.7,1.4-9.7,1.4c-2.3,0-4.3-0.3-6-0.9 c-1.7-0.6-3.1-1.5-4.2-2.9c-1.1-1.4-2-3.3-2.6-5.7c-0.6-2.4-0.9-5.5-0.9-9.2V51.3h28.3V39.8h-28.3V16.6l-13.5,2.3l-0.1,0v66.8 c0,5,0.4,9.4,1.2,13.2c0.8,3.8,2.2,7,4.3,9.6c2,2.6,4.7,4.6,8,5.9c3.3,1.3,7.6,1.9,12.6,1.9c4.3,0,8.2-0.5,11.5-1.5 c3.3-1,5.7-1.9,7.1-2.5l0.1-0.1L666.9,101.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M344.7,193.4c-0.9,1.1-2,2-3.4,2.8c-1.4,0.8-3.1,1.2-5.1,1.2c-1.2,0-2.4-0.2-3.4-0.5 c-1-0.3-1.9-0.8-2.7-1.4c-0.8-0.6-1.3-1.4-1.7-2.3c-0.4-0.9-0.6-2-0.6-3.3c0-1.7,0.4-3.1,1.1-4.1c0.7-1.1,1.7-1.9,2.9-2.5 c1.2-0.6,2.5-1,4-1.3c1.5-0.3,3-0.4,4.6-0.5l4.3-0.1v-1c0-2.1-0.4-3.6-1.3-4.5c-0.9-0.9-2.3-1.4-4.4-1.4c-2,0-3.4,0.3-4.4,1 c-0.9,0.7-1.5,1.6-1.8,2.7l-3.8-0.4c0.4-2.3,1.5-3.9,3.2-5c1.7-1,4-1.6,6.9-1.6c1.8,0,3.3,0.2,4.5,0.6c1.2,0.4,2.2,1,3,1.8 c0.8,0.8,1.3,1.8,1.7,3c0.3,1.2,0.5,2.5,0.5,4v16.1h-4V193.4z M344.6,184.4l-4,0.1c-1.7,0.1-3.1,0.2-4.2,0.5c-1.1,0.3-2,0.6-2.7,1 c-0.7,0.4-1.1,1-1.4,1.6c-0.3,0.6-0.4,1.4-0.4,2.2c0,1.2,0.4,2.2,1.1,3c0.7,0.7,2,1.1,3.7,1.1c2.5,0,4.4-0.6,5.7-1.8 c1.4-1.2,2.1-2.9,2.1-5V184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M385.6,193.2c-1,1.4-2.2,2.4-3.5,3.2c-1.3,0.8-2.9,1.1-4.7,1.1c-1.8,0-3.4-0.3-4.7-1 c-1.3-0.7-2.4-1.6-3.3-2.8c-0.9-1.2-1.5-2.5-1.9-4.1c-0.4-1.6-0.6-3.3-0.6-5.1c0-2,0.3-3.9,0.8-5.5c0.5-1.6,1.2-3,2.2-4.2 c0.9-1.1,2.1-2,3.4-2.6c1.4-0.6,2.9-0.9,4.6-0.9c1.3,0,2.6,0.3,4,0.8c1.3,0.5,2.6,1.5,3.7,3v-12.4h4.2v34.2h-4.1V193.2z  M385.7,183.7c0-2-0.2-3.5-0.6-4.6c-0.4-1.1-1.1-2-2.1-2.8c-0.7-0.6-1.4-1-2.1-1.2c-0.7-0.2-1.5-0.3-2.4-0.3c-1,0-2,0.2-2.8,0.5 c-0.9,0.4-1.6,0.9-2.3,1.7c-0.7,0.8-1.2,1.8-1.5,3c-0.4,1.2-0.6,2.7-0.6,4.5c0,1.8,0.2,3.4,0.6,4.6c0.4,1.2,0.9,2.2,1.6,3 c0.7,0.7,1.4,1.3,2.2,1.6c0.8,0.3,1.7,0.5,2.5,0.5c0.9,0,1.8-0.1,2.5-0.3c0.7-0.2,1.5-0.6,2.2-1.2c1-0.8,1.7-1.7,2.2-2.9 c0.5-1.2,0.7-2.6,0.7-4.4V183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M397,162.6h4.5v4.8H397V162.6z M397.2,172h4.2v24.7h-4.2V172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M405.9,172h4.8l7.4,20.1l7.5-20.1h4.6l-10,24.7h-4.5L405.9,172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M434.6,162.6h4.5v4.8h-4.5V162.6z M434.8,172h4.2v24.7h-4.2V172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M449.1,189.5c0.3,1.7,1,2.9,2.2,3.6c1.2,0.7,2.8,1,4.8,1c2.1,0,3.6-0.4,4.5-1.1c0.9-0.7,1.3-1.7,1.3-2.8 c0-0.5-0.1-0.9-0.2-1.4c-0.1-0.4-0.3-0.8-0.6-1.1c-0.3-0.3-0.8-0.6-1.3-0.9c-0.6-0.3-1.3-0.5-2.2-0.6l-3.2-0.5 c-1.4-0.2-2.6-0.5-3.7-0.9c-1.1-0.4-1.9-0.8-2.7-1.4c-0.7-0.6-1.3-1.2-1.7-2.1c-0.4-0.8-0.6-1.8-0.6-2.9c0-1.1,0.2-2.2,0.7-3.1 c0.5-0.9,1.2-1.7,2.1-2.3c0.9-0.6,1.9-1.1,3.1-1.4c1.2-0.3,2.5-0.5,3.9-0.5c1.8,0,3.3,0.2,4.5,0.5c1.2,0.4,2.2,0.8,2.9,1.4 c0.8,0.6,1.4,1.3,1.8,2.2c0.4,0.8,0.7,1.7,1,2.6l-3.8,0.6c-0.2-0.7-0.5-1.3-0.8-1.8c-0.3-0.5-0.7-0.9-1.1-1.3 c-0.5-0.3-1.1-0.6-1.7-0.8c-0.7-0.2-1.5-0.3-2.6-0.3c-1.1,0-2.1,0.1-2.9,0.3c-0.8,0.2-1.4,0.5-1.8,0.8c-0.5,0.4-0.8,0.7-1,1.2 c-0.2,0.4-0.3,0.9-0.3,1.4c0,0.5,0.1,1,0.2,1.4c0.1,0.4,0.4,0.8,0.7,1.1c0.4,0.3,0.8,0.6,1.4,0.8c0.6,0.2,1.4,0.4,2.3,0.6l3.6,0.6 c2.9,0.5,5,1.3,6.2,2.5c1.3,1.2,1.9,2.9,1.9,5.2c0,1.1-0.2,2-0.6,2.9c-0.4,0.9-1,1.6-1.9,2.3c-0.8,0.7-1.9,1.2-3.1,1.5 c-1.2,0.4-2.7,0.5-4.4,0.5c-1.5,0-2.9-0.1-4.2-0.4c-1.3-0.3-2.4-0.7-3.4-1.4c-1-0.6-1.8-1.4-2.4-2.5c-0.6-1-1-2.3-1.1-3.7H449.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M472.3,162.6h4.5v4.8h-4.5V162.6z M472.4,172h4.2v24.7h-4.2V172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M495.2,197.5c-1.9,0-3.6-0.3-5-0.9c-1.5-0.6-2.7-1.5-3.7-2.6c-1-1.1-1.8-2.5-2.3-4.1 c-0.5-1.6-0.8-3.4-0.8-5.5c0-2,0.3-3.8,0.9-5.5c0.6-1.6,1.4-3,2.4-4.2c1.1-1.1,2.3-2,3.8-2.7c1.5-0.6,3.1-0.9,5-0.9 c1.9,0,3.5,0.3,5,0.9c1.5,0.6,2.7,1.5,3.8,2.6c1,1.1,1.8,2.5,2.4,4.1c0.5,1.6,0.8,3.4,0.8,5.4c0,2-0.3,3.9-0.8,5.5 c-0.6,1.6-1.4,3-2.4,4.2c-1,1.1-2.3,2-3.8,2.7C498.7,197.2,497,197.5,495.2,197.5z M495.2,194.1c1.3,0,2.5-0.2,3.4-0.7 c1-0.5,1.7-1.1,2.4-2c0.6-0.9,1.1-1.9,1.4-3.1c0.3-1.2,0.4-2.5,0.4-3.9c0-1.4-0.1-2.7-0.4-3.9c-0.3-1.2-0.7-2.2-1.4-3 c-0.6-0.8-1.4-1.5-2.4-2c-1-0.5-2.1-0.7-3.4-0.7c-1.3,0-2.5,0.2-3.4,0.7c-0.9,0.5-1.7,1.1-2.3,2c-0.6,0.8-1.1,1.9-1.4,3 c-0.3,1.2-0.4,2.5-0.4,3.9c0,1.4,0.1,2.7,0.4,3.9c0.3,1.2,0.7,2.2,1.3,3.1c0.6,0.9,1.4,1.5,2.3,2S493.9,194.1,495.2,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M513.7,172h4.1v3.8c1.2-1.6,2.6-2.8,4-3.5c1.5-0.7,3-1.1,4.6-1.1c2.8,0,4.9,0.8,6.2,2.3 c1.4,1.5,2,3.8,2,6.7v16.5h-4.2v-15.7c0-2.3-0.4-3.9-1.2-4.9c-0.8-0.9-2.1-1.4-3.8-1.4c-0.9,0-1.8,0.2-2.8,0.5 c-0.9,0.3-1.7,0.8-2.5,1.5c-0.8,0.7-1.4,1.4-1.8,2.2c-0.4,0.8-0.6,1.8-0.6,3v14.6h-4.2V172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M564.7,197.5c-1.9,0-3.6-0.3-5-0.9c-1.5-0.6-2.7-1.5-3.7-2.6c-1-1.1-1.8-2.5-2.3-4.1 c-0.5-1.6-0.8-3.4-0.8-5.5c0-2,0.3-3.8,0.9-5.5c0.6-1.6,1.4-3,2.4-4.2c1.1-1.1,2.3-2,3.8-2.7c1.5-0.6,3.1-0.9,5-0.9 c1.9,0,3.5,0.3,5,0.9c1.5,0.6,2.7,1.5,3.8,2.6c1,1.1,1.8,2.5,2.4,4.1c0.5,1.6,0.8,3.4,0.8,5.4c0,2-0.3,3.9-0.8,5.5 c-0.6,1.6-1.4,3-2.4,4.2c-1,1.1-2.3,2-3.8,2.7C568.2,197.2,566.5,197.5,564.7,197.5z M564.7,194.1c1.3,0,2.5-0.2,3.4-0.7 c1-0.5,1.7-1.1,2.4-2c0.6-0.9,1.1-1.9,1.4-3.1c0.3-1.2,0.4-2.5,0.4-3.9c0-1.4-0.1-2.7-0.4-3.9c-0.3-1.2-0.7-2.2-1.4-3 c-0.6-0.8-1.4-1.5-2.4-2c-1-0.5-2.1-0.7-3.4-0.7c-1.3,0-2.5,0.2-3.4,0.7c-0.9,0.5-1.7,1.1-2.3,2c-0.6,0.8-1.1,1.9-1.4,3 c-0.3,1.2-0.4,2.5-0.4,3.9c0,1.4,0.1,2.7,0.4,3.9c0.3,1.2,0.7,2.2,1.3,3.1c0.6,0.9,1.4,1.5,2.3,2 C562.3,193.8,563.4,194.1,564.7,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M584.4,175.3h-3.9V172h3.9v-2.2c0-1.3,0.2-2.5,0.6-3.4c0.4-1,0.9-1.7,1.6-2.4c0.7-0.6,1.5-1.1,2.4-1.4 c0.9-0.3,1.9-0.5,2.9-0.5c0.7,0,1.4,0,2.1,0.1c0.7,0.1,1.4,0.2,2.1,0.5l-0.7,3.3c-0.5-0.2-1-0.3-1.5-0.3c-0.5,0-0.9-0.1-1.4-0.1 c-1.1,0-2.1,0.3-2.9,0.9c-0.8,0.6-1.2,1.7-1.2,3.2v2.2h6.3v3.3h-6.3v21.4h-4.2V175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M632.9,188.4c-0.4,2.8-1.5,5.1-3.3,6.7c-1.8,1.6-4.2,2.4-7.4,2.4c-1.9,0-3.5-0.3-5-0.9 c-1.5-0.6-2.7-1.5-3.7-2.6c-1-1.1-1.7-2.5-2.2-4.1c-0.5-1.6-0.8-3.4-0.8-5.4c0-2,0.3-3.8,0.8-5.4c0.5-1.6,1.3-3,2.4-4.2 c1-1.1,2.3-2,3.7-2.7c1.5-0.6,3.1-1,5-1c3,0,5.3,0.7,6.9,2.2c1.6,1.5,2.7,3.5,3.1,6l-4.2,0.8c-0.2-0.8-0.4-1.5-0.6-2.2 c-0.3-0.7-0.6-1.3-1.1-1.7c-0.5-0.5-1.1-0.9-1.7-1.1c-0.7-0.3-1.5-0.4-2.5-0.4c-1.3,0-2.4,0.2-3.4,0.7c-0.9,0.5-1.7,1.2-2.3,2.1 c-0.6,0.9-1,1.9-1.3,3.1c-0.3,1.2-0.4,2.4-0.4,3.8c0,1.3,0.1,2.6,0.4,3.8c0.3,1.2,0.7,2.2,1.2,3.1c0.6,0.9,1.3,1.6,2.2,2.1 c0.9,0.5,2.1,0.8,3.4,0.8c2,0,3.5-0.5,4.5-1.5c1-1,1.6-2.4,1.9-4.2H632.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M639.1,162.6h4.5v4.8h-4.5V162.6z M639.3,172h4.2v24.7h-4.2V172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M672.3,189.8c-0.4,2.4-1.5,4.3-3.2,5.6c-1.7,1.4-4.2,2.1-7.3,2.1c-3.8,0-6.7-1.1-8.7-3.4 c-2-2.3-3-5.5-3-9.5c0-2.1,0.3-4,0.9-5.7c0.6-1.7,1.4-3,2.4-4.2c1-1.1,2.3-2,3.7-2.6c1.4-0.6,3-0.9,4.7-0.9c1.9,0,3.6,0.3,4.9,0.9 c1.4,0.6,2.5,1.4,3.4,2.5c0.9,1.1,1.5,2.3,2,3.8c0.4,1.5,0.6,3.1,0.6,4.8v2.1h-18.4c0,1.2,0.2,2.4,0.5,3.5c0.3,1.1,0.8,2,1.4,2.8 c0.6,0.8,1.4,1.4,2.3,1.8c0.9,0.4,2,0.7,3.2,0.7c2.1,0,3.6-0.4,4.5-1.2c1-0.8,1.6-1.8,2-3.2H672.3z M668.5,182.3 c0-1.2-0.1-2.3-0.4-3.2c-0.3-1-0.7-1.8-1.2-2.5c-0.5-0.7-1.2-1.2-2.1-1.6c-0.9-0.4-1.9-0.6-3.1-0.6c-2.2,0-3.9,0.7-5.1,2 c-1.2,1.3-2,3.3-2.2,5.8H668.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M679.1,172h4.1v3.8c1.2-1.6,2.6-2.8,4-3.5c1.5-0.7,3-1.1,4.6-1.1c2.8,0,4.9,0.8,6.2,2.3 c1.4,1.5,2,3.8,2,6.7v16.5H696v-15.7c0-2.3-0.4-3.9-1.2-4.9c-0.8-0.9-2.1-1.4-3.8-1.4c-0.9,0-1.8,0.2-2.8,0.5 c-0.9,0.3-1.7,0.8-2.5,1.5c-0.8,0.7-1.4,1.4-1.8,2.2c-0.4,0.8-0.6,1.8-0.6,3v14.6h-4.2V172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083245",
    d: "M722.8,193.4c-0.9,1.1-2,2-3.4,2.8c-1.4,0.8-3.1,1.2-5.1,1.2c-1.2,0-2.4-0.2-3.4-0.5 c-1-0.3-1.9-0.8-2.7-1.4c-0.8-0.6-1.3-1.4-1.7-2.3c-0.4-0.9-0.6-2-0.6-3.3c0-1.7,0.4-3.1,1.1-4.1c0.7-1.1,1.7-1.9,2.9-2.5 c1.2-0.6,2.5-1,4-1.3c1.5-0.3,3-0.4,4.6-0.5l4.3-0.1v-1c0-2.1-0.4-3.6-1.3-4.5c-0.9-0.9-2.3-1.4-4.4-1.4c-2,0-3.4,0.3-4.4,1 c-0.9,0.7-1.5,1.6-1.8,2.7l-3.8-0.4c0.4-2.3,1.5-3.9,3.2-5c1.7-1,4-1.6,6.9-1.6c1.8,0,3.3,0.2,4.5,0.6c1.2,0.4,2.2,1,3,1.8 c0.8,0.8,1.3,1.8,1.7,3c0.3,1.2,0.5,2.5,0.5,4v16.1h-4V193.4z M722.7,184.4l-4,0.1c-1.7,0.1-3.1,0.2-4.2,0.5c-1.1,0.3-2,0.6-2.7,1 c-0.7,0.4-1.1,1-1.4,1.6c-0.3,0.6-0.4,1.4-0.4,2.2c0,1.2,0.4,2.2,1.1,3c0.7,0.7,2,1.1,3.7,1.1c2.5,0,4.4-0.6,5.7-1.8 c1.4-1.2,2.1-2.9,2.1-5V184.4z"
  })))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "bu",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.055513, 6.312500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.431,6.831l0.007-8.797H5.046v7.993l-6.928,3.993l0.699,1.209L6.431,6.831z M6.889,7.74l-7.627,4.398 l0.699,1.209l6.921-4l6.928,4l0.699-1.209L6.889,7.74z M7.451,6.825l7.62,4.405l0.699-1.209l-6.921-4v-7.993H7.458L7.451,6.825z"
  }))))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "ciena-logo-white",
    viewBox: "0 0 196.833 64.453"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938,62.453c3.451,0,8.835-.7,11.97-2.274V49.245a24.433,24.433,0,0,1-8.384,1.5c-5.152,0-11.216-3.032-11.216-9.447,0-7.337,5.745-10.108,11.436-10.108A31,31,0,0,1,33.906,32.7V21.118a43.266,43.266,0,0,0-10.845-1.773C10.372,19.345.037,27.086.037,41.029c0,14.176,9.983,21.424,21.9,21.424",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.079,62.163a15.514,15.514,0,0,0,12.106-5.178v4.266h13.991V37.565c0-5.784-.973-10.045-4.092-13.1-3.277-3.276-8.3-5.042-15.691-5.024-6,.011-11.567,1.511-16.916,3.274v10.4a44.435,44.435,0,0,1,14.557-2.552c5.56,0,8.225,2.438,8.225,6.7v.683a31.784,31.784,0,0,0-9.9-1.6c-9.671,0-16.148,4.416-16.148,12.944v.153c0,8.221,6.023,12.717,13.866,12.717m.074-13.708c0-3.043,2.44-5.1,6.619-5.1a14.261,14.261,0,0,1,5.643,1.3c0,5.282-2.967,8.443-7.159,8.443-2.968,0-5.1-1.674-5.1-4.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.508,38.991c0-4.653,2.707-7.256,6.408-7.256,3.643,0,6.111,2.623,6.111,7.256V61.239h13.831v-26.9c0-9.215-5.136-14.837-13.694-14.837-5.721,0-9.448,3.192-12.08,6.581l-.573.737V20.6H103.679V61.237h13.829Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.884,61.513c5.681,1.016,11.246-.125,18.671-3.477a23.191,23.191,0,0,0,13.461,4.2c7.211,0,13.1-3.152,17.467-6.075V48.1c-5.425,3.489-13.351,6.047-18.268,2.447,5.02-3.494,9.789-7.677,12.942-12.7,5.027-8.024,1.741-19.722-12.083-19.722-12.182,0-21.4,10.662-21.6,22.586a22.786,22.786,0,0,0,2.138,10.207c-8.044,2.352-9.6-1.525-9.875-8.8-.329-8.745-.389-21.131-.389-21.131H39.479V46.426c0,5.273,1.286,13.457,10.4,15.085M81.337,29.818c4.235-1,8,2.558,3.275,8.552a33.609,33.609,0,0,1-8.065,6.943c-4.68-8.576,1.082-14.622,4.789-15.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.393,7.657A7.655,7.655,0,1,0,46.048,0a7.655,7.655,0,0,0-7.655,7.657v0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.33,61.251a2.54,2.54,0,1,0-.008,0h.008m0-4.685a2.159,2.159,0,1,1-2.141,2.177h0a2.117,2.117,0,0,1,2.059-2.175h.082",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.794,58.952h.523l.8,1.257h.439l-.839-1.293a.756.756,0,0,0,.773-.739.487.487,0,0,0,0-.054c0-.585-.332-.843-1.032-.843h-1.072v2.933h.408Zm0-1.309h.629c.315,0,.665.052.665.461,0,.457-.386.476-.794.476h-.5Z",
    fill: "#fff"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "ciena-logo",
    viewBox: "0 0 196.833 64.453"
  }, /*#__PURE__*/React.createElement("title", null, "Artboard 2"), /*#__PURE__*/React.createElement("path", {
    d: "M21.938,62.453c3.451,0,8.835-.7,11.97-2.274V49.245a24.433,24.433,0,0,1-8.384,1.5c-5.152,0-11.216-3.032-11.216-9.447,0-7.337,5.745-10.108,11.436-10.108A31,31,0,0,1,33.906,32.7V21.118a43.266,43.266,0,0,0-10.845-1.773C10.372,19.345.037,27.086.037,41.029c0,14.176,9.983,21.424,21.9,21.424",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.079,62.163a15.514,15.514,0,0,0,12.106-5.178v4.266h13.991V37.565c0-5.784-.973-10.045-4.092-13.1-3.277-3.276-8.3-5.042-15.691-5.024-6,.011-11.567,1.511-16.916,3.274v10.4a44.435,44.435,0,0,1,14.557-2.552c5.56,0,8.225,2.438,8.225,6.7v.683a31.784,31.784,0,0,0-9.9-1.6c-9.671,0-16.148,4.416-16.148,12.944v.153c0,8.221,6.023,12.717,13.866,12.717m.074-13.708c0-3.043,2.44-5.1,6.619-5.1a14.261,14.261,0,0,1,5.643,1.3c0,5.282-2.967,8.443-7.159,8.443-2.968,0-5.1-1.674-5.1-4.5Z",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.508,38.991c0-4.653,2.707-7.256,6.408-7.256,3.643,0,6.111,2.623,6.111,7.256V61.239h13.831v-26.9c0-9.215-5.136-14.837-13.694-14.837-5.721,0-9.448,3.192-12.08,6.581l-.573.737V20.6H103.679V61.237h13.829Z",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.884,61.513c5.681,1.016,11.246-.125,18.671-3.477a23.191,23.191,0,0,0,13.461,4.2c7.211,0,13.1-3.152,17.467-6.075V48.1c-5.425,3.489-13.351,6.047-18.268,2.447,5.02-3.494,9.789-7.677,12.942-12.7,5.027-8.024,1.741-19.722-12.083-19.722-12.182,0-21.4,10.662-21.6,22.586a22.786,22.786,0,0,0,2.138,10.207c-8.044,2.352-9.6-1.525-9.875-8.8-.329-8.745-.389-21.131-.389-21.131H39.479V46.426c0,5.273,1.286,13.457,10.4,15.085M81.337,29.818c4.235-1,8,2.558,3.275,8.552a33.609,33.609,0,0,1-8.065,6.943c-4.68-8.576,1.082-14.622,4.789-15.5",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.393,7.657A7.655,7.655,0,1,0,46.048,0a7.655,7.655,0,0,0-7.655,7.657v0",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.33,61.251a2.54,2.54,0,1,0-.008,0h.008m0-4.685a2.159,2.159,0,1,1-2.141,2.177h0a2.117,2.117,0,0,1,2.059-2.175h.082",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.794,58.952h.523l.8,1.257h.439l-.839-1.293a.756.756,0,0,0,.773-.739.487.487,0,0,0,0-.054c0-.585-.332-.843-1.032-.843h-1.072v2.933h.408Zm0-1.309h.629c.315,0,.665.052.665.461,0,.457-.386.476-.794.476h-.5Z",
    fill: "#c10230"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "ciena-strip"
  })), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "ciena",
    viewBox: "0 0 196.833 64.453"
  }, /*#__PURE__*/React.createElement("title", null, "Artboard 2"), /*#__PURE__*/React.createElement("path", {
    d: "M21.938,62.453c3.451,0,8.835-.7,11.97-2.274V49.245a24.433,24.433,0,0,1-8.384,1.5c-5.152,0-11.216-3.032-11.216-9.447,0-7.337,5.745-10.108,11.436-10.108A31,31,0,0,1,33.906,32.7V21.118a43.266,43.266,0,0,0-10.845-1.773C10.372,19.345.037,27.086.037,41.029c0,14.176,9.983,21.424,21.9,21.424",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.079,62.163a15.514,15.514,0,0,0,12.106-5.178v4.266h13.991V37.565c0-5.784-.973-10.045-4.092-13.1-3.277-3.276-8.3-5.042-15.691-5.024-6,.011-11.567,1.511-16.916,3.274v10.4a44.435,44.435,0,0,1,14.557-2.552c5.56,0,8.225,2.438,8.225,6.7v.683a31.784,31.784,0,0,0-9.9-1.6c-9.671,0-16.148,4.416-16.148,12.944v.153c0,8.221,6.023,12.717,13.866,12.717m.074-13.708c0-3.043,2.44-5.1,6.619-5.1a14.261,14.261,0,0,1,5.643,1.3c0,5.282-2.967,8.443-7.159,8.443-2.968,0-5.1-1.674-5.1-4.5Z",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.508,38.991c0-4.653,2.707-7.256,6.408-7.256,3.643,0,6.111,2.623,6.111,7.256V61.239h13.831v-26.9c0-9.215-5.136-14.837-13.694-14.837-5.721,0-9.448,3.192-12.08,6.581l-.573.737V20.6H103.679V61.237h13.829Z",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.884,61.513c5.681,1.016,11.246-.125,18.671-3.477a23.191,23.191,0,0,0,13.461,4.2c7.211,0,13.1-3.152,17.467-6.075V48.1c-5.425,3.489-13.351,6.047-18.268,2.447,5.02-3.494,9.789-7.677,12.942-12.7,5.027-8.024,1.741-19.722-12.083-19.722-12.182,0-21.4,10.662-21.6,22.586a22.786,22.786,0,0,0,2.138,10.207c-8.044,2.352-9.6-1.525-9.875-8.8-.329-8.745-.389-21.131-.389-21.131H39.479V46.426c0,5.273,1.286,13.457,10.4,15.085M81.337,29.818c4.235-1,8,2.558,3.275,8.552a33.609,33.609,0,0,1-8.065,6.943c-4.68-8.576,1.082-14.622,4.789-15.5",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.393,7.657A7.655,7.655,0,1,0,46.048,0a7.655,7.655,0,0,0-7.655,7.657v0",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.33,61.251a2.54,2.54,0,1,0-.008,0h.008m0-4.685a2.159,2.159,0,1,1-2.141,2.177h0a2.117,2.117,0,0,1,2.059-2.175h.082",
    fill: "#c10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.794,58.952h.523l.8,1.257h.439l-.839-1.293a.756.756,0,0,0,.773-.739.487.487,0,0,0,0-.054c0-.585-.332-.843-1.032-.843h-1.072v2.933h.408Zm0-1.309h.629c.315,0,.665.052.665.461,0,.457-.386.476-.794.476h-.5Z",
    fill: "#c10230"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "circuit-layer",
    viewBox: "0 0 57 15"
  }, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E2E2E2",
    width: 57,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    dominantBaseline: "middle",
    x: "50%",
    y: "55%",
    "font-fill": "#414141",
    fontWeight: "bold",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "10px"
  }, "CIRCUIT"))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "dge",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.046,13.802l1.514-2.565h6.881l1.514,2.565H7.046z M6.083,15.433h11.835l1.858,3.143H4.225L6.083,15.433z  M9.523,9.613L12,5.424l2.477,4.189H9.523z"
  })))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "endpoint-arrow",
    viewBox: "0 0 30 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-131.000000, -577.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(146.000000, 581.500000) scale(-1, 1) translate(-146.000000, -581.500000) translate(131.000000, 577.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,6 L8,9 L0,4.5 L8,0 L8,3 L30,3 L30,6 L8,6 Z",
    id: "Combined-Shape"
  }))))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "error-404",
    viewBox: "0 0 145 145"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2876,
    fill: "#489999",
    fillOpacity: 0.201,
    enableBackground: "new    ",
    d: "M145,72.5 c0,40.041-32.459,72.5-72.499,72.5S0,112.54,0,72.5S32.46,0,72.5,0S145,32.46,145,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.402,67.26l-0.029-12.315L62.728,42.544H34.57l0.031,24.473l4.717-2.696l5.219,3.245l5.24-3.249 l5.219,3.307l5.249-3.321l4.958,3.368l5.235-3.355L75.402,67.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#859CA8",
    d: "M65.195,68.251l-4.959-3.531l-5.24,3.472l-5.221-3.469l-5.239,3.407l-5.221-3.407l-5.121,3.241l-0.033-25.83 h28.732l12.885,12.637l0.033,13.441l-5.369-3.49L65.195,68.251z M60.255,63.565l4.956,3.527l5.222-3.502l4.559,2.716l-0.027-11.189 L62.562,42.951H34.978l0.029,23.116l4.312-2.472l5.218,3.403l5.243-3.411l5.217,3.465L60.255,63.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.404,76.795l-4.921-2.364l-5.246,2.884l-4.981-2.867l-5.221,2.858l-5.23-2.867l-5.23,2.867l-5.231-2.868 L34.6,76.791v20.138h40.802L75.404,76.795L75.404,76.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#859CA8",
    d: "M75.811,97.336H34.195V76.621l5.152-2.864l5.23,2.974l5.229-2.973l5.23,2.973l5.227-2.972l4.981,2.973 l5.233-2.977l5.334,2.867L75.811,97.336L75.811,97.336z M35.009,96.521h39.987V76.969l-4.508-2.073l-5.259,3.003l-4.981-2.973 l-5.213,2.957l-5.23-2.973l-5.229,2.973l-5.231-2.976l-4.336,2.053C35.009,76.959,35.009,96.521,35.009,96.521z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#859CA8",
    enableBackground: "new    ",
    d: "M49.136,87.837h1.224v1.728h-1.224v2.336h-2.143v-2.336h-4.427 l-0.096-1.35l4.502-7.112h2.165L49.136,87.837L49.136,87.837z M44.605,87.837h2.388v-3.812l-0.141,0.244L44.605,87.837z  M58.652,87.436c0,1.493-0.309,2.635-0.927,3.426s-1.523,1.187-2.714,1.187c-1.176,0-2.076-0.388-2.7-1.164 s-0.942-1.888-0.956-3.337V85.56c0-1.508,0.313-2.652,0.938-3.434c0.626-0.781,1.527-1.171,2.703-1.171s2.076,0.387,2.7,1.161 c0.623,0.774,0.942,1.885,0.956,3.333V87.436z M56.508,85.256c0-0.895-0.122-1.546-0.367-1.954 c-0.244-0.408-0.626-0.612-1.146-0.612c-0.504,0-0.877,0.194-1.116,0.582c-0.239,0.388-0.367,0.995-0.382,1.821v2.625 c0,0.88,0.12,1.534,0.36,1.962c0.239,0.428,0.624,0.641,1.153,0.641c0.524,0,0.903-0.205,1.135-0.616s0.354-1.038,0.363-1.883 C56.508,87.822,56.508,85.256,56.508,85.256z M66.313,87.837h1.224v1.728h-1.224v2.336H64.17v-2.336h-4.427l-0.096-1.35l4.502-7.112 h2.165C66.313,81.103,66.313,87.837,66.313,87.837z M61.782,87.837h2.388v-3.812l-0.141,0.244L61.782,87.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#859CA8",
    d: "M63.435,44.048L73.8,54.09H63.435V44.048 M62.62,42.125v12.78h13.192L62.62,42.125L62.62,42.125z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#859CA8",
    cx: 93.712,
    cy: 43.486,
    r: 11.062
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.487,48.538c-0.46,0-0.819,0.14-1.069,0.418c-0.241,0.267-0.363,0.599-0.363,0.984 c0,0.388,0.123,0.717,0.367,0.978c0.25,0.267,0.608,0.403,1.066,0.403c0.456,0,0.815-0.135,1.068-0.401 c0.248-0.261,0.374-0.591,0.374-0.981c0-0.387-0.125-0.719-0.371-0.986C94.305,48.678,93.945,48.538,93.487,48.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.971,36.768c-0.77-0.741-1.848-1.117-3.202-1.117c-1.301,0-2.379,0.366-3.201,1.086 c-0.833,0.732-1.263,1.702-1.278,2.885l-0.004,0.336h2.534v-0.332c0-0.516,0.167-0.912,0.512-1.213 c0.358-0.312,0.828-0.464,1.437-0.464c0.616,0,1.064,0.161,1.371,0.494c0.31,0.336,0.467,0.818,0.467,1.435 c0,0.656-0.25,1.257-0.754,1.827l-1.329,1.369c-0.544,0.595-0.913,1.152-1.096,1.655c-0.182,0.503-0.279,1.159-0.292,2.005 l-0.006,0.337h2.537v-0.332c0-0.934,0.219-1.65,0.639-2.116l1.107-1.096c1.145-1.202,1.727-2.45,1.727-3.711 C98.138,38.538,97.745,37.513,96.971,36.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF8E00",
    d: "M107.982,109.31h-26.55l11.257-43.687h3.988L107.982,109.31z M82.394,108.237h24.624l-10.75-41.54h-3.17 L82.394,108.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA621",
    d: "M79.688,108.773h30.037c0.614,0,1.113,0.851,1.113,1.901l0,0c0,1.05-0.498,1.901-1.113,1.901H79.688 c-0.614,0-1.113-0.851-1.113-1.901l0,0C78.575,109.624,79.073,108.773,79.688,108.773z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "96.39,67.147 106.907,107.786 82.505,107.786 92.977,67.147 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA621",
    d: "M102.906,91.963H86.489l2.281-8.992h11.845L102.906,91.963z M104.813,99.449l2.291,8.992H82.31l2.281-8.992 H104.813z M98.708,75.484l-8.03-0.038l2.271-8.953h3.469L98.708,75.484z"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "ethernet-layer",
    viewBox: "0 0 57 15"
  }, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E2E2E2",
    width: 57,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    dominantBaseline: "middle",
    x: "50%",
    y: "55%",
    "font-fill": "#414141",
    fontWeight: "bold",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "10px"
  }, "ETHERNET"))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "fiber-layer",
    viewBox: "0 0 57 15"
  }, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E2E2E2",
    width: 57,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    dominantBaseline: "middle",
    x: "50%",
    y: "55%",
    "font-fill": "#414141",
    fontWeight: "bold",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "10px"
  }, "FIBER\r\n\t\t"))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "general-info",
    viewBox: "0 0 50 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-23.000000, -187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I_general_info_test",
    transform: "translate(23.000000, 187.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9333333,39.7333333 L4.8,39.7333333 C3.13333333,39.7333333 1.53333333,38.8 0.733333333,37.3333333 C-0.0666666667,35.8666667 -1.83186799e-15,34 0.933333333,32.6 L20.9333333,2.53333333 C21.8,1.26666667 23.2,0.466666667 24.8,0.466666667 C26.3333333,0.466666667 27.8,1.2 28.6,2.53333333 L48.7333333,32.6 C49.6666667,34 49.8,35.8 49,37.3333333 C48.2,38.8 46.6,39.7333333 44.9333333,39.7333333 Z M24.8,3.13333333 C24.1333333,3.13333333 23.5333333,3.46666667 23.2,4 L3.2,34.0666667 C2.8,34.6666667 2.73333333,35.4 3.13333333,36.0666667 C3.46666667,36.7333333 4.13333333,37.0666667 4.86666667,37.0666667 L45,37.0666667 C45.7333333,37.0666667 46.3333333,36.6666667 46.7333333,36.0666667 C47.0666667,35.4 47.0666667,34.6666667 46.6666667,34.0666667 L26.4,4 C26,3.46666667 25.4,3.13333333 24.8,3.13333333 Z",
    id: "Shape",
    fill: "#BABCBE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 10.666667)",
    fill: "#7C807F"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.73333333,
    cy: 20.6666667,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,3.2 C5.33333333,1.4 4.13333333,0 2.66666667,0 C1.2,0 0.0666666667,1.66666667 0.0666666667,3.46666667 L1.66666667,15.2 C1.66666667,15.8666667 2.06666667,16.3333333 2.6,16.3333333 C3.13333333,16.3333333 3.53333333,15.8 3.53333333,15.2 L5.33333333,3.2 Z",
    id: "Shape"
  })))))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "grid-note-icon",
    viewBox: "0 0 16.859 25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0271BC",
    d: "M12.5,0H0v25h16.859V4.479L12.5,0z M15.859,4.885V24H1V1h10.972v3.724h3.73L15.859,4.885z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19,
    fill: "#0271BC",
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    fill: "#0271BC",
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    fill: "#0271BC",
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    fill: "#0271BC",
    width: 11,
    height: 2
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "gt",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,11h-5.757L12,5.383L8.757,11H3v2h4.602l-3.195,5.533h15.184L16.398,13H21V11z M12,7.383L14.088,11H9.912L12,7.383z  M17.86,17.533H6.14L8.757,13h6.486L17.86,17.533z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "ila",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "5.891,19.417 5.891,4.583 18.109,12  "
  })))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "Infobar-edit",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "InfoBar-Edit",
    transform: "translate(17.000000, 17.000000) scale(-1, 1) translate(-17.000000, -17.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "#",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55,7.711 L7.45,5.811 L7.116,5.477 C6.59132949,4.95232949 5.74067051,4.95232949 5.216,5.477 C4.69132949,6.00167051 4.69132949,6.85232949 5.216,7.377 L5.55,7.711 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(15.895865, 16.161366) rotate(-45.001000) translate(-15.895865, -16.161366) ",
    x: 14.5558653,
    y: 4.3698659,
    width: 2.68,
    height: 23.583
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "26.242 24.612 24.347 26.507 25.045 27.205 27.888 28.152 26.94 25.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.251,24.5 L8.172,4.421 C7.0587513,3.33743165 5.28145483,3.34943729 4.18294606,4.44794606 C3.08443729,5.54645483 3.07243165,7.3237513 4.156,8.437 L24.109,28.391 L24.234,28.516 L30.26,30.525 L28.251,24.5 Z M25.182,23.553 L23.287,25.448 L6.611,8.771 L8.511,6.876 L25.182,23.553 Z M5.216,5.481 C5.74078413,4.95660386 6.59121587,4.95660386 7.116,5.481 L7.45,5.815 L5.55,7.715 L5.216,7.381 C4.69160386,6.85621587 4.69160386,6.00578413 5.216,5.481 Z M25.045,27.205 L24.345,26.505 L26.24,24.605 L26.94,25.305 L27.888,28.147 L25.045,27.205 Z",
    id: "Shape",
    fill: "#0271BC",
    fillRule: "nonzero"
  }))))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "infobar-reset",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,6H6.5A2.5,2.5,0,0,0,4,8.5v10H7V9H25V22H12V18.5l-7,5,7,5V25H25.5A2.5,2.5,0,0,0,28,22.5V8.5A2.5,2.5,0,0,0,25.5,6Z"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "infobar-service-revert",
    viewBox: "-840 413 46 40"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I_x5F_service_x5F_normal-_x28_2_x29_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#E8E8E8",
    points: "-828.2,453 -839.5,433 -828.2,413 -805.8,413 -794.5,433 -805.8,453  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    fill: "#929497",
    d: "M-806.3,413.9l10.8,19.1l-10.8,19.1h-21.3l-10.8-19.1l10.8-19.1H-806.3L-806.3,413.9z  M-805.7,413h-22.4l-11.4,20l11.2,20h22.6l11.2-20L-805.7,413L-805.7,413z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#DBDBDB",
    cx: -829.2,
    cy: 430.3,
    rx: 4.1,
    ry: 4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: -810.1,
    y: 421.7,
    fill: "#DBDBDB",
    width: 1.4,
    height: 22.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_2_",
    fill: "#DBDBDB",
    points: "-809.6,421.3 -808.4,421.9 -817.4,439.7 -818.7,439.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path_1_",
    x: -811.5,
    y: 419.7,
    fill: "#DBDBDB",
    width: 4.1,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path_2_",
    x: -821,
    y: 437,
    fill: "#DBDBDB",
    width: 4.1,
    height: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_1_",
    fill: "#DBDBDB",
    cx: -808.7,
    cy: 442.3,
    rx: 4.1,
    ry: 4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M-825.9,438v-9 M-822.9,423v3h9.8c3.9,0,7,3.1,7,7v1c0,3.9-3.1,7-7,7h-9.8 M-822.9,438h9.8 c2.2,0,4-1.8,4-4v-1c0-2.2-1.8-4-4-4h-9.8V438z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: -826,
    y: 429,
    fill: "#E8E8E8",
    width: 4,
    height: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_3_",
    fill: "#DBDBDB",
    points: "-828.5,430 -818.4,438 -820,438 -829,431  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-2",
    fill: "#009EEF",
    points: "-830.6,427.5 -822.6,423 -822.6,432  "
  }))))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "ip-layer",
    viewBox: "0 0 57 15"
  }, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E2E2E2",
    width: 57,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    dominantBaseline: "middle",
    x: "50%",
    y: "55%",
    "font-fill": "#414141",
    fontWeight: "bold",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "10px"
  }, "\r\n  IP\r\n\t\t"))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "l3-area-border-router",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414141",
    d: " M4.63,12.247L0,8l4.63-4.247l0,3.089h6.739l0.001-3.089L16,8l-4.63,4.247l-0.001-3.09H4.63L4.63,12.247z"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "l3-asbr-router",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M6.571,2.338 c1.593,0,2.869,0.437,3.827,1.312s1.437,2.061,1.437,3.558l-0.001,1.783l2.86,0l-4.278,4.67l-4.278-4.67l3.221,0L9.311,7.163 c0-1.988-0.942-2.982-2.826-2.982c-0.929,0-1.632,0.249-2.109,0.746S3.66,6.143,3.66,7.085l0.187,4.99H1.408L1.307,7.218 c0-1.53,0.474-2.726,1.422-3.587S4.958,2.338,6.571,2.338z"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "l3-empty-state-select-paths",
    viewBox: "0 0 140 140"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEBEB",
    cx: 70,
    cy: 70,
    r: 70
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M70,1c38.047,0,69,30.953,69,69s-30.953,69-69,69S1,108.047,1,70S31.953,1,70,1 M70,0 C31.34,0,0,31.34,0,70s31.34,70,70,70s70-31.34,70-70S108.66,0,70,0L70,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#979797",
    points: "69.819,120.17 69.052,119.529 78.842,107.78 70.988,92.073 64.967,76.025 59.896,59.799  67.994,44.614 78.769,28.937 65.11,17.23 65.761,16.47 80.103,28.763 68.848,45.133 60.975,59.9 65.913,75.7 71.903,91.674  80.029,107.919 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.446,
    y: 57.26,
    fill: "#FFFFFF",
    stroke: "#676767",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.435,
    y: 41.473,
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M72.001,48.038h-7.065v-7.065h7.065V48.038z M65.936,47.038h5.065v-5.065h-5.065V47.038z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.185,
    y: 25.686,
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M82.751,32.252h-7.066v-7.066h7.066V32.252z M76.685,31.252h5.066v-5.066h-5.066V31.252z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.435,
    y: 15.186,
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M72.001,21.752h-7.065v-7.066h7.065V21.752z M65.936,20.752h5.065v-5.066h-5.065V20.752z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.435,
    y: 116.817,
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M72.001,123.382h-7.065v-7.065h7.065V123.382z M65.936,122.382h5.065v-5.065h-5.065V122.382z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.979,
    y: 73.047,
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M68.544,79.612h-7.066v-7.065h7.066V79.612z M62.478,78.612h5.066v-5.065h-5.066V78.612z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.185,
    y: 104.62,
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M82.751,111.186h-7.066v-7.065h7.066V111.186z M76.685,110.186h5.066v-5.065h-5.066V110.186z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.612,
    y: 88.833,
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M74.178,95.399h-7.066v-7.066h7.066V95.399z M68.112,94.399h5.066v-5.066h-5.066V94.399z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 51.615,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    width: 88,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M115,68.115H26v-17h89V68.115z M27,67.115h87v-15H27V67.115z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.664,
    y: 54.615,
    fill: "#979797",
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BABCBE",
    points: "108.906,56.99 105.432,60.794  101.958,56.99 101.031,58.007 105.432,62.827 109.834,58.007 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#808080",
    points: "54.872,79.228 51.269,81.309 47.398,74.604 44.491,77.049  42.992,62.844 54.992,70.986 51.086,72.475 "
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "l3-external-bgp-router",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M4.16,12.949c0.604,0,1.153-0.115,1.65-0.345 c0.496-0.23,0.89-0.551,1.18-0.962l0,0l-0.952-1.066c-0.42,0.541-1.004,0.811-1.75,0.811c-0.483,0-0.882-0.143-1.197-0.429 s-0.504-0.666-0.567-1.14l0,0h4.621V9.026c0-1.149-0.285-2.036-0.855-2.662S4.938,5.425,3.945,5.425 c-0.662,0-1.251,0.155-1.767,0.466S1.263,6.644,0.981,7.219S0.559,8.445,0.559,9.174l0,0v0.188c0,1.086,0.334,1.956,1.003,2.609 C2.229,12.623,3.096,12.949,4.16,12.949z M5.239,8.496H2.544c0.067-0.483,0.22-0.854,0.459-1.113 c0.239-0.259,0.551-0.389,0.936-0.389c0.411,0,0.729,0.117,0.952,0.352s0.34,0.567,0.349,0.996l0,0V8.496z M12.167,12.815 c1.109-0.009,1.963-0.255,2.562-0.738s0.899-1.194,0.899-2.133c0-0.55-0.144-1.015-0.433-1.395c-0.288-0.38-0.683-0.633-1.184-0.758 c0.438-0.17,0.78-0.437,1.026-0.801c0.246-0.364,0.369-0.786,0.369-1.264c0-0.876-0.306-1.541-0.919-1.995s-1.511-0.681-2.696-0.681 l0,0h-3.42v9.764H12.167z M11.872,7.142h-1.489V4.68h1.408c0.554,0,0.96,0.097,1.217,0.292s0.386,0.513,0.386,0.956 C13.394,6.719,12.887,7.124,11.872,7.142L11.872,7.142z M12.107,11.199h-1.723V8.563h1.844c0.925,0.013,1.388,0.467,1.388,1.361 c0,0.398-0.133,0.71-0.399,0.936C12.95,11.086,12.581,11.199,12.107,11.199L12.107,11.199z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "l3-internal-bgp-ro",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M3.665,4.93c0.322,0,0.581-0.093,0.778-0.278 c0.196-0.185,0.295-0.424,0.295-0.715c0-0.287-0.097-0.523-0.291-0.708C4.252,3.044,3.992,2.951,3.665,2.951 c-0.331,0-0.592,0.093-0.784,0.278C2.689,3.414,2.593,3.65,2.593,3.937c0,0.291,0.098,0.529,0.295,0.715 C3.084,4.837,3.343,4.93,3.665,4.93z M4.625,12.951V5.79H2.705v7.161H4.625z M10.071,12.951c1.094-0.009,1.937-0.251,2.528-0.728 c0.591-0.477,0.887-1.178,0.887-2.105c0-0.543-0.142-1.002-0.427-1.377c-0.285-0.375-0.674-0.624-1.168-0.748 c0.432-0.168,0.77-0.431,1.013-0.791c0.243-0.36,0.364-0.775,0.364-1.248c0-0.865-0.302-1.521-0.907-1.969 c-0.604-0.448-1.491-0.672-2.66-0.672l0,0H6.326v9.636H10.071z M9.78,7.352H8.311V4.923h1.39c0.547,0,0.947,0.096,1.201,0.288 c0.254,0.192,0.381,0.506,0.381,0.943C11.283,6.935,10.782,7.335,9.78,7.352L9.78,7.352z M10.012,11.356H8.311V8.755h1.82 c0.913,0.013,1.37,0.461,1.37,1.343c0,0.393-0.131,0.7-0.394,0.923C10.845,11.245,10.48,11.356,10.012,11.356L10.012,11.356z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "l3-internal-router",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414141",
    points: " 12.779,4.914 9.246,8 12.779,11.086 12.781,8.702 16,8.704 16,7.408 12.781,7.407  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414141",
    points: " 3.221,4.914 6.754,8 3.221,11.086 3.219,8.702 0,8.704 0,7.408 3.219,7.407  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414141",
    points: " 11.086,3.738 8,0 4.914,3.738 7.298,3.74 7.296,7.145 8.592,7.145 8.593,3.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414141",
    points: " 11.086,12.466 8,16 4.914,12.466 7.298,12.465 7.296,9.246 8.592,9.246 8.593,12.465  "
  })))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "l3-provider-edge-router",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M2.921,12.437V9.31h1.603 c1.052,0,1.876-0.251,2.471-0.753S7.889,7.37,7.889,6.501c0-0.573-0.136-1.084-0.408-1.533C7.208,4.519,6.819,4.172,6.313,3.929 S5.221,3.563,4.555,3.563l0,0H1.093v8.874H2.921z M4.555,7.829H2.921V5.044h1.676C5.049,5.052,5.402,5.19,5.658,5.458 s0.384,0.62,0.384,1.054c0,0.423-0.127,0.748-0.381,0.975S5.038,7.829,4.555,7.829L4.555,7.829z M15.093,12.437v-1.469h-4.12V8.591 h3.511V7.159h-3.511V5.044h4.108V3.563H9.144v8.874H15.093z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-add-ne-blue",
    viewBox: "575 375 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_4_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.4606,
    y1: 773.5394,
    x2: 27.5445,
    y2: 776.4554,
    gradientTransform: "matrix(16 0 0 -16 136 12800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M619.4,425h-38.8c-3.1,0-5.6-2.5-5.6-5.6v-38.8c0.2-3.1,2.7-5.6,5.6-5.6h38.8c3.1,0,5.6,2.5,5.6,5.6 v38.9C625,422.5,622.5,425,619.4,425z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 585,
    y1: 405.75,
    x2: 625,
    y2: 405.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "url(#SVGID_2_)",
    enableBackground: "new    ",
    points: "615,414.5 615,386.5 625,400 625,420.1  624.8,421 624.7,421.4 624.2,422.3 623.8,423.1 622.8,423.9 621.5,424.5 619.8,425 598,425 585,414.5  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 386.5,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 30,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 393.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 393.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593,
    y: 393.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603,
    y: 393.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 393.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 610,
    cy: 390.5,
    r: 2
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "ADD_NE"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.7,
    y: 384.1,
    fill: "#009EEF",
    width: 9.5,
    height: 10.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M617.8,382.1h-10.6c-0.9,0-1.7,0.8-1.7,1.8v10.7c0,1,0.8,1.8,1.7,1.8h10.7c1,0,1.7-0.8,1.7-1.8v-10.8 C619.6,382.9,618.8,382.1,617.8,382.1z M617.1,390.4h-3.3v3.3h-2.5v-3.3H608v-2.5h3.3v-3.3h2.5v3.3h3.3V390.4z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-add-ne",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_4_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3699,
    y1: 48.3698,
    x2: 5.6979,
    y2: 1.6979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M48.4,50H9.6C6.5,50,4,47.5,4,44.4V5.6C4.2,2.5,6.7,0,9.6,0h38.8C51.5,0,54,2.5,54,5.6v38.9 C54,47.5,51.5,50,48.4,50z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "44,39.5 44,11.5 54,25 54,45.1 53.8,46 53.7,46.4  53.2,47.3 52.8,48.1 51.8,48.9 50.5,49.5 48.8,50 27,50 14,39.5  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11.5,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 30,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 18.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    fill: "#FFFFFF",
    cx: 39,
    cy: 15.5,
    r: 2
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "ADD_NE"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 9.1,
    fill: "#3B647F",
    width: 9.5,
    height: 10.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M46.8,7.1H36.2c-0.9,0-1.7,0.8-1.7,1.8v10.7c0,1,0.8,1.8,1.7,1.8h10.7c1,0,1.7-0.8,1.7-1.8V8.8 C48.6,7.9,47.8,7.1,46.8,7.1z M46.1,15.4h-3.3v3.3h-2.5v-3.3h-3.3v-2.5h3.3V9.6h2.5v3.3h3.3V15.4z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-alarm",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.6767,
    y1: 42.6968,
    x2: 11.3212,
    y2: 7.3412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008A61"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M54,25c0,13.8-11.2,25-25,25c-3.4,0-6.6-0.7-9.6-1.9C10.4,44.3,4,35.4,4,25C4,11.2,15.2,0,29,0 c13.6,0,24.7,10.9,25,24.4C54,24.6,54,24.8,54,25z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M54,25c0,13.8-11.2,25-25,25"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#272425",
    d: "M53.4,30.5c-2.5,10.9-12,19.1-23.5,19.5h-1.8L14.5,36h23.5l0-19.2L53.4,30.5z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17.1,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 23,
    height: 18.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "#F1F1F1",
    d: "M20.2,15.1v22.7h4.5V15.1H20.2z M24,18.8h-3v-3h3V18.8z M24.1,22.9h-3v-3.1h3V22.9z  M24.1,26.8h-3v-3.1h3V26.8z M24,36.8h-3v-3.1h3V36.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 18.9,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 3.4,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 18.9,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 3.4,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 18.9,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 3.4,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 18.9,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 3.4,
    height: 15.1
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M48.4,11.6v7.6c0,0.9-0.7,1.6-1.6,1.6h-4.3l-4.2,3.3v-3.3h-4.6c-0.9,0-1.6-0.7-1.6-1.6 v-7.6c0-0.9,0.7-1.6,1.6-1.6h13.1C47.7,10,48.4,10.8,48.4,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M47.9,10.9v7.6c0,0.9-0.7,1.6-1.6,1.6h-4.2l-3.9,3.3v-3.3h-4.6c-0.9,0-1.6-0.7-1.6-1.6v-7.6 c0-0.9,0.7-1.6,1.6-1.6h12.8C47.2,9.3,47.9,10.1,47.9,10.9z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-equipment",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5358,
    y1: 48.5355,
    x2: 1.4648,
    y2: 1.4645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M45,50H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C50,47.8,47.8,50,45,50z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M50,25.6V45c0,2.8-2.2,5-5,5H16l-6-9h30V13L50,25.6z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 30,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    fill: "#FFFFFF",
    cx: 35,
    cy: 17,
    r: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8.1,
    opacity: 0.1,
    fill: "#272425",
    width: 8,
    height: 36
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M17,8v35h6V8H17z M22,13h-4V9h4V13z M22,19h-4v-4h4V19z M22,25h-4v-4h4V25z M22,41h-4v-4h4V41z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-infrastructur",
    viewBox: "570 375 60 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.2344,
    y1: 773.7656,
    x2: 27.7656,
    y2: 776.2344,
    gradientTransform: "matrix(16 0 0 -16 136 12800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "585.5,425 571,400 585.5,375 614.5,375 629,400 614.5,425 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    enableBackground: "new    ",
    points: "615.4,388.2 588.2,387.6 581.4,408.1 594.8,425  614.5,425 625.3,406.4 "
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    d: "M595.9,412.9l-5.7-1.6l-10.8-2l5.2-13.3h8.8l11,0.4L595.9,412.9 z M583.5,407l7.4,1.4l3.4,1l5.3-10.2l-6.2-0.2l-6.7,0L583.5,407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M618.6,400.8l-19-0.3l6.4-14.8l10.7,1L618.6,400.8z M604.2,397.6l11,0.1l-1.1-8.2l-6.1-0.6L604.2,397.6z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    d: "M595.4,412.6l0-3l10.4-0.1l-5.9-11.7l18.8-0.3l-4.6,14.9h-5.8 L595.4,412.6z M609.1,409.5h2.7l2.8-8.9l-9.8,0.1L609.1,409.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    d: "M591.6,410.2l-2.9-0.7l2.5-10.7h-7.7l3.7-13l21.4,2.8l-14.2,9.6 L591.6,410.2z M587.4,395.9h5.2l7.7-5.2l-11-1.4L587.4,395.9z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M619.2,402.3l-20.3-0.3l6.9-15.8l11.4,1.1L619.2,402.3z M604.9,398.1l9.7,0.1l-1-7.2l-5.4-0.5 L604.9,398.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M619.2,401.3l-20.3-0.3l6.9-15.8l11.4,1.1L619.2,401.3z M604.9,397.1l9.7,0.1l-1-7.2l-5.4-0.5 L604.9,397.1z"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-link",
    viewBox: "570 375 60 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.2344,
    y1: 773.7656,
    x2: 27.7656,
    y2: 776.2344,
    gradientTransform: "matrix(16 0 0 -16 136 12800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "585.5,425 571,400 585.5,375 614.5,375 629,400 614.5,425 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "601.1,399 585.4,408.3 595,425 614.5,425 625.6,406.2  614.8,391.6 601.1,399 "
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 597.9,
    y: 387.2,
    transform: "matrix(0.5385 0.8426 -0.8426 0.5385 614.3745 -320.0779)",
    opacity: 0.8,
    fill: "#FFFFFF",
    width: 3,
    height: 27.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DEFFB3",
    cx: 588.9,
    cy: 407.9,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DEFFB3",
    cx: 610.9,
    cy: 393.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00AA3E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M600.1,391.9"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-log",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_3_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.3698,
    y1: 48.3698,
    x2: 6.6979,
    y2: 1.6979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M49.4,50H10.6C7.5,50,5,47.5,5,44.4V5.6C5.2,2.5,7.7,0,10.6,0h38.8C52.5,0,55,2.5,55,5.6v38.9 C55,47.5,52.5,50,49.4,50z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "43.4,37.7 43.5,10.8 55,25 55,45.1 54.8,46 54.7,46.4  54.2,47.3 53.8,48.1 52.8,48.9 51.5,49.5 49.8,50 30.9,50 16.6,37.7  "
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M22.7,33.9h3.2v1h-4.5v-7.1h1.2V33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M32.2,31.6c0,0.5-0.1,1-0.2,1.5c-0.1,0.4-0.3,0.8-0.6,1.1c-0.3,0.3-0.6,0.5-0.9,0.7S29.7,35,29.2,35 c-0.4,0-0.8-0.1-1.2-0.2s-0.7-0.4-0.9-0.7c-0.3-0.3-0.5-0.7-0.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5v-0.4c0-0.5,0.1-1,0.2-1.5 c0.1-0.4,0.3-0.8,0.6-1.1c0.3-0.3,0.6-0.5,0.9-0.7c0.4-0.2,0.8-0.2,1.2-0.2c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,0.9,0.7 c0.3,0.3,0.5,0.7,0.6,1.1c0.1,0.4,0.2,0.9,0.2,1.5V31.6z M31,31.2c0-0.4,0-0.7-0.1-1.1c-0.1-0.3-0.2-0.6-0.3-0.8S30.2,29,30,28.9 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.2-0.3,0.5-0.3,0.8c-0.1,0.3-0.1,0.7-0.1,1.1 v0.4c0,0.4,0,0.7,0.1,1.1c0.1,0.3,0.2,0.6,0.3,0.8c0.1,0.2,0.3,0.4,0.5,0.5C28.7,34,29,34,29.2,34c0.5,0,1-0.2,1.3-0.6 c0.3-0.4,0.4-1,0.4-1.8V31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M38.9,34c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.5,0.2-0.8,0.3 C37,35,36.6,35,36.2,35c-0.4,0-0.9-0.1-1.2-0.2c-0.4-0.2-0.7-0.4-1-0.7s-0.5-0.6-0.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.5v-0.5 c0-0.5,0.1-1,0.2-1.4s0.3-0.8,0.6-1.1s0.6-0.5,0.9-0.7c0.4-0.2,0.8-0.2,1.2-0.2c0.4,0,0.8,0.1,1.1,0.2s0.6,0.3,0.8,0.5 c0.2,0.2,0.4,0.4,0.5,0.7s0.2,0.6,0.3,0.9h-1.2c0-0.2-0.1-0.4-0.1-0.5s-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.2-0.1-0.4-0.1-0.6-0.1c-0.3,0-0.5,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.2-0.2,0.5-0.3,0.8c-0.1,0.3-0.1,0.6-0.1,1v0.5 c0,0.4,0,0.7,0.1,1c0.1,0.3,0.2,0.6,0.4,0.8c0.2,0.2,0.4,0.4,0.6,0.5C35.7,34,36,34,36.3,34c0.2,0,0.4,0,0.5,0 c0.2,0,0.3-0.1,0.4-0.1s0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.2-0.1v-1.4h-1.5v-0.9h2.7V34z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M41.8,10.2H18.2c-1.4,0-2.5,1.1-2.5,2.5v8.1h0.8v-8.1c0-0.9,0.7-1.7,1.7-1.7h23.7c0.9,0,1.7,0.7,1.7,1.7 v23.4c0,0.9-0.8,1.7-1.7,1.7H18.2c-0.9,0-1.7-0.7-1.7-1.7V22.9h-0.8v13.2c0,1.3,1.1,2.5,2.5,2.5h23.7c1.4,0,2.5-1.2,2.5-2.5V12.7 C44.3,11.3,43.3,10.2,41.8,10.2z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "25,24.6 22.3,22.6 20.6,23.8 15.7,23.8 15.7,22.9 20.3,22.9 22.3,21.6 24.5,23.2 27.1,14.6  30.2,21.8 33.1,20.1 35,22.7 40.3,22.7 40.3,23.6 34.6,23.6 32.8,21.2 29.8,23.1 27.2,17 "
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-metric",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3698,
    y1: 48.3698,
    x2: 5.6979,
    y2: 1.6979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M48.4,50H9.6C6.5,50,4,47.5,4,44.4V5.6C4.2,2.5,6.7,0,9.6,0h38.8C51.5,0,54,2.5,54,5.6v38.9 C54,47.5,51.5,50,48.4,50z"
  }))), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "40.1,35.4 43.7,27.1 42.4,15.5 53.9,27.2 53.9,45.1  53.7,46 53.5,46.4 53.1,47.3 52.6,48.1 51.7,48.9 50.4,49.5 48.7,50 31.8,50 17.1,36.6 29.8,40.5 "
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M29,10.8c7.8,0,14.2,6.3,14.2,14.2S36.8,39.2,29,39.2S14.8,32.8,14.8,25S21.2,10.8,29,10.8 M29,8.3 c-9.2,0-16.7,7.5-16.7,16.7S19.8,41.7,29,41.7S45.7,34.2,45.7,25S38.2,8.3,29,8.3L29,8.3z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M31.4,23.9c-0.2,0-0.5-0.1-0.7-0.2c-0.4-0.4-0.5-1-0.1-1.4l4.8-5.6c0.4-0.4,1-0.5,1.4-0.1 c0.4,0.4,0.5,1,0.1,1.4l-4.8,5.6C32,23.8,31.7,23.9,31.4,23.9z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M29.4,23.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5S28.6,23.5,29.4,23.5 M29.4,21.8 c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2S31.2,21.8,29.4,21.8L29.4,21.8z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#E8E8E8",
    enableBackground: "new    ",
    d: "M29,17c-0.6,0-1-0.4-1-1v-2.7c0-0.6,0.4-1,1-1s1,0.4,1,1V16 C30,16.6,29.5,17,29,17z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#E8E8E8",
    enableBackground: "new    ",
    d: "M40.5,26h-2.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.6c0.6,0,1,0.4,1,1 S41,26,40.5,26z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#E8E8E8",
    enableBackground: "new    ",
    d: "M20.2,26h-2.7c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.7c0.6,0,1,0.4,1,1 S20.8,26,20.2,26z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-monitoring",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3698,
    y1: 48.3698,
    x2: 5.6979,
    y2: 1.6979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M48.4,50H9.6C6.5,50,4,47.5,4,44.4V5.6C4.2,2.5,6.7,0,9.6,0h38.8C51.5,0,54,2.5,54,5.6v38.9 C54,47.5,51.5,50,48.4,50z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "42.4,35 43.4,34.3 44,32.8 44,16.6 54,27.2 54,45.1  53.8,46 53.7,46.4 53.2,47.3 52.8,48.1 51.8,48.9 50.5,49.5 48.8,50 29,49.8 17.3,35  "
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#E8E8E8",
    d: "M17.8,15c-1.4,0-1.7,0.9-1.7,2.3V23h1v-5.7c0-0.7,0-1.3,0.7-1.3H25l0.2-1H17.8z M41.8,15H27.7 l-0.2,1h14.3c0.7,0,1.3,0.7,1.3,1.3v15c0,0.7-0.6,1.7-1.3,1.7h-24c-0.7,0-0.7-1-0.7-1.7V26h-1v6.3c0,1.4,0.3,2.7,1.7,2.7h24 c1.4,0,2.3-1.2,2.3-2.7v-15C44.1,15.9,43.2,15,41.8,15z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#E8E8E8",
    d: "M39.3,38.2c0,0.7-0.6,1.2-1.2,1.2H21.9c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2h3.8 v-1.3h8.7v1.3h3.8C38.8,36.9,39.3,37.5,39.3,38.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M47.3,49.8"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "25.8,29 23.7,26.2 22.7,25.1 21.2,26.6 16.1,26.6 16.1,24.9 20.5,24.9 22.7,22.8 24.8,24.9  27.6,9.3 31.2,22.9 33.9,20.4 36.3,24.9 40.9,24.9 40.9,26.6 35.3,26.6 33.5,23.2 30.3,26.1 27.9,16.9 "
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-ne",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5358,
    y1: 48.5355,
    x2: 1.4648,
    y2: 1.4645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M45,50H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C50,47.8,47.8,50,45,50z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    fill: "none",
    stroke: "#009EEF",
    strokeMiterlimit: 10,
    x1: 13,
    y1: 20.5,
    x2: 17,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    fill: "none",
    stroke: "#009EEF",
    strokeMiterlimit: 10,
    x1: 18,
    y1: 20.5,
    x2: 22,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    fill: "none",
    stroke: "#009EEF",
    strokeMiterlimit: 10,
    x1: 23,
    y1: 20.5,
    x2: 27,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    fill: "none",
    stroke: "#009EEF",
    strokeMiterlimit: 10,
    x1: 28,
    y1: 20.5,
    x2: 32,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    fill: "none",
    stroke: "#009EEF",
    strokeMiterlimit: 10,
    x1: 33,
    y1: 20.5,
    x2: 37,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 13,
    y1: 37.5,
    x2: 17,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 18,
    y1: 37.5,
    x2: 22,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 23,
    y1: 37.5,
    x2: 27,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 28,
    y1: 37.5,
    x2: 32,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 33,
    y1: 37.5,
    x2: 37,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.25,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 10,
    y1: 11.5,
    x2: 40,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 35,
    cy: 16,
    r: 2
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M50,25.6V45c0,2.8-2.2,5-5,5H16l-6-9h30V13L50,25.6z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-network-map",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5358,
    y1: 48.5355,
    x2: 1.4648,
    y2: 1.4645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M45,50H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C50,47.8,47.8,50,45,50z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M50,30.6V45c0,2.8-2.2,5-5,5H17.7L7.1,32.4L18,38l1,1l12-7h1l12,7V20.5L50,30.6z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "7.1,14.6 7.1,32.4 18,38 18,20  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "32,15 32,32 44,39 44,20.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "31,15 31,32 19,39 19,20  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 25,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 29,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 25,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 31,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 19,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 19,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 12.1,
    y1: 20.1,
    x2: 16.9,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 16.8,
    y1: 26.6,
    x2: 14.5,
    y2: 32.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 14.8,
    y1: 32.4,
    x2: 21.4,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 21.2,
    y1: 30.7,
    x2: 25.7,
    y2: 26.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 25.7,
    y1: 26.6,
    x2: 30,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 30,
    y1: 30.7,
    x2: 34.5,
    y2: 26.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 34.5,
    y1: 26.6,
    x2: 39.3,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 39.3,
    y1: 20.2,
    x2: 39.3,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 34.5,
    y1: 26.6,
    x2: 34.5,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 34.5,
    y1: 20.5,
    x2: 30,
    y2: 22.1
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 30,
    y1: 22.1,
    x2: 25.6,
    y2: 26.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 11,
    y1: 20,
    x2: 25.6,
    y2: 26.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 16,
    y1: 26.5,
    x2: 26,
    y2: 26.5
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#272425",
    d: "M19.3,39.3"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-photonic",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.75,
    y1: 105.25,
    x2: 9.25,
    y2: 144.75,
    gradientTransform: "matrix(2.5862 0 0 -2.5862 0 398.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "37.5,139.7 0,75 37.5,10.3 112.5,10.3 150,75 112.5,139.7 "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    enableBackground: "new    ",
    points: "92.6,36.7 35.4,81.2 64.7,139.7 112.5,139.7  135.3,100.3 "
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#F1F1F1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 87.2,48.6 47.1,78.6 103.4,108.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 89.2,
    y1: 49.4,
    x2: 90.5,
    y2: 54.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "3.7279,3.7279",
    x1: 92.3,
    y1: 63.9,
    x2: 99.6,
    y2: 96.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 100.6,
    y1: 101.4,
    x2: 101.9,
    y2: 106.6
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 34.7,
    y: 65.7,
    fill: "#FFFFFF",
    width: 17.6,
    height: 17.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 88.7,
    cy: 45.5,
    r: 10.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 103.4,
    cy: 104.5,
    r: 10.6
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-service",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.75,
    y1: 105.25,
    x2: 9.25,
    y2: 144.75,
    gradientTransform: "matrix(2.5862 0 0 -2.5862 0 398.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "37.5,139.7 0,75 37.5,10.3 112.5,10.3 150,75 112.5,139.7 "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    enableBackground: "new    ",
    points: "109.9,38.8 102.6,42 91.8,53.1 70.3,77.2 38.7,77.2  28.4,87.4 59.2,139.7 112.5,139.7 140.9,90.5 "
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 101.1,
    y1: 49.1,
    x2: 101.1,
    y2: 54.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "3,3",
    x1: 101.1,
    y1: 59.5,
    x2: 101.1,
    y2: 98.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 101.1,
    y1: 103.4,
    x2: 101.1,
    y2: 106
  }))), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    fill: "#272425",
    cx: 29.9,
    cy: 74.9,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 28.4,
    cy: 73.5,
    r: 11.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 28.7,
    y1: 75,
    x2: 57.2,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 100.9,
    y1: 40.1,
    x2: 69.8,
    y2: 74.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.8,
    y: 29.7,
    fill: "#C7FFCB",
    width: 18.1,
    height: 18.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.7,
    y: 65.4,
    fill: "#C7FFCB",
    width: 18.1,
    height: 18.1
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    fill: "#272425",
    cx: 101.9,
    cy: 108.6,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 100.5,
    cy: 107.2,
    r: 11.6
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-swagger",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_5_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3704,
    y1: 48.3704,
    x2: 5.6733,
    y2: 1.6733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M48.4,50H9.6C6.5,50,4,47.5,4,44.4V5.6C4.1,2.5,6.6,0,9.6,0h38.8C51.5,0,54,2.5,54,5.6v38.9 C54,47.5,51.5,50,48.4,50z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "19.5,11.4 38.1,11.4 54,27.7 54,45.1 53.8,46  53.7,46.4 53.2,47.3 52.8,48.1 51.8,48.9 50.5,49.5 48.8,50 27,50 16.2,36.6 15.8,35.5 15,25  "
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19,36c0.3,0.2,1,0.4,2,0.4h0.5v2.2h-0.9c-1,0-1.8-0.1-2.2-0.2c-0.7-0.2-1.2-0.6-1.7-1.1 c-0.4-0.5-0.7-1.1-0.9-1.8c-0.1-0.7-0.2-2-0.2-3.7s-0.1-2.9-0.3-3.5c-0.2-0.6-0.5-1.2-1-1.5c-0.5-0.4-1.2-0.6-2-0.6 c0,0,0-2.5,0-2.5c0.8,0,1.5-0.2,2-0.6c0.5-0.4,0.8-0.9,1-1.5c0.2-0.6,0.3-1.8,0.3-3.3c0-1.6,0-2.6,0.1-3.1 c0.1-0.8,0.3-1.4,0.5-1.9c0.3-0.5,0.6-0.9,1-1.1c0.4-0.3,0.9-0.5,1.5-0.7c0.4-0.1,1.1-0.1,2-0.1h0.9v2.2h-0.5 c-1.1,0-1.8,0.2-2.2,0.5c-0.4,0.4-0.5,1.1-0.5,2.4c0,2.5-0.1,4-0.2,4.7c-0.2,1-0.5,1.8-1,2.3C16.7,24,16,24.5,15,25 c1.2,0.4,2,1.1,2.5,2s0.8,2.3,0.8,4.4c0,1.8,0,2.9,0.1,3.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.4,23.7V26c-0.8,0-1.5,0.2-2,0.6c-0.5,0.4-0.8,0.9-1,1.5c-0.2,0.6-0.3,1.8-0.3,3.3 c0,1.6,0,2.6-0.1,3.1c-0.1,0.8-0.3,1.4-0.5,1.9c-0.3,0.5-0.6,0.9-1,1.1c-0.4,0.3-0.9,0.5-1.5,0.7c-0.4,0.1-1.1,0.2-2,0.2h-0.9 v-2.2h0.5c1.1,0,1.8-0.2,2.2-0.5c0.4-0.3,0.5-1.1,0.5-2.4c0-2.4,0-3.8,0.1-4.5c0.2-1,0.5-1.9,1-2.5c0.5-0.6,1.2-1.1,2.1-1.5 c-1.2-0.5-2.1-1.2-2.6-2.1c-0.5-0.9-0.7-2.3-0.7-4.3c0-1.8,0-2.9-0.1-3.3c-0.1-0.6-0.3-1.1-0.6-1.3s-1-0.4-2-0.4H35v-2.2h0.9 c1,0,1.8,0.1,2.2,0.2c0.7,0.2,1.2,0.6,1.7,1c0.4,0.5,0.7,1.1,0.9,1.8c0.1,0.7,0.2,2,0.2,3.7s0.1,2.9,0.3,3.5 c0.2,0.6,0.5,1.2,1,1.5C42.9,23.5,43.6,23.7,44.4,23.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.5,24.6c0-1.1,0.8-1.8,1.9-1.8c1.1,0,1.9,0.8,1.9,1.8s-0.7,1.8-1.9,1.8C20.3,26.4,19.5,25.6,19.5,24.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.2,24.6c0-1.1,0.8-1.8,1.9-1.8s1.9,0.8,1.9,1.8s-0.7,1.8-1.9,1.8C27,26.4,26.2,25.6,26.2,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.8,24.6c0-1.1,0.8-1.8,1.9-1.8s1.9,0.8,1.9,1.8s-0.7,1.8-1.9,1.8C33.6,26.4,32.8,25.6,32.8,24.6z"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-user",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_2_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3698,
    y1: 48.3698,
    x2: 5.6979,
    y2: 1.6979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68AACC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03386081,
    style: {
      stopColor: "#6799B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4F69"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M48.4,50H9.6C6.5,50,4,47.5,4,44.4V5.6C4.2,2.5,6.7,0,9.6,0h38.8C51.5,0,54,2.5,54,5.6v38.9 C54,47.5,51.5,50,48.4,50z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M54.1,27.2v17.9L53.8,46l-0.2,0.4l-0.5,0.9l-0.5,0.8l-0.9,0.8 l-1.4,0.6L48.7,50H28.4L13.2,40h31.9c-0.2-2-0.9-4.4-2.6-5.9c0,0-3.9-3.1-9.2-4.1h-0.4l-0.6-2.2C34,27,34.4,25,34.8,23h0.1 c0.9,0,1.5-0.6,1.5-1.5l0.2-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.2-0.2-0.3-0.2-0.5-0.3c0.2-0.5,0.2-1.1,0.2-1.7c0-1-0.3-2-0.7-2.9 l-1.4-1.9L32,10.5l2.7,2.2L54.1,27.2z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M45.6,40.2H12.8l0,0h-0.3c0.2-2.6,1.2-5.1,2.7-6.4c0.2-0.2,4.1-3.8,9.4-3.9h0.1c0.1-0.3,0.2-0.7,0.4-1.7 c-1.6-1-2-3-2.3-4.7c-1-0.2-1.7-1-1.7-2.1L21,20.2c0-0.6,0.2-1.1,0.6-1.5c0.1-0.1,0.2-0.2,0.3-0.3c-0.1-0.5-0.2-0.9-0.2-1.4 c0-4,3.2-7.2,7.2-7.2H29c3.9,0.1,7.1,3.3,7.1,7.2c0,0.5,0,1-0.1,1.5c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.4,0.6,0.9,0.6,1.5l-0.2,1.5 c0,1.1-0.7,1.9-1.7,2c-0.2,1.6-0.7,3.7-2.3,4.7c0.2,0.8,0.3,1.3,0.4,1.7h0.2c5.3,0.3,9.2,3.8,9.3,3.9c1.4,1.3,2.3,3.3,2.7,5.9 L45.6,40.2z M13.3,39.4h31.3c-0.3-2.2-1.2-3.8-2.4-4.9c-0.1,0-3.8-3.6-8.9-3.7l0,0l0,0h-0.8v-0.4c0-0.1-0.3-1.2-0.6-2.2l-0.1-0.3 l0.3-0.2c1.4-0.7,1.8-2.5,2.2-4.5l0.1-0.3h0.3c0.8,0,1.2-0.7,1.2-1.2l0.2-1.5c0-0.3-0.2-0.6-0.4-0.8c-0.1-0.1-0.2-0.2-0.4-0.3 l-0.3-0.2l0.1-0.3c0.2-0.4,0.2-1,0.2-1.5c0-3.5-2.8-6.3-6.2-6.4h-0.1c-3.5,0-6.3,2.9-6.3,6.4c0,0.5,0.1,0.9,0.2,1.4l0.1,0.5 l-0.2,0.2c-0.2,0.1-0.2,0.2-0.4,0.3c-0.2,0.3-0.4,0.6-0.4,0.8l0.2,1.3c0,0.7,0.3,1.3,1.1,1.3h0.3l0.2,0.3c0.3,2.1,0.7,3.8,2.2,4.5 l0.3,0.2l-0.1,0.3c-0.2,0.9-0.6,2-0.6,2.2v0.4h-0.4c-0.3,0-0.5,0-0.5,0h-0.4c-4.8,0.3-8.3,3.7-8.4,3.7 C14.5,35.6,13.7,37.2,13.3,39.4z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "launcher-icons-utlilzation",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5358,
    y1: 48.5355,
    x2: 1.4648,
    y2: 1.4645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M45,50H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C50,47.8,47.8,50,45,50z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M50,25.6V45c0,2.8-2.2,5-5,5H16l-6-9h30V13L50,25.6z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 30,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 4,
    height: 18
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    fill: "#FFFFFF",
    cx: 35,
    cy: 17,
    r: 2
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 82,
    height: 81,
    xlinkHref: "F6BD352A29FC6959.png",
    transform: "matrix(1 0 0 1 45 -14)"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.2,18.8c-1.4,2.4-4,4-7,4c-4.5,0-8.2-3.7-8.2-8.2c0-4.4,3.5-8.1,8-8.2V14L43.2,18.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M44.4,14.6c0,1.2-0.2,2.3-0.7,3.3L41.9,17c0.3-0.7,0.5-1.5,0.5-2.4c0-3.4-2.8-6.2-6.2-6.2 c-0.1,0-0.1,0-0.2,0v-2c0.1,0,0.1,0,0.2,0C40.7,6.4,44.4,10.1,44.4,14.6z"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "link_directional_down",
    viewBox: "0 0 20 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    fill: "#BABCBE",
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "11,13 6,19 1,13  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    fill: "#919395",
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    fill: "#919395",
    width: 8,
    height: 8
  })))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "link_directional_up",
    viewBox: "0 0 20 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    fill: "#BABCBE",
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "1,19 6,13 11,19  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    fill: "#919395",
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    fill: "#919395",
    width: 8,
    height: 8
  })))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-bidirectional-line",
    viewBox: "0 0 25 6"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Infobar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infobar-alarm-spec",
    transform: "translate(-424.000000, -892.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(436.500000, 895.000000) scale(-1, 1) translate(-436.500000, -895.000000) translate(424.000000, 892.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,3 L18,3",
    id: "Line-3",
    stroke: "#BABCBE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#919395",
    x: 0,
    y: 0,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#919395",
    x: 19,
    y: 0,
    width: 6,
    height: 6
  }))))))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-bundle",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M15,0c0.552,0,1,0.448,1,1v14 c0,0.552-0.448,1-1,1H1c-0.552,0-1-0.448-1-1V1c0-0.552,0.448-1,1-1H15z M15,1H1v14h14V1z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.670964, 4.002083)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#414141",
    points: "5.912,0.791 2.502,8.531  1.008,8.531 4.412,1.143 0,1.143 0,0 5.912,0  "
  })))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-degraded",
    viewBox: "0 0 27 16"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FED200",
    width: 27,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EFC059",
    d: "M13.5,0 c-0.391,0-0.781,0.186-1.013,0.642L5.642,14.179c-0.217,0.427-0.171,0.844,0.002,1.181C5.82,15.715,6.151,16,6.653,16h13.693 c0.503,0,0.834-0.285,1.014-0.648c0.169-0.329,0.215-0.746-0.002-1.174L14.512,0.643C14.282,0.187,13.891,0,13.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE775",
    d: "M6.661,14.68l6.838-13.521 l6.84,13.521c0.018,0.036,0.022,0.07,0.016,0.1l-0.015,0.043c-0.007,0.015-0.009,0.019-0.005,0.02l-13.682,0 c0.01,0,0.015,0.001,0.014-0.003C6.639,14.781,6.634,14.733,6.661,14.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M13.501,11.34 c0.628,0,1.138,0.509,1.138,1.137c0,0.63-0.509,1.138-1.138,1.138s-1.138-0.509-1.138-1.138 C12.364,11.849,12.873,11.34,13.501,11.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M13.481,5.243 c-0.848,0-1.544,0.602-1.544,1.35l0.706,3.376l0.004,0.037l0.045,0.139c0.145,0.299,0.453,0.468,0.789,0.468 c0.452,0,0.844-0.309,0.844-0.719l0.732-3.278l0-0.201l-0.029-0.155C14.855,5.649,14.216,5.243,13.481,5.243z"
  })))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-down-in-bundle",
    viewBox: "0 0 28.9 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-down-bundle",
    transform: "translate(7.141 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LinkBundle",
    transform: "translate(-7.141 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 28.9,
    height: 4,
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M2.367.5H30.261",
    transform: "translate(-1.864 3)",
    fill: "none",
    stroke: "rgba(0,0,0,0.2)",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6-2",
    "data-name": "Line 6",
    d: "M2.367.5H30.261",
    transform: "translate(-1.864)",
    fill: "none",
    stroke: "rgba(255,255,255,0.75)",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Notification_Error-small",
    "data-name": "Notification/Error-small",
    transform: "translate(-0.998 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M4.427,0,0,4.427V9.573L4.427,14H9.573L14,9.573V4.427L9.573,0Z",
    transform: "translate(1 1)",
    fill: "#e52c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M10.987,16H5.013L0,10.987V5.013L5.013,0h5.974l2.507,2.507L16,             5.013v5.974L10.987,16ZM5.427,1h0L1,5.427v5.146L5.427,15h5.146L15,10.573V5.427L10.573,1H5.427Z",
    fill: "#c81d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M.5,9a1,1,0,1,1,1,1A1,1,0,0,1,.5,9ZM.917,6.5,0,1.467A1.474,             1.474,0,0,1,1.472,0,1.456,1.456,0,0,1,3,1.383L2.028,6.5a.535.535,0,0,1-.555.5A.536.536,0,0,1,.917,6.5Z",
    transform: "translate(6.5 3)",
    fill: "#fff"
  }))))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-down",
    viewBox: "0 0 27 16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E52C2C",
    width: 7,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E52C2C",
    width: 7,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E52C2C",
    width: 7,
    height: 4
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-lag",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EDEDED",
    d: " M9.151,7L0,7V6l8.903,0c0.078,0.227,0.146,0.474,0.2,0.735L9.151,7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EDEDED",
    d: " M16,6v1l-3.52,0c-0.035-0.342-0.088-0.676-0.157-1L16,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D8D8D8",
    d: " M9.231,8c0,0.346-0.029,0.682-0.08,1L0,9V7l9.151-0.002C9.202,7.317,9.231,7.654,9.231,8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D8D8D8",
    d: " M16,7v2l-3.52,0c0.034-0.327,0.051-0.661,0.051-1c0-0.339-0.017-0.673-0.051-1L16,7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BEBEBE",
    d: " M8.903,10L0,10V9l9.151,0.001C9.108,9.27,9.049,9.527,8.978,9.767L8.903,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BEBEBE",
    d: " M16,9v1l-3.677,0.001C12.392,9.676,12.445,9.342,12.48,9L16,9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M7.731,1.9c2.275,0,4.1,2.738,4.1,6.1 s-1.825,6.1-4.1,6.1c-1.429,0-2.722-1.09-3.464-2.832l-0.094-0.231l0.093-0.136l1.86,0.001l0.088,0.052 C6.644,11.74,7.211,12.2,7.731,12.2c1.104,0,2.2-1.909,2.2-4.2s-1.096-4.2-2.2-4.2c-0.48,0-1.001,0.393-1.416,1.072L6.214,5.048 L6.126,5.1L4.266,5.1L4.173,4.964C4.896,3.087,6.239,1.9,7.731,1.9z"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-line",
    viewBox: "0 0 35 20"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#BABCBE",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 32.6,
    y1: 10.3,
    x2: 4.4,
    y2: 10.3
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-locked",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M15,0c0.552,0,1,0.448,1,1v14 c0,0.552-0.448,1-1,1H1c-0.552,0-1-0.448-1-1V1c0-0.552,0.448-1,1-1H15z M15,1H1v14h14V1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M6.5,4.62V2.333C6.5,1.462,6.175,0,4,0 S1.5,1.461,1.5,2.333V4.62H0v6h8v-6H6.5z M2.5,2.333C2.5,1.728,2.678,1.11,4,1.11s1.5,0.618,1.5,1.223V4.62h-3V2.333z"
  })))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-protected",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M15,0c0.552,0,1,0.448,1,1v14 c0,0.552-0.448,1-1,1H1c-0.552,0-1-0.448-1-1V1c0-0.552,0.448-1,1-1H15z M15,1H1v14h14V1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414141",
    d: " M8.077,2l0,0.106l0.025,0.023l0.056,0.052l0.104,0.102l0.171,0.17l0.083,0.081l0.09,0.086l0.096,0.09L8.77,2.771l0.071,0.063 l0.074,0.064l0.078,0.065l0.081,0.066l0.085,0.067L9.269,3.18l0,0l0.117,0.085c0.064,0.045,0.13,0.091,0.199,0.137L9.69,3.47 c0.733,0.466,1.749,0.916,3.167,1.136c0.332,2.13,0.048,4.31-0.463,5.398c-0.494,1.052-1.481,2.034-2.427,2.765l-0.126,0.096 c-0.021,0.016-0.042,0.031-0.063,0.047l-0.124,0.091l-0.123,0.088L9.41,13.177c-0.04,0.028-0.08,0.055-0.12,0.082l-0.118,0.078 l-0.058,0.038l0,0l-0.114,0.073l-0.112,0.069l-0.162,0.096l0,0l-0.103,0.059l-0.1,0.055l-0.096,0.051l-0.091,0.047l-0.087,0.042 l-0.042,0.02l0,0l-0.079,0.036l-0.051,0.021V14l-0.025-0.008l0,0L8,13.973l0,0L7.923,14l0-0.057c-0.094-0.039-0.201-0.089-0.32-0.15 L7.5,13.738l0,0l-0.109-0.06c-0.037-0.021-0.075-0.042-0.114-0.065l-0.118-0.07c-0.06-0.036-0.121-0.074-0.184-0.113L6.849,13.35 c-1.132-0.736-2.602-1.982-3.243-3.346C3.095,8.916,2.811,6.736,3.143,4.606c0.774-0.12,1.427-0.309,1.981-0.531l0.131-0.054 c0.237-0.1,0.454-0.206,0.654-0.315l0.107-0.06c0.035-0.02,0.07-0.04,0.104-0.06l0.101-0.061l0,0l0.097-0.061l0,0l0.094-0.061l0,0 l0.091-0.061l0,0l0.088-0.061l0,0l0.085-0.061l0,0L6.758,3.16c0.013-0.01,0.027-0.02,0.04-0.03l0.077-0.06l0,0l0.075-0.06l0,0 l0.072-0.059l0,0l0.103-0.087l0,0l0.097-0.085l0,0l0.091-0.083l0,0l0.086-0.08l0,0l0.106-0.102l0,0l0.303-0.3l0,0l0.069-0.066l0,0 l0.048-0.043l0,0l0-0.106C7.947,2.009,7.972,2.024,8,2.044c0.021-0.015,0.041-0.027,0.059-0.036L8.077,2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.152363, 3.653972)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "3.844,3.987 5.023,5.247 8.02,2  8.849,2.896 5.023,7.051 3,4.87  "
  })))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-unidirectional-arrow-left",
    viewBox: "0 0 25 6"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Infobar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infobar-alarm-spec",
    transform: "translate(-424.000000, -880.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(436.500000, 883.000000) scale(-1, 1) translate(-436.500000, -883.000000) translate(424.000000, 880.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,3 L18,3",
    id: "Line-3",
    stroke: "#BABCBE"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    fill: "#929497",
    points: "11 0 14 3 11 6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#919395",
    x: 0,
    y: 0,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#919395",
    x: 19,
    y: 0,
    width: 6,
    height: 6
  }))))))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-unidirectional-arrow-right",
    viewBox: "0 0 25 6"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Infobar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infobar-alarm-spec",
    transform: "translate(-424.000000, -868.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(424.000000, 868.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,3 L18,3",
    id: "Line-3",
    stroke: "#BABCBE"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    fill: "#929497",
    points: "11 0 14 3 11 6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#919395",
    x: 0,
    y: 0,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#919395",
    x: 19,
    y: 0,
    width: 6,
    height: 6
  }))))))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-unidirectional-arrow",
    viewBox: "0 0 35 20"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#BABCBE",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 32.6,
    y1: 10.3,
    x2: 4.4,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#BABCBE",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    points: "12.8,1.7 4.4,9.9 12.8,18.3 "
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-unmanaged-network",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M8,1c3.86,0,7,3.14,7,7s-3.14,7-7,7 s-7-3.14-7-7S4.14,1,8,1 M8,0C3.582,0,0,3.582,0,8s3.582,8,8,8s8-3.582,8-8S12.418,0,8,0L8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#414141",
    d: "M7.214,3.255c1.632,0,2.956,1.292,2.956,2.885 c0,0.011,0,0.022,0,0.033c1.899,0.205,3.356,1.404,3.356,2.852c0,1.593-1.764,2.885-3.941,2.885c-0.544,0-1.061-0.081-1.532-0.226 C7.611,11.83,7.131,11.91,6.628,11.91c-2.177,0-3.941-1.507-3.941-3.366c0-1.105,0.623-2.085,1.586-2.699 C4.424,4.391,5.683,3.255,7.214,3.255z"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-backplate-disabled",
    viewBox: "0 0 70 70"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M64.8,66.5H5.2c-2.8,0-5.2-2.3-5.2-5.2V10.5c0-3,2.5-5.2,5.2-5.2h59.5c3,0,5.2,2.3,5.2,5.2v50.8 C70,64.2,67.7,66.5,64.8,66.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: 38.5,
    opacity: 0.7,
    fill: "#7B7F7F",
    enableBackground: "new    ",
    width: 29.8,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 38.5,
    opacity: 0.7,
    fill: "#7B7F7F",
    enableBackground: "new    ",
    width: 22.8,
    height: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 50.8,
    opacity: 0.7,
    fill: "#7B7F7F",
    enableBackground: "new    ",
    width: 22.8,
    height: 5.2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7B7F7F",
    points: "62,14 51.5,25.6 56.7,25.6 51.5,35 62,23.4 56.7,23.4  "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7B7F7F",
    points: "19.2,14 8.8,25.6 14,25.6 8.8,35 19.2,23.4 14,23.4  "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M42.9,28.5c-1.8,0-3.9-1.4-4.7-2.1l1.1-0.9c0.9,0.9,3,2.1,4.2,1.8c0.7-0.4,0.9-1.6,0.9-2.4 c0-1.1-0.4-1.6-0.9-1.9c-1.6-0.7-4.9,0.7-5.9,1.4l-0.7-1c0.5-0.3,4.7-2.6,7.2-1.4c1.1,0.5,1.6,1.6,1.8,3c0,1.9-0.5,3.1-1.6,3.5 C43.6,28.5,43.2,28.5,42.9,28.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M32.7,33.2c-0.5,0-1.2-0.2-1.9-0.4c-1.9-0.7-2.8-1.8-2.8-2.8c0.2-1.9,3-3.3,4.4-3.7l0.4,1.2 c-1.1,0.3-3.3,1.6-3.5,2.6c0,0.7,1,1.4,1.9,1.8c1.1,0.4,1.8,0.4,2.3,0c1.4-0.9,1.4-4.4,1.2-5.4l1.4-0.2c0,0.5,0.5,5.1-1.8,6.5 C34,33.1,33.2,33.2,32.7,33.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M33.8,24.5c-0.5-0.2-5.1-2.1-5.4-4.7c-0.2-1,0.5-2.1,1.8-3c1.8-1.2,3.1-1.4,4.2-0.7 c1.9,1,1.6,4.5,1.4,5.2l-1.4-0.2c0.2-1.1,0.2-3.5-0.7-4c-0.7-0.3-1.8,0.2-2.6,0.7s-1.2,1.2-1.2,1.8c0.2,1.6,3.5,3.1,4.5,3.7 L33.8,24.5z"
  })), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#7B7F7F",
    cx: 35.5,
    cy: 24.7,
    rx: 2.8,
    ry: 2.6
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M64.8,5.2h-5.2V7h5.2V5.2L64.8,5.2L64.8,5.2z M54.2,5.2H49V7h5.2V5.2L54.2,5.2z M43.8,5.2h-5.2V7h5.2V5.2 L43.8,5.2z M33.2,5.2H28V7h5.2V5.2L33.2,5.2z M22.8,5.2h-5.2V7h5.2V5.2L22.8,5.2z M12.2,5.2H7V7h5.2V5.2L12.2,5.2z M1.9,6.3 c0,0.2-0.2,0.4-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C0.7,7.9,0.3,8.4,0.2,8.9l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v0.5 h1.8v1.1c0-1.1,0.5-2.1,1.4-2.8L1.9,6.3L1.9,6.3z M1.8,16.3H0v5.2h1.8V16.3L1.8,16.3z M1.8,26.8H0V32h1.8V26.8L1.8,26.8z M1.8,37.3 H0v5.2h1.8V37.3L1.8,37.3z M1.8,47.8H0V53h1.8V47.8L1.8,47.8z M1.8,58.3H0v3l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c0,0.2,0,0.4,0.2,0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v0.2l1.6-0.7c0.2,1.1,0,0.5,0,0V58.3L1.8,58.3z M4.7,64.8l-0.2,1.8c0.2,0,0.4,0,0.5,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h4.5v-1.8H5.2 C5.1,64.8,4.9,64.8,4.7,64.8L4.7,64.8z M20.3,64.8h-5.2v1.8h5.2V64.8L20.3,64.8z M30.8,64.8h-5.2v1.8h5.2V64.8L30.8,64.8z  M41.3,64.8H36v1.8h5.2V64.8L41.3,64.8z M51.8,64.8h-5.2v1.8h5.2V64.8L51.8,64.8z M62.3,64.8H57v1.8h5.2V64.8L62.3,64.8z M68.2,61.4 c0,1.2-0.7,2.3-1.8,2.8l0.9,1.6c0.7-0.5,1.4-1,1.9-1.8l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c0.2-0.5,0.4-1,0.4-1.8L68.2,61.4L68.2,61.4z M70,50.9h-1.8v5.2H70V50.9L70,50.9z M70,40.4h-1.8v5.2H70V40.4L70,40.4z M70,29.9h-1.8 v5.2H70V29.9L70,29.9z M70,19.4h-1.8v5.2H70V19.4L70,19.4z M69.8,9.1l-1.8,0.5c0.2,0.2,0.2,0.5,0.2,0.9v3.7H70v-3.7l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C70,9.6,69.8,9.3,69.8,9.1 L69.8,9.1z M64.8,5.2V7c0.3,0,0.7,0,1,0.2l0.5-1.8h-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c-0.2,0-0.4,0-0.7-0.2 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2L64.8,5.2L64.8,5.2 L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2 L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2z"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-backplate-normal",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: -13,
    fill: "#929497",
    width: 1,
    height: 64
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M38,37.5H2c-1.1,0-2-0.9-2-2v-31c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2v31C40,36.6,39.1,37.5,38,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M38,3.5c0.6,0,1,0.4,1,1v31c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1v-31c0-0.6,0.4-1,1-1H38 M38,2.5H2 c-1.1,0-2,0.9-2,2v31c0,1.1,0.9,2,2,2h36c1.1,0,2-0.9,2-2v-31C40,3.4,39.1,2.5,38,2.5L38,2.5z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 22,
    fill: "#E8E8E8",
    width: 17,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22,
    fill: "#E8E8E8",
    width: 13,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 29,
    fill: "#E8E8E8",
    width: 13,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "35.4,8 29.4,14.6 32.4,14.6 29.4,20 35.4,13.4 32.4,13.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "11,8 5,14.6 8,14.6 5,20 11,13.4 8,13.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M24.5,16.3c-1,0-2.2-0.8-2.7-1.2l0.6-0.5c0.5,0.5,1.7,1.2,2.4,1c0.4-0.2,0.5-0.9,0.5-1.4 c0-0.6-0.2-0.9-0.5-1.1c-0.9-0.4-2.8,0.4-3.4,0.8L21,13.3c0.3-0.2,2.7-1.5,4.1-0.8c0.6,0.3,0.9,0.9,1,1.7c0,1.1-0.3,1.8-0.9,2 C24.9,16.3,24.7,16.3,24.5,16.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M18.7,19c-0.3,0-0.7-0.1-1.1-0.2c-1.1-0.4-1.6-1-1.6-1.6c0.1-1.1,1.7-1.9,2.5-2.1l0.2,0.7 c-0.6,0.2-1.9,0.9-2,1.5c0,0.4,0.6,0.8,1.1,1c0.6,0.2,1,0.2,1.3,0c0.8-0.5,0.8-2.5,0.7-3.1l0.8-0.1c0,0.3,0.3,2.9-1,3.7 C19.4,18.9,19,19,18.7,19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M19.3,14c-0.3-0.1-2.9-1.2-3.1-2.7c-0.1-0.6,0.3-1.2,1-1.7c1-0.7,1.8-0.8,2.4-0.4c1.1,0.6,0.9,2.6,0.8,3 l-0.8-0.1c0.1-0.6,0.1-2-0.4-2.3c-0.4-0.2-1,0.1-1.5,0.4c-0.5,0.3-0.7,0.7-0.7,1c0.1,0.9,2,1.8,2.6,2.1L19.3,14z"
  })), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#BABCBE",
    cx: 20.3,
    cy: 14.1,
    rx: 1.6,
    ry: 1.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-backplate-planning",
    viewBox: "0 0 70 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M64.8,66.5H5.2c-2.8,0-5.2-2.3-5.2-5.2V10.5c0-3,2.5-5.2,5.2-5.2h59.5c3,0,5.2,2.3,5.2,5.2v50.8 C70,64.2,67.7,66.5,64.8,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M64.8,5.2h-5.2V7h5.2V5.2L64.8,5.2L64.8,5.2z M54.2,5.2H49V7h5.2V5.2L54.2,5.2z M43.8,5.2h-5.2V7h5.2V5.2 L43.8,5.2z M33.2,5.2H28V7h5.2V5.2L33.2,5.2z M22.8,5.2h-5.2V7h5.2V5.2L22.8,5.2z M12.2,5.2H7V7h5.2V5.2L12.2,5.2z M1.9,6.3 c0,0.2-0.2,0.4-0.4,0.4l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C0.7,7.9,0.3,8.4,0.2,8.9l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 v0.5h1.8v1.1c0-1.1,0.5-2.1,1.4-2.8L1.9,6.3L1.9,6.3z M1.8,16.3H0v5.2h1.8V16.3L1.8,16.3z M1.8,26.8H0V32h1.8V26.8L1.8,26.8z  M1.8,37.3H0v5.2h1.8V37.3L1.8,37.3z M1.8,47.8H0V53h1.8V47.8L1.8,47.8z M1.8,58.3H0v3l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0c0,0.2,0,0.4,0.2,0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v0.2l1.6-0.7c0.2,1.1,0,0.5,0,0V58.3L1.8,58.3z M4.7,64.8l-0.2,1.8c0.2,0,0.4,0,0.5,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h4.5v-1.8H5.2 C5.1,64.8,4.9,64.8,4.7,64.8L4.7,64.8z M20.3,64.8h-5.2v1.8h5.2V64.8L20.3,64.8z M30.8,64.8h-5.2v1.8h5.2V64.8L30.8,64.8z  M41.3,64.8H36v1.8h5.2V64.8L41.3,64.8z M51.8,64.8h-5.2v1.8h5.2V64.8L51.8,64.8z M62.3,64.8H57v1.8h5.2V64.8L62.3,64.8z  M68.2,61.4c0,1.2-0.7,2.3-1.8,2.8l0.9,1.6c0.7-0.5,1.4-1,1.9-1.8l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0c0.2-0.5,0.4-1,0.4-1.8L68.2,61.4L68.2,61.4z M70,50.9h-1.8v5.2H70V50.9L70,50.9z M70,40.4h-1.8v5.2H70V40.4L70,40.4z  M70,29.9h-1.8v5.2H70V29.9L70,29.9z M70,19.4h-1.8v5.2H70V19.4L70,19.4z M69.8,9.1l-1.8,0.5c0.2,0.2,0.2,0.5,0.2,0.9v3.7H70v-3.7 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 C70,9.6,69.8,9.3,69.8,9.1L69.8,9.1z M64.8,5.2V7c0.3,0,0.7,0,1,0.2l0.5-1.8h-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0c-0.2,0-0.4,0-0.7-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2C64.9,5.2,64.9,5.2,64.8,5.2 C64.9,5.2,64.9,5.2,64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2 L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2L64.8,5.2z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "12.9,5.2 10.8,7 10.7,7.2 2.3,15.2 0,17.5 0,17.5 0,15.6 1.8,13.8 8.8,7 10.5,5.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "25.4,5.2 24.5,5.6 22.9,7 22.9,7 2.3,27.5 1.8,28 1.1,28.7 0,29.8 0,27.8 1.8,26.1 21,7  22.8,5.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "37.6,5.2 0,42.5 0,39.5 1.2,38.5 1.8,37.8 2.3,37.3 32.5,7 32.9,6.7 34.6,5.2 35,5.1 35.2,5.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "50,5.2 0.5,54.2 0,54.8 0,52 2.3,49.7 45,7 45.3,6.7 45.5,7 47.6,5.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M62.5,5.2l-1.2,1.2L4.4,63l-1.8,1.8H2.5H2.3c-0.3,0-0.5,0-0.5,0l0,0l-0.2,0.2v-0.2l0,0 c-0.2-0.2-0.3-0.3-0.5-0.5l59-59H62.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M70,7.9v1.2L12.6,66.5h-2.4l2.1-2.1l1.4-1.4l56-56l0,0l0,0C70,7.2,70,7.5,70,7.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "70,19.1 70,21.5 25,66.5 22.6,66.5 22.8,66.3 26.1,63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "70,31.5 70,34 37.5,66.5 35,66.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "70,43.8 70,46.4 68.2,48.1 49.9,66.5 47.2,66.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "70,56.2 70,58.6 69.1,59.5 65.6,63 64.8,63.9 62.1,66.5 59.7,66.5  "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: 38.5,
    opacity: 0.7,
    fill: "#7B7F7F",
    enableBackground: "new    ",
    width: 29.8,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 38.5,
    opacity: 0.7,
    fill: "#7B7F7F",
    enableBackground: "new    ",
    width: 22.8,
    height: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 50.8,
    opacity: 0.7,
    fill: "#7B7F7F",
    enableBackground: "new    ",
    width: 22.8,
    height: 5.2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7B7F7F",
    points: "62,14 51.5,25.6 56.7,25.6 51.5,35 62,23.4 56.7,23.4  "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7B7F7F",
    points: "19.2,14 8.8,25.6 14,25.6 8.8,35 19.2,23.4 14,23.4  "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M42.9,28.5c-1.8,0-3.9-1.4-4.7-2.1l1.1-0.9c0.9,0.9,3,2.1,4.2,1.8c0.7-0.4,0.9-1.6,0.9-2.4 c0-1.1-0.4-1.6-0.9-1.9c-1.6-0.7-4.9,0.7-5.9,1.4l-0.7-1c0.5-0.3,4.7-2.6,7.2-1.4c1.1,0.5,1.6,1.6,1.8,3c0,1.9-0.5,3.1-1.6,3.5 C43.6,28.5,43.2,28.5,42.9,28.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M32.7,33.2c-0.5,0-1.2-0.2-1.9-0.4c-1.9-0.7-2.8-1.8-2.8-2.8c0.2-1.9,3-3.3,4.4-3.7l0.4,1.2 c-1.1,0.3-3.3,1.6-3.5,2.6c0,0.7,1,1.4,1.9,1.8c1.1,0.4,1.8,0.4,2.3,0c1.4-0.9,1.4-4.4,1.2-5.4l1.4-0.2c0,0.5,0.5,5.1-1.8,6.5 C34,33.1,33.2,33.2,32.7,33.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M33.8,24.5c-0.5-0.2-5.1-2.1-5.4-4.7c-0.2-1,0.5-2.1,1.8-3c1.8-1.2,3.1-1.4,4.2-0.7 c1.9,1,1.6,4.5,1.4,5.2l-1.4-0.2c0.2-1.1,0.2-3.5-0.7-4c-0.7-0.3-1.8,0.2-2.6,0.7s-1.2,1.2-1.2,1.8c0.2,1.6,3.5,3.1,4.5,3.7 L33.8,24.5z"
  })), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#7B7F7F",
    cx: 35.5,
    cy: 24.7,
    rx: 2.8,
    ry: 2.6
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ei-card-disabled",
    viewBox: "0 0 70 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M54.2,3.5v63c0,0.2,0,0.5,0,0.7c0,0.2,0,0.2-0.2,0.3c0,0.2,0,0.2-0.2,0.4l-1,1.4 c-0.2,0.2-0.4,0.4-0.5,0.4c0,0-0.2,0-0.2,0.2c-0.2,0-0.4,0.3-0.4,0.3H18.7l0,0l0,0c-0.4,0-0.7-0.2-1.1-0.3 c-1-0.7-1.9-1.9-1.9-3.3V3.1c0-0.2,0-0.2,0-0.4c0-0.2,0-0.2,0-0.3V2.1l0,0l0,0l0,0l0,0l0,0V1.8c0,0,0.4,0,0.5,0h0.2V1.6l0,0 c-0.2,0-0.3,0-0.3-0.2h-0.4l0,0C17.5,0.9,17.5,0,18,0l0,0h0.2l0,0l0,0h0.2l0,0l0,0l0,0l0,0l0,0l0,0h0.4l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0h31.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c0.2,0,0.4,0.2,0.5,0.3l0,0C53.5,0.9,54.2,2.1,54.2,3.5z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 54.2,
    fill: "#7B7F7F",
    width: 28,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.8,
    fill: "#7B7F7F",
    width: 28,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M45.5,0v1.8h5.2V0H45.5z M35,0v1.8h5.2V0H35z M24.5,0v1.8h5.2V0H24.5z M19.2,0L19.2,0L19.2,0L19.2,0L19.2,0 C19.1,0,19.1,0,19.2,0C19.1,0,19.1,0,19.2,0C19.1,0,19.1,0,19.2,0L19.2,0C19.1,0,19.1,0,19.2,0C19.1,0,19.1,0,19.2,0h-0.2l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0,0,0-0.2,0l0,0c-0.7,0.2-1.2,0.7-1.8,1.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l-1.2,1.2c0,0,0,0.2,0,0.3c0,0.2,0,0.2,0,0.4c0,0,0,0,0,0.2l0,0l1.8,0.2c-0.2-1,0.7-1.8,1.6-1.8V0L19.2,0z M15.8,8.8V14h1.8V8.8 H15.8z M15.8,19.2v5.2h1.8v-5.2H15.8z M15.8,29.8V35h1.8v-5.2H15.8z M15.8,40.2v5.2h1.8v-5.2H15.8z M15.8,50.8V56h1.8v-5.2H15.8z  M15.8,61.2v5.2h1.8v-5.2H15.8z M19.1,68.2L19.1,68.2L19.1,68.2L18.7,70l0,0l0,0h5.8v-1.8H19.1z M29.8,68.2V70H35v-1.8H29.8z  M40.2,68.2V70h5.2v-1.8H40.2z M52.5,66.8c-0.2,0.9-0.9,1.4-1.8,1.4V70h1c0.2,0,0.4-0.2,0.4-0.3c0,0,0.2,0,0.2-0.2 c0.2-0.2,0.3-0.2,0.5-0.3l1-1.4c0-0.2,0-0.2,0.2-0.3c0,0,0-0.2,0.2-0.3L52.5,66.8z M52.5,56v5.2h1.8V56H52.5z M52.5,45.5v5.2h1.8 v-5.2H52.5z M52.5,35v5.2h1.8V35H52.5z M52.5,24.5v5.2h1.8v-5.2H52.5z M52.5,14v5.2h1.8V14H52.5z M52.5,3.5v5.2h1.8V3.5H52.5z  M51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2C51.6,0,51.6,0,51.6,0.2 C51.5,0,51.5,0,51.6,0.2h-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v1.8h0.2c0.2,0,0.2,0,0.4,0l0.2-0.5L51.6,0.2 C51.8,0.2,51.6,0.2,51.6,0.2z"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ei-card-normal",
    viewBox: "0 0 1200 800"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 15,
    fill: "#E8E8E8",
    width: 404,
    height: 775
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: -240,
    fill: "#929497",
    width: 20,
    height: 1280
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 620,
    fill: "#BABCBE",
    width: 320,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 100,
    fill: "#BABCBE",
    width: 320,
    height: 40
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M780,20c12,0,20,8,20,20v720c0,12-8,20-20,20H420c-12,0-20-8-20-20V40c0-12,8-20,20-20H780 M780,0H420 c-22,0-40,18-40,40v720c0,22,18,40,40,40h360c22,0,40-18,40-40V40C820,18,802,0,780,0L780,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 780,
    opacity: 0.7,
    fill: "#919395",
    enableBackground: "new    ",
    width: 360,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    opacity: 0.5,
    fill: "#DDDDDD",
    enableBackground: "new    ",
    width: 360,
    height: 20
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ei-card-planning",
    viewBox: "0 0 70 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M54.2,3.5v63c0,0.2,0,0.5,0,0.7c0,0.2,0,0.2-0.2,0.3c0,0.2,0,0.2-0.2,0.4l-1,1.4 c-0.2,0.2-0.4,0.4-0.5,0.4c0,0-0.2,0-0.2,0.2c-0.2,0-0.4,0.3-0.4,0.3H18.7l0,0l0,0c-0.4,0-0.7-0.2-1.1-0.3 c-1-0.7-1.9-1.9-1.9-3.3V3.1c0-0.2,0-0.2,0-0.4c0-0.2,0-0.2,0-0.3V2.1l0,0l0,0l0,0l0,0l0,0V1.8c0,0,0.4,0,0.5,0h0.2V1.6l0,0 c-0.2,0-0.3,0-0.3-0.2h-0.4l0,0C17.5,0.9,17.5,0,18,0l0,0h0.2l0,0l0,0h0.2l0,0l0,0l0,0l0,0l0,0l0,0h0.4l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0h31.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c0.2,0,0.4,0.2,0.5,0.3l0,0C53.5,0.9,54.2,2.1,54.2,3.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "28,0 26.2,1.8 17.5,10.5 15.8,12.2 15.8,9.6 25.4,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "40.2,0 40.2,0 38.5,1.8 17.5,22.8 15.8,24.5 15.8,24.5 15.8,22.1 37.8,0  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M52.3,0.3l-0.9,0.9l-0.5,0.5L15.8,36.9v-2.4L50.2,0h0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.5l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C52,0,52.1,0.2,52.3,0.3L52.3,0.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "54.2,8.4 54.2,10.8 15.8,49.4 15.8,46.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "54.2,20.6 54.2,23.1 15.8,61.6 15.8,59.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M54.2,33.1v2.4L19.8,70h-1l0,0l0,0c-0.4,0-0.7-0.2-1.1-0.3l1.4-1.4L54.2,33.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "54.2,45.5 54.2,48 32.2,70 29.8,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "54.2,57.8 54.2,60.4 53.4,61.2 45.5,69.1 44.6,70 42,70  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 54.2,
    fill: "#7B7F7F",
    width: 28,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.8,
    fill: "#7B7F7F",
    width: 28,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M45.5,0v1.8h5.2V0H45.5z M35,0v1.8h5.2V0H35z M24.5,0v1.8h5.2V0H24.5z M19.2,0L19.2,0L19.2,0L19.2,0L19.2,0 C19.1,0,19.1,0,19.2,0C19.1,0,19.1,0,19.2,0C19.1,0,19.1,0,19.2,0L19.2,0C19.1,0,19.1,0,19.2,0C19.1,0,19.1,0,19.2,0h-0.2l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0,0,0-0.2,0l0,0c-0.7,0.2-1.2,0.7-1.8,1.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l-1.2,1.2c0,0,0,0.2,0,0.3c0,0.2,0,0.2,0,0.4c0,0,0,0,0,0.2l0,0l1.8,0.2c-0.2-1,0.7-1.8,1.6-1.8V0L19.2,0z M15.8,8.8V14h1.8V8.8 H15.8z M15.8,19.2v5.2h1.8v-5.2H15.8z M15.8,29.8V35h1.8v-5.2H15.8z M15.8,40.2v5.2h1.8v-5.2H15.8z M15.8,50.8V56h1.8v-5.2H15.8z  M15.8,61.2v5.2h1.8v-5.2H15.8z M19.1,68.2L19.1,68.2L19.1,68.2L18.7,70l0,0l0,0h5.8v-1.8H19.1z M29.8,68.2V70H35v-1.8H29.8z  M40.2,68.2V70h5.2v-1.8H40.2z M52.5,66.8c-0.2,0.9-0.9,1.4-1.8,1.4V70h1c0.2,0,0.4-0.2,0.4-0.3c0,0,0.2,0,0.2-0.2 c0.2-0.2,0.3-0.2,0.5-0.3l1-1.4c0-0.2,0-0.2,0.2-0.3c0,0,0-0.2,0.2-0.3L52.5,66.8z M52.5,56v5.2h1.8V56H52.5z M52.5,45.5v5.2h1.8 v-5.2H52.5z M52.5,35v5.2h1.8V35H52.5z M52.5,24.5v5.2h1.8v-5.2H52.5z M52.5,14v5.2h1.8V14H52.5z M52.5,3.5v5.2h1.8V3.5H52.5z  M51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2L51.6,0.2C51.6,0,51.6,0,51.6,0.2 C51.5,0,51.5,0,51.6,0.2h-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v1.8h0.2c0.2,0,0.2,0,0.4,0l0.2-0.5L51.6,0.2 C51.8,0.2,51.6,0.2,51.6,0.2z"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-endpoint-source",
    viewBox: "0 0 40 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-14",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.500000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93708802,9.92722047 C5.93577518,9.86220918 5.93511561,9.79703754 5.93511561,9.73171185 C5.93511561,4.48667889 10.1870549,0.234739563 15.4320879,0.234739563 C20.6771209,0.234739563 24.9290602,4.48667889 24.9290602,9.73171185 C24.9290602,9.79703754 24.9284006,9.86220918 24.9270878,9.92722047 L24.9270878,19.6654846 L5.93708802,19.6654846 L5.93708802,9.92722047 Z",
    id: "Combined-Shape",
    fill: "#919395",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Combined-Shape-Copy-146",
    fill: "#FFFFFF",
    transform: "translate(15.432088, 6.384284) scale(-1, 1) rotate(-90.000000) translate(-15.432088, -6.384284) ",
    points: "17.8906296 10.0720964 12.9735462 6.38428386 17.8906296 2.69647135"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4-Copy-2",
    fill: "#A6A6A6",
    fillRule: "nonzero",
    points: "30.1567951 10.8800427 30.1567951 23.4257131 0.707380727 23.4257131 0.707380727 10.8800427"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F0F2F4",
    points: "1.70738073 11.8800427 1.70738073 22.4257131 29.1567951 22.4257131 29.1567951 11.8800427"
  }))))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-endpoint",
    viewBox: "0 0 40 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-13",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(4.500000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4320879,19.2750005 C10.1870549,19.2750005 5.93511561,15.0230612 5.93511561,9.77802824 C5.93511561,4.53299527 10.1870549,0.28105595 15.4320879,0.28105595 C20.6771209,0.28105595 24.9290602,4.53299527 24.9290602,9.77802824 C24.9290602,15.0230612 20.6771209,19.2750005 15.4320879,19.2750005 Z",
    id: "Oval-Copy",
    fill: "#919395",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4-Copy-2",
    fill: "#A6A6A6",
    fillRule: "nonzero",
    points: "30.1567951 8.88004275 30.1567951 21.4257131 0.707380727 21.4257131 0.707380727 8.88004275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F0F2F4",
    points: "1.70738073 9.88004275 1.70738073 20.4257131 29.1567951 20.4257131 29.1567951 9.88004275"
  }))))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ne-planning",
    viewBox: "-846 415.5 35 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M-814,450.5h-29c-1.7,0-3-1.4-3-3v-29c0-1.6,1.3-3,3-3h29c1.7,0,3,1.4,3,3v29 C-811,449.1-812.3,450.5-814,450.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -842,
    y: 427,
    fill: "#CDCDCD",
    width: 7,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: -832,
    y: 427,
    fill: "#CDCDCD",
    width: 7,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: -822,
    y: 427,
    fill: "#CDCDCD",
    width: 7,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: -820,
    y: 420,
    fill: "#CDCDCD",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fill: "#FFFFFF",
    d: "M-842.9,418h33c0.6,0,1,0.4,1,1v28c0,0.6-0.4,1-1,1h-33c-0.6,0-1-0.4-1-1v-28 C-843.9,418.4-843.5,418-842.9,418z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    opacity: 0.5817,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-841.3,418.5 -845.8,423 -846,423.4 -846,421.5 -843,418.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-832.4,418.5 -845.8,431.9 -846,432.3 -846,430.4 -834.1,418.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-823.6,418.5 -845.8,440.7 -846,441 -846,439.2 -825.4,418.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-814.8,418.5 -846,449.9 -846,448.1 -845.8,447.8 -816.5,418.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-811,421.8 -811,423.5 -840.9,453.5 -842.6,453.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-811,430.5 -811,432.3 -832.1,453.5 -833.9,453.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-811,439.7 -811,441.5 -823,453.5 -824.8,453.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "-811,448.5 -811,450.4 -814.1,453.5 -816,453.5  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M-814,415.5h-4v1h4V415.5L-814,415.5L-814,415.5z M-822,415.5h-4v1h4V415.5L-822,415.5z M-830,415.5h-4v1h4 V415.5L-830,415.5z M-838,415.5h-4v1h4V415.5L-838,415.5z M-845.5,416.9c-0.2,0.3-0.3,0.6-0.4,1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v2.3h1v-2.3 c0-0.4,0.1-0.8,0.3-1.1L-845.5,416.9L-845.5,416.9z M-845,424.8h-1v4h1V424.8L-845,424.8z M-845,432.8h-1v4h1V432.8L-845,432.8z  M-845,440.8h-1v4h1V440.8L-845,440.8z M-844.8,448.3l-0.9,0.4c0.1,0.2,0.2,0.4,0.3,0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0 h0.6v-1h-0.6C-843.8,449.5-844.5,449-844.8,448.3L-844.8,448.3z M-834.4,449.5h-4v1h4V449.5L-834.4,449.5z M-826.4,449.5h-4v1h4 V449.5L-826.4,449.5z M-818.4,449.5h-4v1h4V449.5L-818.4,449.5z M-812.1,448.2c-0.3,0.8-1,1.3-1.9,1.3h-0.4v1h0.4l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0v0c0.7-0.3,1.2-0.8,1.5-1.5 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 L-812.1,448.2L-812.1,448.2z M-811,440.6h-1v4h1V440.6L-811,440.6z M-811,432.6h-1v4h1V432.6L-811,432.6z M-811,424.6h-1v4h1V424.6 L-811,424.6z M-811.6,416.7l-0.8,0.6c0.2,0.3,0.4,0.7,0.4,1.2v2.1h1v-2.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C-811.1,417.6-811.3,417.1-811.6,416.7 L-811.6,416.7z"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ne",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "#BABCBE",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    fill: "#E8E8E8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.5L37.51 1.5",
    id: "Line",
    strokeOpacity: 0.75,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 39.5L37.5 39.5",
    id: "Line",
    stroke: "#979797",
    strokeLinecap: "square"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "list-pluggable-disabled",
    viewBox: "0 0 70 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M57.8,61.2H12.2c-1.9,0-3.5-1.6-3.5-3.5V12.2c0-1.9,1.6-3.5,3.5-3.5h45.5c1.9,0,3.5,1.6,3.5,3.5v45.5 C61.2,59.7,59.7,61.2,57.8,61.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20,
    y1: 35,
    x2: 20,
    y2: 65,
    gradientTransform: "matrix(1.75 0 0 1.75 0 -52.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06236049,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9208,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M57.8,11c0.7,0,1.2,0.5,1.2,1.2v45.5c0,0.7-0.5,1.2-1.2,1.2H12.2c-0.7,0-1.2-0.5-1.2-1.2V12.2 c0-0.7,0.5-1.2,1.2-1.2H57.8 M57.8,8.8H12.2c-1.9,0-3.5,1.6-3.5,3.5v45.5c0,1.9,1.6,3.5,3.5,3.5h45.5c1.9,0,3.5-1.6,3.5-3.5 V12.2C61.2,10.3,59.7,8.8,57.8,8.8L57.8,8.8z"
  })))), /*#__PURE__*/React.createElement("g", null, _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F4F5F6",
    points: "54.2,23.1 54.2,39 15.8,39 15.8,23.1 24.1,23.1 24.1,18 45.9,18 45.9,23.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 20,
    y1: 40.3,
    x2: 20,
    y2: 52.3,
    gradientTransform: "matrix(1.75 0 0 1.75 0 -52.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.002716e-7,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBCBC"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M44.1,19.8v3.2v1.8h1.8h6.6v12.4h-35V24.7h6.6h1.8v-1.8v-3.2H44.1 M45.9,18H24.1v5.1h-8.4V39h38.5 V23.1h-8.4V18L45.9,18z"
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDDDDD",
    d: "M123,60.2H77.5c-1.9,0-3.5-1.6-3.5-3.5V14.2c0-1.9,1.6-3.5,3.5-3.5H123c1.9,0,3.5,1.6,3.5,3.5v42.5 C126.5,58.6,125,60.2,123,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M123,8.9h-5.2v1.8h5.2V8.9L123,8.9z M112.5,8.9h-5.2v1.8h5.2V8.9L112.5,8.9z M102,8.9h-5.2v1.8h5.2V8.9 L102,8.9z M91.5,8.9h-5.2v1.8h5.2V8.9L91.5,8.9z M81,8.9h-3.5c-0.9,0-1.8,0.2-2.5,0.7l0.9,1.6c0,0,0.2,0,0.2-0.2l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0h3.5V8.9H81z M74,15.8h-1.8V21H74V15.8L74,15.8z M74,26.2h-1.8v5.2H74V26.2L74,26.2z M74,36.8h-1.8V42H74 V36.8L74,36.8z M74,47.2h-1.8v5.2H74V47.2L74,47.2z M74.2,57.6l-1.8,0.5c0.7,2.3,2.6,3.7,5.1,3.7h0.9V60h-0.9l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C75.6,59.7,74.5,58.8,74.2,57.6L74.2,57.6z  M88.9,60.2h-5.2V62h5.2V60.2L88.9,60.2z M99.4,60.2h-5.2V62h5.2V60.2L99.4,60.2z M109.9,60.2h-5.2V62h5.2V60.2L109.9,60.2z  M120.4,60.2h-5.2V62h5.2V60.2L120.4,60.2z M128.3,54.4h-1.8v2.3l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l1.2,1.2c1.1-1,1.8-2.4,1.8-3.8v0.3C129.5,54.4,128.3,54.4,128.3,54.4z M128.3,43.9h-1.8v5.2h1.8V43.9L128.3,43.9z M128.3,33.4 h-1.8v5.2h1.8V33.4L128.3,33.4z M128.3,22.9h-1.8v5.2h1.8V22.9L128.3,22.9z M127.6,11.6l-1.6,0.9c0,0,0,0,0,0.2l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v3.5h1.8v-3.5 C128.3,13.3,128.1,12.4,127.6,11.6L127.6,11.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F4F5F6",
    points: "119.3,23.4 119.3,39.2 80,39.2 80,23.4 88.5,23.4 88.5,18.6 110.8,18.6 110.8,23.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.95,
    y1: 39.6153,
    x2: 56.95,
    y2: 53.4497,
    gradientTransform: "matrix(1.75 0 0 1.75 0 -52.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.002716e-7,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBCBC"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M110.8,18.6v4.9h8.6v15.8H80V23.5h8.6v-4.9L110.8,18.6 M112.5,16.8h-1.8H88.5h-1.8v1.8v3.1H80 h-1.8v1.8v15.8V41H80h39.4h1.8v-1.8V23.5v-1.8h-1.8h-6.8v-3.1L112.5,16.8L112.5,16.8z"
  })))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDDDDD",
    d: "M57.8,61.2H12.2c-1.9,0-3.5-1.6-3.5-3.5V12.2c0-1.9,1.6-3.5,3.5-3.5h45.5c1.9,0,3.5,1.6,3.5,3.5v45.5 C61.2,59.7,59.7,61.2,57.8,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M57.8,8.8h-5.2v1.8h5.2V8.8L57.8,8.8L57.8,8.8z M47.2,8.8H42v1.8h5.2V8.8L47.2,8.8z M36.8,8.8h-5.2v1.8 h5.2V8.8L36.8,8.8z M26.2,8.8H21v1.8h5.2V8.8L26.2,8.8z M15.8,8.8h-3.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0-0.2,0-0.2,0.2l0.9,1.6c-1.2,0-1,0-0.7,0h3.5V8.8L15.8,8.8z M10.5,13.8H8.8 v5.2h1.8V13.8L10.5,13.8z M10.5,24.3H8.8v5.2h1.8V24.3L10.5,24.3z M10.5,34.8H8.8v5.2h1.8V34.8L10.5,34.8z M10.5,45.3H8.8v5.2 h1.8V45.3L10.5,45.3z M10.5,55.8H8.8v1.9l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c0.2,0.2,0.3,0.4,0.5,0.5l1-1.4c0.4,1.9,0.2,1.4,0.2,0.9V55.8L10.5,55.8z M20.5,59.5h-5.3v1.8h5.3V59.5L20.5,59.5z M31,59.5h-5.2 v1.8H31V59.5L31,59.5z M41.5,59.5h-5.2v1.8h5.2V59.5L41.5,59.5z M52,59.5h-5.2v1.8H52V59.5L52,59.5z M59.5,58.1 c-0.2,0.9-0.9,1.4-1.8,1.4h-0.5v1.8h0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0c1.2-0.4,2.1-1.4,2.3-2.6L59.5,58.1L59.5,58.1z M61.2,48h-1.8v5.2h1.8V48L61.2,48z M61.2,37.5h-1.8v5.2h1.8 V37.5L61.2,37.5z M61.2,26.9h-1.8v5.3h1.8V26.9L61.2,26.9z M61.2,16.4h-1.8v5.2h1.8V16.4L61.2,16.4z M57.8,8.8v1.8 c0.7,0,1.4,0.5,1.8,1.2l1.8-0.5c-0.2-0.7-0.5-1.2-1-1.6l0,0c0,0,0,0-0.2-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.8,8.8,57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8 L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8 L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M57.8,61.2H12.2c-1.9,0-3.5-1.6-3.5-3.5V12.2c0-1.9,1.6-3.5,3.5-3.5h45.5c1.9,0,3.5,1.6,3.5,3.5v45.5 C61.2,59.7,59.7,61.2,57.8,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M57.8,8.8h-5.2v1.8h5.2V8.8L57.8,8.8L57.8,8.8z M47.2,8.8H42v1.8h5.2V8.8L47.2,8.8z M36.8,8.8h-5.2v1.8 h5.2V8.8L36.8,8.8z M26.2,8.8H21v1.8h5.2V8.8L26.2,8.8z M15.8,8.8h-3.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0-0.2,0-0.2,0.2l0.9,1.6c-1.2,0-1,0-0.7,0h3.5V8.8L15.8,8.8z M10.5,13.8H8.8 v5.2h1.8V13.8L10.5,13.8z M10.5,24.3H8.8v5.2h1.8V24.3L10.5,24.3z M10.5,34.8H8.8v5.2h1.8V34.8L10.5,34.8z M10.5,45.3H8.8v5.2 h1.8V45.3L10.5,45.3z M10.5,55.8H8.8v1.9l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c0.2,0.2,0.3,0.4,0.5,0.5l1-1.4c0.4,1.9,0.2,1.4,0.2,0.9V55.8L10.5,55.8z M20.5,59.5h-5.3v1.8h5.3V59.5L20.5,59.5z M31,59.5h-5.2 v1.8H31V59.5L31,59.5z M41.5,59.5h-5.2v1.8h5.2V59.5L41.5,59.5z M52,59.5h-5.2v1.8H52V59.5L52,59.5z M59.5,58.1 c-0.2,0.9-0.9,1.4-1.8,1.4h-0.5v1.8h0.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0c1.2-0.4,2.1-1.4,2.3-2.6L59.5,58.1L59.5,58.1z M61.2,48h-1.8v5.2h1.8V48L61.2,48z M61.2,37.5h-1.8v5.2h1.8 V37.5L61.2,37.5z M61.2,26.9h-1.8v5.3h1.8V26.9L61.2,26.9z M61.2,16.4h-1.8v5.2h1.8V16.4L61.2,16.4z M57.8,8.8v1.8 c0.7,0,1.4,0.5,1.8,1.2l1.8-0.5c-0.2-0.7-0.5-1.2-1-1.6l0,0c0,0,0,0-0.2-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.8,8.8,57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8 L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8 L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "54.2,22.6 54.2,38.5 15.8,38.5 15.8,22.6 24.1,22.6 24.1,17.5 45.9,17.5 45.9,22.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M44.1,19.2v3.1v1.8h1.8h6.6v12.6h-35V24.3h6.6h1.8v-1.8v-3.3H44.1 M45.9,17.5H24.1v5.1h-8.4v15.9h38.5 V22.6h-8.4V17.5L45.9,17.5z"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-pluggable-normal",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M33,35H7c-1.1,0-2-0.9-2-2V7c0-1.1,0.9-2,2-2h26c1.1,0,2,0.9,2,2v26C35,34.1,34.1,35,33,35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD0D1",
    d: "M33,6.3c0.4,0,0.7,0.3,0.7,0.7v26c0,0.4-0.3,0.7-0.7,0.7H7c-0.4,0-0.7-0.3-0.7-0.7V7 c0-0.4,0.3-0.7,0.7-0.7H33 M33,5H7C5.9,5,5,5.9,5,7v26c0,1.1,0.9,2,2,2h26c1.1,0,2-0.9,2-2V7C35,5.9,34.1,5,33,5L33,5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F4F5F6",
    points: "31.3,13.2 31.3,22.2 8.7,22.2 8.7,13.2 13.7,13.2 13.7,10.4 26.3,10.4 26.3,13.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M25.3,11.4v1.8v1h1h3.9v7H9.7v-7h3.9h1v-1v-1.8L25.3,11.4 M26.3,10.4H13.7v2.8h-5v9h22.5v-9h-4.9 L26.3,10.4L26.3,10.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 33.7,
    fill: "#B2B4B7",
    width: 26,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    fill: "#E8E8E8",
    width: 26,
    height: 1.3
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "list-pluggable-planning",
    viewBox: "0 0 70 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M57.8,61.2H12.2c-1.9,0-3.5-1.6-3.5-3.5V12.2c0-1.9,1.6-3.5,3.5-3.5h45.5c1.9,0,3.5,1.6,3.5,3.5v45.5 C61.2,59.7,59.7,61.2,57.8,61.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9714,
    y1: 34.9714,
    x2: 19.9714,
    y2: 4.9714,
    gradientTransform: "matrix(1.75 0 0 -1.75 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06236049,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9208,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M57.8,11c0.7,0,1.2,0.5,1.2,1.2v45.5c0,0.7-0.5,1.2-1.2,1.2H12.2c-0.7,0-1.2-0.5-1.2-1.2V12.2 c0-0.7,0.5-1.2,1.2-1.2H57.8 M57.8,8.8H12.2c-1.9,0-3.5,1.6-3.5,3.5v45.5c0,1.9,1.6,3.5,3.5,3.5h45.5c1.9,0,3.5-1.6,3.5-3.5 V12.2C61.2,10.3,59.7,8.8,57.8,8.8L57.8,8.8z"
  })))), /*#__PURE__*/React.createElement("g", null, _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F4F5F6",
    points: "54.2,23.1 54.2,39 15.8,39 15.8,23.1 24.1,23.1 24.1,18 45.9,18 45.9,23.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9714,
    y1: 29.7,
    x2: 19.9714,
    y2: 17.7,
    gradientTransform: "matrix(1.75 0 0 -1.75 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.002716e-7,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBCBC"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M44.1,19.8V23v1.8h1.8h6.6v12.4h-35V24.7h6.6h1.8v-1.8v-3.2L44.1,19.8 M45.9,18H24.1v5.1h-8.4V39 h38.5V23.1h-8.4L45.9,18L45.9,18z"
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDDDDD",
    d: "M123,60.2H77.5c-1.9,0-3.5-1.6-3.5-3.5V14.2c0-1.9,1.6-3.5,3.5-3.5H123c1.9,0,3.5,1.6,3.5,3.5v42.5 C126.5,58.6,125,60.2,123,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929497",
    d: "M123,8.9h-5.2v1.8h5.2V8.9L123,8.9z M112.5,8.9h-5.2v1.8h5.2V8.9L112.5,8.9z M102,8.9h-5.2v1.8h5.2V8.9 L102,8.9z M91.5,8.9h-5.2v1.8h5.2V8.9L91.5,8.9z M81,8.9h-3.5c-0.9,0-1.8,0.2-2.5,0.7l0.9,1.6c0,0,0.2,0,0.2-0.2l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0h3.5V8.9H81z M74,15.8h-1.8V21H74V15.8L74,15.8z M74,26.2h-1.8v5.2H74V26.2L74,26.2z M74,36.8h-1.8V42H74 V36.8L74,36.8z M74,47.2h-1.8v5.2H74V47.2L74,47.2z M74.2,57.6l-1.8,0.5c0.7,2.3,2.6,3.7,5.1,3.7h0.9V60h-0.9l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C75.6,59.7,74.5,58.8,74.2,57.6L74.2,57.6z  M88.9,60.2h-5.2V62h5.2V60.2L88.9,60.2z M99.4,60.2h-5.2V62h5.2V60.2L99.4,60.2z M109.9,60.2h-5.2V62h5.2V60.2L109.9,60.2z  M120.4,60.2h-5.2V62h5.2V60.2L120.4,60.2z M128.3,54.4h-1.8v2.3l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l1.2,1.2c1.1-1,1.8-2.4,1.8-3.8v0.3H128.3z M128.3,43.9h-1.8v5.2h1.8V43.9L128.3,43.9z M128.3,33.4h-1.8v5.2h1.8V33.4 L128.3,33.4z M128.3,22.9h-1.8v5.2h1.8V22.9L128.3,22.9z M127.6,11.6l-1.6,0.9c0,0,0,0,0,0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0v3.5h1.8v-3.5 C128.3,13.3,128.1,12.4,127.6,11.6L127.6,11.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F4F5F6",
    points: "119.3,23.4 119.3,39.2 80,39.2 80,23.4 88.5,23.4 88.5,18.6 110.8,18.6 110.8,23.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.9714,
    y1: 30.3847,
    x2: 56.9714,
    y2: 16.5561,
    gradientTransform: "matrix(1.75 0 0 -1.75 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.002716e-7,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBCBC"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M110.8,18.6v4.9h8.6v15.8H80V23.5h8.6v-4.9H110.8 M112.5,16.8h-1.8H88.5h-1.8v1.8v3.1H80h-1.8 v1.8v15.8V41H80h39.4h1.8v-1.8V23.5v-1.8h-1.8h-6.8v-3.1L112.5,16.8L112.5,16.8z"
  })))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M57.8,61.2H12.2c-1.9,0-3.5-1.6-3.5-3.5V12.2c0-1.9,1.6-3.5,3.5-3.5h45.5c1.9,0,3.5,1.6,3.5,3.5v45.5 C61.2,59.7,59.7,61.2,57.8,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M57.8,8.8h-5.2v1.8h5.2V8.8L57.8,8.8L57.8,8.8z M47.2,8.8H42v1.8h5.2V8.8L47.2,8.8z M36.8,8.8h-5.2v1.8 h5.2V8.8L36.8,8.8z M26.2,8.8H21v1.8h5.2V8.8L26.2,8.8z M15.8,8.8h-3.5l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0-0.2,0-0.2,0.2l0.9,1.6c-1.2,0-1,0-0.7,0h3.5V8.8L15.8,8.8z M10.5,13.8H8.8 V19h1.8v-5.2H10.5z M10.5,24.3H8.8v5.2h1.8v-5.2H10.5z M10.5,34.8H8.8V40h1.8v-5.2H10.5z M10.5,45.3H8.8v5.2h1.8v-5.2H10.5z  M10.5,55.8H8.8v1.9l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0.2,0.2,0.3,0.4,0.5,0.5 l1-1.4c0.4,1.9,0.2,1.4,0.2,0.9V55.8L10.5,55.8z M20.5,59.5h-5.3v1.8h5.3V59.5L20.5,59.5z M31,59.5h-5.2v1.8H31V59.5L31,59.5z  M41.5,59.5h-5.2v1.8h5.2V59.5L41.5,59.5z M52,59.5h-5.2v1.8H52V59.5L52,59.5z M59.5,58.1c-0.2,0.9-0.9,1.4-1.8,1.4h-0.5v1.8h0.5 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 c1.2-0.4,2.1-1.4,2.3-2.6L59.5,58.1L59.5,58.1z M61.2,48h-1.8v5.2h1.8V48L61.2,48z M61.2,37.5h-1.8v5.2h1.8V37.5L61.2,37.5z  M61.2,26.9h-1.8v5.3h1.8V26.9L61.2,26.9z M61.2,16.4h-1.8v5.2h1.8V16.4L61.2,16.4z M57.8,8.8v1.8c0.7,0,1.4,0.5,1.8,1.2l1.8-0.5 c-0.2-0.7-0.5-1.2-1-1.6l0,0c0,0,0,0-0.2-0.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8C57.9,8.8,57.9,8.8,57.8,8.8 C57.9,8.8,57.8,8.8,57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8 L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8 L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8L57.8,8.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "17.1,10.5 10.8,16.8 10.5,17.3 10.5,14.7 14.7,10.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "29.6,10.5 10.8,29.2 10.5,29.8 10.5,27.1 27.1,10.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "41.8,10.5 10.8,41.6 10.5,42 10.5,39.5 39.4,10.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "54.2,10.5 10.5,54.4 10.5,52 10.8,51.5 51.8,10.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "59.5,15.1 59.5,17.5 17.7,59.5 15.2,59.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "59.5,27.3 59.5,29.8 29.9,59.5 27.5,59.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "59.5,40.2 59.5,42.7 42.7,59.5 40.2,59.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F9FAFA",
    points: "59.5,52.5 59.5,55.1 55.1,59.5 52.5,59.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "54.2,22.6 54.2,38.5 15.8,38.5 15.8,22.6 24.1,22.6 24.1,17.5 45.9,17.5 45.9,22.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M44.1,19.2v3.1v1.8h1.8h6.6v12.6h-35V24.3h6.6h1.8v-1.8v-3.3H44.1 M45.9,17.5H24.1v5.1h-8.4v15.9h38.5 V22.6h-8.4L45.9,17.5L45.9,17.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "52.5,24.5 52.5,36.8 17.5,36.8 17.5,24.5 26.2,24.5 26.2,19.2 43.8,19.2 43.8,24.5  "
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-product-disabled",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M26.3,7c-0.5-0.8-1.5-1.1-2.3-0.9l-9.1,3c-0.8,0.3-1.8,1.1-2,1.9L6.4,28c-0.4,0.8,0.1,1.8,0.9,2L23,35.9 c0.8,0.4,1.8-0.1,2-0.9l6.5-17c0.4-0.8,0.3-2-0.3-2.9L26.3,7z M23,11.8c-0.6-0.3-1-1-0.6-1.6c0.3-0.6,1-1,1.6-0.6 c0.6,0.3,1,1,0.6,1.6C24.3,11.7,23.7,12.1,23,11.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7B7F7F",
    strokeMiterlimit: 10,
    strokeDasharray: "3.0552,3.0552",
    d: "M26.3,7 c-0.5-0.8-1.5-1.1-2.3-0.9l-9.1,3c-0.8,0.3-1.8,1.1-2,1.9L6.4,28c-0.4,0.8,0.1,1.8,0.9,2L23,35.9c0.8,0.4,1.8-0.1,2-0.9l6.5-17 c0.4-0.8,0.3-2-0.3-2.9L26.3,7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M23.5,9.9c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S23,9.9,23.5,9.9 M23.5,8.9 c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S24.5,8.9,23.5,8.9L23.5,8.9z"
  })))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-resource-active",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M4.5,39.5c-2.2,0-4-1.8-4-4v-31c0.1-2.2,1.9-4,4-4h31c2.2,0,4,1.8,4,4v31.1c0,2.2-1.8,3.9-4,3.9H4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M35.5,1C37.4,1,39,2.6,39,4.5v31.1c0,1.9-1.6,3.4-3.5,3.4h-31C2.6,39,1,37.4,1,35.5l0-31 C1.1,2.6,2.6,1,4.5,1H35.5 M35.5,0h-31C2.1,0,0.1,2,0,4.5v31C0,38,2,40,4.5,40h31c2.5,0,4.5-2,4.5-4.4V4.5C40,2,38,0,35.5,0 L35.5,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M15.4,21.6l2.6,4.4l-2.6,4.4h-5.1L7.7,26l2.6-4.4H15.4 M16.2,20H9.4l-3.4,6l3.4,6h7l3.4-6L16.2,20L16.2,20z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M32.2,21.8V30h-8.2v-8.2H32.2 M33.8,20.2H22.5v11.4h11.4V20.2L33.8,20.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M32.2,10.2v4H7.8v-4H32.2 M33.8,8.6H6.2v7.2h27.5V8.6L33.8,8.6z"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-resource-disabled",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M35.5,40h-31C2,40,0,38,0,35.5v-31C0.1,2,2.1,0,4.5,0h31C38,0,40,2,40,4.5v31.1C40,38,38,40,35.5,40z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M35.5,0h-5v1.1h5V0L35.5,0L35.5,0z M25.5,0h-5v1.1h5V0L25.5,0z M15.5,0h-5v1.1h5V0L15.5,0z M5.5,0h-1l0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0C3.1,0.2,2.5,0.4,1.9,0.9c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C1.4,1.2,1.2,1.5,1,1.7l0.8,0.7 c0.7-0.8,1.6-1.3,2.6-1.3h1V0L5.5,0z M1.1,6.4H0v5h1.1V6.4L1.1,6.4z M1.1,16.4H0v5h1.1V16.4L1.1,16.4z M1.1,26.4H0v5h1.1V26.4 L1.1,26.4z M1.2,36.2l-1.1,0.2c0.1,0.6,0.4,1.2,0.7,1.7l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0.6,0.7,1.4,1.2,2.3,1.4l0.3-1.1C2.4,38.5,1.4,37.5,1.2,36.2L1.2,36.2z M13.4,38.9h-5V40h5V38.9L13.4,38.9z M23.4,38.9h-5V40h5 V38.9L23.4,38.9z M33.4,38.9h-5V40h5V38.9L33.4,38.9z M40,34.7h-1.1v0.9c0,1-0.5,2-1.4,2.7l0.6,0.9c0.9-0.6,1.5-1.6,1.7-2.6 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0V34.7L40,34.7z M40,24.7h-1.1v5H40V24.7L40,24.7z M40,14.7h-1.1v5H40V14.7L40,14.7z M40,4.7 h-1.1v5H40V4.7L40,4.7z M35.5,0v1.1c0.6,0,1.2,0.1,1.7,0.4l0.5-1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0v0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0v0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C35.6,0,35.6,0,35.5,0L35.5,0C35.6,0,35.6,0,35.5,0 C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0 C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0 C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0 C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0C35.6,0,35.6,0,35.5,0 L35.5,0C35.6,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0 C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0 C35.5,0,35.5,0,35.5,0C35.5,0,35.5,0,35.5,0L35.5,0L35.5,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M15.4,21.6l2.6,4.4l-2.6,4.4h-5.1L7.7,26l2.6-4.4H15.4 M16.2,20H9.4l-3.4,6l3.4,6h7l3.4-6L16.2,20L16.2,20z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M32.2,21.8V30h-8.2v-8.2H32.2 M33.8,20.2H22.5v11.4h11.4V20.2L33.8,20.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M32.2,10.2v4H7.8v-4H32.2 M33.8,8.6H6.2v7.2h27.5V8.6L33.8,8.6z"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "mcp-logo",
    viewBox: "0 0 290 24"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#282A36;}\r\n\t\t"), /*#__PURE__*/React.createElement("title", null, "Artboard 1 copy 23"), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,1l4,12.4l4-12.4h5.7v17.8h-4.3v-4.2l0.4-8.5L11,18.8H8.2L3.9,6.1l0.4,8.5v4.2H0V1H5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,18.8c-0.2-0.4-0.3-0.8-0.4-1.2c-0.8,1-2,1.5-3.2,1.4c-1.2,0-2.3-0.4-3.2-1.1c-0.8-0.7-1.3-1.7-1.3-2.8 c-0.1-1.3,0.5-2.5,1.6-3.3c1.4-0.8,3-1.2,4.6-1.1h1.3V10c0-1.2-0.5-1.8-1.6-1.8c-0.7-0.1-1.4,0.4-1.5,1.1c0,0.1,0,0.2,0,0.4h-4.1 c0-1.2,0.6-2.4,1.6-3.1c1.2-0.8,2.7-1.3,4.2-1.2c1.4-0.1,2.9,0.4,4,1.2c1,0.8,1.5,2.1,1.5,3.4v5.9c0,1,0.2,1.9,0.6,2.8v0.2 L29.2,18.8z M26.6,16.1c0.4,0,0.9-0.1,1.3-0.3c0.3-0.2,0.6-0.4,0.7-0.7v-2.1h-1.2c-1.4,0-2.2,0.6-2.2,1.9c0,0.3,0.1,0.7,0.4,0.9 C25.9,16,26.3,16.1,26.6,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.8,5.6L39,7.1c0.9-1.2,2.3-1.9,3.8-1.8c1.2-0.1,2.3,0.4,3.1,1.2c0.8,1.1,1.1,2.4,1.1,3.7v8.5h-4.1v-8.4 c0-0.5-0.1-1-0.4-1.5c-0.4-0.4-0.9-0.5-1.5-0.5c-0.7,0-1.4,0.3-1.8,1v9.3H35V5.6H38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,18.8c-0.2-0.4-0.3-0.8-0.4-1.2c-0.8,1-2,1.5-3.2,1.4c-1.2,0-2.3-0.4-3.2-1.1c-0.8-0.7-1.3-1.7-1.3-2.8 c-0.1-1.3,0.5-2.5,1.6-3.3c1.4-0.8,3-1.2,4.6-1.1h1.3V10c0-1.2-0.5-1.8-1.6-1.8c-0.7-0.1-1.4,0.4-1.5,1.1c0,0.1,0,0.2,0,0.4h-4.1 c0-1.2,0.6-2.4,1.6-3.1c1.2-0.8,2.7-1.3,4.2-1.2c1.4-0.1,2.9,0.4,4,1.2c1,0.8,1.5,2.1,1.5,3.4v5.9c0,1,0.2,1.9,0.6,2.8v0.2 L56.6,18.8z M54.1,16.1c0.4,0,0.9-0.1,1.3-0.3c0.3-0.2,0.6-0.4,0.7-0.7v-2.1h-1.2c-1.4,0-2.2,0.6-2.2,1.9c0,0.3,0.1,0.7,0.4,0.9 C53.4,16,53.7,16.1,54.1,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,12.1c0-1.2,0.2-2.4,0.7-3.5c0.4-1,1-1.8,1.9-2.4c0.8-0.6,1.9-0.9,2.9-0.8c1.2-0.1,2.4,0.5,3.2,1.4l0.1-1.1 h3.7v12.7c0,1.1-0.3,2.1-0.8,3c-0.6,0.9-1.4,1.6-2.4,2C70.3,23.8,69,24,67.8,24c-1,0-1.9-0.2-2.8-0.5c-0.8-0.3-1.5-0.8-2.1-1.4 l1.7-2.4c0.7,0.9,1.9,1.4,3,1.4c1.8,0,2.7-0.9,2.7-2.8v-0.4c-0.8,0.9-1.9,1.3-3,1.3c-1.5,0-3-0.7-3.9-1.9c-1.1-1.4-1.6-3.2-1.5-5 L62,12.1z M66.1,12.3c0,0.9,0.2,1.8,0.6,2.6c0.4,0.6,1,1,1.7,0.9c0.8,0.1,1.5-0.3,1.9-0.9V9.4c-0.4-0.6-1.2-1-1.9-0.9 c-0.7,0-1.4,0.4-1.7,1C66.3,10.4,66.1,11.3,66.1,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3,19c-1.8,0.1-3.6-0.6-4.9-1.8c-1.3-1.2-2-3-1.9-4.7v-0.3c0-1.2,0.2-2.5,0.8-3.6c0.5-1,1.2-1.8,2.2-2.4 c1-0.6,2.2-0.9,3.4-0.8c1.6-0.1,3.3,0.5,4.4,1.7c1.1,1.3,1.7,3.1,1.6,4.8v1.6h-8.2c0.1,0.7,0.5,1.3,1,1.7c0.5,0.4,1.2,0.7,1.9,0.6 c1.2,0.1,2.3-0.5,3.1-1.4l1.9,2.2c-0.6,0.8-1.3,1.3-2.2,1.7C85.4,18.8,84.3,19,83.3,19z M82.8,8.5c-1.2,0-1.9,0.8-2.2,2.4h4.2v-0.3 c0.1-0.6-0.1-1.1-0.5-1.5C83.9,8.7,83.4,8.5,82.8,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,23.6l-2.1-1l0.4-0.8c0.5-0.9,0.8-2,0.9-3v-3.1h3.3l0,2.7c0,1-0.3,2-0.7,2.9C93.4,22.1,92.7,22.9,92,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.1,12.8c0,1.2-0.4,2.3-1,3.3c-0.6,1-1.5,1.7-2.6,2.2c-1.2,0.5-2.5,0.8-3.8,0.8c-2.1,0.1-4.1-0.7-5.5-2.3 c-1.4-1.8-2.2-4.1-2-6.5V9.4c0-1.6,0.3-3.1,0.9-4.6c0.6-1.2,1.5-2.3,2.6-3c1.2-0.7,2.6-1.1,4-1.1c1.9-0.1,3.7,0.5,5.2,1.7 c1.3,1.2,2.2,2.9,2.2,4.7h-4.3c0.1-0.9-0.2-1.7-0.8-2.3c-0.7-0.5-1.5-0.8-2.3-0.7c-0.9-0.1-1.8,0.4-2.3,1.2 c-0.6,1.2-0.9,2.5-0.8,3.8v1.3c-0.1,1.4,0.1,2.8,0.7,4.1c0.5,0.8,1.5,1.3,2.5,1.2c0.8,0.1,1.6-0.2,2.3-0.7c0.6-0.6,0.9-1.4,0.8-2.2 L118.1,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.4,12c0-1.2,0.2-2.4,0.8-3.5c0.5-1,1.3-1.8,2.2-2.4c1-0.6,2.2-0.9,3.4-0.8c1.8-0.1,3.5,0.6,4.7,1.8 c1.2,1.4,1.8,3.2,1.7,5v0.1c0.1,1.8-0.5,3.6-1.7,4.9c-1.2,1.2-2.9,1.9-4.7,1.8c-1.7,0.1-3.3-0.5-4.5-1.7c-1.2-1.2-1.8-2.9-1.8-4.6 L119.4,12z M123.6,12.3c-0.1,0.9,0.1,1.9,0.6,2.7c0.4,0.6,1,0.9,1.7,0.9c1.5,0,2.2-1.1,2.3-3.4v-0.4c0-2.4-0.8-3.6-2.3-3.6 c-1.4,0-2.1,1-2.2,3.1L123.6,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.8,5.6l0.1,1.6c0.9-1.2,2.3-1.9,3.8-1.8c1.2-0.1,2.3,0.4,3.1,1.2c0.8,1.1,1.1,2.4,1.1,3.7v8.5h-4.1v-8.4 c0-0.5-0.1-1-0.4-1.5c-0.4-0.4-0.9-0.5-1.5-0.5c-0.7,0-1.4,0.3-1.8,1v9.3H134V5.6H137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153,2.3v3.3h2.2v2.9H153v6.1c0,0.4,0.1,0.7,0.3,1c0.3,0.2,0.7,0.3,1.1,0.3c0.3,0,0.7,0,1-0.1v2.9 c-0.8,0.2-1.5,0.4-2.3,0.4c-1.1,0.1-2.3-0.3-3.1-1c-0.7-0.8-1.1-1.9-1-3V8.4h-1.7V5.6h1.7V2.3H153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8,9.3l-1.4-0.1c-1-0.2-2,0.3-2.5,1.2v8.4h-4.1V5.6h3.9l0.1,1.7c0.5-1.2,1.6-1.9,2.9-1.9 c0.4,0,0.8,0,1.1,0.1L164.8,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.3,12c0-1.2,0.2-2.4,0.8-3.5c0.5-1,1.3-1.8,2.2-2.4c1-0.6,2.2-0.9,3.4-0.8c1.8-0.1,3.5,0.6,4.7,1.8 c1.2,1.4,1.8,3.2,1.7,5v0.1c0.1,1.8-0.5,3.6-1.7,4.9c-1.2,1.2-2.9,1.9-4.7,1.8c-1.7,0.1-3.3-0.5-4.5-1.7c-1.2-1.2-1.8-2.9-1.8-4.6 L165.3,12z M169.4,12.3c-0.1,0.9,0.1,1.9,0.6,2.7c0.4,0.6,1,0.9,1.7,0.9c1.5,0,2.2-1.1,2.3-3.4v-0.4c0-2.4-0.8-3.6-2.3-3.6 c-1.4,0-2.1,1-2.2,3.1L169.4,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.2,18.8h-4.1V0h4.1L184.2,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.5,18.8c-0.2-0.4-0.3-0.8-0.4-1.2c-0.8,1-2,1.5-3.2,1.4c-1.2,0-2.3-0.4-3.2-1.1c-0.8-0.7-1.3-1.7-1.3-2.8 c-0.1-1.3,0.5-2.5,1.6-3.3c1.4-0.8,3-1.2,4.6-1.1h1.3V10c0-1.2-0.5-1.8-1.6-1.8c-0.7-0.1-1.4,0.4-1.5,1.1c0,0.1,0,0.2,0,0.4h-4.1 c0-1.2,0.6-2.4,1.6-3.1c1.2-0.8,2.7-1.3,4.2-1.2c1.4-0.1,2.9,0.4,4,1.2c1,0.8,1.5,2.1,1.5,3.4v5.9c0,1,0.2,1.9,0.6,2.8v0.2 L200.5,18.8z M197.9,16.1c0.4,0,0.9-0.1,1.3-0.3c0.3-0.2,0.6-0.4,0.7-0.7v-2.1h-1.2c-1.4,0-2.2,0.6-2.2,1.9c0,0.3,0.1,0.7,0.4,0.9 C197.2,16,197.5,16.1,197.9,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.1,5.6l0.1,1.6c0.9-1.2,2.3-1.9,3.8-1.8c1.2-0.1,2.3,0.4,3.1,1.2c0.8,1.1,1.1,2.4,1.1,3.7v8.5H214v-8.4 c0-0.5-0.1-1-0.4-1.5c-0.4-0.4-0.9-0.5-1.5-0.5c-0.7,0-1.4,0.3-1.8,1v9.3h-4.1V5.6H210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.9,12.1c-0.1-1.8,0.4-3.5,1.4-5c0.9-1.2,2.3-1.9,3.8-1.8c1.2,0,2.3,0.5,3,1.4V0h4.1v18.8h-3.7l-0.2-1.4 c-0.7,1.1-1.9,1.7-3.2,1.7c-1.5,0.1-2.9-0.6-3.7-1.8C220.3,15.7,219.8,13.9,219.9,12.1z M224,12.3c0,2.3,0.7,3.5,2.1,3.5 c0.8,0.1,1.6-0.4,2-1.1v-5c-0.3-0.8-1.1-1.2-1.9-1.2c-1.3,0-2,1-2.1,3.1L224,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.2,12.7v6H241V1h7.1c1.2,0,2.5,0.2,3.6,0.8c1,0.5,1.8,1.2,2.4,2.1c0.6,0.9,0.9,2,0.9,3.1 c0.1,1.6-0.6,3.1-1.9,4.2c-1.5,1.1-3.3,1.7-5.1,1.6H245.2z M245.2,9.4h2.8c0.7,0,1.4-0.2,1.9-0.6c0.5-0.5,0.7-1.1,0.7-1.8 c0-0.7-0.2-1.4-0.7-2c-0.5-0.5-1.1-0.8-1.8-0.8h-2.9L245.2,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.4,18.8h-4.1V0h4.1V18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.4,18.8c-0.2-0.4-0.3-0.8-0.4-1.2c-0.8,1-2,1.5-3.2,1.4c-1.2,0-2.3-0.4-3.2-1.1c-0.8-0.7-1.3-1.7-1.3-2.8 c-0.1-1.3,0.5-2.5,1.6-3.3c1.4-0.8,3-1.2,4.6-1.1h1.3V10c0-1.2-0.5-1.8-1.6-1.8c-0.7-0.1-1.4,0.4-1.5,1.1c0,0.1,0,0.2,0,0.4h-4.1 c0-1.2,0.6-2.4,1.6-3.1c1.2-0.8,2.7-1.3,4.2-1.2c1.4-0.1,2.9,0.4,4,1.2c1,0.8,1.5,2.1,1.5,3.4v5.9c0,1,0.2,1.9,0.6,2.8v0.2 L271.4,18.8z M268.8,16.1c0.4,0,0.9-0.1,1.3-0.3c0.3-0.2,0.6-0.4,0.7-0.7v-2.1h-1.2c-1.4,0-2.2,0.6-2.2,1.9c0,0.3,0.1,0.7,0.4,0.9 C268.1,16,268.5,16.1,268.8,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281,5.6l0.1,1.6c0.9-1.2,2.3-1.9,3.8-1.8c1.2-0.1,2.3,0.4,3.1,1.2c0.8,1.1,1.1,2.4,1.1,3.7v8.5H285v-8.4 c0-0.5-0.1-1-0.4-1.5c-0.4-0.4-0.9-0.5-1.5-0.5c-0.7,0-1.4,0.3-1.8,1v9.3h-4.1V5.6H281z"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "ne-association-state-loa",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#00F2F2",
    d: " M2.005,0h12c1.105,0,2,0.895,2,2v12c0,1.105-0.895,2-2,2h-12c-1.105,0-2-0.895-2-2V2C0.005,0.895,0.9,0,2.005,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M7.135,9.666 c0-0.547,0.066-0.982,0.199-1.307S7.71,7.716,8.063,7.401c0.354-0.314,0.589-0.57,0.706-0.768S8.945,6.229,8.945,6.01 c0-0.66-0.305-0.99-0.914-0.99c-0.289,0-0.521,0.089-0.694,0.267S7.072,5.709,7.064,6.022H5.365c0.008-0.746,0.249-1.33,0.724-1.752 s1.122-0.633,1.942-0.633c0.828,0,1.471,0.2,1.928,0.601s0.686,0.966,0.686,1.696c0,0.332-0.074,0.646-0.223,0.94 s-0.408,0.622-0.779,0.981L9.168,8.307c-0.297,0.285-0.467,0.619-0.51,1.002L8.635,9.666H7.135z M6.965,11.465 c0-0.262,0.089-0.478,0.267-0.647s0.405-0.255,0.683-0.255c0.277,0,0.505,0.085,0.683,0.255s0.267,0.386,0.267,0.647 c0,0.258-0.087,0.471-0.261,0.639s-0.403,0.252-0.688,0.252c-0.285,0-0.515-0.084-0.688-0.252S6.965,11.723,6.965,11.465z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "network-map-site-planned",
    viewBox: "8 8 55 55"
  }, /*#__PURE__*/React.createElement("g", null, _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 50 0 1 12 1 12 7 38 7 38 1 49 1 49 50",
    fill: "#babcbe",
    transform: "translate(10,10)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(10,10)",
    stroke: "#f0f2f4",
    points: "0 1.5 11.5 1.5 11.5 7.5 39.5 7.5 39.5 1.5 49 1.5",
    strokeMiterlimit: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 10.497,
    y1: 59.129,
    x2: 57.854,
    y2: 11.772,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.239,
    y1: 59.487,
    x2: 58.504,
    y2: 18.222,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.324,
    y1: 59.502,
    x2: 58.498,
    y2: 25.325,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.424,
    y1: 59.502,
    x2: 58.502,
    y2: 32.422,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.519,
    y1: 59.507,
    x2: 58.497,
    y2: 39.527,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.633,
    y1: 59.493,
    x2: 58.509,
    y2: 46.616,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.732,
    y1: 59.495,
    x2: 58.5,
    y2: 53.725,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.511,
    y1: 52.015,
    x2: 44.855,
    y2: 17.671,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.516,
    y1: 44.91,
    x2: 37.795,
    y2: 17.631,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.503,
    y1: 37.823,
    x2: 30.54,
    y2: 17.786,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.502,
    y1: 30.724,
    x2: 23.593,
    y2: 17.633,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.52,
    y1: 23.606,
    x2: 21.323,
    y2: 12.803,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.505,
    y1: 16.521,
    x2: 15.453,
    y2: 11.573,
    style: {
      stroke: "rgb(240, 242, 244)",
      strokeLinecap: "round"
    }
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "network-map-site",
    viewBox: "8 8 55 55"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 50 0 1 12 1 12 7 38 7 38 1 49 1 49 50",
    fill: "#eaeaea",
    transform: "translate(10,10)"
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(10,10)",
    stroke: "#ffffff",
    strokeOpacity: 0.75,
    points: "1 1.5 11.5 1.5 11.5 7.5 39.5 7.5 39.5 1.5 49 1.5",
    strokeMiterlimit: 10,
    fill: "none"
  })))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "no-details-data-graphic",
    viewBox: "0 0 147 147"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    stroke: "#E0E0E0",
    d: "M72.5004012,0 C112.541097,0 145,32.4597049 145,72.4995988 C145,112.540295 112.541097,145 72.5004012,145 C32.4597049,145 0,112.540295 0,72.4995988 C0,32.4597049 32.4597049,0 72.5004012,0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 32,
    x: 26,
    y: 40,
    fill: "#FFF",
    stroke: "#859CA8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 38,
    y: 46,
    fill: "#FFF",
    stroke: "#859CA8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0271BC",
    points: "10.623 .8 3.981 7.442 1.377 4.838 0 6.215 3.981 10.197 12 2.177",
    transform: "translate(42 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 32,
    x: 26,
    y: 72,
    stroke: "#859CA8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 38,
    y: 78,
    stroke: "#859CA8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#859CA8",
    d: "M82.0416306,48.0416306 L96.0416306,75.0416306 L86.0416306,73.5576306 L86.0416306,87.0416306 C86.0416306,87.5939153 85.5939153,88.0416306 85.0416306,88.0416306 L79.0416306,88.0416306 C78.4893458,88.0416306 78.0416306,87.5939153 78.0416306,87.0416306 L78.0416306,73.5576306 L68.0416306,75.0416306 L82.0416306,48.0416306 Z",
    transform: "rotate(-45 82.042 68.042)"
  })))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "no-topology-data-error",
    viewBox: "0 0 140 140"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEBEB",
    cx: 70,
    cy: 70,
    r: 70
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M70,1c38.047,0,69,30.953,69,69s-30.953,69-69,69S1,108.047,1,70S31.953,1,70,1 M70,0 C31.34,0,0,31.34,0,70s31.34,70,70,70s70-31.34,70-70S108.66,0,70,0L70,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.163,
    y: 40.883,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    width: 38.187,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1625E",
    d: "M84.85,89.383H45.663v-49H84.85V89.383z M46.663,88.383H83.85v-47H46.663V88.383z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#979797",
    points: "39.756,112.582 39.41,111.643 53.764,106.363 54.816,88.833 55.814,88.893 54.723,107.076 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#979797",
    points: "76.433,47.111 76.002,46.209 93.122,38.046 87.147,21.078 88.091,20.746 94.364,38.562 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.572,
    y: 53.023,
    transform: "matrix(0.5 -0.866 0.866 0.5 -17.7434 81.3792)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M62.898,60.882l-6.119-3.533l3.533-6.119l6.119,3.533L62.898,60.882z M58.145,56.983l4.387,2.533 l2.533-4.387l-4.387-2.533L58.145,56.983z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.385,
    y: 43.346,
    transform: "matrix(0.5 -0.866 0.866 0.5 -1.9565 89.3688)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M77.71,51.205l-6.119-3.533l3.533-6.119l6.12,3.533L77.71,51.205z M72.958,47.306l4.387,2.533l2.533-4.387 l-4.387-2.533L72.958,47.306z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.587,
    y: 35.049,
    transform: "matrix(0.5 -0.866 0.866 0.5 13.8303 100.1182)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M94.913,42.908l-6.118-3.533l3.532-6.119l6.118,3.533L94.913,42.908z M90.16,39.009l4.388,2.533 l2.532-4.387l-4.388-2.533L90.16,39.009z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.528,
    y: 20.581,
    transform: "matrix(0.5 -0.866 0.866 0.5 24.3303 89.3688)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M90.854,28.44l-6.118-3.533l3.533-6.119l6.118,3.533L90.854,28.44z M86.101,24.541l4.388,2.533l2.533-4.387 l-4.388-2.533L86.101,24.541z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.713,
    y: 108.596,
    transform: "matrix(0.5 -0.866 0.866 0.5 -77.3004 89.3688)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M40.039,116.455l-6.119-3.533l3.533-6.12l6.119,3.533L40.039,116.455z M35.286,112.556l4.387,2.533 l2.533-4.387l-4.387-2.533L35.286,112.556z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.604,
    y: 68.961,
    transform: "matrix(0.5 -0.866 0.866 0.5 -33.5303 85.912)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M58.93,76.82l-6.119-3.533l3.533-6.119l6.119,3.533L58.93,76.82z M54.177,72.921l4.387,2.533l2.533-4.387 l-4.387-2.533L54.177,72.921z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.12,
    y: 103.408,
    transform: "matrix(0.5 -0.866 0.866 0.5 -65.104 100.1182)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M55.446,111.267l-6.12-3.533l3.533-6.119l6.119,3.533L55.446,111.267z M50.693,107.368l4.387,2.533 l2.533-4.387l-4.387-2.533L50.693,107.368z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.589,
    y: 85.45,
    transform: "matrix(0.5 -0.866 0.866 0.5 -49.3172 91.5453)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M55.915,93.309l-6.119-3.533l3.533-6.119l6.119,3.533L55.915,93.309z M51.162,89.41l4.387,2.533 l2.533-4.387l-4.387-2.533L51.162,89.41z"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "no-topology-data",
    viewBox: "0 0 140 140"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEBEB",
    cx: 70,
    cy: 70,
    r: 70
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M70,1c38.047,0,69,30.953,69,69s-30.953,69-69,69S1,108.047,1,70S31.953,1,70,1 M70,0 C31.34,0,0,31.34,0,70s31.34,70,70,70s70-31.34,70-70S108.66,0,70,0L70,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.163,
    y: 40.883,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    width: 38.187,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#859CA8",
    d: "M84.85,89.383H45.663v-49H84.85V89.383z M46.663,88.383H83.85v-47H46.663V88.383z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#979797",
    points: "39.756,112.582 39.41,111.643 53.764,106.363 54.816,88.833 55.814,88.893 54.723,107.076 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#979797",
    points: "76.433,47.111 76.002,46.209 93.122,38.046 87.147,21.078 88.091,20.746 94.364,38.562 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.572,
    y: 53.023,
    transform: "matrix(0.5 -0.866 0.866 0.5 -17.7434 81.3792)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M62.898,60.882l-6.119-3.533l3.533-6.119l6.119,3.533L62.898,60.882z M58.145,56.983l4.387,2.533 l2.533-4.387l-4.387-2.533L58.145,56.983z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.385,
    y: 43.346,
    transform: "matrix(0.5 -0.866 0.866 0.5 -1.9565 89.3688)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M77.71,51.205l-6.119-3.533l3.533-6.119l6.12,3.533L77.71,51.205z M72.958,47.306l4.387,2.533l2.533-4.387 l-4.387-2.533L72.958,47.306z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.587,
    y: 35.049,
    transform: "matrix(0.5 -0.866 0.866 0.5 13.8303 100.1182)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M94.913,42.908l-6.118-3.533l3.532-6.119l6.118,3.533L94.913,42.908z M90.16,39.009l4.388,2.533 l2.532-4.387l-4.388-2.533L90.16,39.009z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.528,
    y: 20.581,
    transform: "matrix(0.5 -0.866 0.866 0.5 24.3303 89.3688)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M90.854,28.44l-6.118-3.533l3.533-6.119l6.118,3.533L90.854,28.44z M86.101,24.541l4.388,2.533l2.533-4.387 l-4.388-2.533L86.101,24.541z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.713,
    y: 108.596,
    transform: "matrix(0.5 -0.866 0.866 0.5 -77.3004 89.3688)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M40.039,116.455l-6.119-3.533l3.533-6.12l6.119,3.533L40.039,116.455z M35.286,112.556l4.387,2.533 l2.533-4.387l-4.387-2.533L35.286,112.556z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.604,
    y: 68.961,
    transform: "matrix(0.5 -0.866 0.866 0.5 -33.5303 85.912)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M58.93,76.82l-6.119-3.533l3.533-6.119l6.119,3.533L58.93,76.82z M54.177,72.921l4.387,2.533l2.533-4.387 l-4.387-2.533L54.177,72.921z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.12,
    y: 103.408,
    transform: "matrix(0.5 -0.866 0.866 0.5 -65.104 100.1182)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M55.446,111.267l-6.12-3.533l3.533-6.119l6.119,3.533L55.446,111.267z M50.693,107.368l4.387,2.533 l2.533-4.387l-4.387-2.533L50.693,107.368z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.589,
    y: 85.45,
    transform: "matrix(0.5 -0.866 0.866 0.5 -49.3172 91.5453)",
    fill: "#FFFFFF",
    width: 6.066,
    height: 6.066
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M55.915,93.309l-6.119-3.533l3.533-6.119l6.119,3.533L55.915,93.309z M51.162,89.41l4.387,2.533 l2.533-4.387l-4.387-2.533L51.162,89.41z"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "note-indicator",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M0 0h16v12.207a2 2 0 0 1-.544 1.37l-1.687 1.794a2 2 0 0 1-1.457.629H2a2 2 0 0 1-2-2V0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    stroke: "#FFF",
    d: "M16 12.5h-3.5m0 0V16"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.506 10.81-.247.247-.342 1.026 1.026-.342.247-.247-.684-.684zm6.564-6.564L4.917 10.4l.683.684 6.154-6.154-.684-.684zm1.209-.525a.483.483 0 0 0-.684 0l-.115.115.684.684.115-.115a.484.484 0 0 0 0-.684zm-8.527 7.023 7.433-7.433a1.065 1.065 0 0 1 1.504 0c.415.415.415 1.09 0 1.504l-7.433 7.433L3 13l.752-2.256z"
  }))))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "off-home",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#686868",
    cx: 9.5,
    cy: 13.498,
    rx: 1.211,
    ry: 1.169
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M11.449,5.871c0-0.731-0.866-1.34-1.986-1.34c-1.119,0-1.913,0.69-1.913,1.421l1.191,4.872 c0,0.264,0.325,0.487,0.722,0.487c0.397,0,0.722-0.223,0.722-0.487L11.449,5.871z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M15.5,1h-12C2.119,1,1,2.119,1,3.5v12C1,16.881,2.119,18,3.5,18h12c1.381,0,2.5-1.119,2.5-2.5v-12 C18,2.119,16.881,1,15.5,1z M17,15.5c0,0.828-0.672,1.5-1.5,1.5h-12C2.672,17,2,16.328,2,15.5v-12C2,2.672,2.672,2,3.5,2h12 C16.328,2,17,2.672,17,3.5V15.5z"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "operational-ring-block",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,15.75a7.664,7.664,0,0,1-4.756-1.641,7.77,7.77,0,0,1-1.369-1.373A7.667,7.667,0,0,1,.25,8,7.759,7.759,0,0,1,8,.25a7.669,7.669,0,0,1,4.745,1.632,7.763,7.763,0,0,1,1.371,1.37A7.671,7.671,0,0,1,15.75,8,7.759,7.759,0,0,1,8,15.75ZM4.135,12.91l.24.172A6.2,6.2,0,0,0,8,14.25,6.257,6.257,0,0,0,14.25,8a6.191,6.191,0,0,0-1.164-3.619l-.171-.24ZM8,1.75a6.241,6.241,0,0,0-5.1,9.856l.171.242,8.779-8.767-.241-.172A6.2,6.2,0,0,0,8,1.75Z",
    fill: "#e52c2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,.5a7.424,7.424,0,0,1,4.592,1.579,7.564,7.564,0,0,1,1.326,1.326A7.423,7.423,0,0,1,15.5,8,7.508,7.508,0,0,1,8,15.5a7.423,7.423,0,0,1-4.6-1.587,7.542,7.542,0,0,1-1.325-1.329A7.426,7.426,0,0,1,.5,8,7.508,7.508,0,0,1,8,.5M3.043,12.234l.418-.418,8.361-8.349.418-.418-.482-.343A6.49,6.49,0,0,0,2.7,11.751l.343.483M8,14.5A6.49,6.49,0,0,0,13.29,4.236l-.343-.48-.417.417L4.167,12.525l-.417.417.48.343A6.441,6.441,0,0,0,8,14.5M8,0a8.021,8.021,0,1,0,4.9,1.685A8,8,0,0,0,8,0ZM3.108,11.462a5.99,5.99,0,0,1,8.36-8.349l-8.36,8.349ZM8,14a5.955,5.955,0,0,1-3.479-1.121l8.362-8.352A5.99,5.99,0,0,1,8,14Z",
    fill: "#a31414"
  })))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "optical-layer",
    viewBox: "0 0 57 15"
  }, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E2E2E2",
    width: 57,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    dominantBaseline: "middle",
    x: "50%",
    y: "55%",
    "font-fill": "#414141",
    fontWeight: "bold",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "10px"
  }, "OPTICAL"))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "outOfSync",
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    fill: "#fff",
    stroke: "#babcbe",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "InfoBar-Resync",
    transform: "translate(1.786 2.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M8.529,16.347a3.675,3.675,0,0,1-6.085-1.272H3.679L1.839,12.5,0,15.075H1.285a4.782,4.782,0,0,0,8.806.993l-.97-.527a3.7,3.7,0,0,1-.592.805Z",
    transform: "translate(0 -9.007)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8.794,4.108A3.682,3.682,0,0,1,12.236,6.5H11L12.84,9.074,14.68,6.5H13.4A4.78,4.78,0,0,0,4.6,5.49l.966.531A3.679,3.679,0,0,1,8.794,4.108Z",
    transform: "translate(-2.908 -3.006)",
    fill: "#676767"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M10,0,0,10",
    transform: "translate(2.672 2.5)",
    fill: "none",
    stroke: "#ff1d1d",
    strokeWidth: 1.5
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "peer-oms-launch",
    viewBox: "0 0 32.558 26.504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Peer-OMS",
    "data-name": "Icon Peer-OMS",
    transform: "translate(6.149 -3.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M22.5,4.5h6.832v6.832",
    transform: "translate(-4.337)",
    fill: "none",
    stroke: "#0271bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M15,13.224,23.724,4.5",
    transform: "translate(1.271)",
    fill: "none",
    stroke: "#0271bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "back",
    width: 25.13,
    height: 25.13,
    transform: "translate(-6.149 4.46)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M4.712,25.13V17.276h7.853V25.13ZM0,21.2V3.927H3.927v.785H.785V20.418H3.927V21.2ZM4.712,7.853V0h7.853V7.853Z",
    transform: "translate(0.133 4.46)",
    fill: "#0271bc"
  })))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "physical-layer",
    viewBox: "0 0 57 15"
  }, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E2E2E2",
    width: 57,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    dominantBaseline: "middle",
    x: "50%",
    y: "55%",
    "font-fill": "#414141",
    fontWeight: "bold",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "10px"
  }, "PHY"))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-active",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M26.1,7.6c-0.5-0.7-1.4-1.1-2.2-0.8l-8.8,2.9c-0.7,0.2-1.7,1.1-1.9,1.8L7,27.7c-0.4,0.7,0,1.7,0.8,1.9 l15,5.6c0.7,0.4,1.7-0.1,1.9-0.8L31,18.1c0.4-0.7,0.2-1.9-0.2-2.8L26.1,7.6z M22.8,12.2c-0.6-0.2-1-1-0.6-1.6 c0.2-0.6,1.2-1.2,1.8-0.8c0.6,0.2,0.8,1.2,0.4,1.8C24.2,12.1,23.6,12.5,22.8,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M23.3,36L23.3,36c-0.2,0-0.5,0-0.7-0.1l-15-5.8c-0.5-0.1-1-0.6-1.2-1.1c-0.2-0.5-0.2-1.1,0-1.7l6.2-16.2 c0.4-1,1.4-1.9,2.3-2.2l8.8-2.9C23.9,6,24.2,6,24.4,6c0.8,0,1.7,0.5,2.2,1.2l4.7,7.9c0.6,1,0.7,2.4,0.2,3.2l-6.2,16.2 C25,35.4,24.3,36,23.3,36z M24.5,7.2c-0.1,0-0.2,0-0.4,0l-8.9,3c-0.6,0.2-1.3,1-1.6,1.4L7.5,27.8c-0.1,0.2-0.1,0.5,0,0.7 C7.6,28.8,7.7,28.9,8,29l15,5.6c0.1,0,0.2,0.1,0.4,0.1l0,0c0.4,0,0.7-0.2,0.8-0.6l6.2-16.3c0.2-0.5,0.2-1.6-0.2-2.2l-4.6-7.9 C25.4,7.4,24.9,7.2,24.5,7.2z"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M23.5,9.9c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S23,9.9,23.5,9.9 M23.5,8.9 c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S24.5,8.9,23.5,8.9L23.5,8.9z"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-agile",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M49,50H1c-0.5,0-1-0.5-1-1V1c0-0.6,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.5,49.5,50,49,50z"
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "24.6,33.1 24.6,39.7 31.3,39.7 "
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "18.4,10.8 24.6,10.8 24.6,16.8 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M17.4,12.8c1.1,0,2-0.9,2-2s-0.9-2-2-2V12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M32.3,41.7c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2V41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    d: "M16.7,17.3h-13c-0.3,0-0.5-0.2-0.5-0.5v-13c0-0.3,0.2-0.5,0.5-0.5h13c0.3,0,0.5,0.2,0.5,0.5 v13C17.2,17.1,16.9,17.3,16.7,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFFFFF",
    d: "M46,46.4H33c-0.3,0-0.5-0.2-0.5-0.5v-13c0-0.3,0.2-0.5,0.5-0.5h13c0.3,0,0.5,0.2,0.5,0.5v13 C46.5,46.2,46.3,46.4,46,46.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12,11.9H8.4l-0.8,2.2H6.4l3.3-8.5h1l3.2,8.5h-1.2L12,11.9z M8.7,10.9h2.9L10.2,7h0L8.7,10.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.8,42.7h4.8v0.9h-6.1v-0.9L41,36h-4.5v-0.9h5.8v0.8L37.8,42.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 24.9,
    cy: 24.9,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M19.6,19.7c-1.5,5.5,1.6,11.1,6.9,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M26.7,32.2c3.2-5,1.8-11.5-3-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M32,22.5c-2.9,5.1-9.3,7-14.3,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M17.6,24.3c3.9-4.3,10.4-4.7,14.6-1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 19.2,
    cy: 22.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 26.7,
    cy: 20.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 31.6,
    cy: 23.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 28.4,
    cy: 26.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 20.7,
    cy: 27.8,
    r: 0.8
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "product-catalog",
    viewBox: "-2.5 -12.5 60 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.1,
    y1: 121.1,
    x2: -18.1,
    y2: 26.9,
    gradientTransform: "matrix(0.5 0 0 0.5 13 -24.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M47.5,37.5h-40c-2.8,0-5-2.2-5-5v-40c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40 C52.5,35.3,50.3,37.5,47.5,37.5z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M38.5-5.4l14,11v18.3v8.6c0,2.8-2.2,5-5,5H30L11.1,26L38.5-5.4z "
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9DE2F4",
    d: "M37.9-6.4c-0.7-1.1-2.1-1.7-3.2-1.2L21.8-3.4c-1.1,0.3-2.4,1.7-2.9,2.8L9.8,23.2 c-0.4,1.1,0.1,2.4,1.3,2.9l21.9,8.4c1.1,0.4,2.4-0.1,2.9-1.3l9.2-23.8c0.4-1.1,0.3-2.9-0.3-4L37.9-6.4z M33.2,0.6 c-0.9-0.3-1.4-1.4-1-2.3c0.3-0.9,1.4-1.4,2.3-1c1,0.3,1.4,1.4,1,2.3C35.2,0.4,34.2,1,33.2,0.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#SVGID_3_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M39.4,19.1L41,30l-8.5,6.9l-9.9-3.9l-1.7-10.9l8.5-6.9L39.4,19.1 M39.8,18.7l-10.5-4.1l-8.9,7.3 L22,33.4l10.6,4.1l8.8-7.4L39.8,18.7L39.8,18.7z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005582",
    points: "26.1,22.5 29.6,28.7 29,29 25.5,22.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1,
    y: 21.8,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 12.1414 -10.5337)",
    fill: "#005582",
    width: 0.7,
    height: 11.4
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005582",
    points: "36.5,21.9 36.9,22.4 29.5,29.1 29,28.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 21.2,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 10.3734 -11.5961)",
    fill: "#005582",
    width: 2.1,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 27.5,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 12.148 -8.4501)",
    fill: "#005582",
    width: 2.1,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 41.5751 52.8926)",
    fill: "#005582",
    cx: 25.7,
    cy: 22.6,
    rx: 2.1,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 52.5183 73.5756)",
    fill: "#005582",
    cx: 33.1,
    cy: 31.9,
    rx: 2.1,
    ry: 2
  })))))))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-default",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M49,50H1c-0.6,0-1-0.5-1-1V1c0-0.5,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.5,49.5,50,49,50z"
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "24.7,16.4 24.7,10.5 36.4,10.5 "
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "13.6,39.5 24.7,39.5 24.7,32.3 "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 36.4,
    cy: 10.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 13.6,
    cy: 39.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 24.7,
    cy: 24.3,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M19.4,19c-1.5,5.5,1.6,11.1,6.9,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M26.5,31.5c3.2-5,1.8-11.5-3-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M31.8,21.9c-2.9,5.1-9.3,7-14.3,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M17.4,23.6c3.9-4.3,10.4-4.7,14.6-1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 19,
    cy: 22.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 26.5,
    cy: 20.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 31.4,
    cy: 22.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 28.2,
    cy: 25.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 20.5,
    cy: 27.2,
    r: 0.8
  }))))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-dwdm",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9C83BD",
    d: "M49,50H1c-0.5,0-1-0.5-1-1V1c0-0.6,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.5,49.5,50,49,50z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 10.8,
    opacity: 0.7,
    fill: "#FFFFFF",
    width: 45.4,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 22.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 45.5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 33.9,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 45.4,
    height: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_4"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "6.5,25.3 6.5,26.3 10.2,25.1 6.5,23.9 6.5,24.8 4.4,24.8 4.4,25.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "24.3,25.3 24.3,26.3 27.9,25.1 24.3,23.9 24.3,24.8 22.1,24.8 22.1,25.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "6.5,13.6 6.5,14.6 10.2,13.3 6.5,12.1 6.5,13.1 4.4,13.1 4.4,13.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "6.5,36.7 6.5,37.6 10.2,36.4 6.5,35.2 6.5,36.2 4.4,36.2 4.4,36.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "24.3,13.6 24.3,14.6 27.9,13.3 24.3,12.1 24.3,13.1 22.1,13.1 22.1,13.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "24.3,36.7 24.3,37.6 27.9,36.4 24.3,35.2 24.3,36.2 22.1,36.2 22.1,36.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "42.4,13.6 42.4,14.6 46,13.3 42.4,12.1 42.4,13.1 40.3,13.1 40.3,13.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "42.4,36.7 42.4,37.6 46,36.4 42.4,35.2 42.4,36.2 40.3,36.2 40.3,36.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C318C",
    points: "42.4,25.3 42.4,26.3 46,25.1 42.4,23.9 42.4,24.8 40.3,24.8 40.3,25.3  "
  })))))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#9C83BD",
    strokeWidth: 1.0382,
    strokeMiterlimit: 10,
    d: "M15.3,45.8h-3c-0.6,0-1-0.4-1-1V4.5 c0-0.1,0.1-0.3,0.3-0.3H16c0.1,0,0.3,0.1,0.3,0.3v40.3C16.3,45.4,15.8,45.8,15.3,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#9C83BD",
    strokeWidth: 1.0382,
    strokeMiterlimit: 10,
    d: "M37.7,45.8h-3c-0.6,0-1-0.4-1-1V4.5 c0-0.1,0.1-0.3,0.3-0.3h4.5c0.1,0,0.3,0.1,0.3,0.3v40.3C38.7,45.4,38.3,45.8,37.7,45.8z"
  }))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-evpl",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M49,50H1c-0.5,0-1-0.5-1-1V1c0-0.6,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.5,49.5,50,49,50z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeDasharray: 1.5,
    d: "M20.2,10.3c0,0-7-1.1-8.7,6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeDasharray: 1.5,
    d: "M20.2,39.8c0,0-7,1.1-8.7-6"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 10.3,
    x2: 35.7,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.9516,
    strokeMiterlimit: 10,
    x1: 29.6,
    y1: 25.1,
    x2: 34.2,
    y2: 25.1
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 19.6,
    y1: 25.1,
    x2: 24.8,
    y2: 25.1
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 39.7,
    x2: 35.7,
    y2: 39.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M31.5,15.3h-9.3c-0.2,0-0.4-0.2-0.4-0.4V5.7c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4 V15C31.9,15.2,31.7,15.3,31.5,15.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.2,11.4h-2.6L25,13h-0.8l2.4-6.1h0.7l2.3,6.1h-0.8L28.2,11.4z M25.9,10.7h2.1l-1-2.8h0L25.9,10.7z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M31.8,44.7h-9.3c-0.2,0-0.4-0.2-0.4-0.4v-9.3c0-0.2,0.2-0.4,0.4-0.4h9.3 c0.2,0,0.4,0.2,0.4,0.4v9.3C32.2,44.5,32,44.7,31.8,44.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26,42.1h3.4v0.6H25v-0.6l3.3-4.8h-3.2v-0.6h4.2v0.6L26,42.1z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M26,27.6v-5.5c0-0.1,0.1-0.2,0.2-0.2h2.1c0.1,0,0.2,0.1,0.2,0.2v5.5c0,0.1-0.1,0.2-0.2,0.2 h-2.1C26.1,27.8,26,27.7,26,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M45.1,28.2h-9.8c-0.2,0-0.3-0.1-0.3-0.3v-5.7c0-0.2,0.1-0.3,0.3-0.3h9.8 c0.2,0,0.3,0.1,0.3,0.3v5.7C45.4,28,45.3,28.2,45.1,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.7,23.4v-0.5c0-0.1,0.1-0.2,0.2-0.2h0.5c0.1,0,0.2,0.1,0.2,0.2v0.5c0,0.1-0.1,0.2-0.2,0.2H27 C26.8,23.6,26.7,23.5,26.7,23.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.2,26.8h-1.5c-0.1,0-0.3-0.1-0.3-0.3v-3.1c0-0.1,0.1-0.3,0.3-0.3h1.5c0.1,0,0.3,0.1,0.3,0.3v3.1 C38.4,26.7,38.3,26.8,38.2,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44,26.8h-4.3c-0.1,0-0.3-0.1-0.3-0.3v-3.1c0-0.1,0.1-0.3,0.3-0.3H44c0.1,0,0.3,0.1,0.3,0.3v3.1 C44.2,26.7,44.1,26.8,44,26.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.7,27v-2.4c0-0.1,0.1-0.2,0.2-0.2h0.5c0.1,0,0.2,0.1,0.2,0.2V27c0,0.1-0.1,0.2-0.2,0.2H27 C26.8,27.2,26.7,27.1,26.7,27z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 10.7,
    cy: 24.9,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M5.4,19.7C3.9,25.2,7,30.8,12.3,32.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M12.5,32.2c3.2-5,1.8-11.5-3-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M17.8,22.5c-2.9,5.1-9.3,7-14.3,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M3.4,24.3c3.9-4.3,10.4-4.7,14.6-1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 5,
    cy: 22.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 12.6,
    cy: 20.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 17.4,
    cy: 23.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 14.3,
    cy: 26.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 6.5,
    cy: 27.8,
    r: 0.8
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M21.5,8.2c-1.1,0-2,0.9-2,2s0.9,2,2,2V8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M21.5,37.5c-1.1,0-2,0.9-2,2s0.9,2,2,2V37.5z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 4.3,
    opacity: 0.8,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 2.1,
    opacity: 0.8,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M44.7,18.6h-8.1V6.5h8.1V18.6z M40.2,8.7h-1.9v1.9h1.9V8.7z  M43.1,8.7h-1.9v1.9h1.9V8.7z M40.2,11.8h-1.9v1.9h1.9V11.8z M43.1,11.8h-1.9v1.9h1.9V11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 32.9,
    opacity: 0.8,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 30.7,
    opacity: 0.8,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M44.7,47.2h-8.1V35.1h8.1V47.2z M40.2,37.3h-1.9v1.9h1.9V37.3z  M43.1,37.3h-1.9v1.9h1.9V37.3z M40.2,40.4h-1.9v1.9h1.9V40.4z M43.1,40.4h-1.9v1.9h1.9V40.4z"
  })))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-fre",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Restricted"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M49,50.1H1c-0.5,0-1-0.5-1-1v-48c0-0.6,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.6,49.5,50.1,49,50.1z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.75,
    width: 46,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAZCAYAAABzVH1EAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABGFJREFUeNrsV8tOHEcUrap+z8MO i8FINhICJpGwwIhIsWTvkWUrvwFfkG0U5S/YOKso+Y3EiYiV2DsiLLEgEGCEPQzz6p5+VN+c2zSS hYA0ob1xKKlU1TXT99a5575aiY9kqBsgN0BugFw6zCv8V77/8PU334pGY1yWeZkff/iefv3lxftH 9J8ud8nv8umzL+WrP34Xc3NzslarS8dxhGEYpVp1NBoJpSStr6/T/PyCePNmU+zs/EU5ILoyECKS zWZTbG1tqUePHsP9pIrjSAGAcl2X32EgkhUnSVIKiGq1msmCbsJK/X4v5VGpVNLNzc304GA/XVtb o5WVFZJSFgMyOzsLIJ8a3W7XwOWtwWBg4WULEE0AMNKUMkBRFAmtdSlAIE/EccyXpCgKNfDoJNEx AMbQE7uuk/R6Pd1uv0th4EIxIpmJ8fE7hut6dhiGHs4qEOxBiQvhFvYGhCtYTrJ7nWehqwxmAiB4 TfGYEokEM1RKjaDftyzL1zoN9/f3xO7u7rludlGwK7xsgVkPgm7hvdsQimnUwYCLcwbDGU+yG16X DcjI2NCagUgN40Q4GxKlvTjWx6wHjJFhmBlQTF2IkYWFB4iJxDRNwwOAW5gNnDcgfAzWr2Ha2JuS /aAEIDkYYhAQCTYowNrFxdtSpmwwjXiM4SUxDJsgXuRZVs4CybKTZZoKNJpKuQ6E1sDAJwwG+wYU 3GaXxmqWXIc4PtjazMaA3ZhOxghnA8TNAPFqfPHwodzd2ZGvX7+6FIgYGxsToyCQlUoV7mWa8E0b tLt5nNQw67zP3y27oDIbUZ6EQoDxbNt24Bq4iWFgL6vVWpb6C8WIVIrCcASZDsjQKWcQKRXn2SSn Ps6pLZURdiHIjzkD56CQuWLOYCnSP1m2fWFiOQuEXvz8k5iemWGPZQExUq0Ptxrgt2OsZk698wEY oTyQI+jxWR8ujWKih7BmyMDCUaj/3NigVuvg37MWV9LhcJDevz/P1g/gVn1c3Oa4RjYJuEbhOUvB 8sQ8ZbUpxAWQGee0i+0AswMgx4Yhh57nRa1WS29vb6e+PyzkWtRut1NQGjuOG+DyBivAeYDLd6Ak YwND8TGe4Ynq2nUEMk7rA6dWdt0Aj0P2BujCzWXY7/c1QBSuIxnFqKgJFyHO377vx7CUz/UDg9Ou gVVyQWQfzDLnNQYTC3m8ZrphRHiDSGCnEIHNQc9rhGDXF/Vc5wY79zTPn3+nuZI2m5+lsAjn76BS 8bLMcdqicK9VRovC3QFnolNWoA/uPYRg0gCoUTeSIAj08vIyLS5+Raurq4WbRpE3jXJ6ekZx0Zua mlKdTkdMTExIy7K5NWFGxInXXX/AQJlRGMze3t9Uq9fp3du3yJ4hHR4ept3uMeVNoyjcNJ7H/tLS 59yDicnJyaxTfbC4JOv1WqlFhDNSp3Mk0O2Ku/fuic7REYGNQt8lRT+s6LSSbmx0s4MnT5+V/mH1 8uVvhJntwYD4X46P5pv9HwEGAHbCuun01wA8AAAAAElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 22.5159 22.325)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.3,
    y: 24.1,
    fill: "#FFFFFF",
    width: 7.2,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.75,
    width: 95,
    height: 95,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACspJREFUeNrsXW2MFVcZPufMzP2c u8tddlFqsU3LaqFGi9BEaG2XJiX1j1hCYk3Vn5aIxNjEGFMlDcYYY1J/+JFWoz/Uxpo0aH/UVEgE YwsaIKIpUF0wBVpQW/bu7v2+83F83jNn2LvIwl3SGmXeN5k9Z2fuPWfmec77cebHfYRgY2NjY2O7 NpOL/YLW2nxHSsnozcdFWFz0202I+cx3vvekaWtTF0y786uPmYsPf/LTmSbi6Z/9xLS7vvZ101ZH lhpCdmzflhKj3xJCyBO++/2nJAYm0KXrOPKdy5fLRqMpX3/trCgUi/L8uXPipptvzrSrnH71Vb38 hhtEp93W77pxhfD9sv7H+fM6jCINsjQWsvjcZx/Rg3qOXIiMnz79jPzyl74o165dK8eWvcNpNhoq iiJFRDiOo+i7M9PTwq9UzBi4nikiyr5v2ka9roeXLDGwAZ+YiAE+Ma7Hb/zrn9GRI0f0N775Lf2p hx8aiBS5EBl/OHhA1et1FfR6jut5LgB3lFIu+g4+o+gfmAzC0IwRx7HQODKReJUSeHbT91wXjx3r CH8AeBwGAXVDEBKhH3q5XFSpVOIPrd8QD0KKe+mJ1DM+uvlB1ev13EKh4IGMHBmIoMPDCqC7cDAy ESPhnibJg6xMhC8grimJI4xTgqB+DEzgIFGINnBdtwdP6YGUXqfTCfDREJgOlFMuBVCOj79Hrlw5 7owsXYr5nHwQBPk4iooAvIjrRdxKAasjh3MuWgfnVWwrDPKu650R3VdJKTwtkQGLlOOEaHs418Gl Ns63ca7teV4XRHWnLlwIT56cjCYn/6avRMp/eMgda9Yo36+obrfrtlutHEgpYXAfI1CyoKOESYuA nrzFpfAl0xoYjbyGUvr/jZP0ASlUUYPHDwFCTydEtNDWBWGDKAYMNYUtFESxX/E1CIkG9pCdj+9S JycnHQqNcLk82C1jsmF4wBJMWEW/imtDmJTOF3BDLtrES5A/ZEY2JxSjKIeQd+CI0A/RdvD4TVye Rb+GCzVgNo3+DKJME8VQF9eClePj0a7Hd8YDecjY2DIxXavJ186eVUCXruVxlIDyECYbweCjOKq4 gSE6jyNHhIAMZbnIBCEUsmgBAgdDCE71cK6Fc7No87QwpT2Po4MvdLHAgxtXrJCE8UBJneL/Y1/Z KeGFMp/PKyRqF65HYakAlMv4yDD6S9ESKVTnGS+hMaS1dLeaAULSdEJVk/EOqvxxFGwID9BvgS3a C1DYd5GQFWF7/tzr0uTaBaqteR6CqkrgC2JoeJhKXozielgKxHgZg1SwIogU8pQRnPPtDXiU35L7 zNQe0VRXFIbIC9CnwseQgX4TWFHoyqNE9hCyHIQsRdgWCrcM5iEbN24Up079He19hKqkfQYGpHDk oZu3VRaR4KNPIYsO8hCPbsSynpn3VklAmCOEMLAhqklYERkGO4R0J9m0yHK5LH/xzM/F4UN/vDoh +/fvN+00dt9gUyChK7PXwIC2mspRTknLX5tDDCFEXNZClk4eNrKEKNsWQQLl3ZwN5Q4RIoFls9mk 1yvi7Nkz5hgoqW/+2BZZpFcjtNkLQ0Et7TWwEUoGThK9Z8nx7MTUOulb4Ay92U0JkbalAoeihWsi Cw7gRxWrwRI7eqngIYTxc7/aPRgho6OjJo+YGjsIzMQqCYyqr5qiSYgcIsH0U0KyFrLS7UiKhT3o lRK97DNhPKJXSoRjLiewURQIW4PlkH5rtVrC1tlms9d3E9KinlYKNGmaP2SWyl6Lh+rLn+nzzwvd aZ8wLZVKVx1bXfZdDVyM3pVRyIrnBpf9E/TnjCyRMceJlP0LtR+bFAvCzmAILAnTQUxdLXnJbAH9 1rJ2DVsBxbD9bxkTwoSwMSFMCBsTwoSwMSFMCBsTwoSwMSFsTAgTwsaEMCFsTAgTwsaEMCFsTAgb E8KEsDEhTAgbE8KEsDEhTAgbE8LGhDAhbEwIE8LGhDAhbEwIE8LGhLAxIUwIGxPChLAxIUwIGxPC hLAxIWxMCBPCxoQwIWxMCBPCxoQwIZeYzsov7L8Ndi3YLUgI/XA1qZFJKw+XDi7nfnpc9/fFIhUt rwOsL+JxOWzM/8DOYLgIOdbL/vZ7qVwWwdyP8SfMYXArgpUqy1wkou+30DPDhgVZpwszxaJPn8r8 JHhscSld5Uf4r0iI4ziGENLpo0lSIugmLPipmEl6yD4ZoOve+p41TjA3WMwjyRKjCUPSeXQSLBdH yN69v9EfeP8dulgsas/zEjKiSNtJI0wYoaVflSfxkrQlizMu6GKwsNhEVijMqE8qx9EePKbb6eh2 u63//Jejgyt9njl9Wtxzz4SZMAwCbb2DiAit0BUdXXuQEJYRM7H6GVmUPIosGZ0+XAKrQxVa7AyO +UJB5PJ5g/FAhOzbt088+dQPRKvZ1EuqVWIzhpcYMuB6NEEX/UQ4UeuG1Vyim/HmiUtmy0P6RcEI k5bFqEuYkSYuPhwh/MfFUklP12r64w99Qmx75DNG8+uKhExMTIjnf/2CmJqqIX/0aLmTpChN1iMZ URJNRJsojyVk0LWClfgxoldZk80jjGyY6lh8ptGftf02YUcY0udAChb6iBgZqRqsBwlZemxsGUlQ a7hVjJItxDIIMDuxT8pjsyIRASNnoJsoxYmknmv1pzKlQZVWWkQIvIFCVcsSUhOJ2meTsCMM6TOI PPG7bxo1GItBtHCJdRJjr01NGT1wMBq6+TwJUrXhl3USArNhiSZoWVHJnFVoU/1KMxkpe4WtriIb RchL6jKRW62RHi7CRhug9KIwDBH+Y8L2lltXXnF7MO/KXXd/WI6vHE+0cDudHMYpua5bweZmCEli mHRxRaJjSILFeZLTEyLRDcvoTjy2FSYVPV1aqPi/Qfq3iGUzjlKzwLAODFuFQoEWdzB5cjJ66cXf 64EIof9vu22VWrfuThIHJ930AgYkkcQSaC2TBCsmKmKiAq6TTp9rybiouXS9SySRfrqaW+HaChST jnqIhdtRlNRJhjUJ8y2Q0QZWHdJZP3z4UPTKKydisQj5br3pgY/o5365O75/0wNRvT7by+Vyot1q xRg41XzNgRwjSowaW+HWSDc32c1nIGTZ3bcB1Arco7iNSCo7DV0kVNwFJh1UVt0erFIZivbueSHe /OAWDUIWJXAvXj52XD7xxLclCHDCMHK6nbZL3oCc4pGuKxIYkUhCk8pxXYX9irhUyS0L0couQOFi A40cEcc2n1Cpi81bgJwRkNfkC8UQUFIaiR599Av6fbevXhwhRP6x4yfks8/uVrt3PytXr1qtCsWi 22w0yBMcxEIFskyY6na7RJwZg2RFs/J2kR6Y5GnJALTO5/OmckI/Ru6N4TlR2fdjYBIeP3E83rJl q966dUt8++pV+mpBxF1w04MBzpw5LQ+89KJGsqfKS1arVRUjTczMTItKpSJRNYjqyIiZgUJblix9 NzU7M6N93xf1el0PDy8RFd/Xs7OzMa7ro0f/FG+4624iQw9CxoIvF1NS1nxwrfjxj36oQYS+d+I+ iYmjN998AzvGSBw5fEhgYnHvxEYzi2NXTNbs2LGXNYkNr113p/D9shgdHdONRkP8bv9vTb7YvuPz YlAyFhXzsUcxn33v+K2m3bTpfnN+/foNIst28OAB0+7Zs9e0f508ZSL3ju3b/jsR3O5SBRvjwsbG lnn7twADAJm8ZdZ+eqmcAAAAAElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 3.232 13.0887)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 15.4,
    fill: "#FFFFFF",
    width: 18,
    height: 18
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 24.2,
    y1: 24.9,
    x2: 24.2,
    y2: 24.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "15.3,32.2 15.3,29.4 16.2,29.4 14.6,26.6 13,29.4 13.8,29.4 13.8,32.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "13.8,16.7 13.8,19.5 13,19.5 14.6,22.2 16.2,19.5 15.3,19.5 15.3,16.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "12.4,23.6 9.6,23.6 9.6,22.8 6.8,24.4 9.6,26 9.6,25.2 12.4,25.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "16.7,25.2 19.5,25.2 19.5,26 22.3,24.4 19.5,22.8 19.5,23.6 16.7,23.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 39.4,
    cy: 24.6,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M34.1,19.4c-1.5,5.5,1.6,11.1,6.9,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M41.2,31.9c3.2-5,1.8-11.5-3-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M46.5,22.2c-2.9,5.1-9.3,7-14.3,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3999D4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M32.1,24c3.9-4.3,10.4-4.7,14.6-1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 33.7,
    cy: 22.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 41.3,
    cy: 20.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 46.1,
    cy: 22.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 42.9,
    cy: 26,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3999D4",
    cx: 35.2,
    cy: 27.5,
    r: 0.8
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "product-nfv",
    viewBox: "0 0 60 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.55,
    y1: 122.55,
    x2: 5.45,
    y2: 75.45,
    gradientTransform: "matrix(1 0 0 1 1 -74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M50,50H10c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C55,47.8,52.8,50,50,50z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M36.9,44.3L55,21.4v15V45c0,2.8-2.2,5-5,5H31.2l-7.9-10.9 L36.9,44.3z"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9DE2F4",
    d: "M48.1,9.9c-0.6-1-1.9-1.5-2.9-1.1l-11.7,3.8c-1,0.3-2.2,1.5-2.6,2.5l-8.3,21.6c-0.4,1,0.1,2.2,1.2,2.6 l19.9,7.6c1,0.4,2.2-0.1,2.6-1.2l8.3-21.6c0.4-1,0.3-2.6-0.3-3.6L48.1,9.9z M43.8,16.2c-0.8-0.3-1.3-1.3-0.9-2.1 c0.3-0.8,1.3-1.3,2.1-0.9c0.9,0.3,1.3,1.3,0.9,2.1C45.6,16.1,44.7,16.6,43.8,16.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#SVGID_3_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M49.4,33l1.5,9.9l-7.7,6.3l-9-3.5l-1.5-9.9l7.7-6.3L49.4,33 M49.8,32.7L40.3,29l-8.1,6.6L33.7,46 l9.6,3.7l8-6.7L49.8,32.7L49.8,32.7z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005582",
    points: "37.4,36.1 40.6,41.7 40,42 36.8,36.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 35.5,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 17.5488 -13.425)",
    fill: "#005582",
    width: 0.6,
    height: 10.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005582",
    points: "46.8,35.6 47.2,36 40.5,42.1 40,41.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 34.9,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 15.9458 -14.3883)",
    fill: "#005582",
    width: 1.9,
    height: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 40.7,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 17.5547 -11.5359)",
    fill: "#005582",
    width: 1.9,
    height: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 58.5907 83.2308)",
    fill: "#005582",
    cx: 37,
    cy: 36.2,
    rx: 1.9,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 68.5124 101.9831)",
    fill: "#005582",
    cx: 43.7,
    cy: 44.6,
    rx: 1.9,
    ry: 1.8
  }))))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M17.4,25.9h-2.1l-4-6.5v6.5H9.3v-10h2.1l4,6.6v-6.6h2V25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M25.2,21.8h-3.9v4.1h-2.1v-10h6.5v1.7h-4.4v2.6h3.9V21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M30.6,23.4l2.3-7.5h2.3l-3.5,10h-2.1l-3.5-10h2.3L30.6,23.4z"
  })))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-tp",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M49,50H1c-0.5,0-1-0.5-1-1V1c0-0.6,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.5,49.5,50,49,50z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.75,
    width: 189,
    height: 164,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAACnCAYAAABHLVPlAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAD1NJREFUeNrsXYtuIrkWtJsmZHbv /v+H7mQIr/bdSG2pUjl+dRsCpEqygEDANFU+D9vHzgmCIAg/E/5O30sQahDWvsHYkfQSgPBwYhg7 kl5iEO6F5OFaAvCZWwlAuKUAQuY1vlYEYyPxkezeeJwSiEQh9CJ8MFpKBEVrMDaQ3yL8YAhgSFgG CUBYQn6+nYj8U0YMRWvQagGQ4AM063HJIkgUQs5vz434ExB/otbkCo2VxHcGyT/aJnHrDTFIAMIa 8jPhL3B7AZ6hEALwLLQKgN0YJv5m/n/r/qbCGkgIgsv48C5D/I92pvtn4lGVNaixAOzfR7J/tG3i PotgkACEBeRnFwfJ/tFOQHw/3y9ZlUVBsKfRPxL+BW7j/djQGliZIpFfyJE1NnR1TkD848ytE/HK cpuaYwBr5LfIvzPai2ENrHhAAhBK5GeX5zS3A3DsPUH+4D6nQ83Pq7UATH4UwK+5vc5tBxbBcodE fKEkhGC4PXHUP86kfyfXOhUwu7VZIG8Ev9uZ6K8z+f+aGwohioADYwlAKImAR/9I/sNM/C241tbr N/PjoeQGjRXuD4sAXaDXmfh/zw2FsAMrMBbcIEFAAVij/2Fue+ATkv8Mrx8KcWeosQC5DBC6QCiC f0AElhUYMp0SRH7L/8fRn8mPr4ltTIhgURaoFAS/ghv0v1kE8TY+tyWTNTitERLS/v8E2Z8LjP7o +jgY9TE2qEm6NAmgVgQxEEYB/AWZIQyGtXJUyAW/mP48U9Ynkj8+d6CM0Oi+rkZYJACLpKVsEAbE f4MbtIPO10yKCfL/MaA9ktuDVgHT7lvDzWb+dpkJtizBDkSAFuEXCWAjAQiF7E+gAJh9fov87PpU x5otq0F5JSgKYISAl8Wwo056uUFCwQW6UEYHfX4e9VN+fxWnWvcDIPmxjYZbxG1TMFGCyM8WgMm/ NYhfswCzmwVwLr1EgleF8iK5bSY6lwAkAuc+zwAj+UdnrzhOkb6aWy0WwIoJrLggZSGsGEDkFzgG iLO3kfybDOlzI35XC2ARlTe9DBlBpDosAQjW5heX4FBpO2418ZcIwFWYGe/ySylyG+iFn4mYnvTg AvkM4QeXXlHczKWx45dY0uQGCaHCzc4VZliFsRPxcyTWnmChxrUOiZiz5X4zt4YVMcDS12shnFDi jC8kYmqSNa63AFoIXkN8iUDIkd9fm/xLBeCv/HpBuBnXBl1j4SdDAhAkAEGQAARBAhAECUAQJABB kAAEQQIQBAlAECQAQZAABEECEAQJQBAkAEGQAARBAhAECUAQJABBkAAEQQIQBAlAECQAQZAABEEC EAQJQBAkAEGQAARBAhAECUAQJABBkAAEQQIQBAlAECQAQZAABEECEAQJQBAkAEGQAARBAhAECUAQ JABBkAAEQQIQBAlAECQAQZAABEECEAQJQBAkAEGQAARBAhAkAEGQAARBAhAECUAQJABBkAAE4aYI xuNg/L30HuHaAggLXx9Wvo/wM0SQI3HqubCUT0NHxdYQO4j8wgLyXs0SjCsJHyqFwPc9/d2LBw/t rvR6v2DcD5WvX4Sxs4pDxReyyN/rgkpItyV9uJIAattqjCs6WnqupuO9yO+NfkkM1yF/71jO4ssE LRj3g9GnRcIYO6t1ynR+AlJ6IL/vQP6QEINE0J/4oTDorf0M5MsFWnyc4lm4RQzQotYLtYGI6ReO 1j7zPz7hWkkI/chf6+62CoI5dZ55cza4hIJgETQJYWwkfor8lwTpL/AlPrCZheAbiemNW77vDSHI Gqx3S0ru7FQQRovI8D0/eHOidp5vWRhToi9XsQATdRJJfoZOfrQjEG8iAbRYAIvs3AZDGCEhCGH5 yBwyLm5JCLXpTuTUB4cO0CKvzgmr0CTCsfECcAexo7FjsY0z4eN7bOZmjdi5bA6Tf4BbvB/osYLh vkFpzuJPGSHUEt8ZFiAK4H1uh/kWeXYGMUwFl6hZAFbHJuogjvaxg1sgYXzdptEFSo36A7UNtACf 6424Q1ZguetzId/8khmFp0xmJlQMtiiuyKv9f+0PieFoWAP8/C4uUAAXZkqM+pH4u5n8G/ifM/xt IILWjP4W8SPhx8T9ALfsAkkE7S7vBL/lmfzxM7XJcEdqVgdYnxk/I/LrQwBv8+0erMEJYoOLa5g3 GBsDX+7YKUP+GMS8ADkHsgA1QkC3BsmObevsOQZXITgh7/JOFOMdyd09wS1mbjgwbbEA6GafwA3a gwD+kCU4JVyhVRbAyrmeKTh5B5IPRP4DCcA3WoAU+bfQXhK5YK9s0OK0p0VGHvQOhiuC2Zpcnr40 6E5GHHAAEfwmK3AgAVxqP7clCJ4Srs+WyD8R+fH5oSEIZtcHyf8ytx19WZfICvF8gITQ9ptfDHdk D/74O2VpTq6co6/JOKHlOUAssC9YgVQc8qUPY0NnLAG8g2uDPj8Gw2NjAOwpiI0Nyb+bG5o8l0mL ehF+UQbIGonRHflDwakVmC6JBTjZciLOvUNMsIfPPWfigGoLECoUeTSC2onSVi8QEyzx/9n1wZH/ 9b/2i8jPQfIFHqdWowr1KcmLYQH+gDvCIsD05BIBWFYARXAg62PFAF3SoCGRATq4z5NcGLBsM6N/ SQAc/I40+r/CBUbyY4wQ+zkaF1/kb88AXYzYLwakb7MI3igzc6z0x0MhCL+QAHm+iWMQFoHLCbA2 BogXwc8f4o3nz0ZcYJHfZ4JeFsBAo/8O1M7kjyKJP9TYkg8Wim6QlfbegwB+U56eY4HaiTH+/Esi DWu1bhbAWrLMInA0+mOQhGlPa/a31v9H92c3j/5M/hGez10EuT7LUqG5uZ89WYKYoowB65lSojVL qS0BWv1AFyuXAWqOAXIdip1wiXztCBmfDaUxS6s4+TGP7DsYUSL50TJYJrDr5okfRn5XcINQBNYk 1TGTDarlWyoVzytCrfx/ldUZKzqCI701Qmzc5+UOvFTBGvlLKVDO/rwQ+dEq/HL5iRDtQ15vBUJG BJiZ4YyQlZasnYNwrm7PibUsunryrXYtEIvAujBM+qHC9fEVGaCRAl4kvxX8NJlAoSkYngwXBK2B NUF2XvF7hIwYU/tRuq8GtVJUHj6ICc/uTsvaf28IYEs+/9Z9nviwyD+J+N1doZwQUtmZU2MqtOQK paxCbrKry0ywz6SrJoO4rtHtSQXBoxHw5qL+1CggIfR1haxdf7wf5OzyM7NLs1POlXemVbu8SywA i4LdnKng4tSSHyewBnCFrOW4qU3TIv5thTC59FLpHvFYbrtjy8abZgGU0lZr9vhaIojuT/zbxtmb MKzdSQp4r0t8lxBCbn94L7c0FATRjLFDJ6y/rxUAPp4KrWQKhesLwiWs73TljNzq9xmv9OFhIfkD kN4lLmjK9F2zcJOQF0GuolsoBLffivFelJiwBLkyebUBUCjEMUKfysw1WaS7s87Dnf4IpSzO2iBK liE/qpcIXeMS1fjtEkDhIpeqkIVKExsqMwk/lfRrX+Me9ZqOT/ZDthbn9ZlRyT8p4Wss400qM0sA fV2Y1uK8vkD8Zym02+KW3LQyswSwXgRLi/MOiSD42QrthkrSO5deV3O1yswSQJ+sQq44LwvCcoVS +4UfudBuS1VnrsSQun7dKzNLAMsD49rivHFnGBbntdYvPVOh3SVVnUv1Xq9SmVkCWCaEluK8J/d5 0z5vzrcqRzxyod01VZ15Xc/VKzNLAO0ZnqXFeSdnV6ezNu88S6HdlqrOU0IAB3fFyswSQHvAu7Q4 L5dntHauPXqh3TVVna2N51evzCwBtP2wa4rznhICQMI/cqHdpVWdU6evsAW4SmVmCaA98F1anPeF yJ4qspsqtOsgfXrvrlDIxEgnl67uzLFUvL5Yha1rZWYJoO7H7FGcdwsEZ/LnCu1axXb9nblCuX2z 1lFD6MKciMCcSIivw/In3SozSwDLRrSa4ryxct2OyD+6rxWmX6BZNWx8JmUa3PfNEeTWN02Z64WN xcDWwaoB1K0yswTQlsVoLc67S4z+TP5YaPc1Q/7Bpfc9X+PA76UiyCUJsJbmPuHPW2lPjAWwGO7q yswSQN2PuqY470vGz0fy/6LR37l0fSM+eOO7yJ/LkrE/j+7iH/e1qvN7wRIcSUBdKjNLAG3uT0tx Xhz5twmfH6tMY+kOTHumCnxxXPAdcUDIDBIp8u8hmE358zkRdK3MLAG0BcJLivOOlNbEgPfVfS3e 5I30aEoAk0svnfguK5maGLQE8C9ldfaGAKzZ9YPrVJlZAqj7gdcU57Vy+7GqHJKf3Z6NIQJPgkuV ffwuK2BVUMbAF1OZv6G9Obuqs5UZ6lqZWQJY9iPXFOfdJIiMhXbRb40EtibCLPKnDvy4hRBCwU1M lTHfGy7QbyOrY5WatOYJVldmlgDafuiW4rybzGj+QhmL4L6eQ8YCQPLH52sO/Lt1tsw6y+udMjco gDf3+YSXQ0IAvFSiS2VmCWC5CErFeTl4xZGd61V6g/wjjf4YZ6A4vtMFCgUBHN3XA+VwNveN7qMF SK3xsYi+uDKzBLBMCLXFebnIbiyviGYasz2cKkXyY/qVn78HC8Cx0NnZh0u/kRg4JcoBbWqHXZfK zBJA/Q/cWpzXJ0TAi7XY9bH8fswwvbhlh/7dIgs0GelgPsaIT3LhCTE+5vTi7LX+XSozSwDrAr9S cV4WgHWecCpOSJEfzz671xiAD5fG0xx/G6lPngM4unyp+W6VmSWA9UJwLl+c1yq26ypSng4IFVdE vpD7U3vo9y3I75y9BIIPs2Py85qgUkbH+lz3aKP+Iwsgd4FDRgDBSFVam2EG8qetFaUth37f2gLk jjTdk89vreu3Mj/OlavzPWyZlEcujFUqzstLFC4FAXC6E9cVxdnje/D/c8mBlBXAlKglgBT5a4rc PjSeqTJcDWLAHEd3a41/afRPLY24BwGkNg0dDSG8U9CbW8n5NIR/VgG0xAsogjORn1OepRPvbz0L nEsKsCuEM7W5dTwnGvl/DPmfXQApXzV3hBMvubaWVtQe+v0d33Hp6eqc838K/14CyBPlVod+38qy OXej09UlgMd3h2516Pd3CNu5K5+uLgE8lwiueej3reMAKx7ofrq6BPA8Qrjmod/3Eg90P139mfAT z8hKFcJN1Qh1d+r21LpCKavw0Gt4JIA+391XiOKRr9VVTleXAJ7TGljCeIZr9JRreCSA610H/2TX 6CnX8EgAuia9BCEIgiAIgiAIgiAIwk/A/wUYALvae047b8tiAAAAAElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 2.4314 3.4072)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "6.2,7.2 44,7.2 44,29 36.2,29 36.2,36.1 31.7,36.1 31.7,39 18.5,39 18.5,36.1 13.9,36.1  13.9,29.2 6.2,29.2  "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 24.6,
    fill: "#FFFFFF",
    width: 16.4,
    height: 9.2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.75,
    width: 46,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAC5RJREFUeNrsWklzHEkVzqylV3W3 pPF4I0YzY3k8B4+JYMBwcQDDEbj6wvwA/wzL1yE4+k/YRwMHcGAzgIWZhW0sE17ksA22xouk1tbd 1VWVfN+rzHaqR7IWbAgiXBEvKlWVWflevu+tLaVeXa+uV9dLv4wxampqSmO4JXEe57/oK/xPmNe4 Ll++rGv1hq5Wa/rx48d67uFD/f7739Tf/d739XvvHRMql8r6IZ5/A8+PH/+O/t3v/6Au/vpXItSl S5fUmTNn/meCCPP/uH5dR1GsHz16pBcWF/X4+Lje89qe4ODBr+n9+/br1zAul0o6DCO9d+9e/eZb b6mHc3N6ZuaaajVb8vzW7VkR6r8miNNArT6iRxoNvby8oivVqm40GkG5UgnwKqhUKmG9Xg9whfwb FHY6nSDP86DVaulyuRKkaapLEG58bFyXymV1+/ZtVa3VqEX14Yc/2bWGti3IzMyMvnr1qhof36Mn JiZ0P0kCCBKEYLpcLoca96TXCyFwlOV5CCuIIEDUS5IQzAc48jCDEHGpRC0FYRhCI6HCGv3GGxMq TTP1ySd/UhcvXoTGZl6OID/80Y/1vXv3dZIk+tDkZMBTz7IsNGA4wpWD+X6/T8ZjqC3G8xKEiSFA BIqhzoiCcj4ExSjkAYh2sByaKqu039dzc3OqvbQk2rl588aLFYRCHD16TIN5kmiBpw7cRLjHEIIM lyBECVAqO4JGynhfwidK4DnGsxhjrqEw3JdIDeI41viGhrCq0WiqiYk31dtvT6rR0dEdCaO3I4Qx uV5dXQ1w6gG0QiZoA3LaeZbF1ASF4jNLcvL2+wZ/g1eTgVKwD5zpPp73oZk+NMJxijkZxhkEy3Fg +dzcQ9Prdsy5c+e4fncaoWHTJggnagKPgqSX0GiJiBiwKoF48lXMJdXwvI6/65grRL9gie8reMb5 paDQDPd1goqtYL3C91We5XInzP55/56h24aL350g1DkNmzYhcII3ohDdbpdC8PQJmyokrmH6CMYj WNQAkw0sbRj3rBCKc6p4XiHkMHaC+MII89hPGXwUmlcPHvzLLMwvqG6vty2I6c0gVUIQA065ETUR 4dTiXq8XwygrsHAyVoPx1hyzphBKmKVt0A50gQmG8QzDBPceqIt3a7iv4tkq7muYsAaNdDG5C6eQ wCP2nz59krVGR7NqtbotiG2kEYkTdLHUhrjTLCORuTI2qtlT5ok3QS3QKDYZ5d1SSzRjTMPCTbRC eFmNRD60VCEtLF7hbHKTZlmOgzMQQiHQbgti4bBtMGIz2DFO0MXSO3Fz2gThZBkbwY5Ny/QYhcC7 MY4pBMYiCMmDV8UTZB2sME+EwABiGDqGPI4ig4BpRkZGzJewFzgWde3atU2DZThsG0w7GLHFzRZ+ P84K1yo2YbHf9E5/3BKFoEDUUNMTom4PgELQHdO7OUEKZUAACJLTc5EAM45zagdZAN9vqZVh0EnC Nzl5WAycdpHSQ6Vp1TI10AKYEwGwIcej9l3dg5C4YDJEG7H20QGtgJZAi6B5EubNg9kFTF4ExJZp P5yLfRPw0J/7ci67fOk3xtqbea5GHKyYADJ3YtrBiG2DXcVYbYCxpmcTA004SBF2eEet0fVWhiAV WeEcpHKrjVQ5QozRhXPIwDHJRGFkYK/UyNY2wo8zFWcWKwkfEgmbdpQgZZVxQhVwaQ3ZhLOLpicE tVIV54DYYY07toHUoaCAUhEMGRQT7NnnGHv1GTjhITPwkAPm5vDhd9TeffvMZq54IAjrCtYTTMUJ KyaAjNg25RAjDwpBBvDaQBMOWtRCyaUllkLfuC3cRAispwCJUAFBEQiCpYAWo73pJT1z584dNbeJ Vnxjl6KI9YRzu0wAnSA2WjcctDzvNKwJiSOeEOs8lNOGhVLfxpcubQjr5I5nPWoFKUyKVIKZaX7/ /v38j9NXNoVW5P/BrBPFEKOshqei4QT2kvScNqMLzyMxxWK/7EXsQc5ljV3b09eeAH3rvcr2OxSa d1krPNlcDV4zEOuG68VYb2boXxHknSNH1Ot7XlcohpgaSNqe0zgLAy3ccYHz0LrQyEs3ImsDg/TD i+xOiGAIapE3X4oxmYP9mBEDWnygDQ91iysafsAYoop0VTMI5cVHtPUHcreeJ/DG2p6+ez8Ye25+ mAJH/je4iyoWs1ahN2Vw1jsWpNvpGGjEQBsmf3YSvg83Njbk3thYCJmh8VfW2nXryKb5cimbqhhB VEqJiW+zI0Fu3rih+klfIZoq2AgTUeOiLNMG62kGxPqCLtR5IO+drwkzvM6jlHWK942CsF8gCpJN ycOW0Fo34/PPP1PIOlkbGHgLBa/hhHCuMrVeJnHexUbsnjViR+nQ344Sj3oSO559jx6MRVdmA2LO /ckHIaa30Mo698u+E1s27HawUUDjdsGMnsV6J59KXjYbbuBiM0+onnWzazYFWcb3mKq0cVBtpi04 wBU8W7GpTBeJagLi4eWNZsNEUbxpHBlAa2pqSjWao+rTzz5VqDtMjGSNURVXZjWxETMubkTW+I3n YiMrmBMosQxy3YqtRRzxex2JI4zsDJJYg8iew06YNJqxsTF14MAB8+etci32k9gBZPOMfSe2bNjt kALpmYuVeDLkav3cyQxpIvGEd0Isu6QR85k4ti1RQyuGc4rAKHBDMMx63W5+feaa+fjj325t7C4F YlBsNpomK4obUgqY+dpYdZCyQjk7o/G7KF32Ivq67JeasFBa5B1/L7tKEXdqJTHUKBwJ3SZ5aC+1 De132zU7e7FsY7IDyIYA+04CmWcxIfDig7MHccHW8/j24MNwxcJJbMJqwlHbamjZCSNrkX8xz6rV 63mvl5gmbOTUqVNqW/UI3fhHP/2Znp6eZr8zQKkZAmbSu4KGKjgg1ukslFzyWBDyLV2UvjWb9Za8 4im3LnadjZBxZ+QkjEUzrN+xV5d2guCcwgFkf/vrX/LJyUPPrdujoQpR7vBe6tixrxv2mPBRiQtw gfQgQb/IeUQxhkzmeaqJ5wIWNdf28Qsrq63EJoV+42HZaopEbbAx0cfkFA6Hfa58sd023Oro0aPq ec2H53ZRUDezExgAahFOhm3RktVMRRenX8sL5mu6aPlUbTI5qD1stM48yHWsrazhFe2FHZQ1XXRR ervtokQbPfz28W+pCxcuGGAzZ0EDnIpiaDM4YiVRl6kFTi4oTpoMdHThil0GTI83EESCHVJzL1Xv WBvqUhPUKg6lr4q4ka11Ovndu3cNElnzy1/8fMtu44ax//Tp0+bQoUMKsUQ1Wy2BGPJQqprFjkAE WmE/akVq7MJ4F0BPsSHpCcZPFO+W+JzvVVGXL4JpruP6NXsQ4m7hIbMu3O1Su53TwHmoL7z3S4JP DzIb8SOGWkZ9EKFn6wlJ9ZmKC6iLH1aovcxqhlE2NTZtSQvXzgJKci4KcevWzfyLL/5uTp48qbbb +91yBoVh+Ts/v6AXFxd0rVpFBTkizQkWXKqoTaSu0DZI0shZnDkbYe42aGQX8aZoaOPOzIGGvbq6 khNO1ASF8DLnF/OzAov9d989In0l9mKRi0kHkM0z9p0AhdymExlrbJan4slgD1EcE4YMbmws0OuJ IVMTcIdSj5crlSxC0MPc/M7srKnXa+bEiRNsou/oF9Nt/dDDDh+bY2woN5tNaWOyA8jmmRVE8jIy xhobR88stkjxIQhhxKyWCSDmZUw7CCUGO8aZp/PzEvBqtZr5wQcfqLNnz5qd/vy24x8hgVs9OzvL ykfvP3BQr62tyg+brCzhrjWYlMqS5SnhJbCyqTiENjAKw+KNaUetVkc2+0DiBJ3L+fPnd/279Y5/ 1XXaIbOE2/SVK4rNM7pptmzY7VhqL5rl5SWzsrKc874EpsG4pOKt1qhhAjg9fUVRC4jYilDajRZe yj8J0CkgIwj8WnyY+J7zXsY/D+gXLN92vmfUq+vV9f9z/VuAAQBfnbCWJC0bdQAAAABJRU5ErkJg gg==",
    transform: "matrix(0.24 0 0 0.24 3.1032 35.9529)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 8.6,
    cy: 41.5,
    r: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.75,
    width: 46,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAyCAYAAAAX1CjLAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAC2dJREFUeNrsWllzHFcV7tvd0zMj a0a2hDZHcQrFRs4DCSmg7OIRKENCqqjwArwS4G/Y/gPkB6TiFJUHlsojS2Ig+InyAjiBB4iXh9iK ZUvWMpp9erl835lz5fYSSxpJLh7cVafune67nO+evXs87+n19Hp67eVl9mJRa63BtdWxHsba3eYh 3Asw73/wJ/OTN37mnXn7Lfn9wx/9+L6xv/n1r6TlGIzdE5Bmt9b44/tnzSvfPSEg5ufnzfHj3/D+ fumCPDt8+Ih3YHRU+qsrK/batasy8WtfP2bPn/+bNzMzYwkWa3hYwwHbEUB/JxIiKJy6tBcuXjTf /Na3zfC+YX9kZL+/trYazDx7KJiePhg2m82w0+kIsc97fMYxHMs5nMs18mvqHgNdwaBSotqdO3fO fP/1Hxjf903c6/lfGB/3wXgwPjER1mq1wDcmSLMsyLIsxPgwjuOg2+kEmI0Zxm+32/7k5KTfqNfN xOSkWbpzx2AN78WXvmLO/fVDz+3xpIDJib755i9EQmNjY36pVPZbAFSIojDwfQIo9LrdMAiCCKde sFlWSNO0gPuhgMQYAk2SBPhMUAhDQ7DtVsubmpo262trVF3vnXfO0A7N5cv/3HNgAurQc8+JlCbG J3wwFIB5YAgEEBgtdLvdCG1RqYR5RYwhRUASYW4kjgvgADjACfhJHPvFYtH4QWA63a43VC57kKJI b3b2eW+74MJBQC1CZY4cmfPjuOe3Wi1KJoClFyANIUqJEtE2kOdqL/R6uFIS+jFAAlMc41GMNWJI McZwA5Dpkf1z3CvDnmrW4nntrgFzrvz27QWvVCqZNM38TqcdhGFIooQIIMJpF8FjEVIpUioKjEAD FwuUu5RAMC4G0h5udvG7C1BdrIdlaJ4mxh4p1NwjOJ7J6dOn7a5KDAvKYcOrmZXlZRp4UF/vBb1e r+BUDnZU8ny/TNUD72VQiWCpfhmA+fc8cKbS6pEg4Q7aNu63cT9MkwRm6lMTJI4AqK2tNQjI3Lj5 mbfVULAVYFzQnDjxHTN39AV/aXExgDcLomKxAIdRxPMSnMYQdhrK0nQIXO0Ds0O4P0S7EuBgOBda MtxLrEoJ1EK/xUMAEHEoFCpEJtxDA2y9XrfHjh2321HJrTgPM33woJl9/jA3pC2JkwDzRahRGQwQ 1D6Mq2KzEbQjaPejdcTfVcytoj+MvoDmgYDoRArKh+9UHmsDGX6iA+diSdVK1UKQ3qVLF10YGDzz 4EZv/PTnZv7mDTM6OuYXCoWQkoJNFXGyZWy0D4OGMa4C/RoByBECwMYVtMNOamSeTkTXTDEvVolR Ug3wv452HfdqsC+263jWALgm9mpDC7p0LFNTU+kn//1PdvbsB9lm6VewWRT+5MoVkRbsiYE1xBGK tMBcGSdKSVVMHxClcwD9UfQPOGkpcQyBcnw5Ly16T1VTp15g2ctwSBnu0BZTgM2wl4X92anpg3Yr UtssqtO2kB1M+WLHhULUabeLIgkyC/UjGBDBjOZAidRoaxrHxDPqYYlHRNvBc0qsjt810Ar6q7i3 jEErWHsNh1dD5tKAA2khY+lCgr0SwsC77/4yVQeyfYlRDW/O3zK3Fm6ZqclpH7KXuAT7iry+13N2 JbaE9oCCykvL2dU+UNkF67xt4d6GtHBlYD4FKDqXBP0EQGMAS1OJ5GGGjMYyab5+/fpgzoM7zR7+ kvn3xx/5EH8ADxim/dSIcYreb1jtaSQHiKq4H7831E+dhbh/ghLv11c/AaXxjV5DvCVB4XePdshY RgKwBGqY9uI4Q06afXF21n75xZcem418LjAmn9jSzDwzI96QLp65H+0Dmw+pzVRVMvd5wQdsqqRu n4AKGmKYiQgoSkqllWgYiBVYT8NBT4O5gEZGkiGCZ0gW7NWrVwYrW/7w+98xjnhwHAZq4EMFmZWH euIEGal6lTUol9U5OCo+SOolXQ5Zys9j69QVKhgxPdPULIB9++ShVC4bqKMhbwMHaAZliahpSjIM JEwLdDOxObWVKM88paMOo+BcPSWkKp6p06KNJO6Acrbn5oYOFAb7MAES0rnU66eWO8g8kFl7iPoG sUTSKSxI1fGDvsH7qsqh5oJhrh+4VgNvkHsJ4kAFD9A9IGqD0sdBQnJymoijBLal+mzTCrpSqTDx 9bDow5Vmn8mtkPeIvve4Oe4gXAv7Fh6oPbuSBENiHiT2kPg1YbO5ePI48h5oNyW5tOUkqiAk58Fx bAncYyX2r48/8mpraxZB2aJooolZv28jmSaz3CFxrXo29lPXSmzq97McST2mLe3svvls5TnmkqiN PEQmxP3Sb4eqiJxMFuEpgVB7+JmWHRuumXGGLhmty9a7+jvWDCNWJxHnKTevl5/n3DvXZxEqh4LD ZFpFUE4ldwTs1e+9JotEUcQ8jbkbMjY5zcQxhX5Ha6m2q6vcb32WB9zNlSsdN5fEubm6rANQXU2W BRw0JiMP1B4k4pa8DQTs1KlT3iuvvuZdu3bVRlHRAiClh+QjSyA9d9qOsRaoSQIjDRL7eN7U+60c gJbWYPnnzdx85o9tFqBOepASiokkjZEEN5tNiyDNlz6DOY+TJ096KFk81kU8KZySqCGBucpXT7cp mb5mF+q6jcYrSrensc53ZYukTv1DIUhJglmqYJ26HkpLJArJ4iR7AfbkPGYdMAd77eoVq2Zitw3M 1ToM0r0eyyEvQ/RPsXCCEsJJq+XKf5cq5cr/WE+8mCsmN7J7Mq7z6zikGto1gmN9ptKmhPnaIFZn wqIzK5fL9r33fmt3ZGNUR4CxlWqVxWwGr5QyITX38jgy1tTCkIytavmxTEL/Lmj5UZQbw/ErOl/A UWqQVMvrO6SeqD+y/nKpJLw43vakgmZuBxVl5j6sZX/VvQJgLcb7mv89VEGr1+vmbJPquK6Skwoa 3PfrsAEr6HCTCto67zg6NmabjQbVQUp7viIDI3BXiWQJjHE4ZcaeDaY1qS26VCuniol6yLZzMmpb daeKYRCwEO3iMONWq5UyfvLdB22L0trsZc6WPkrQA9FgqY5wtzRicQoQdxcA28rUOqteVr/4TRVc wuaL6N8hoX+b5H6DFjlGVXPF2RjXgtclYFbMMUKN1GILC7eyiclJcRh0bLvxtcUeevYZOanPbn0m WQPf0qJ0iKEPXTIhbhtOgKU8GRRGfZ82tEQASgIoU1AYu4Qxdx0oUA2/GwwHeNbh2pQ+9kmRr2YX Lpy3Nz791OY1accS0xOySIYtVTKOk7QQRXzJQu/WhSAZd2grjGF9cNauqJO4S4Dg5q4QHIrpt8uQ 8CrHQoVr8lYKBwR1E2lxbVySbi0uLWbugLf63Ww7n2jue3fP19y1tVXaWcDXEZAcsEbyRaUQhlKH 6ZeVAMbh0wjldFiD9N860VYl1ULgjWFLCQpapBcp7ZfPUgfqw7/82SXGW/7iud1vTwKu2Wx4S0tL pr5e96enp8F64A+Vy0GSIhr0s9SAn5MImlUvv52xPvX6Ed7iBCQ9IvMpAz4AYG6KuUkLNgxw2cLC QlapVjZAbfcr53a/aNozb79lXzg6Z7lhVIyy8fFxMpQOVyoJHIvEN9hFB266BSm1wHQT9tJAPBRi n/f4jGM4lnM4l2twLa7JtbkHPOBAn24H+VTrvJKdmztqG81GtrK6klar1ZQejJ6MMQdM9yC8DnI8 JrSS8GpyK/f4jGM41nk/rsG1uCbXzu/1RL5BuwIzL72bN28IUwjmKdQyIaOMQaYf83oxDYivk9Hn PT7jGI6d17lcg2txTa6tr+UG+si+438NuA8JDJog4/7+MDNzyFy+/A+PAfyR7/3C0L788le9+fkb 1v09gmrHdfbqvx87+heBIzgZ98Lnc0nHbMzZyb8Ensg/c7a59v+HZJ5eT6+9uf4nwABtmFF57sIX QgAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 35.9869 35.9529)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 41.5,
    cy: 41.5,
    r: 2.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 8.6,
    y1: 39.8,
    x2: 8.6,
    y2: 43.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 10.2,
    y1: 41.5,
    x2: 7,
    y2: 41.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 41.5,
    y1: 39.8,
    x2: 41.5,
    y2: 43.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 43.1,
    y1: 41.5,
    x2: 39.9,
    y2: 41.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 9.8,
    fill: "#FFFFFF",
    width: 28.5,
    height: 2.9
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-vf",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M49,50H1c-0.5,0-1-0.5-1-1V1c0-0.6,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.5,49.5,50,49,50z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.9594,2.9594",
    cx: 25,
    cy: 25,
    r: 21.7
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M14.4,24c0.6,0.5-2.7-1.3-1.4-4.5c1.3-3.2-0.7-4.9-0.7-4.9c-0.2,0.1,2.6-0.3,2.9,2.5 c0.4,3.2,2,2.9,2.4,2.9c1.4,0,3-4.4,1.2-7s-3.8-3.7-3.8-3.7s2.4-0.5,4.8,0.6c4.2,1.9,6.4,5,6.8,7.8c0.2,1.7,2.1,1.9,2.1,1.9 s2.4,0.2,1.8-2.3c-0.5-2.3-3.2-4.8-3.2-4.8s3.6,0,6.1,2.3c1.7,1.6,2.9,3.6,2.3,6.5c-0.5,2.6-1.9,2.8-1.9,2.8L14.4,24L14.4,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.1,24c0.6,0.3-2.5-1-1.3-3.4c1.2-2.4-0.6-3.7-0.6-3.7c-0.2,0.1,2.4-0.2,2.7,1.9c0.3,2.4,1.9,2.2,2.2,2.2 c1.3,0,2.8-3.3,1.2-5.3c-1.6-2-3.5-2.8-3.5-2.8s2.3-0.4,4.5,0.4c3.9,1.4,6,3.8,6.3,5.9c0.2,1.3,1.9,1.5,1.9,1.5s2.3,0.1,1.7-1.7 c-0.5-1.7-2.9-3.7-2.9-3.7s3.4,0,5.7,1.8c1.6,1.2,2.7,2.7,2.1,4.9c-0.5,2-1.7,2.1-1.7,2.1L15.1,24L15.1,24z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 25.4,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 25.4,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.3,
    y: 25.4,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 34,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 34,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.3,
    y: 34,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 29.7,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29.7,
    opacity: 0.5,
    fill: "#3999D4",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 8.5,
    height: 3.3
  }))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-vm",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M49,50H1c-0.5,0-1-0.5-1-1V1c0-0.6,0.5-1,1-1h48c0.5,0,1,0.4,1,1v48C50,49.5,49.5,50,49,50z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M44.7,29.8H5.3c-0.6,0-1-0.4-1-1V7.2c0-0.6,0.4-1,1-1h39.4c0.5,0,1,0.4,1,1v21.6 C45.7,29.4,45.2,29.8,44.7,29.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    d: "M44.9,42.6H5.1c-0.6,0-1-0.4-1-1v-6.3c0-0.6,0.4-1,1-1h39.9c0.6,0,1,0.4,1,1v6.3 C45.9,42.2,45.5,42.6,44.9,42.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 21.4,
    fill: "#FFFFFF",
    width: 33.8,
    height: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 8.2,
    cy: 38.5,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 36.5,
    fill: "#FFFFFF",
    width: 0.4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 36.5,
    fill: "#FFFFFF",
    width: 0.4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 36.5,
    fill: "#FFFFFF",
    width: 0.4,
    height: 4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M23.9,26.6h-0.4v-1.4h-1.6v1.4h-0.4v-3.2h0.4v1.5h1.6v-1.5h0.4V26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3999D4",
    d: "M25.7,25.8l0.1,0.3h0l0.1-0.3l0.8-2.4h0.5l-1.2,3.2h-0.4l-1.2-3.2h0.5L25.7,25.8z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 7.7,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 10,
    height: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 14.1,
    opacity: 0.5,
    fill: "#3999D4",
    width: 6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 9.3,
    fill: "#FFFFFF",
    width: 6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 7.7,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 10,
    height: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 14.1,
    opacity: 0.5,
    fill: "#3999D4",
    width: 6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 9.3,
    fill: "#FFFFFF",
    width: 6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.9,
    y: 7.7,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 10,
    height: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 14.1,
    opacity: 0.5,
    fill: "#3999D4",
    width: 6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 9.3,
    fill: "#FFFFFF",
    width: 6,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "product-vnf",
    viewBox: "0 0 60 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.65,
    y1: 122.25,
    x2: 5.55,
    y2: 75.15,
    gradientTransform: "matrix(1 0 0 1 1 -74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M50.1,49.7h-40c-2.8,0-5-2.2-5-5v-40c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40 C55.1,47.5,52.9,49.7,50.1,49.7z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M36.9,44L55,21.1v15v8.7c0,2.8-2.2,5-5,5H31.3l-7.9-10.9 L36.9,44z"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9DE2F4",
    d: "M48.1,9.6c-0.6-1-1.9-1.5-2.9-1.1l-11.7,3.8c-1,0.3-2.2,1.5-2.6,2.5l-8.3,21.6c-0.4,1,0.1,2.2,1.2,2.6 l19.9,7.6c1,0.4,2.2-0.1,2.6-1.2l8.3-21.6c0.4-1,0.3-2.6-0.3-3.6L48.1,9.6z M43.9,15.9c-0.8-0.3-1.3-1.3-0.9-2.1 c0.3-0.8,1.3-1.3,2.1-0.9c0.9,0.3,1.3,1.3,0.9,2.1C45.7,15.8,44.7,16.3,43.9,15.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#SVGID_3_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M49.4,32.6l1.5,9.9l-7.7,6.3l-9-3.5l-1.5-9.9l7.7-6.3L49.4,32.6 M49.8,32.4l-9.5-3.6l-8.1,6.6 l1.5,10.3l9.6,3.7l8-6.7L49.8,32.4L49.8,32.4z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005582",
    points: "37.4,35.8 40.6,41.4 40.1,41.7 36.9,36.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 35.1,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 17.4316 -13.4555)",
    fill: "#005582",
    width: 0.6,
    height: 10.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005582",
    points: "46.8,35.2 47.2,35.7 40.5,41.8 40.1,41.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 34.6,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 15.8286 -14.4188)",
    fill: "#005582",
    width: 1.9,
    height: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 40.3,
    transform: "matrix(0.9335 0.3585 -0.3585 0.9335 17.4375 -11.5664)",
    fill: "#005582",
    width: 1.9,
    height: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 58.872 82.5951)",
    fill: "#005582",
    cx: 37.1,
    cy: 35.8,
    rx: 1.9,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9335 -0.3585 0.3585 -0.9335 68.7935 101.3474)",
    fill: "#005582",
    cx: 43.8,
    cy: 44.3,
    rx: 1.9,
    ry: 1.8
  }))))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M13.1,23.1l2.3-7.5h2.3l-3.5,10H12l-3.5-10h2.3L13.1,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M26.6,25.6h-2.1l-4-6.5v6.5h-2.1v-10h2.1l4,6.6v-6.6h2V25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M34.4,21.5h-3.9v4.1h-2.1v-10h6.5v1.7h-4.4v2.6h3.9V21.5z"
  })))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-equipment-complete",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.5,
    fill: "#7B7F7F",
    points: "22,20 3,20 3,4 22,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13,21.1 8.2,21.1 8.1,1 12.9,1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M8,2v21h5V2H8z M12,7H9V4h3V7z M12,11H9V8h3V11z M12,15H9v-3h3V15z M12,21H9v-3h3V21z"
  })))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-equipment-failed",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.5,
    fill: "#E32C2C",
    points: "22,20 3,20 3,4 22,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13,21.1 8.2,21.1 8.1,1 12.9,1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E32C2C",
    d: "M8,2v21h5V2H8z M12,7H9V4h3V7z M12,11H9V8h3V11z M12,15H9v-3h3V15z M12,21H9v-3h3V21z"
  })))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-equipment-pending",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.5,
    fill: "#7B7F7F",
    points: "22,20 3,20 3,4 22,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13,21.1 8.2,21.1 8.1,1 12.9,1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M8,2v21h5V2H8z M12,7H9V4h3V7z M12,11H9V8h3V11z M12,15H9v-3h3V15z M12,21H9v-3h3V21z"
  })))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-equipment-processing",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.5,
    fill: "#009EEF",
    points: "22,20 3,20 3,4 22,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13,21.1 8.2,21.1 8.1,1 12.9,1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M8,2v21h5V2H8z M12,7H9V4h3V7z M12,11H9V8h3V11z M12,15H9v-3h3V15z M12,21H9v-3h3V21z"
  })))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-shallow-complete",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7B7F7F",
    points: "22,20 3,20 3,4.1 22,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#676767",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 19,
    y1: 18,
    x2: 23,
    y2: 22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14,18c-2.6,0-5-2.4-5-5c0-2.6,2.4-5,5-5c2.6,0,5,2.4,5,5C19,15.6,16.6,18,14,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "M14,9c2.1,0,4,1.9,4,4c0,2.1-1.9,4-4,4s-4-1.9-4-4C10,11,11.9,9,14,9 M14,7c-3.1,0-6,2.8-6,6s2.9,6,6,6 s6-2.8,6-6S17.1,7,14,7L14,7z"
  })))))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-shallow-failed",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E32C2C",
    points: "22,20 3,20 3,4.1 22,4  "
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    fill: "#E32C2C",
    cx: 17.6,
    cy: 6.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14,18c-2.6,0-5-2.4-5-5c0-2.6,2.4-5,5-5c2.6,0,5,2.4,5,5C19,15.6,16.6,18,14,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E32C2C",
    d: "M14,9c2.1,0,4,1.9,4,4c0,2.1-1.9,4-4,4s-4-1.9-4-4C10,11,11.9,9,14,9 M14,7c-3.1,0-6,2.8-6,6 c0,3.2,2.9,6,6,6s6-2.8,6-6C20,9.8,17.1,7,14,7L14,7z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 17.7,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 49.4914 20.5)",
    fill: "#E32C2C",
    width: 1.4,
    height: 5.7
  })))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-shallow-pending",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7B7F7F",
    points: "22,20 3,20 3,4.1 22,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#7B7F7F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 19,
    y1: 18,
    x2: 23,
    y2: 22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14,18c-2.6,0-5-2.4-5-5c0-2.6,2.4-5,5-5c2.6,0,5,2.4,5,5C19,15.6,16.6,18,14,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M14,9c2.1,0,4,1.9,4,4c0,2.1-1.9,4-4,4s-4-1.9-4-4C10,11,11.9,9,14,9 M14,7c-3.1,0-6,2.8-6,6s2.9,6,6,6 s6-2.8,6-6S17.1,7,14,7L14,7z"
  })))))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-shallow-processing",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#009EEF",
    points: "22,20 3,20 3,4.1 22,4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 3,
    height: 10
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#009EEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 19,
    y1: 18,
    x2: 23,
    y2: 22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14,18c-2.6,0-5-2.4-5-5c0-2.6,2.4-5,5-5c2.6,0,5,2.4,5,5C19,15.6,16.6,18,14,18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M14,9c2.1,0,4,1.9,4,4c0,2.1-1.9,4-4,4s-4-1.9-4-4C10,11,11.9,9,14,9 M14,7c-3.1,0-6,2.8-6,6s2.9,6,6,6 s6-2.8,6-6S17.1,7,14,7L14,7z"
  })))))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-staging-complete",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    fill: "#7B7F7F",
    width: 21,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#F1F1F1",
    points: "17,21 13,21 13,8 17,8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    fill: "#F1F1F1",
    width: 2,
    height: 2
  })))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-staging-failed",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    fill: "#E32C2C",
    width: 21,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#F1F1F1",
    points: "17,21 13,21.1 13,8 17,8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    fill: "#F1F1F1",
    width: 2,
    height: 2
  })))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-staging-pending",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    fill: "#7B7F7F",
    width: 21,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#F1F1F1",
    points: "17,21 13,21 13,8 17,8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    fill: "#F1F1F1",
    width: 2,
    height: 2
  })))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-enrollment-staging-processing",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    fill: "#009EEF",
    width: 21,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#F1F1F1",
    points: "17,21 13,21.1 13,8 17,8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    opacity: 0.6,
    fill: "#F1F1F1",
    width: 4,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    fill: "#F1F1F1",
    width: 2,
    height: 2
  })))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-overlay-failed",
    viewBox: "0 0 5 25"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E42D2C",
    points: "3,4 4,5 3,15 2,15 1,5 2,4 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#E42D2C",
    points: "1,17 1,20 4,20 4,17 "
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-overlay-pending",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M12.5,1.4c6.1,0,11.1,5,11.1,11.1s-5,11.1-11.1,11.1s-11.1-5-11.1-11.1S6.4,1.4,12.5,1.4 M12.5,0 C5.6,0,0,5.6,0,12.5S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0L12.5,0z"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    id: "progress-overlay-processing",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M17.5,2C26,2,33,9,33,17.5S26,33,17.5,33S2,26,2,17.5S9,2,17.5,2 M17.5,0C7.8,0,0,7.8,0,17.5 S7.8,35,17.5,35S35,27.2,35,17.5S27.2,0,17.5,0L17.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M17.5,0v2C23,2,27.9,5,30.6,9.3l1.7-1.1C29.3,3.3,23.8,0,17.5,0z"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    id: "provisioned-ring-block",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("title", null, "provisioned ring block"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,15.75A7.769,7.769,0,0,1,.25,8,7.759,7.759,0,0,1,8,.25a7.669,7.669,0,0,1,4.745,1.632,7.763,7.763,0,0,1,1.371,1.37A7.671,7.671,0,0,1,15.75,8,7.759,7.759,0,0,1,8,15.75ZM4.135,12.91l.24.172A6.2,6.2,0,0,0,8,14.25,6.257,6.257,0,0,0,14.25,8a6.191,6.191,0,0,0-1.164-3.619l-.171-.24ZM8,1.75a6.241,6.241,0,0,0-5.1,9.856l.172.242,8.778-8.767-.241-.172A6.2,6.2,0,0,0,8,1.75Z",
    fill: "#859ca8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,.5a7.424,7.424,0,0,1,4.592,1.579,7.564,7.564,0,0,1,1.326,1.326A7.423,7.423,0,0,1,15.5,8,7.508,7.508,0,0,1,8,15.5a7.423,7.423,0,0,1-4.6-1.587,7.542,7.542,0,0,1-1.325-1.329A7.426,7.426,0,0,1,.5,8,7.508,7.508,0,0,1,8,.5M3.043,12.234l.418-.418,8.361-8.349.418-.418-.482-.343A6.49,6.49,0,0,0,2.7,11.751l.343.483M8,14.5A6.49,6.49,0,0,0,13.29,4.236l-.343-.48-.417.417L4.167,12.525l-.417.417.48.343A6.441,6.441,0,0,0,8,14.5M8,0a8.021,8.021,0,1,0,4.9,1.685A8,8,0,0,0,8,0ZM3.108,11.462a5.99,5.99,0,0,1,8.36-8.349l-8.36,8.349ZM8,14a5.955,5.955,0,0,1-3.479-1.121l8.362-8.352A5.99,5.99,0,0,1,8,14Z",
    fill: "#33424f"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "resource-vms",
    viewBox: "0 0 60 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.15,
    y1: 272.55,
    x2: 5.05,
    y2: 225.45,
    gradientTransform: "matrix(1 0 0 1 1 -224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    style: {
      stopColor: "#00D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M49.6,50h-40c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C54.6,47.8,52.4,50,49.6,50z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M54.6,25.6V45c0,2.8-2.2,5-5,5h-29l-9.1-9h33.1l-0.1-31 L54.6,25.6z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 33,
    height: 31
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.5,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.6,36.2c0,0.9-0.7,1.6-1.6,1.6c-0.1,0-0.1,0-0.2,0H27.5c-0.5,0-0.9-0.4-0.9-0.9S27,36,27.5,36 c0,0,0.1,0,0.2,0c-0.1-0.3-0.1-0.5-0.1-0.8c0-1.5,1.2-2.6,2.6-2.6c0.3,0,0.5,0,0.8,0.1c0.4-2.1,2.2-3.6,4.3-3.6 c2.4,0,4.4,2,4.4,4.4c0,0.5-0.1,0.9-0.2,1.3c0.2,0,0.3-0.1,0.5-0.1C40.9,34.6,41.6,35.3,41.6,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.5,34.7"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M17.8,21.7l1.9-6.4h2l-3,8.5h-1.8l-3-8.5h2L17.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M24.8,15.2l2.2,6.2l2.2-6.2h2.3v8.5h-1.8v-2.3l0.2-4l-2.3,6.4h-1.2l-2.3-6.4l0.2,4v2.3h-1.8v-8.5H24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M36.3,22c0-0.1,0-0.2-0.1-0.2s-0.1-0.1-0.2-0.2s-0.2-0.1-0.4-0.2s-0.4-0.1-0.7-0.2 c-0.3-0.1-0.6-0.2-0.9-0.3s-0.5-0.2-0.7-0.4s-0.4-0.3-0.5-0.5s-0.2-0.4-0.2-0.7c0-0.3,0.1-0.5,0.2-0.8s0.3-0.4,0.5-0.6 s0.5-0.3,0.8-0.4s0.7-0.2,1.1-0.2c0.4,0,0.8,0.1,1.1,0.2s0.6,0.2,0.8,0.4s0.4,0.4,0.5,0.6s0.2,0.5,0.2,0.8h-1.7 c0-0.2-0.1-0.4-0.2-0.6s-0.4-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.7,0.2s-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0.1,0.2s0.1,0.1,0.2,0.2 s0.2,0.1,0.4,0.2s0.3,0.1,0.6,0.1c0.3,0.1,0.7,0.1,1,0.2s0.5,0.2,0.8,0.4s0.4,0.3,0.5,0.6S38,21.6,38,22c0,0.3-0.1,0.5-0.2,0.8 s-0.3,0.4-0.5,0.6s-0.5,0.3-0.8,0.4s-0.7,0.1-1.1,0.1c-0.4,0-0.8-0.1-1.2-0.2s-0.6-0.3-0.9-0.5s-0.4-0.4-0.5-0.7s-0.2-0.5-0.2-0.8 h1.6c0,0.2,0,0.3,0.1,0.4s0.1,0.2,0.3,0.3s0.2,0.1,0.4,0.2s0.3,0.1,0.4,0.1c0.3,0,0.6-0.1,0.7-0.2S36.3,22.2,36.3,22z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "resource-vnfs",
    viewBox: "0 0 60 50"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.15,
    y1: 272.55,
    x2: 5.05,
    y2: 225.45,
    gradientTransform: "matrix(1 0 0 1 1 -224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    style: {
      stopColor: "#00D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#009EEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007FEF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M49.6,50h-40c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h40c2.8,0,5,2.2,5,5v40C54.6,47.8,52.4,50,49.6,50z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M54.6,25.6V45c0,2.8-2.2,5-5,5h-29l-9.1-9h33.1l-0.1-31 L54.6,25.6z"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10,
    opacity: 0.4,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 33,
    height: 31
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M17.8,21.7l1.9-6.4h2l-3,8.5h-1.8l-3-8.5h2L17.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M29.4,23.8h-1.8l-3.4-5.6v5.6h-1.8v-8.5h1.8l3.4,5.6v-5.6h1.8V23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M36.1,20.3h-3.4v3.5H31v-8.5h5.6v1.4h-3.8v2.2h3.4V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005582",
    d: "M40.9,22c0-0.1,0-0.2-0.1-0.2s-0.1-0.1-0.2-0.2s-0.2-0.1-0.4-0.2s-0.4-0.1-0.7-0.2 c-0.3-0.1-0.6-0.2-0.9-0.3s-0.5-0.2-0.7-0.4s-0.4-0.3-0.5-0.5s-0.2-0.4-0.2-0.7c0-0.3,0.1-0.5,0.2-0.8s0.3-0.4,0.5-0.6 s0.5-0.3,0.8-0.4s0.7-0.2,1.1-0.2c0.4,0,0.8,0.1,1.1,0.2s0.6,0.2,0.8,0.4s0.4,0.4,0.5,0.6s0.2,0.5,0.2,0.8h-1.7 c0-0.2-0.1-0.4-0.2-0.6s-0.4-0.2-0.7-0.2c-0.3,0-0.5,0.1-0.7,0.2s-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0.1,0.2s0.1,0.1,0.2,0.2 s0.2,0.1,0.4,0.2s0.3,0.1,0.6,0.1c0.3,0.1,0.7,0.1,1,0.2s0.5,0.2,0.8,0.4s0.4,0.3,0.5,0.6s0.2,0.5,0.2,0.8c0,0.3-0.1,0.5-0.2,0.8 s-0.3,0.4-0.5,0.6s-0.5,0.3-0.8,0.4s-0.7,0.1-1.1,0.1c-0.4,0-0.8-0.1-1.2-0.2s-0.6-0.3-0.9-0.5s-0.4-0.4-0.5-0.7s-0.2-0.5-0.2-0.8 h1.6c0,0.2,0,0.3,0.1,0.4s0.1,0.2,0.3,0.3s0.2,0.1,0.4,0.2s0.3,0.1,0.4,0.1c0.3,0,0.6-0.1,0.7-0.2S40.9,22.2,40.9,22z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.5,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.6,36.2c0,0.9-0.7,1.6-1.6,1.6c-0.1,0-0.1,0-0.2,0H27.5c-0.5,0-0.9-0.4-0.9-0.9S27,36,27.5,36 c0,0,0.1,0,0.2,0c-0.1-0.3-0.1-0.5-0.1-0.8c0-1.5,1.2-2.6,2.6-2.6c0.3,0,0.5,0,0.8,0.1c0.4-2.1,2.2-3.6,4.3-3.6 c2.4,0,4.4,2,4.4,4.4c0,0.5-0.1,0.9-0.2,1.3c0.2,0,0.3-0.1,0.5-0.1C40.9,34.6,41.6,35.3,41.6,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.5,34.7"
  })))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    id: "roadm",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.555513, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.051,4.56 -2.355,4.56 -2.355,2.964 5.995,2.964  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.115,7.836 -2.355,7.836 -2.355,6.24 4.058,6.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.178,11.111 -2.355,11.111 -2.355,9.515 2.122,9.515  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.469,0.424 17.244,13.576 1.694,13.576  "
  }))))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    id: "rpl-active",
    viewBox: "0 0 27 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E52C2C",
    d: " M5,3c2.206,0,4.078,1.429,4.742,3.411l2.611,0.001v3.294l-2.651,0C9.004,11.627,7.162,13,5,13c-2.761,0-5-2.239-5-5S2.239,3,5,3z  M8.011,6.056l-4.927,4.972C3.638,11.38,4.295,11.583,5,11.583c1.979,0,3.583-1.604,3.583-3.583 C8.583,7.284,8.373,6.616,8.011,6.056z M5,4.417C3.021,4.417,1.417,6.021,1.417,8c0,0.7,0.201,1.353,0.548,1.905l4.913-4.958 C6.332,4.611,5.689,4.417,5,4.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E52C2C",
    d: " M22,3c2.761,0,5,2.239,5,5s-2.239,5-5,5c-2.162,0-4.004-1.373-4.701-3.294l-2.475,0V6.412l2.434-0.001C17.922,4.429,19.794,3,22,3z  M24.918,5.92l-4.857,5.094c0.559,0.36,1.224,0.569,1.939,0.569c1.979,0,3.583-1.604,3.583-3.583 C25.583,7.225,25.337,6.507,24.918,5.92z M22,4.417c-1.979,0-3.583,1.604-3.583,3.583c0,0.69,0.195,1.335,0.533,1.882l4.785-5.018 C23.221,4.579,22.63,4.417,22,4.417z"
  }))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    id: "rpl-owner",
    viewBox: "0 0 27 16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.234,
    y: 6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EDEDED",
    width: 17.766,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.234,
    y: 7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D8D8D8",
    width: 17.766,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.234,
    y: 9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BEBEBE",
    width: 17.766,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M5,3c2.761,0,5,2.239,5,5 s-2.239,5-5,5s-5-2.239-5-5S2.239,3,5,3z M8.024,6.077L3.087,11.03c0.554,0.35,1.21,0.553,1.913,0.553 c1.979,0,3.583-1.604,3.583-3.583C8.583,7.292,8.378,6.632,8.024,6.077z M5,4.417C3.021,4.417,1.417,6.021,1.417,8 c0,0.701,0.202,1.356,0.55,1.908l4.93-4.949C6.346,4.615,5.696,4.417,5,4.417z"
  }))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-critical",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E52C2C",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#FFFFFF",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#FFFFFF",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#FFFFFF",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 24,
    cy: 22,
    r: 3
  })))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-disabled",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M26.2,0h-3v1h3V0L26.2,0L26.2,0z M20.2,0h-3v1h3V0L20.2,0z M14.2,0h-3v1h3V0L14.2,0z M9,1.3L8.3,2.7 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C7.9,3.3,7.6,3.9,7.6,3.9 l0.9,0.5l1.4-2.6L9,1.3L9,1.3z M6.1,6.6c0,0-0.3,0.6-0.6,1.2l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0L4.7,9.2l0.9,0.5L7,7.1L6.1,6.6L6.1,6.6z M3.2,11.8c0,0-0.1,0.3-0.3,0.6 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l-1,1.9l0.9,0.5l1.4-2.6L3.2,11.8L3.2,11.8z M3.5,16.6l-0.9,0.5c0,0,0.5,0.9,0.9,1.6l0,0c0,0,0,0,0,0l0.5,1 L5,19.2L3.5,16.6L3.5,16.6z M6.4,21.9l-0.9,0.5L7,25l0.9-0.5L6.4,21.9L6.4,21.9z M9.3,27.1l-0.9,0.5L9.8,30l0,0H10v-0.1l0.6-0.3 l0,0l0,0l0,0L9.3,27.1L9.3,27.1z M16,29h-3v1h3V29L16,29z M22,29h-3v1h3V29L22,29z M26.2,28l-0.6,1H25v1h1.2l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0.8-1.5L26.2,28L26.2,28z M29.1,22.7l-1.4,2.6l0.9,0.5c0,0,0.3-0.6,0.6-1.2l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0l0,0l0,0l0.8-1.4L29.1,22.7L29.1,22.7z  M32,17.5l-1.4,2.6l0.9,0.5c0,0,0.7-1.2,1.1-2l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.3-0.6 L32,17.5L32,17.5z M33.2,12.7l-0.9,0.5l1.3,2.3l0.5-0.3l0,0l-0.5,0.3l0.5-0.3l0.2,0.1l0.2-0.3c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0l0,0L33.2,12.7L33.2,12.7z M30.3,7.4l-0.9,0.5l1.4,2.6l0.9-0.5L30.3,7.4L30.3,7.4z M27.4,2.2l-0.9,0.5L28,5.3 l0.9-0.5l0,0L27.4,2.2L27.4,2.2z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#7B7F7F",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#7B7F7F",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#7B7F7F",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#7B7F7F",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#7B7F7F",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#7B7F7F",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#7B7F7F",
    cx: 24,
    cy: 22,
    r: 3
  })))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-ep-directional-flip",
    viewBox: "0 0 20 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    fill: "#BABCBE",
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "1,19 6,13 11,19  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    fill: "#919395",
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    fill: "#919395",
    width: 8,
    height: 8
  })))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-ep-directional",
    viewBox: "0 0 20 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    fill: "#BABCBE",
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "11,13 6,19 1,13  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    fill: "#919395",
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    fill: "#919395",
    width: 8,
    height: 8
  })))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-ep-major-ring",
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 12,
    height: 9,
    fill: "#5a6671"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.75 20.75 5.5 20.75 5.5 19.25 2.25 19.25 2.25 6.75 5.5 6.75 5.5 5.25 0.75 5.25 0.75 20.75",
    fill: "#5a6671"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 12,
    height: 9,
    fill: "#5a6671"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.5 5.25 20.5 6.75 23.75 6.75 23.75 19.25 20.5 19.25 20.5 20.75 25.25 20.75 25.25 5.25 20.5 5.25",
    fill: "#5a6671"
  }))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-ep",
    viewBox: "0 0 20 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    fill: "#BABCBE",
    width: 1,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    fill: "#BABCBE",
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 24,
    fill: "#BABCBE",
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    fill: "#919395",
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    fill: "#919395",
    width: 8,
    height: 8
  })))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-indeterminate",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#272425",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#FFFFFF",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#FFFFFF",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#FFFFFF",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 24,
    cy: 22,
    r: 3
  })))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-critical",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E52C2C",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#FFFFFF",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-disabled",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M26.2,0h-3v1h3V0L26.2,0L26.2,0z M20.2,0h-3v1h3V0L20.2,0z M14.2,0h-3v1h3V0L14.2,0z M9,1.3L8.3,2.7l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C7.9,3.3,7.6,3.9,7.6,3.9l0.9,0.5l1.4-2.6L9,1.3L9,1.3z M6.1,6.6 c0,0-0.3,0.6-0.6,1.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0L4.7,9.2l0.9,0.5L7,7.1L6.1,6.6L6.1,6.6z  M3.2,11.8c0,0-0.1,0.3-0.3,0.6l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-1,1.9l0.9,0.5l1.4-2.6L3.2,11.8L3.2,11.8z M3.5,16.6l-0.9,0.5c0,0,0.5,0.9,0.9,1.6l0,0l0,0 l0.5,1l1-0.5L3.5,16.6L3.5,16.6z M6.4,21.9l-0.9,0.5L7,25l0.9-0.5L6.4,21.9L6.4,21.9z M9.3,27.1l-0.9,0.5L9.8,30l0,0H10v-0.1 l0.6-0.3l0,0l0,0l0,0L9.3,27.1L9.3,27.1z M16,29h-3v1h3V29L16,29z M22,29h-3v1h3V29L22,29z M26.2,28l-0.6,1H25v1h1.2l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.8-1.5L26.2,28L26.2,28z M29.1,22.7l-1.4,2.6l0.9,0.5c0,0,0.3-0.6,0.6-1.2l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.8-1.4L29.1,22.7L29.1,22.7z M32,17.5l-1.4,2.6l0.9,0.5c0,0,0.7-1.2,1.1-2l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.3-0.6L32,17.5L32,17.5z M33.2,12.7l-0.9,0.5l1.3,2.3l0.5-0.3l0,0l-0.5,0.3 l0.5-0.3l0.2,0.1l0.2-0.3l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0c0,0,0,0,0-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0L33.2,12.7L33.2,12.7z M30.3,7.4l-0.9,0.5l1.4,2.6l0.9-0.5L30.3,7.4L30.3,7.4z M27.4,2.2l-0.9,0.5L28,5.3 l0.9-0.5l0,0L27.4,2.2L27.4,2.2z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#7B7F7F",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#7B7F7F",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#7B7F7F",
    width: 4,
    height: 4
  })))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-inderterminate",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#272425",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#FFFFFF",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-lag-normal",
    viewBox: "0 0 44 40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I_link_normal-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#E8E8E8",
    points: "11.5 39.3 0.9 20 11.5 0.7 32.7 0.7 43.3 20 32.7 39.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 1.3L42.6 20 32.3 38.7 11.9 38.7 1.7 20 12 1.3 32.3 1.3 32.3 1.3ZM33.1 0L11.1 0 0.1 20 11 40 33 40 43.9 20 33.1 0 33.1 0Z",
    id: "Shape",
    fill: "#BABCBE"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#919395",
    fillRule: "nonzero",
    points: "22 9 23 9 23 31 22 31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy",
    fill: "#919395",
    fillRule: "nonzero",
    points: "23 9 24 9 24 31 23 31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-4",
    fill: "#919395",
    fillRule: "nonzero",
    points: "21 9 22 9 22 31 21 31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#E8E8E8",
    cx: 22.5,
    cy: 20,
    rx: 4.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#979797",
    cx: 22.5,
    cy: 19,
    rx: 4.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#919395",
    fillRule: "nonzero",
    points: "19 5 26 5 26 12 19 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path-Copy-2",
    fill: "#919395",
    fillRule: "nonzero",
    points: "19 28 26 28 26 35 19 35"
  }))))), _symbol154 || (_symbol154 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-LOA",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00F2F2",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#FFFFFF",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })))), _symbol155 || (_symbol155 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-major",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#EF8E00",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#FFFFFF",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })))), _symbol156 || (_symbol156 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-minor",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E2DC00",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#FFFFFF",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })))), _symbol157 || (_symbol157 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-normal",
    viewBox: "52.5 55 45 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "64.5,94.3 53.9,75 64.5,55.7 85.7,55.7 96.3,75 85.7,94.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M85.3,56.3L95.6,75L85.3,93.7H64.9L54.7,75l10.3-18.7H85.3 M86.1,55h-22L53.1,75L64,95h22l10.9-20L86.1,55 L86.1,55z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 64.3,
    fill: "#919395",
    width: 1.3,
    height: 22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 61.7,
    fill: "#919395",
    width: 5.3,
    height: 5.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 84.3,
    fill: "#919395",
    width: 5.3,
    height: 5.3
  })))), _symbol158 || (_symbol158 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-planning",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M26.2,0h-3v1h3V0L26.2,0L26.2,0z M20.2,0h-3v1h3V0L20.2,0z M14.2,0h-3v1h3V0L14.2,0z M9,1.3L8.3,2.7l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C7.9,3.3,7.6,3.9,7.6,3.9l0.9,0.5l1.4-2.6L9,1.3L9,1.3z M6.1,6.6 c0,0-0.3,0.6-0.6,1.2l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0L4.7,9.2l0.9,0.5L7,7.1L6.1,6.6L6.1,6.6z  M3.2,11.8c0,0-0.1,0.3-0.3,0.6l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-1,1.9l0.9,0.5l1.4-2.6L3.2,11.8L3.2,11.8z M3.5,16.6l-0.9,0.5c0,0,0.5,0.9,0.9,1.6l0,0l0,0 l0.5,1l1-0.5L3.5,16.6L3.5,16.6z M6.4,21.9l-0.9,0.5L7,25l0.9-0.5L6.4,21.9L6.4,21.9z M9.3,27.1l-0.9,0.5L9.8,30l0,0H10v-0.1 l0.6-0.3l0,0l0,0l0,0L9.3,27.1L9.3,27.1z M16,29h-3v1h3V29L16,29z M22,29h-3v1h3V29L22,29z M26.2,28l-0.6,1H25v1h1.2l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.8-1.5L26.2,28L26.2,28z M29.1,22.7l-1.4,2.6l0.9,0.5c0,0,0.3-0.6,0.6-1.2l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.8-1.4L29.1,22.7L29.1,22.7z M32,17.5l-1.4,2.6l0.9,0.5c0,0,0.7-1.2,1.1-2l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.3-0.6L32,17.5L32,17.5z M33.2,12.7l-0.9,0.5l1.3,2.3l0.5-0.3l0,0l-0.5,0.3 l0.5-0.3l0.2,0.1l0.2-0.3l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0c0,0,0,0,0-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0L33.2,12.7L33.2,12.7z M30.3,7.4l-0.9,0.5l1.4,2.6l0.9-0.5L30.3,7.4L30.3,7.4z M27.4,2.2l-0.9,0.5L28,5.3 l0.9-0.5l0,0L27.4,2.2L27.4,2.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "10.8,1 6.8,7.4 10.3,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "14.7,1 4.1,17.7 3.5,16.8 13.6,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "18.6,1 5.8,21 5.3,20.1 17.5,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "22.4,1 7.6,24.3 7.1,23.3 21.3,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "26,1.5 9.4,27.5 8.9,26.6 25.2,1 25.8,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "27.8,4.7 12.3,29 11.2,29 27.3,3.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "29.6,7.9 16.1,29 15,29 29.1,7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "31.4,11.2 20,29 18.9,29 30.9,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "33.2,14.4 23.9,29 22.8,29 32.7,13.5  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#7B7F7F",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#7B7F7F",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#7B7F7F",
    width: 4,
    height: 4
  })))), _symbol159 || (_symbol159 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-link-warning",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7D85B2",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 7,
    fill: "#FFFFFF",
    width: 1,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 5,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 22,
    fill: "#FFFFFF",
    width: 4,
    height: 4
  })))), _symbol160 || (_symbol160 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-LOA",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00F2F2",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#FFFFFF",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#FFFFFF",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#FFFFFF",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 24,
    cy: 22,
    r: 3
  })))), _symbol161 || (_symbol161 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-LSP-infrastructure",
    viewBox: "0 0 50 40"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "13.8,40 2.5,20 13.8,0 36.2,0 47.5,20 36.2,40 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M35.7,0.9L46.5,20L35.7,39.1H14.4L3.6,20L14.4,0.9H35.7 M36.3,0H13.9L2.5,20l11.2,20h22.6l11.2-20L36.3,0 L36.3,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    fill: "#BABCBE",
    enableBackground: "new    ",
    d: "M12.4,25.8l5.8,1.1l2.7,0.8l4.1-8l-4.9-0.2h-5.2L12.4,25.8z  M22.1,30.4l-4.5-1.3l-8.4-1.6l4.1-10.4h6.9l8.6,0.3L22.1,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    opacity: 0.7,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    d: "M28.6,18.4l8.6,0.1l-0.9-6.4l-4.8-0.5L28.6,18.4z  M39.9,20.9L25,20.7l5-11.6l8.4,0.8L39.9,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    fill: "#BABCBE",
    enableBackground: "new    ",
    d: "M32.5,27.7h2.1l2.2-7l-7.7,0.1L32.5,27.7z M21.8,30.1v-2.3 l8.1-0.1l-4.6-9.2L40,18.3L36.4,30h-4.5L21.8,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    fill: "#BABCBE",
    enableBackground: "new    ",
    d: "M15.5,17.1h4.1l6-4.1L17,11.9L15.5,17.1z M18.8,28.3l-2.3-0.5 l2-8.4h-6l2.9-10.2l16.7,2.2L21,18.9L18.8,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    fill: "#919395",
    d: "M29.2,18l7.6,0.1L36,12.5l-4.2-0.4L29.2,18z M40.4,21.3l-15.9-0.2l5.4-12.4l8.9,0.9L40.4,21.3 z"
  })))), _symbol162 || (_symbol162 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-major",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#EF8E00",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#FFFFFF",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#FFFFFF",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#FFFFFF",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 24,
    cy: 22,
    r: 3
  })))), _symbol163 || (_symbol163 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-minor",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E2DC00",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#FFFFFF",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#FFFFFF",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#FFFFFF",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 24,
    cy: 22,
    r: 3
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "service-nfv",
    viewBox: "0 0 60 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.75,
    y1: 5.25,
    x2: 9.25,
    y2: 44.75,
    gradientTransform: "matrix(1 0 0 -1 1 50)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "15.5,50 1,25 15.5,0 44.5,0 59,25 44.5,50  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    enableBackground: "new    ",
    points: "43.5,11 41.7,13 37.7,17 28.3,27.1 16.3,27 12,29.8  23.9,50 44.5,50 55.5,30.9  "
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 39.5,
    y1: 15,
    x2: 39.5,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "2,2",
    x1: 39.5,
    y1: 18,
    x2: 39.5,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 39.5,
    y1: 29,
    x2: 39.5,
    y2: 30
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 12,
    cy: 25.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 13,
    y1: 24.5,
    x2: 23,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7056,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 40,
    y1: 11.5,
    x2: 28,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 7.5,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 21.2,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30,41.6h-1.8L24.8,36v5.6H23v-8.5h1.8l3.4,5.6v-5.6H30V41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.4,38.1H33v3.5h-1.8v-8.5h5.6v1.4H33v2.2h3.4C36.4,36.7,36.4,38.1,36.4,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41,39.5l1.9-6.4h2l-3,8.5h-1.8l-3-8.5h2L41,39.5z"
  })))))), _symbol164 || (_symbol164 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-normal",
    viewBox: "52.5 55 45 40"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "63.8,95 52.5,75 63.8,55 86.2,55 97.5,75 86.2,95 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M85.7,55.9L96.5,75L85.7,94.1H64.4L53.6,75l10.8-19.1H85.7 M86.3,55H63.9L52.5,75l11.2,20h22.6l11.2-20 L86.3,55L86.3,55z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "63.5,71.9 74.5,80.9 73.6,81.9 62.6,72.9 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 63.7,
    fill: "#BABCBE",
    width: 1.4,
    height: 22.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "82.4,63.3 83.6,63.9 74.6,81.7 73.3,81.1 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 61.7,
    fill: "#919395",
    width: 4.1,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 79,
    fill: "#919395",
    width: 4.1,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#919395",
    cx: 62.8,
    cy: 72.3,
    rx: 4.1,
    ry: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#919395",
    cx: 83.3,
    cy: 84.3,
    rx: 4.1,
    ry: 4
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "service-odu-1",
    viewBox: "0 0 58 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.75,
    y1: 44.7296,
    x2: 9.25,
    y2: 5.2296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "14.5,50 0,25 14.5,0 43.5,0 58,25 43.5,50  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    points: "42.5,11 40.7,13 36.7,17 27.3,27.1 15.3,27 11,29.8 22.9,50 43.5,50 54.5,30.9  "
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 38.5,
    y1: 15,
    x2: 38.5,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "2,2",
    x1: 38.5,
    y1: 18,
    x2: 38.5,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 38.5,
    y1: 29,
    x2: 38.5,
    y2: 30
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 11,
    cy: 25.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 12,
    y1: 24.5,
    x2: 22,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7056,
    strokeMiterlimit: 10,
    x1: 39,
    y1: 11.5,
    x2: 27,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 7.5,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 21.2,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27,37.6c0,0.7-0.1,1.2-0.3,1.8s-0.4,1-0.7,1.3s-0.7,0.6-1.1,0.8s-0.9,0.3-1.5,0.3s-1-0.1-1.5-0.3 s-0.8-0.5-1.2-0.8s-0.6-0.8-0.8-1.3s-0.3-1.1-0.3-1.8v-0.4c0-0.6,0.1-1.2,0.3-1.8s0.4-1,0.7-1.3s0.7-0.6,1.1-0.8s0.9-0.3,1.5-0.3 s1,0.1,1.5,0.3s0.8,0.5,1.1,0.8s0.6,0.8,0.7,1.3s0.3,1.1,0.3,1.8V37.6z M25.2,37.2c0-0.9-0.2-1.6-0.5-2s-0.8-0.7-1.4-0.7 s-1.1,0.2-1.4,0.7s-0.5,1.1-0.5,2v0.4c0,0.4,0,0.8,0.1,1.2s0.2,0.6,0.4,0.9s0.4,0.4,0.6,0.5s0.5,0.2,0.8,0.2c0.6,0,1-0.2,1.4-0.7 s0.5-1.2,0.5-2V37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.3,41.6v-8.5h2.6c0.6,0,1.1,0.1,1.6,0.3s0.9,0.5,1.2,0.8s0.6,0.8,0.8,1.3s0.3,1.1,0.3,1.7v0.4 c0,0.6-0.1,1.2-0.3,1.7s-0.5,0.9-0.8,1.3s-0.8,0.6-1.2,0.8s-1,0.3-1.6,0.3H28.3z M30.1,34.5v5.7h0.8c0.7,0,1.2-0.2,1.6-0.7 s0.5-1.1,0.5-2v-0.4c0-0.9-0.2-1.5-0.5-2s-0.9-0.7-1.6-0.7H30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M42.6,33.1v5.6c0,0.5-0.1,0.9-0.2,1.3s-0.4,0.7-0.7,0.9s-0.6,0.4-1,0.6s-0.8,0.2-1.3,0.2 c-0.5,0-0.9-0.1-1.3-0.2s-0.7-0.3-1-0.6s-0.5-0.6-0.7-0.9S36,39.2,36,38.7v-5.6h1.8v5.6c0,0.6,0.1,1,0.4,1.2s0.6,0.4,1.1,0.4 c0.5,0,0.8-0.1,1.1-0.4s0.4-0.7,0.4-1.2v-5.6H42.6z"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "service-odu",
    viewBox: "0 0 60 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.75,
    y1: 44.75,
    x2: 9.25,
    y2: 5.25,
    gradientTransform: "matrix(1 0 0 1 1 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "15.5,50 1,25 15.5,0 44.5,0 59,25 44.5,50  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    enableBackground: "new    ",
    points: "43.5,11 41.7,13 37.7,17 28.3,27.1 16.3,27 12,29.8  23.9,50 44.5,50 55.5,30.9  "
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 39.5,
    y1: 15,
    x2: 39.5,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "2,2",
    x1: 39.5,
    y1: 18,
    x2: 39.5,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 39.5,
    y1: 29,
    x2: 39.5,
    y2: 30
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 12,
    cy: 25.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 13,
    y1: 24.5,
    x2: 23,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7056,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    x1: 40,
    y1: 11.5,
    x2: 28,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 7.5,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 21.2,
    fill: "#C7FFCB",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.2,41.6v-8.5h2.6c0.6,0,1.1,0.1,1.6,0.3s0.9,0.5,1.2,0.8s0.6,0.8,0.8,1.3s0.3,1.1,0.3,1.7v0.4 c0,0.6-0.1,1.2-0.3,1.7s-0.5,0.9-0.8,1.3s-0.8,0.6-1.2,0.8s-1,0.3-1.6,0.3L29.2,41.6L29.2,41.6z M31,34.5v5.7h0.8 c0.7,0,1.2-0.2,1.6-0.7s0.5-1.1,0.5-2v-0.4c0-0.9-0.2-1.5-0.5-2s-0.9-0.7-1.6-0.7H31V34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.6,33.1v5.6c0,0.5-0.1,0.9-0.2,1.3s-0.4,0.7-0.7,0.9s-0.6,0.4-1,0.6s-0.8,0.2-1.3,0.2 s-0.9-0.1-1.3-0.2s-0.7-0.3-1-0.6s-0.5-0.6-0.7-0.9S37,39.2,37,38.7v-5.6h1.8v5.6c0,0.6,0.1,1,0.4,1.2s0.6,0.4,1.1,0.4 s0.8-0.1,1.1-0.4s0.4-0.7,0.4-1.2v-5.6C41.8,33.1,43.6,33.1,43.6,33.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.4,37.6c0,0.7,0,1.2-0.2,1.8s-0.3,1-0.6,1.3s-0.7,0.6-1.1,0.8s-0.9,0.3-1.5,0.3s-1-0.1-1.5-0.3 s-0.8-0.5-1.2-0.8s-0.6-0.8-0.8-1.3s-0.3-1.1-0.3-1.8v-0.4c0-0.6,0.1-1.2,0.3-1.8s0.4-1,0.7-1.3s0.7-0.6,1.1-0.8 s0.9-0.3,1.5-0.3s1,0.1,1.5,0.3s0.8,0.5,1.1,0.8s0.6,0.8,0.7,1.3s0.3,1.1,0.3,1.8V37.6L27.4,37.6z M25.8,37.2 c0-0.9-0.2-1.6-0.5-2s-0.8-0.7-1.4-0.7s-1.1,0.2-1.4,0.7s-0.5,1.1-0.5,2v0.4c0,0.4,0,0.8,0.1,1.2s0.2,0.6,0.4,0.9 s0.4,0.4,0.6,0.5s0.5,0.2,0.8,0.2c0.6,0,1-0.2,1.4-0.7s0.5-1.2,0.5-2V37.2z"
  }))))))), _symbol165 || (_symbol165 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-planning",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BABCBE",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M26.2,0h-3v1h3V0L26.2,0L26.2,0z M20.2,0h-3v1h3V0L20.2,0z M14.2,0h-3v1h3V0L14.2,0z M9,1.3L8.3,2.7 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C7.9,3.3,7.6,3.9,7.6,3.9 l0.9,0.5l1.4-2.6L9,1.3L9,1.3z M6.1,6.6c0,0-0.3,0.6-0.6,1.2l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0L4.7,9.2l0.9,0.5L7,7.1L6.1,6.6L6.1,6.6z M3.2,11.8c0,0-0.1,0.3-0.3,0.6 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l-1,1.9l0.9,0.5l1.4-2.6L3.2,11.8L3.2,11.8z M3.5,16.6l-0.9,0.5c0,0,0.5,0.9,0.9,1.6l0,0c0,0,0,0,0,0l0.5,1 L5,19.2L3.5,16.6L3.5,16.6z M6.4,21.9l-0.9,0.5L7,25l0.9-0.5L6.4,21.9L6.4,21.9z M9.3,27.1l-0.9,0.5L9.8,30l0,0H10v-0.1l0.6-0.3 l0,0l0,0l0,0L9.3,27.1L9.3,27.1z M16,29h-3v1h3V29L16,29z M22,29h-3v1h3V29L22,29z M26.2,28l-0.6,1H25v1h1.2l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0.8-1.5L26.2,28L26.2,28z M29.1,22.7l-1.4,2.6l0.9,0.5c0,0,0.3-0.6,0.6-1.2l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0l0,0l0,0l0.8-1.4L29.1,22.7L29.1,22.7z  M32,17.5l-1.4,2.6l0.9,0.5c0,0,0.7-1.2,1.1-2l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0l0,0l0,0l0,0l0,0l0.3-0.6 L32,17.5L32,17.5z M33.2,12.7l-0.9,0.5l1.3,2.3l0.5-0.3l0,0l-0.5,0.3l0.5-0.3l0.2,0.1l0.2-0.3c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0,0l0,0l0,0L33.2,12.7L33.2,12.7z M30.3,7.4l-0.9,0.5l1.4,2.6l0.9-0.5L30.3,7.4L30.3,7.4z M27.4,2.2l-0.9,0.5L28,5.3 l0.9-0.5l0,0L27.4,2.2L27.4,2.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "10.8,1 6.8,7.4 10.3,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "14.7,1 4.1,17.7 3.5,16.8 13.6,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "18.6,1 5.8,21 5.3,20.1 17.5,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "22.4,1 7.6,24.3 7.1,23.3 21.3,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "26,1.5 9.4,27.5 8.9,26.6 25.2,1 25.8,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "27.8,4.7 12.3,29 11.2,29 27.3,3.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "29.6,7.9 16.1,29 15,29 29.1,7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "31.4,11.2 20,29 18.9,29 30.9,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "33.2,14.4 23.9,29 22.8,29 32.7,13.5  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#7B7F7F",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#7B7F7F",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#7B7F7F",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#7B7F7F",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#7B7F7F",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#7B7F7F",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#7B7F7F",
    cx: 24,
    cy: 22,
    r: 3
  })))), _symbol166 || (_symbol166 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-protection-full",
    viewBox: "0 0 11 13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M5.5,0C5.5,0,7,3.1,11,3.1c0,0,0.9,6.6-5.5,9.3L5.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M5.5,12.4C-0.9,9.7,0,3.1,0,3.1C4,3.1,5.5,0,5.5,0L5.5,12.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#595A5C",
    d: "M5.5,1.7C6.3,2.6,7.7,3.8,9.9,4c0,1.6-0.5,5.4-4.4,7.2C1.6,9.3,1.1,5.7,1.1,4C3.3,3.8,4.7,2.6,5.5,1.7  M5.5,0C5.5,0,4,3.1,0,3.1c0,0-0.9,6.6,5.5,9.3C11.9,9.7,11,3.1,11,3.1C7,3.1,5.5,0,5.5,0L5.5,0z"
  })))))), _symbol167 || (_symbol167 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-protection-partial",
    viewBox: "0 0 11 13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M5.5,0C5.5,0,7,3.1,11,3.1c0,0,0.9,6.6-5.5,9.3L5.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M5.5,12.4C-0.9,9.7,0,3.1,0,3.1C4,3.1,5.5,0,5.5,0L5.5,12.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#595A5C",
    d: "M5.5,1.7C6.3,2.6,7.7,3.8,9.9,4c0,1.6-0.5,5.4-4.4,7.2C1.6,9.3,1.1,5.7,1.1,4C3.3,3.8,4.7,2.6,5.5,1.7  M5.5,0C5.5,0,4,3.1,0,3.1c0,0-0.9,6.6,5.5,9.3C11.9,9.7,11,3.1,11,3.1C7,3.1,5.5,0,5.5,0L5.5,0z"
  })))))), _symbol168 || (_symbol168 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-warning",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#7D85B2",
    points: "9.8,30 1.5,15 9.8,0 26.2,0 34.5,15 26.2,30  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.9,
    transform: "matrix(0.7652 0.6438 -0.6438 0.7652 13.6699 -4.672)",
    fill: "#FFFFFF",
    width: 10.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6.5,
    fill: "#FFFFFF",
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5.7,
    transform: "matrix(0.8962 0.4437 -0.4437 0.8962 7.9517 -7.7516)",
    fill: "#FFFFFF",
    width: 1,
    height: 14.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 9,
    cy: 13,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 24,
    cy: 22,
    r: 3
  })))), _symbol169 || (_symbol169 = /*#__PURE__*/React.createElement("symbol", {
    id: "services",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 2.2,
    fill: "#7C807F",
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 25,
    fill: "#7C807F",
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.8,
    fill: "#7C807F",
    width: 7.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#7C807F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 4.8,
    y1: 15.6,
    x2: 22.9,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#7C807F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 22.9,
    y1: 27.8,
    x2: 31.2,
    y2: 6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#7C807F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 4.8,
    y1: 15.6,
    x2: 6.2,
    y2: 15.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#7C807F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2.7901,2.7901",
    x1: 8.8,
    y1: 14.2,
    x2: 28.5,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#7C807F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 29.8,
    y1: 6.6,
    x2: 31.2,
    y2: 6
  }))))), _symbol170 || (_symbol170 = /*#__PURE__*/React.createElement("symbol", {
    id: "shield-full",
    viewBox: "0 0 11 13"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7B7F7F;}\r\n\t\t"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,0C5.5,0,7,3.1,11,3.1c0,0,0.9,6.6-5.5,9.3V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,12.4C-0.9,9.7,0,3.1,0,3.1C4,3.1,5.5,0,5.5,0V12.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#595A5C",
    d: "M5.5,1.7C6.3,2.6,7.7,3.8,9.9,4c0,1.6-0.5,5.4-4.4,7.2C1.6,9.3,1.1,5.7,1.1,4C3.3,3.8,4.7,2.6,5.5,1.7  M5.5,0C5.5,0,4,3.1,0,3.1c0,0-0.9,6.6,5.5,9.3C11.9,9.7,11,3.1,11,3.1C7,3.1,5.5,0,5.5,0L5.5,0z"
  })))))), _symbol171 || (_symbol171 = /*#__PURE__*/React.createElement("symbol", {
    id: "shield-half",
    viewBox: "0 0 11 13"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7B7F7F;}\r\n\t\t"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,0C5.5,0,7,3.1,11,3.1c0,0,0.9,6.6-5.5,9.3V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M5.5,12.4C-0.9,9.7,0,3.1,0,3.1C4,3.1,5.5,0,5.5,0V12.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#595A5C",
    d: "M5.5,1.7C6.3,2.6,7.7,3.8,9.9,4c0,1.6-0.5,5.4-4.4,7.2C1.6,9.3,1.1,5.7,1.1,4C3.3,3.8,4.7,2.6,5.5,1.7  M5.5,0C5.5,0,4,3.1,0,3.1c0,0-0.9,6.6,5.5,9.3C11.9,9.7,11,3.1,11,3.1C7,3.1,5.5,0,5.5,0L5.5,0z"
  })))))), _symbol172 || (_symbol172 = /*#__PURE__*/React.createElement("symbol", {
    id: "subway-amp",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "2,20 17,10 2,0  "
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "subway-device",
    viewBox: "0 0 76 126"
  }, /*#__PURE__*/React.createElement("g", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.25,
    width: 82,
    height: 133,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAACFCAYAAADIF68MAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABq1JREFUeNrs191S20YUB3CdXUmW ccgHgaFO0inT4Y5LXoCXyFP2JXgBplfcdHLBdJhQSkiIHSNZWu3pfyXbGKehdcpkSP0/M8uuZWuR fjr7IYnuDokY86HLQMlcPWsfrKjc4W1AXWh/EXKKZ/b29sxoNDJlWZq6rmXT+5XMznfGqLVW0zT1 vV7PHx8fexz2C6i3IBvE/f19e35+HmdZlsR5nhRJkgDSdLw3mmUrhSlFoWNjPCB9VlWV63aroiiq 7e1td3R0VM9jyiLi6elp+sTarsuyNQD2kijKnEhqVW2kKroi86YEIBGtRepYtYRBboy5Tsfj0UA1 7/f71Tzm/Bxof3vxIl1bW+v5onjq43gDeBvo7DG+73rvE3RkJpOD/O8Rw/hF4JYr8f5ajRloXV8C 4H3s/dUnkevd09MKc2iDGYfzXmNO/HV318Zl2cGkuI5JYQsnv0RvL1Ceo+NHgqxUVROyciWWZmQj isc9j/F5iBrTpenWxogXqTIAX7SIfgoZ4YCsDYdxhYkRR5/g0DY6+Qn1DtS2tc3KFG27MluiAAko ABaoP+Km3wYxg2HtvB9i8RmNdnbK1ycn8gt+3WQkIE3e68VRXWcQX0e9iQzsi+qP6K3fDG/VNAqQ K5CRc4lZ42Zz3P8VkinCKB2gfRHWDSw6yXPsaKY/jqeNnnNmFMeJ8b6LieERwJ5iXniG+hk6CxnZ QSdmpTJStYZmu1VRDYjrYb1wdZ1iMbFVnocklBnkGB+wvUECapgULBoJnkDIwCycOCnh8+pATjKy NcTwFgmgKerEhv0QvOq5vXUD2cFvMZHCTkLxs41mu90JC4yRdlivDmTIKmlu1TZFBJuYJsmaBVcX prgGEmmnH+I4LPW1d85Fxjis/aH2ocPplkduvzauAmZ7v3P1RFcWEcw0+8zVlcIQa41xmFSx/xQH w1omkHLHCzujhYwwg6rF0Aaix9uMhzr+aJgA/GTXTsR/A9mM8XZ+bN8dQ/vmPZKIy0DerPpCwPuA ZBCSkIRkEJKQhCQkg5CEJCQhGYQkJCEZhCQkIQnJICQhCUlIBiEJSUgGIQlJSEIyCElIQjIISUhC EpJBSEISkpAMQhKSkAxCEpKQhGQQkpCEJCSDkIQkJIOQhCQkIRmEJCQhCUkCQhKSkAxCEpKQhGQQ kpCEZBCSkIQkJIOQhCQkIRmEJCQhGYQkJCEJySAkIQlJSAYhCUlIBiEJSUhCMghJSEIyCHlfES8e kChSVKoiGoUSPk9rVf1O7kvur6fbBlOfOyEFP54AerRqjxKFEkVNwfcN8UOV0xtAuQfQxgF1U9BR raEdjsFIWtjPIa0xalDKuq6tSIVflThc4IQc7Wz6s3t92vcYE8RpMbN2ePCy5CWHgQcwDECHMysc KSceZTjmYZR2OhrMbkFu4dShtTooyzq2NpyUo7NhZMxH1FeTp12gbR9kRjZDZQZoca1W2odu5r5b djiHLAwJ9UmCRRQNQxv/IIdRVcJqHWZbk2E+y8jLNPVZllV5nhc4+BG5+w4dvNX26QxQsgeakQ0U /oT0CPeToKSTOm4wl334IRvb6WyM5xAQL1DO4XGJ44OAGawugf3zwhxi9vBPx7u7mff+KfB+MN6/ xOTwEidvouN1dNCRr7mob7CoiDG4TA1ZmOJaOziUNdORaoLPYRSZZSFxjgtTG8oAfV0Y1VN4nGA4 /47F4sxa+6Hz5k1xHEXhd36akSFF/ZuiqB6pjpwxlzhJjbU5rvBPZOeaep/ggsNQmZ/UH8b8CChc p/UiKT5kUOviAjPcQyrtdLTsNs/jnsP8WKDvIer3+HwOzD+8c5eJ96NrY6pX7UKki6ub7O/v27Oz s+SxSLfsdHrIzrVYtetwgXYyP+oDXGwCJMLiepMojrOorsM01IlaWCSRkej2qv6l9G5Q0A+eibRD O4qu0f8A9RUeylVUVYM11evk1avy6OionkDeGqYzzPPz8xhzQBLneVIkSYJFynS8N5plD3PFxgPG vRvrXIxRlGBEpeJc6jH+bMjGJRJAJntGDF9v6trh3ICZxyLXOXYwzrlxv9+v5hH/bp81W/329vbM aDQyWJ3QXy2b3j9IxBBuY0PCNeImTVZVtsoymDrbQQL4gLhkAkhRYK4QLeO4jlFg4NbzvBr1em7n 5MQd3gxpvesNQBZQm/bBQ36POTiIhsMh7r+Q8XgcahNG539JgHfYI4Z8TrGb6fV6fmtryx8eHupk gx4tvt3IP2f6dxWfvdl8bQIc3sbShfZ3D/Xt37XvwJuPvwQYAAoMTSbaJIhqAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -3 -3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 38,
    y1: 122.006,
    x2: 38,
    y2: 2.0087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F5F5"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M3,118c0,2.2,1.8,4,4,4l62,0c2.2,0,4-1.8,4-4V6c0-2.2-1.8-4-4-4L7,2C4.8,2,3,3.8,3,6V118z"
  }))))), _symbol173 || (_symbol173 = /*#__PURE__*/React.createElement("symbol", {
    id: "subway-endpoint",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M20,20c-5.5,0-10-4.5-10-10S14.5,0,20,0"
  }))))), _symbol174 || (_symbol174 = /*#__PURE__*/React.createElement("symbol", {
    id: "subway-firewall",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B7F7F",
    d: "M20,2.2C20,2.1,19.9,2,19.8,2H0.2C0.1,2,0,2.1,0,2.2v15.5C0,17.9,0.1,18,0.2,18h19.5 c0.1,0,0.2-0.1,0.2-0.2V2.2z M11.1,17.9c1-0.8,2.4-2.5,1.5-3.9c-0.4-0.6-0.4,0-0.9,0.2c-0.3,0.2-1.2,0.5-1.6,0.2 c0.8-0.8,1.2-1.9,0.7-3c-0.2-0.3-0.7-1.3-1.2-1.3c0.9,1.5-1.4,3.1-2.1,4.1c-0.5,0.7-0.5,1.5-0.1,2.3c0.2,0.5,0.7,0.9,1,1.4 c-2.3-0.8-4.2-3-3.2-5.5c0.4-0.9,1.7-1.8,1.4-2.9C6.4,8.9,5.9,8.7,5.4,8.6C6,8,6.9,7.7,7.8,7.6C7,5.1,9.2,2.1,11.9,3.8 c-1,0.2-1.2,0.8-1.2,1.7c0.1,1,1.3,1.9,1.9,2.7c0.9,1.3,1.8,2.7,2.2,4.2C15.4,14.8,13.4,17.4,11.1,17.9z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "subway-line-card-gradient",
    viewBox: "0 0 40 120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20,
    y1: 119.9989,
    x2: 20,
    y2: 0.00117618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F5F5"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M0,118c0,1.1,0.9,2,2,2l36,0c1.1,0,2-0.9,2-2V2c0-1.1-0.9-2-2-2L2,0C0.9,0,0,0.9,0,2V118z"
  })))), _symbol175 || (_symbol175 = /*#__PURE__*/React.createElement("symbol", {
    id: "subway-line-card",
    viewBox: "0 0 40 120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#272425",
    d: "M0,118c0,1.1,0.9,2,2,2l36,0c1.1,0,2-0.9,2-2V2c0-1.1-0.9-2-2-2L2,0C0.9,0,0,0.9,0,2V118z"
  })))), _symbol176 || (_symbol176 = /*#__PURE__*/React.createElement("symbol", {
    id: "subway-router",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "4,14 0,10 4,6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "7,11 4,11 4,9 7,9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "16,6 20,10 16,14  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    fill: "#919395",
    width: 3.5,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "6,17 10,12 14,17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17,
    fill: "#919395",
    width: 2,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "14,3 10,7 6,3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    fill: "#919395",
    width: 2,
    height: 4
  }))))))), /*#__PURE__*/React.createElement("symbol", {
    id: "subway-service-backplane",
    viewBox: "0 0 25 70"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.5,
    y1: -5.611582e-10,
    x2: 12.5,
    y2: 70
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2F2F2"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    fill: "url(#SVGID_1_)",
    width: 25,
    height: 70
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B9BBBD",
    points: "25,46.6 9.9,46.6 9.9,29.1 0,29.1 0,27.1 11.9,27.1 11.9,44.6 25,44.6  "
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "subway-shape-trap-mux",
    viewBox: "0 130 40 120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -54.9839,
    y1: 2904.4331,
    x2: -54.9839,
    y2: 3024.4331,
    gradientTransform: "matrix(1 0 0 -1 74.9839 3154.4331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F5F5"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "40,138.7 0,130 0,250 40,241.3  "
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "subway-shape-trap",
    viewBox: "0 0 40 120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.9839,
    y1: 3034.4331,
    x2: -44.9839,
    y2: 3154.4331,
    gradientTransform: "matrix(-1 0 0 -1 -24.9839 3154.4331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F5F5"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "0,8.7 40,0 40,120 0,111.3  "
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "subway-shape",
    viewBox: "0 130 40 120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20,
    y1: -120,
    x2: 20,
    y2: 8.076313e-10,
    gradientTransform: "matrix(1 0 0 -1 0 130)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F5F5"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M0,248c0,1.1,0.9,2,2,2h36c1.1,0,2-0.9,2-2V132c0-1.1-0.9-2-2-2H2c-1.1,0-2,0.9-2,2V248z"
  })))), _symbol177 || (_symbol177 = /*#__PURE__*/React.createElement("symbol", {
    id: "subway-switching",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "7.1,15.7 2.9,15.7 2.9,14.2 6.3,14.2 12.9,4.3 15.7,4.3 15.7,5.8 13.7,5.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "4.3,18.5 0,15 4.3,11.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "15.7,1.5 20,5 15.7,8.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "7.3,4.3 2.9,4.3 2.9,5.8 6.3,5.8 12.9,15.7 15.7,15.7 15.7,14.2 13.7,14.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "4.3,1.5 0,5 4.3,8.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#919395",
    points: "15.7,18.5 20,15 15.7,11.4  "
  })))))))), _symbol178 || (_symbol178 = /*#__PURE__*/React.createElement("symbol", {
    id: "subway-virtual",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M17.2,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M20,13.7c0,1.2-0.9,2.1-2.1,2.1c-0.1,0-0.2,0-0.3,0H1.2c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2 c0.1,0,0.2,0,0.2,0c-0.1-0.3-0.2-0.7-0.2-1c0-1.9,1.6-3.5,3.5-3.5c0.4,0,0.7,0.1,1.1,0.2c0.5-2.7,2.9-4.8,5.8-4.8 c3.2,0,5.8,2.6,5.8,5.8c0,0.6-0.1,1.2-0.3,1.8c0.2-0.1,0.5-0.1,0.7-0.1C19.1,11.7,20,12.6,20,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919395",
    d: "M17.2,11.8"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiena);
export default __webpack_public_path__ + "static/media/ciena.svg";
export { ForwardRef as ReactComponent };